import { ObserversModule } from '@angular/cdk/observers';
import * as i1$1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { ElementRef, Directive, Inject, Host, Optional, Input, HostListener, NgZone, Injectable, Pipe, NgModule, Component, ContentChild, HostBinding, ViewEncapsulation, InjectionToken, ViewChild, ViewChildren, EventEmitter, Output, SkipSelf, Self, ContentChildren, ComponentRef, Injector, PLATFORM_ID, inject } from '@angular/core';
import * as i2$4 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3$1 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i4$1 from '@angular/material/input';
import { MatInputModule, MatInput } from '@angular/material/input';
import * as i4$3 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i2$6 from '@angular/material/tabs';
import { MatTabsModule, MAT_TABS_CONFIG } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i2$7 from '@angular/cdk/portal';
import { ComponentPortal, TemplatePortal, PortalModule } from '@angular/cdk/portal';
import * as i1$2 from '@angular/cdk/scrolling';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import * as i7 from '@angular/material/autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import * as i2 from '@angular/material/button';
import { MatButton, MatButtonModule } from '@angular/material/button';
import * as i4$2 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import * as i2$3 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i2$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/material/menu';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import * as i2$5 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i2$1 from '@angular/material/progress-spinner';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import * as i2$8 from '@angular/material/table';
import { MatTableModule } from '@angular/material/table';
import * as i4 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i1$3 from '@coolon/pectin';
import { GarbageCollector, DelegatingValueModel, assert, UnaryCommand, lang, Dsl, Logger, TrackExternal, ValueModel, StoreInValueModel, Command, MutableListModel, StoreInListModel, Disposable, DelegatingListModel, MutableValueModel, FocusManager, EventListenerList, Form, Guard, Binding, DebugContext, ListModel, Functions, SelectionModel, HasDelegate, MultipleSelectionModel, AbstractComputedListModel, DelegatingSelectionModel, DelegateProxyHandler, DirtyTrackingForm, PagedListModel, PageController, ComputedListModel, Deferred } from '@coolon/pectin';
import { __decorate, __param, __metadata } from 'tslib';
import * as i1 from '@angular/platform-browser';
import escapeStringRegexp from 'escape-string-regexp';
import { isEmpty, isString, isFunction, isNil, isInteger, isEqual, first, uniq, last, isObject, isNumber, isNaN as isNaN$1 } from 'lodash';
import { marked } from 'marked';
import { Memoize } from '@typescript-plus/fast-memoize-decorator';
import { Enum } from 'typescript-string-enums';
import { lang as lang$1, assert as assert$1, Stringy, Klass, Opts } from '@coolon/typescript-utilities';
import * as i5 from '@angular/material/core';
import produce from 'immer';
import { isFunction as isFunction$1, isNil as isNil$1, isEmpty as isEmpty$1, findLast } from 'lodash-es';
import ResizeObserver from 'resize-observer-polyfill';
import * as i5$1 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i7$1 from '@angular/flex-layout';
import { FlexModule, GridModule } from '@angular/flex-layout';
import * as i1$6 from '@angular/material/dialog';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import * as i1$4 from '@angular/router';
import { UrlSegment, NavigationStart, NavigationEnd, NavigationError, NavigationCancel, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import * as i1$5 from '@angular/cdk/overlay';
import * as i3$2 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import 'reflect-metadata';
import { style, query, group, animate, trigger, transition } from '@angular/animations';

class CommandDirective extends GarbageCollector {
    constructor(elementRef, matButton, matMenuItem) {
        super();
        this.elementRef = elementRef;
        this._commandEnabled = this.registerDisposable(new DelegatingValueModel().withDefault(false));
        this._commandParameterProvided = false;
        // Material buttons and menu items don't respond to the disabled binding so we
        // need to inject them from our host element and handle them manually.
        this.matControl = matButton || matMenuItem;
    }
    set pectinCommand(command) {
        this._command = command;
        this._commandEnabled.setDelegate(command ? command.enabled$ : null);
    }
    get pectinCommand() {
        return this._command;
    }
    set commandParameter(value) {
        this._commandParameterProvided = true;
        this._commandParameter = value;
    }
    get commandParameter() {
        return this._commandParameter;
    }
    ngOnInit() {
        assert.notNil(this.pectinCommand);
        if (this.pectinCommand instanceof UnaryCommand) {
            if (!this._commandParameterProvided) {
                lang.illegalState('UnaryCommands require the command parameter to be specified.');
            }
        }
        else {
            if (this._commandParameterProvided) {
                lang.illegalState('command parameters are only supported by UnaryCommands');
            }
        }
    }
    ngAfterViewInit() {
        const { when } = Dsl.disposeWith(this);
        when(this._commandEnabled).changes(enabled => this.updateEnabledState(enabled), {
            initialValue: 'triggerChange'
        });
    }
    updateEnabledState(enabled) {
        // for some reason mat-buttons kills the disabled host binding.  It works on a regular button but for now
        // we need to do this. The set timeout is required to prevent the button getting a expression changed
        // when it's clicked.
        if (this.matControl) {
            setTimeout(() => {
                this.matControl.disabled = !enabled;
            }, 0);
        }
        if (!enabled) {
            // Note:
            // We can't use a host binding here for disabled as the directive can be used on arbitrary
            // components (e.g. divs) and the compiler will barf if we use the host binding.
            this.elementRef.nativeElement.setAttribute('disabled', 'disabled');
            if (this.elementRef.nativeElement.tagName === 'A') {
                this.elementRef.nativeElement.removeAttribute('href');
            }
        }
        else {
            this.elementRef.nativeElement.removeAttribute('disabled');
            if (this.elementRef.nativeElement.tagName === 'A') {
                this.elementRef.nativeElement.setAttribute('href', 'javascript:void');
            }
        }
    }
    ngOnDestroy() {
        this.dispose();
    }
    notifyClick($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.pectinCommand.enabled$.value) {
            if (this.pectinCommand instanceof UnaryCommand) {
                this.pectinCommand.withContext({ event: $event }).execute(this.commandParameter);
            }
            else {
                this.pectinCommand.withContext({ event: $event }).execute();
            }
        }
        else {
            console.warn('disabled command clicked, ignoring.');
        }
    }
}
CommandDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandDirective, deps: [{ token: ElementRef }, { token: i2.MatButton, host: true, optional: true }, { token: i3.MatMenuItem, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
CommandDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: CommandDirective, selector: "[pectinCommand]", inputs: { pectinCommand: "pectinCommand", commandParameter: "commandParameter" }, host: { listeners: { "click": "notifyClick($event)" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[pectinCommand]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: i2.MatButton, decorators: [{
                    type: Host
                }, {
                    type: Optional
                }] }, { type: i3.MatMenuItem, decorators: [{
                    type: Host
                }, {
                    type: Optional
                }] }]; }, propDecorators: { pectinCommand: [{
                type: Input
            }], commandParameter: [{
                type: Input
            }], notifyClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class DisposableComponent extends GarbageCollector {
    ngOnDestroy() {
        this.dispose();
    }
}
DisposableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DisposableComponent, deps: null, target: i0.ɵɵFactoryTarget.Directive });
DisposableComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: DisposableComponent, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DisposableComponent, decorators: [{
            type: Directive
        }] });

let FocusBinding = class FocusBinding extends GarbageCollector {
    // TODO: update to support alternate focus mechanisms so we can interoperate with mat-checkbox
    constructor(focusTargetElement, ngZone, document, focusContext) {
        super();
        this.focusTargetElement = focusTargetElement;
        this.ngZone = ngZone;
        this.focusContext = focusContext;
        // @see https://stackoverflow.com/questions/49513359/could-not-resolve-type-document-in-angular5/53715642#53715642
        this.document = document;
        // TODO: Make this also track the current enabled/disabled state.
        const { when } = Dsl.disposeWith(this);
        when(this.focusContext.focused).changes((focused) => {
            if (focused && !this.alreadyHasFocus()) {
                this.tryAndFocus();
            }
        }, { initialValue: 'triggerChangeUnlessNil' });
    }
    onFocusIn() {
        this.focusContext.notifyFocusIn();
    }
    onFocusOut() {
        this.focusContext.notifyFocusOut();
    }
    // Hook method for debugging via tracing.
    alreadyHasFocus() {
        return this.isElementFocused(this.focusTarget);
    }
    // Hook method for debugging via tracing.
    isElementFocused(element) {
        return this.document.activeElement === element;
    }
    tryAndFocus(retries = 5) {
        if (this.modelShouldStillHaveFocus() && this.canFocus()) {
            if (!this.alreadyHasFocus()) {
                this.focusTarget.focus();
            }
            // if we didn't get the focus we try again later.
            if (!this.alreadyHasFocus()) {
                Logger.get(this).log(`focus failed, trying ${retries} more times`);
                if (retries > 0) {
                    // try again on the next paint
                    // TODO: is there an angular way of doing this without calling a window function.
                    requestAnimationFrame(() => {
                        this.tryAndFocus(retries - 1);
                    });
                }
                else {
                    Logger.get(this).warn(`Tried to focus but gave up as the component wasn't enabled or visible.`);
                }
            }
        }
    }
    get focusTarget() {
        return this.focusTargetElement;
    }
    // Hook method for debugging via tracing.
    modelShouldStillHaveFocus() {
        return this.focusContext.focused.value;
    }
    // Hook method for debugging via tracing.
    canFocus() {
        const dimension = this.focusTarget.getBoundingClientRect();
        const hasSize = dimension.height >= 0 && dimension.height >= 0;
        // tslint:disable-next-line:no-string-literal
        return hasSize && !this.focusTarget['disabled'];
    }
};
FocusBinding = __decorate([
    __param(1, Inject(NgZone)),
    __param(2, Inject(DOCUMENT)),
    __metadata("design:paramtypes", [HTMLElement,
        NgZone, Object, Object])
], FocusBinding);

class FocusBindingFactory {
    constructor(ngZone, document) {
        this.ngZone = ngZone;
        // @see https://stackoverflow.com/questions/49513359/could-not-resolve-type-document-in-angular5/53715642#53715642
        this.document = document;
    }
    // @Trace()
    createBinding(el, focusContext) {
        return new FocusBinding(el, this.ngZone, this.document, focusContext);
    }
}
FocusBindingFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusBindingFactory, deps: [{ token: NgZone }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
FocusBindingFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusBindingFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusBindingFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i0.NgZone, decorators: [{
                    type: Inject,
                    args: [NgZone]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

class FocusBindingDirective extends DisposableComponent {
    constructor(el, focusBindingFactory) {
        super();
        this.el = el;
        this.focusBindingFactory = focusBindingFactory;
    }
    onFocusIn() {
        if (this.hasBinding()) {
            this.pectinFocusBinding.notifyFocusIn();
        }
    }
    onFocusOut() {
        if (this.hasBinding()) {
            this.pectinFocusBinding.notifyFocusOut();
        }
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        if (this.hasBinding()) {
            this.registerDisposable(this.focusBindingFactory.createBinding(this.focusTarget, this.pectinFocusBinding));
        }
        else {
            Logger.get(this).warn('pectinFocusBinding was nil');
        }
    }
    hasBinding() {
        return !!this.pectinFocusBinding && !!this.pectinFocusBinding;
    }
    get focusTarget() {
        return this.focusBindingTarget || this.el.nativeElement;
    }
}
FocusBindingDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusBindingDirective, deps: [{ token: ElementRef }, { token: FocusBindingFactory }], target: i0.ɵɵFactoryTarget.Directive });
FocusBindingDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: { pectinFocusBinding: "pectinFocusBinding", focusBindingTarget: "focusBindingTarget" }, host: { listeners: { "focusin": "onFocusIn()", "focusout": "onFocusOut()" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusBindingDirective, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[pectinFocusBinding]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef, decorators: [{
                    type: Inject,
                    args: [ElementRef]
                }] }, { type: FocusBindingFactory }]; }, propDecorators: { pectinFocusBinding: [{
                type: Input
            }], focusBindingTarget: [{
                type: Input
            }], onFocusIn: [{
                type: HostListener,
                args: ['focusin']
            }], onFocusOut: [{
                type: HostListener,
                args: ['focusout']
            }] } });

class HighlightTextModelDirective extends GarbageCollector {
    constructor() {
        super();
    }
    ngOnDestroy() {
        this.dispose();
    }
}
HighlightTextModelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HighlightTextModelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
HighlightTextModelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: HighlightTextModelDirective, selector: "[aupHighlightTextModel]", inputs: { aupHighlightTextModel: "aupHighlightTextModel" }, usesInheritance: true, ngImport: i0 });
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], HighlightTextModelDirective.prototype, "aupHighlightTextModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HighlightTextModelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aupHighlightTextModel]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { aupHighlightTextModel: [{
                type: Input
            }] } });

class HighlightPipe extends GarbageCollector {
    constructor(sanitizer, highlightContext) {
        super();
        this.sanitizer = sanitizer;
        this.highlightContext = highlightContext;
    }
    ngOnDestroy() {
        this.dispose();
    }
    transform(value, searchModel) {
        const model = searchModel ?? this.highlightContext?.aupHighlightTextModel;
        const searchText = model?.value;
        if (isEmpty(searchText) || !isString(value)) {
            return value;
        }
        // Match in a case insensitive manner
        const re = new RegExp(escapeStringRegexp(searchText), 'gi');
        const match = value.match(re);
        // If there's no match, just return the original value.
        if (!match) {
            return value;
        }
        const result = value.replace(re, '<mark>' + match[0] + '</mark>');
        return this.sanitizer.bypassSecurityTrustHtml(result);
    }
}
HighlightPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HighlightPipe, deps: [{ token: i1.DomSanitizer }, { token: HighlightTextModelDirective, optional: true }], target: i0.ɵɵFactoryTarget.Pipe });
HighlightPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: HighlightPipe, name: "aupHighlight", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: HighlightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'aupHighlight',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }, { type: HighlightTextModelDirective, decorators: [{
                    type: Optional
                }] }]; } });

/**
 * Attaches a garbage collector that will be disposed with the directive.  The main use case for it is
 * providing a disposal hook when using command factories.
 *
 * @example
 * <a *ngFor="let item of menuItems.value"
 *    aup-gc #gc="aup-gc"
 *    [pectinCommand]="commandFactory.create(item.place, gc)"
 * </a>
 *
 */
class GarbageCollectorDirective extends GarbageCollector {
    constructor() {
        super();
    }
    ngOnDestroy() {
        this.dispose();
    }
}
GarbageCollectorDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: GarbageCollectorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
GarbageCollectorDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: GarbageCollectorDirective, selector: "[aup-gc]", exportAs: ["aup-gc"], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: GarbageCollectorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aup-gc]',
                    exportAs: "aup-gc"
                }]
        }], ctorParameters: function () { return []; } });

class DirectivesModule {
}
DirectivesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DirectivesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DirectivesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: DirectivesModule, declarations: [CommandDirective,
        FocusBindingDirective,
        HighlightPipe,
        HighlightTextModelDirective,
        GarbageCollectorDirective], imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule], exports: [CommandDirective,
        FocusBindingDirective,
        HighlightPipe,
        HighlightTextModelDirective,
        GarbageCollectorDirective] });
DirectivesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DirectivesModule, imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DirectivesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CommandDirective,
                        FocusBindingDirective,
                        HighlightPipe,
                        HighlightTextModelDirective,
                        GarbageCollectorDirective
                    ],
                    imports: [
                        CommonModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatTabsModule
                    ],
                    exports: [
                        CommandDirective,
                        FocusBindingDirective,
                        HighlightPipe,
                        HighlightTextModelDirective,
                        GarbageCollectorDirective
                    ]
                }]
        }] });

const markdownPillExtension = (renderPill) => {
    return {
        name: 'aup-pill',
        level: 'inline',
        start: (src) => {
            const index = src.match(/\(\([^)]/)?.index;
            // if (index) {
            //     console.log({start:src})
            // }
            return index;
        },
        tokenizer: function (src) {
            const rule = /^(\(\((([^)])+)\)\))/; // Regex for the complete token
            const match = rule.exec(src);
            if (match) {
                const token = {
                    type: 'aup-pill',
                    raw: match[0],
                    text: match[2].trim(), // Additional custom properties
                    // tokens: []              // Array where child inline tokens will be generated
                };
                // console.log(token)
                // this.lexer.inlineTokens(token.text, token.tokens);    // Queue this data to be processed for inline tokens
                return token;
            }
            else {
                return undefined;
            }
        },
        renderer: function (token) {
            // @ts-ignore (until typings are up to date)
            const url = token.text;
            return renderPill(token.text);
        }
    };
};

class MarkdownService {
    constructor() {
    }
    render(content) {
        return marked.parse(content, {
            smartLists: true
        });
    }
    renderInline(content) {
        return marked.parseInline(content);
    }
    usePillExtension(renderer) {
        marked.use({
            extensions: [markdownPillExtension(renderer ?? (text => `<span class='aup-pill'>${text}<span>`))]
        });
    }
}
MarkdownService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MarkdownService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
MarkdownService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MarkdownService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MarkdownService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return []; } });

class BusyOverlayComponent extends GarbageCollector {
    constructor() {
        super();
    }
    ngOnInit() {
    }
}
BusyOverlayComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: BusyOverlayComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BusyOverlayComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: BusyOverlayComponent, selector: "aup-busy-overlay", inputs: { busyModel: "busyModel", busy: "busy" }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n<div class=\"busy-overlay-backdrop\" *ngIf=\"busyModel.value\">\n  <mat-progress-spinner mode=\"indeterminate\" [diameter]=\"52\"></mat-progress-spinner>\n</div>\n", styles: [":host{position:relative;display:flex;flex-direction:column;align-items:stretch}div.busy-overlay-backdrop{z-index:var(--aup-busy-overlay-z-index, 10);position:absolute;background-color:#0003;top:0;left:0;bottom:0;right:0;display:grid;grid-template-columns:auto;grid-template-rows:auto;place-content:center}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$1.MatProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], BusyOverlayComponent.prototype, "busyModel", void 0);
__decorate([
    StoreInValueModel('busyModel'),
    __metadata("design:type", Boolean)
], BusyOverlayComponent.prototype, "busy", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: BusyOverlayComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-busy-overlay', template: "<ng-content></ng-content>\n<div class=\"busy-overlay-backdrop\" *ngIf=\"busyModel.value\">\n  <mat-progress-spinner mode=\"indeterminate\" [diameter]=\"52\"></mat-progress-spinner>\n</div>\n", styles: [":host{position:relative;display:flex;flex-direction:column;align-items:stretch}div.busy-overlay-backdrop{z-index:var(--aup-busy-overlay-z-index, 10);position:absolute;background-color:#0003;top:0;left:0;bottom:0;right:0;display:grid;grid-template-columns:auto;grid-template-rows:auto;place-content:center}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { busyModel: [{
                type: Input
            }], busy: [{
                type: Input
            }] } });

var CommandFace;
(function (CommandFace) {
    let Position;
    (function (Position) {
        Position["START"] = "start";
        Position["END"] = "end";
    })(Position = CommandFace.Position || (CommandFace.Position = {}));
    CommandFace.Style = Enum({
        FLAT: 'flat',
        STROKED: 'stroked',
        RAISED: 'raised'
    });
    function getColorOf(face) {
        return isFunction(face?.color) ? face.color() : undefined;
    }
    CommandFace.getColorOf = getColorOf;
    function getStyleOf(face) {
        return isFunction(face?.style) ? face.style() : undefined;
    }
    CommandFace.getStyleOf = getStyleOf;
    function getIconOf(face) {
        return isFunction(face?.icon) ? face.icon() : undefined;
    }
    CommandFace.getIconOf = getIconOf;
    function getIconPositionOf(face) {
        return isFunction(face?.iconPosition) ? face.iconPosition() : undefined;
    }
    CommandFace.getIconPositionOf = getIconPositionOf;
    function getTooltipOf(face) {
        return isFunction(face?.tooltip) ? face.tooltip() : undefined;
    }
    CommandFace.getTooltipOf = getTooltipOf;
    function getTextOf(face) {
        return isFunction(face?.text) ? face.text() : undefined;
    }
    CommandFace.getTextOf = getTextOf;
    class Adapter {
        constructor(face) {
            this.face = face;
        }
        get text() {
            return CommandFace.getTextOf(this.face);
        }
        get icon() {
            return CommandFace.getIconOf(this.face);
        }
        get iconPosition() {
            return CommandFace.getIconPositionOf(this.face);
        }
        get tooltip() {
            return CommandFace.getTooltipOf(this.face);
        }
        get iconPositionStart() {
            return this.iconPosition === CommandFace.Position.START;
        }
        get iconPositionEnd() {
            return this.iconPosition === CommandFace.Position.END;
        }
        get color() {
            return CommandFace.getColorOf(this.face);
        }
        get style() {
            return CommandFace.getStyleOf(this.face);
        }
    }
    __decorate([
        Memoize(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "text", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "icon", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "iconPosition", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "tooltip", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "iconPositionStart", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "iconPositionEnd", null);
    __decorate([
        Memoize(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "color", null);
    __decorate([
        Memoize(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], Adapter.prototype, "style", null);
    CommandFace.Adapter = Adapter;
})(CommandFace || (CommandFace = {}));

class AbstractCardContainerComponent extends DisposableComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
}
AbstractCardContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractCardContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AbstractCardContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractCardContainerComponent, selector: "aup-abstract-card-container", inputs: { addCardCommand: "addCardCommand", addCardFace: "addCardFace" }, queries: [{ propertyName: "addCardTemplate", first: true, predicate: ["addCardTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], AbstractCardContainerComponent.prototype, "addCardCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractCardContainerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'aup-abstract-card-container',
                    template: '',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { addCardCommand: [{
                type: Input
            }], addCardFace: [{
                type: Input
            }], addCardTemplate: [{
                type: ContentChild,
                args: ['addCardTemplate']
            }] } });

class ScrollContainerComponent extends DisposableComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
}
ScrollContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ScrollContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ScrollContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ScrollContainerComponent, selector: "aup-scroll-container", inputs: { disableScroll$: "disableScroll$", disableScroll: "disableScroll" }, host: { properties: { "class.disable-scroll": "this.disableScroll" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"scroll-container\" cdkScrollable>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host:not(.disable-scroll){min-height:0}:host:not(.disable-scroll)>.scroll-container{flex-basis:0;overflow-y:scroll;align-items:stretch}:host>.scroll-container{display:flex;flex-direction:column;flex:1}\n"], dependencies: [{ kind: "directive", type: i1$2.CdkScrollable, selector: "[cdk-scrollable], [cdkScrollable]" }] });
__decorate([
    TrackExternal({ defaultValue: false }),
    __metadata("design:type", ValueModel)
], ScrollContainerComponent.prototype, "disableScroll$", void 0);
__decorate([
    StoreInValueModel("disableScroll$"),
    __metadata("design:type", Boolean)
], ScrollContainerComponent.prototype, "disableScroll", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ScrollContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-scroll-container", template: "<div class=\"scroll-container\" cdkScrollable>\n  <ng-content></ng-content>\n</div>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host:not(.disable-scroll){min-height:0}:host:not(.disable-scroll)>.scroll-container{flex-basis:0;overflow-y:scroll;align-items:stretch}:host>.scroll-container{display:flex;flex-direction:column;flex:1}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { disableScroll$: [{
                type: Input
            }], disableScroll: [{
                type: Input
            }, {
                type: HostBinding,
                args: ["class.disable-scroll"]
            }] } });

class IconComponent {
    constructor() {
        this.allowedPrefixes = Enum.values(IconComponent.IconPrefix).map(p => `${p}:`);
        this.iconPrefix = IconComponent.IconPrefix;
    }
    set icon(iconName) {
        this._icon = iconName;
        if (!iconName) {
            this.errorMessage = 'icon is nil';
            this.prefix = undefined;
            return;
        }
        const colonIndex = iconName.indexOf(':');
        if (colonIndex > 0) {
            this.prefix = this.icon.slice(0, colonIndex);
            this.suffix = this.icon.slice(colonIndex + 1);
        }
        if (this.prefix) {
            this.errorMessage = `Unknown icon "${iconName}"`;
        }
        this.errorMessage = `Unknown icon prefix, expected one of [${this.allowedPrefixes.join(',')}] got "${this.prefix}:"`;
    }
    get icon() {
        return this._icon;
    }
    get faIcon() {
        return `fa-${this.suffix}`;
    }
}
IconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: IconComponent, selector: "aup-icon", inputs: { icon: "icon" }, ngImport: i0, template: "<ng-container [ngSwitch]=\"prefix\">\n\n  <mat-icon *ngSwitchCase=\"iconPrefix.SVG\"\n            [svgIcon]=\"suffix\"\n            class=\"svgIcon\">\n  </mat-icon>\n\n  <mat-icon *ngSwitchCase=\"iconPrefix.MATERIAL\">\n    {{suffix}}\n  </mat-icon>\n\n  <div *ngSwitchCase=\"iconPrefix.FONT_AWESOME\" class=\"faIconWrapper\">\n    <i class=\"fa-solid\" [class]=\"faIcon\"></i>\n  </div>\n\n  <mat-icon *ngSwitchDefault\n            [matTooltip]=\"errorMessage\">\n    bug_report\n  </mat-icon>\n\n</ng-container>\n\n", styles: [":host{display:inline-flex;width:24px}fa-icon{vertical-align:middle}.faIconWrapper{display:flex;flex-direction:row;align-items:center;justify-content:center;width:24px;height:24px}.svgIcon{width:24px;height:24px}:host(.mat-chip-remove) mat-icon{font-size:18px}mat-icon{width:inherit;height:inherit;margin-right:0!important}\n"], dependencies: [{ kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i2$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-icon', template: "<ng-container [ngSwitch]=\"prefix\">\n\n  <mat-icon *ngSwitchCase=\"iconPrefix.SVG\"\n            [svgIcon]=\"suffix\"\n            class=\"svgIcon\">\n  </mat-icon>\n\n  <mat-icon *ngSwitchCase=\"iconPrefix.MATERIAL\">\n    {{suffix}}\n  </mat-icon>\n\n  <div *ngSwitchCase=\"iconPrefix.FONT_AWESOME\" class=\"faIconWrapper\">\n    <i class=\"fa-solid\" [class]=\"faIcon\"></i>\n  </div>\n\n  <mat-icon *ngSwitchDefault\n            [matTooltip]=\"errorMessage\">\n    bug_report\n  </mat-icon>\n\n</ng-container>\n\n", styles: [":host{display:inline-flex;width:24px}fa-icon{vertical-align:middle}.faIconWrapper{display:flex;flex-direction:row;align-items:center;justify-content:center;width:24px;height:24px}.svgIcon{width:24px;height:24px}:host(.mat-chip-remove) mat-icon{font-size:18px}mat-icon{width:inherit;height:inherit;margin-right:0!important}\n"] }]
        }], propDecorators: { icon: [{
                type: Input
            }] } });
(function (IconComponent) {
    IconComponent.IconPrefix = Enum({
        SVG: 'svg',
        FONT_AWESOME: 'fa',
        MATERIAL: 'mat'
    });
})(IconComponent || (IconComponent = {}));

/**
 * Custom CSS:
 * @example
 * root: { // globally
 *   --aup-command-face-icon-gap: 8px;
 * }
 * aup-command-face { // per instance
 *   --icon-gap: 4px;
 * }
 */
class CommandFaceComponent extends DisposableComponent {
    constructor() {
        super();
        this.facesModel = new MutableListModel();
        this.ignoreIcon = false;
        this.ignoreText = false;
        this.includeMissingIconInLayout = false;
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.faceAdapters = chain(this.facesModel).map(face => new CommandFace.Adapter(face));
        const activeFace = this.faceAdapters.first();
        this.activeIcon = activeFace.pluck("icon");
        this.activeColor = activeFace.pluck("color");
    }
    set face(face) {
        this.facesModel.value = [face];
    }
    get requiresMissingIconInLayout() {
        return this.includeMissingIconInLayout && !this.activeIcon.value;
    }
    ngOnInit() {
    }
    shouldIncludeIcon(face) {
        return (!this.ignoreIcon && face.icon) || this.includeMissingIconInLayout;
    }
    hasIconStart(face) {
        return this.shouldIncludeIcon(face) && (!face.iconPosition || face.iconPosition === CommandFace.Position.START);
    }
    hasIconEnd(face) {
        return this.shouldIncludeIcon(face) && face.iconPosition === CommandFace.Position.END;
    }
    get color() {
        return this.activeColor.value;
    }
}
CommandFaceComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandFaceComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CommandFaceComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: CommandFaceComponent, selector: "aup-command-face", inputs: { _rawFaces: ["faces", "_rawFaces"], face: "face", ignoreIcon: "ignoreIcon", ignoreText: "ignoreText", includeMissingIconInLayout: "includeMissingIconInLayout" }, host: { properties: { "class.hide-icon": "this.requiresMissingIconInLayout", "attr.color": "this.color" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"face-container\" *ngFor=\"let face of faceAdapters.value\">\n  <aup-icon *ngIf=\"hasIconStart(face)\" [icon]=\"face.icon\"></aup-icon>\n  <span *ngIf=\"face.text\">{{face.text}}</span>\n  <aup-icon *ngIf=\"hasIconEnd(face)\" [icon]=\"face.icon\"></aup-icon>\n</div>\n", styles: ["aup-command-face{--icon-gap: var(--aup-command-face-icon-gap);display:inline-grid}aup-command-face>.face-container{grid-column:1;grid-row:1;display:inline-flex;flex-direction:row;align-items:center}aup-command-face>.face-container:not(:first-child){visibility:hidden}aup-command-face>.face-container *+*{margin-left:var(--icon-gap)}aup-command-face.hide-icon aup-icon{visibility:hidden}aup-command-face.centered{justify-items:center}aup-command-face.start{justify-items:self-start}aup-command-face.end{justify-items:self-end}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    StoreInListModel('facesModel'),
    __metadata("design:type", Array)
], CommandFaceComponent.prototype, "_rawFaces", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandFaceComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-command-face', encapsulation: ViewEncapsulation.None, template: "<div class=\"face-container\" *ngFor=\"let face of faceAdapters.value\">\n  <aup-icon *ngIf=\"hasIconStart(face)\" [icon]=\"face.icon\"></aup-icon>\n  <span *ngIf=\"face.text\">{{face.text}}</span>\n  <aup-icon *ngIf=\"hasIconEnd(face)\" [icon]=\"face.icon\"></aup-icon>\n</div>\n", styles: ["aup-command-face{--icon-gap: var(--aup-command-face-icon-gap);display:inline-grid}aup-command-face>.face-container{grid-column:1;grid-row:1;display:inline-flex;flex-direction:row;align-items:center}aup-command-face>.face-container:not(:first-child){visibility:hidden}aup-command-face>.face-container *+*{margin-left:var(--icon-gap)}aup-command-face.hide-icon aup-icon{visibility:hidden}aup-command-face.centered{justify-items:center}aup-command-face.start{justify-items:self-start}aup-command-face.end{justify-items:self-end}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { _rawFaces: [{
                type: Input,
                args: ['faces']
            }], face: [{
                type: Input
            }], ignoreIcon: [{
                type: Input
            }], ignoreText: [{
                type: Input
            }], includeMissingIconInLayout: [{
                type: Input
            }], requiresMissingIconInLayout: [{
                type: HostBinding,
                args: ['class.hide-icon']
            }], color: [{
                type: HostBinding,
                args: ['attr.color']
            }] } });

/**
 * @example
 * // basic usage
 * <aup-card-container>
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-container>
 *
 * // adds an add button with a the '+' icon to the end of the card list.
 * <aup-card-container [addCardCommand]="addCard">
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-container>
 *
 * // adds an add button with the specified face
 * <aup-card-container [addCardCommand]="addCard" [addCardFace]="i18n.addCard" >
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-container>
 *
 * // use the aup-add-card-activity to display as the new card place holder and to run
 * // the activity inside teh card
 * <aup-card-container [addCardCommand]="addCard" [addCardFace]="i18n.addCard" >
 *   <my-card *ngFor="..."></my-card>
 *   <aup-add-card-activity type="inline" renderAs="card" [face]="i18n.commands.addModal" [activityClass]="AddCardActivity"></aup-add-card-activity>
 * </aup-card-container>
 *
 * // adds an add card component using the specified template.  The template
 * // will fill it's container in the grid.
 * <aup-card-container>
 *   <my-card *ngFor="..."></my-card>
 *   <ng-template #addCardTemplate>
 *     <div>This is a new card template, it will the the size of the other cards.</div>
 *   </ng-template>
 * </aup-card-container>
 *
 * // sing the default new card styles for your template
 * @import "../../../../assets/styles";
 * .my-new-card {
 *   @include aup-card-container-new-card-style();
 *   // OR
 *   @include aup-card-container-new-card-style(
 *      $color: rgba(0,0,0,0.54),
 *      $background-color: rgba(255,255,255,0.8),
 *      $hover-color: $color,
 *      $background-hover-color: white
 *   )
 * }
 * <aup-card-container>
 *   <my-card *ngFor="..."></my-card>
 *   <ng-template #addCardTemplate>
 *     <div class="my-new-card" >This is a new card template, it will the the size of the other cards.</div>
 *   </ng-template>
 * </aup-card-container>
 *
 * // CSS Vars
 * aup-card-container {
 *   --card-gap: var(--card-gap, 16px);
 *   --card-width: var(--card-width, 300px);
 *   --card-max-width: auto;
 *   --card-height: var(--card-height, auto);
 *   --card-min-height: var(--card-min-height, auto);
 *   --card-background: var(--card-background, #fcfcfb);
 * }
 */
class CardContainerComponent extends AbstractCardContainerComponent {
    constructor(elementRef) {
        super();
        this.elementRef = elementRef;
        /**
         * Enable scrolling.  If true the container will have height==0 so you must set it's height explicitly
         * or place in a layout that will stretch it such as a grid or flex layout.
         */
        this.enabledScroll = false;
    }
    set columnCount(count) {
        if (!isNil(count) && (!isInteger(count) || count < 1)) {
            lang$1.illegalState('columnCount must be a positive integer or nil');
        }
        this._columnCount = count;
        this.updateColumnCountStyles();
    }
    get columnCount() {
        return this._columnCount;
    }
    ngOnInit() {
        super.ngOnInit();
        this.updateColumnCountStyles();
    }
    get isAutoColumns() {
        return isNil(this._columnCount);
    }
    get isSingleColumn() {
        return this._columnCount === 1;
    }
    updateColumnCountStyles() {
        const el = this.elementRef.nativeElement;
        if (isNil(this._columnCount)) {
            el.style.setProperty('--aup-card-container-column-count', '');
        }
        else {
            el.style.setProperty('--aup-card-container-column-count', this._columnCount);
        }
    }
}
CardContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CardContainerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
CardContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: CardContainerComponent, selector: "aup-card-container", inputs: { columnCount: "columnCount", enabledScroll: "enabledScroll" }, host: { properties: { "class.auto-columns": "this.isAutoColumns", "class.single-column": "this.isSingleColumn" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"header-container\">\n  <ng-content select=\"[card-container-header]\"></ng-content>\n</div>\n\n<ng-template #content>\n  <div class=\"card-container\">\n    <ng-content></ng-content>\n\n    <div class=\"add-card-container\" *ngIf=\"addCardCommand.enabled$.value\" [pectinCommand]=\"addCardCommand\">\n      <aup-command-face *ngIf=\"addCardFace\" [faces]=\"[addCardFace]\"></aup-command-face>\n      <aup-icon *ngIf=\"!addCardFace\" icon=\"mat:add\"></aup-icon>\n    </div>\n\n    <div class=\"add-card-template\" *ngIf=\"addCardTemplate\">\n      <ng-container [ngTemplateOutlet]=\"addCardTemplate\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<div class=\"no-scroll-container\" *ngIf=\"!enabledScroll\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n\n<aup-scroll-container *ngIf=\"enabledScroll\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</aup-scroll-container>\n\n<div class=\"footer-container\">\n  <ng-content select=\"[card-container-footer]\"></ng-content>\n</div>\n\n", styles: [":host{--resolved-card-gap: var(--card-gap, 16px);--resolved-card-width: var(--card-width, 300px);--resolved-card-max-width: var(--card-max-width, auto);--resolved-card-height: var(--card-height, auto);--resolved-card-min-height: var(--card-min-height, auto);--resolved-card-background: var(--card-background, var(--aup-card-container-default-background-color));flex:1;display:flex;flex-direction:column;align-items:stretch;background:var(--resolved-card-background)}:host.auto-columns .card-container{grid-template-columns:repeat(auto-fit,minmax(var(--resolved-card-width),var(--resolved-card-max-width)));min-width:calc(var(--resolved-card-width) + 2 * var(--resolved-card-gap));width:calc((var(--resolved-card-width) + var(--resolved-card-gap)) * 2 + var(--grid-gap))}:host:not(.auto-columns) .card-container{grid-template-columns:repeat(var(--aup-card-container-column-count),1fr)}.card-container{display:grid;box-sizing:border-box;padding:var(--resolved-card-gap);min-height:calc(var(--resolved-card-height) + 2 * var(--resolved-card-gap));max-width:100%;grid-auto-rows:minmax(var(--resolved-card-min-height),var(--resolved-card-height));grid-gap:var(--resolved-card-gap)}aup-scroll-container,.no-scroll-container{flex:1}.add-card-container{height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:center;justify-content:center;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}.add-card-container mat-icon{font-size:200%}.add-card-container:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.add-card-container:hover{border-color:transparent;background-color:#fff;color:#0000008a}.add-card-template-container{height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:stretch;justify-content:stretch}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: ScrollContainerComponent, selector: "aup-scroll-container", inputs: ["disableScroll$", "disableScroll"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CardContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-card-container', template: "<div class=\"header-container\">\n  <ng-content select=\"[card-container-header]\"></ng-content>\n</div>\n\n<ng-template #content>\n  <div class=\"card-container\">\n    <ng-content></ng-content>\n\n    <div class=\"add-card-container\" *ngIf=\"addCardCommand.enabled$.value\" [pectinCommand]=\"addCardCommand\">\n      <aup-command-face *ngIf=\"addCardFace\" [faces]=\"[addCardFace]\"></aup-command-face>\n      <aup-icon *ngIf=\"!addCardFace\" icon=\"mat:add\"></aup-icon>\n    </div>\n\n    <div class=\"add-card-template\" *ngIf=\"addCardTemplate\">\n      <ng-container [ngTemplateOutlet]=\"addCardTemplate\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n\n<div class=\"no-scroll-container\" *ngIf=\"!enabledScroll\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</div>\n\n<aup-scroll-container *ngIf=\"enabledScroll\">\n    <ng-container *ngTemplateOutlet=\"content\"></ng-container>\n</aup-scroll-container>\n\n<div class=\"footer-container\">\n  <ng-content select=\"[card-container-footer]\"></ng-content>\n</div>\n\n", styles: [":host{--resolved-card-gap: var(--card-gap, 16px);--resolved-card-width: var(--card-width, 300px);--resolved-card-max-width: var(--card-max-width, auto);--resolved-card-height: var(--card-height, auto);--resolved-card-min-height: var(--card-min-height, auto);--resolved-card-background: var(--card-background, var(--aup-card-container-default-background-color));flex:1;display:flex;flex-direction:column;align-items:stretch;background:var(--resolved-card-background)}:host.auto-columns .card-container{grid-template-columns:repeat(auto-fit,minmax(var(--resolved-card-width),var(--resolved-card-max-width)));min-width:calc(var(--resolved-card-width) + 2 * var(--resolved-card-gap));width:calc((var(--resolved-card-width) + var(--resolved-card-gap)) * 2 + var(--grid-gap))}:host:not(.auto-columns) .card-container{grid-template-columns:repeat(var(--aup-card-container-column-count),1fr)}.card-container{display:grid;box-sizing:border-box;padding:var(--resolved-card-gap);min-height:calc(var(--resolved-card-height) + 2 * var(--resolved-card-gap));max-width:100%;grid-auto-rows:minmax(var(--resolved-card-min-height),var(--resolved-card-height));grid-gap:var(--resolved-card-gap)}aup-scroll-container,.no-scroll-container{flex:1}.add-card-container{height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:center;justify-content:center;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}.add-card-container mat-icon{font-size:200%}.add-card-container:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.add-card-container:hover{border-color:transparent;background-color:#fff;color:#0000008a}.add-card-template-container{height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:stretch;justify-content:stretch}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { columnCount: [{
                type: Input
            }], enabledScroll: [{
                type: Input
            }], isAutoColumns: [{
                type: HostBinding,
                args: ['class.auto-columns']
            }], isSingleColumn: [{
                type: HostBinding,
                args: ['class.single-column']
            }] } });

/**
 * @deprecated deprecated, use `aup-card-container [columnCount]="1"` instead.
 * @example
 * // basic usage
 * <aup-card-stack>
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-stack>
 *
 * // adds an add button with a the '+' icon to the end of the card list.
 * <aup-card-stack [addCardCommand]="addCard">
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-stack>
 *
 * // adds an add button with the specified face
 * <aup-card-stack [addCardCommand]="addCard" [addCardFace]="i18n.addCard" >
 *   <my-card *ngFor="..."></my-card>
 * </aup-card-stack>
 *
 * // use the aup-add-card-activity to display as the new card place holder and to run
 * // the activity inside teh card
 * <aup-card-stack [addCardCommand]="addCard" [addCardFace]="i18n.addCard" >
 *   <my-card *ngFor="..."></my-card>
 *   <aup-add-card-activity type="inline" renderAs="card" [face]="i18n.commands.addModal" [activityClass]="AddCardActivity"></aup-add-card-activity>
 * </aup-card-stack>
 *
 * // adds an add card component using the specified template.  The template
 * // will fill it's container in the grid.
 * <aup-card-stack>
 *   <my-card *ngFor="..."></my-card>
 *   <ng-template #addCardTemplate>
 *     <div>This is a new card template, it will the the size of the other cards.</div>
 *   </ng-template>
 * </aup-card-stack>
 *
 * // sing the default new card styles for your template
 * @import "../../../../assets/styles";
 * .my-new-card {
 *   @include aup-card-stack-new-card-style();
 *   // OR
 *   @include aup-card-stack-new-card-style(
 *      $color: rgba(0,0,0,0.54),
 *      $background-color: rgba(255,255,255,0.8),
 *      $hover-color: $color,
 *      $background-hover-color: white
 *   )
 * }
 * <aup-card-stack>
 *   <my-card *ngFor="..."></my-card>
 *   <ng-template #addCardTemplate>
 *     <div class="my-new-card" >This is a new card template, it will the the size of the other cards.</div>
 *   </ng-template>
 * </aup-card-stack>
 *
 * // CSS Vars
 * aup-card-stack {
 *   --card-gap: var(--card-gap, 16px);
 *   --card-height: var(--card-height, auto);
 *   --card-min-height: var(--card-min-height, auto);
 *   --card-background: var(--card-background, #fcfcfb);
 * }
 */
class CardStackComponent extends AbstractCardContainerComponent {
    constructor() {
        super();
        console.warn('<aup-card-stack></aup-card-stack> is deprecated.  Use <aup-card-container [columnCount]="1"> instead.');
    }
}
CardStackComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CardStackComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CardStackComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: CardStackComponent, selector: "aup-card-stack", usesInheritance: true, ngImport: i0, template: "<div class=\"card-container\">\n  <ng-content></ng-content>\n</div>\n<div class=\"footer\">\n  <div class=\"add-card-container\" *ngIf=\"addCardCommand.enabled$.value\" [pectinCommand]=\"addCardCommand\">\n    <aup-command-face *ngIf=\"addCardFace\" [faces]=\"[addCardFace]\"></aup-command-face>\n    <aup-icon *ngIf=\"!addCardFace\" icon=\"mat:add\"></aup-icon>\n  </div>\n\n  <div class=\"add-card-template\" *ngIf=\"addCardTemplate\">\n    <ng-container [ngTemplateOutlet]=\"addCardTemplate\"></ng-container>\n  </div>\n  <ng-content select=\"[aup-card-stack-footer]\"></ng-content>\n</div>\n", styles: [":host{--resolved-card-gap: var(--card-gap, 16px);--resolved-card-height: var(--card-height, auto);--resolved-card-min-height: var(--card-min-height, auto);--resolved-card-background: var(--card-background, #fcfcfb);flex:1;display:block;background:var(--resolved-card-background)}.card-container{display:grid;grid-template-columns:1fr;grid-auto-rows:minmax(var(--resolved-card-min-height),var(--resolved-card-height));grid-gap:var(--resolved-card-gap);box-sizing:border-box;padding:var(--resolved-card-gap);max-width:100%}.footer{display:flex;flex-direction:column;align-items:stretch;padding:0 var(--resolved-card-gap) var(--resolved-card-gap)}.add-card-container{width:var(--resolved-card-width);height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:center;justify-content:center;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}.add-card-container mat-icon{font-size:200%}.add-card-container:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.add-card-container:hover{border-color:transparent;background-color:#fff;color:#0000008a}.add-card-template-container{width:var(--resolved-card-width);height:var(--resolved-card-height);display:flex;flex-direction:column;align-items:stretch;justify-content:stretch}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CardStackComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-card-stack', template: "<div class=\"card-container\">\n  <ng-content></ng-content>\n</div>\n<div class=\"footer\">\n  <div class=\"add-card-container\" *ngIf=\"addCardCommand.enabled$.value\" [pectinCommand]=\"addCardCommand\">\n    <aup-command-face *ngIf=\"addCardFace\" [faces]=\"[addCardFace]\"></aup-command-face>\n    <aup-icon *ngIf=\"!addCardFace\" icon=\"mat:add\"></aup-icon>\n  </div>\n\n  <div class=\"add-card-template\" *ngIf=\"addCardTemplate\">\n    <ng-container [ngTemplateOutlet]=\"addCardTemplate\"></ng-container>\n  </div>\n  <ng-content select=\"[aup-card-stack-footer]\"></ng-content>\n</div>\n", styles: [":host{--resolved-card-gap: var(--card-gap, 16px);--resolved-card-height: var(--card-height, auto);--resolved-card-min-height: var(--card-min-height, auto);--resolved-card-background: var(--card-background, #fcfcfb);flex:1;display:block;background:var(--resolved-card-background)}.card-container{display:grid;grid-template-columns:1fr;grid-auto-rows:minmax(var(--resolved-card-min-height),var(--resolved-card-height));grid-gap:var(--resolved-card-gap);box-sizing:border-box;padding:var(--resolved-card-gap);max-width:100%}.footer{display:flex;flex-direction:column;align-items:stretch;padding:0 var(--resolved-card-gap) var(--resolved-card-gap)}.add-card-container{width:var(--resolved-card-width);height:var(--resolved-card-height);min-height:var(--resolved-card-min-height);display:flex;flex-direction:column;align-items:center;justify-content:center;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}.add-card-container mat-icon{font-size:200%}.add-card-container:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}.add-card-container:hover{border-color:transparent;background-color:#fff;color:#0000008a}.add-card-template-container{width:var(--resolved-card-width);height:var(--resolved-card-height);display:flex;flex-direction:column;align-items:stretch;justify-content:stretch}\n"] }]
        }], ctorParameters: function () { return []; } });

const HorizontalAlignment = Enum({
    START: 'start',
    CENTER: 'center',
    END: 'end'
});

class PopupAwareComponent extends DisposableComponent {
    constructor(element, parent) {
        super();
        this.element = element;
        this.parent = parent;
        if (parent) {
            this.registerDisposable(this.parent.register(this));
        }
    }
    get componentIndex() {
        return this.computeComponentIndex();
    }
    computeComponentIndex() {
        let node = this.element.nativeElement;
        let index = 0;
        while ((node = node.previousElementSibling)) {
            index++;
        }
        return index;
    }
    getFace() {
        return undefined;
    }
}

const POPUP_CONTAINER = new InjectionToken('popup-component');

/**
 *
 */
class CommandComponent extends PopupAwareComponent {
    constructor(element, parent) {
        super(element, parent);
        this.CommandFace = CommandFace;
        this.alignFace = HorizontalAlignment.CENTER;
        const { chain, switchOn } = Dsl.disposeWith(this);
        this.faces$ = chain(this.command.busy$).mapToList(busy => {
            return busy ?
                [this.busyFaceModel.value, this.faceModel.value] :
                [this.faceModel.value, this.busyFaceModel.value];
        }, { allowNil: true, dependsOn: [this.faceModel, this.busyFaceModel] })
            .rejectNil();
        this.activeFace$ = this.faces$.first();
        this.buttonStyle$ = chain(this.activeFace$).map(f => CommandFace.getStyleOf(f));
        this.color$ = chain(this.activeFace$).map(f => CommandFace.getColorOf(f));
        this.tooltip$ = chain(this.activeFace$).map(f => CommandFace.getTooltipOf(f));
        this.iconOnly$ = this.faces$.select(face => {
            return isEmpty(CommandFace.getTextOf(face)) && !isEmpty(CommandFace.getIconOf(face));
        }).count().equals(this.faces$.count());
    }
    isActive(face) {
        return this.activeFace$.query().equals(face);
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        // console.log(this.element.nativeElement.previousSibling)
    }
    getFace() {
        return this.face;
    }
    requestFocus() {
        this.button.focus();
    }
}
CommandComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandComponent, deps: [{ token: i0.ElementRef }, { token: POPUP_CONTAINER, optional: true }], target: i0.ɵɵFactoryTarget.Component });
CommandComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: CommandComponent, selector: "aup-command", inputs: { command: "command", faceModel: "faceModel", face: "face", busyFaceModel: "busyFaceModel", busyFace: "busyFace", alignFace: "alignFace" }, host: { properties: { "class": "this.alignFace" } }, viewQueries: [{ propertyName: "button", first: true, predicate: MatButton, descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"iconOnly$.value\">\n  <button mat-icon-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n          [matTooltip]=\"tooltip$.value\">\n    <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n  </button>\n</ng-container>\n<ng-container *ngIf=\"!iconOnly$.value\">\n  <ng-container [ngSwitch]=\"buttonStyle$.value\">\n    <ng-container *ngSwitchCase=\"CommandFace.Style.STROKED\">\n      <button mat-stroked-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"CommandFace.Style.RAISED\">\n      <button mat-raised-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <button mat-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:inline-flex;flex-direction:row;justify-content:stretch}:host.centered button{text-align:center}:host.start button{text-align:start}:host.end button{text-align:end}button{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], CommandComponent.prototype, "command", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], CommandComponent.prototype, "faceModel", void 0);
__decorate([
    StoreInValueModel('faceModel'),
    __metadata("design:type", Object)
], CommandComponent.prototype, "face", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], CommandComponent.prototype, "busyFaceModel", void 0);
__decorate([
    StoreInValueModel('busyFaceModel'),
    __metadata("design:type", Object)
], CommandComponent.prototype, "busyFace", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CommandComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-command', template: "<ng-container *ngIf=\"iconOnly$.value\">\n  <button mat-icon-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n          [matTooltip]=\"tooltip$.value\">\n    <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n  </button>\n</ng-container>\n<ng-container *ngIf=\"!iconOnly$.value\">\n  <ng-container [ngSwitch]=\"buttonStyle$.value\">\n    <ng-container *ngSwitchCase=\"CommandFace.Style.STROKED\">\n      <button mat-stroked-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchCase=\"CommandFace.Style.RAISED\">\n      <button mat-raised-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n    <ng-container *ngSwitchDefault>\n      <button mat-button [pectinCommand]=\"command\" [color]=\"color$.value\" [class.busy]=\"command.busy$.value\"\n              [matTooltip]=\"tooltip$.value\">\n        <aup-command-face [class]=\"alignFace\" [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n    </ng-container>\n  </ng-container>\n</ng-container>\n", styles: [":host{display:inline-flex;flex-direction:row;justify-content:stretch}:host.centered button{text-align:center}:host.start button{text-align:start}:host.end button{text-align:end}button{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [POPUP_CONTAINER]
                }, {
                    type: Optional
                }] }]; }, propDecorators: { command: [{
                type: Input
            }], faceModel: [{
                type: Input
            }], face: [{
                type: Input
            }], busyFaceModel: [{
                type: Input
            }], busyFace: [{
                type: Input
            }], alignFace: [{
                type: Input
            }, {
                type: HostBinding,
                args: ["class"]
            }], button: [{
                type: ViewChild,
                args: [MatButton]
            }] } });

/**
 *
 */
class FlexComponent extends DisposableComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
}
FlexComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FlexComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FlexComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FlexComponent, selector: "aup-flex", usesInheritance: true, ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FlexComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-flex', template: `` }]
        }], ctorParameters: function () { return []; } });

/**
 *
 */
class AbstractPopupMenuComponent extends PopupAwareComponent {
    constructor(element, parent) {
        super(element, parent);
        this._unorderedChildren = new MutableListModel();
        this.faceModelDelegate = this.registerDisposable(new DelegatingValueModel());
        this.xPosition = 'after';
        this.yPosition = 'below';
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        // group.faceListModel = chain(this.faceModel).mapToList(face => [face]);
        this.faceAdapterModel = chain(this.faceModelDelegate).map(f => new CommandFace.Adapter(f));
        this.faces$ = chain(this.faceAdapterModel).pluck('face').mapToList(face => [face]);
        this.children = chain(this._unorderedChildren).sortBy('componentIndex');
    }
    ngAfterContentChecked() {
        // force the list to re-order as the child indicies may have changed.
        this._unorderedChildren.value = [...this._unorderedChildren.value];
    }
    get faceAdapter() {
        if (!this.faceAdapterModel) {
            console.error('Somehow faceAdapterModel is nil -- set a break point here and let me know what\'s going on');
        }
        return this.faceAdapterModel?.value ?? new CommandFace.Adapter(undefined);
    }
    isRoot() {
        return !this.parent;
    }
    // @Trace()
    register(component) {
        this._unorderedChildren.push(component);
        return Disposable.disposableThatRuns(() => {
            this._unorderedChildren.remove(component);
        });
    }
    onCommandFired() {
        this.triggers.forEach(trigger => {
            if (trigger.menuOpen) {
                trigger.closeMenu();
            }
        });
    }
    getFace() {
        return this.faceAdapter.face;
    }
}
AbstractPopupMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractPopupMenuComponent, deps: [{ token: i0.ElementRef }, { token: POPUP_CONTAINER }], target: i0.ɵɵFactoryTarget.Component });
AbstractPopupMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractPopupMenuComponent, selector: "aup-abstract-popup-menu", inputs: { xPosition: "xPosition", yPosition: "yPosition", enabled: "enabled", enabledModel: "enabledModel" }, viewQueries: [{ propertyName: "triggers", predicate: MatMenuTrigger, descendants: true }], usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    StoreInValueModel('enabledModel'),
    __metadata("design:type", Boolean)
], AbstractPopupMenuComponent.prototype, "enabled", void 0);
__decorate([
    TrackExternal({ defaultValue: true }),
    __metadata("design:type", ValueModel)
], AbstractPopupMenuComponent.prototype, "enabledModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractPopupMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-abstract-popup-menu', template: '' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [POPUP_CONTAINER]
                }] }]; }, propDecorators: { xPosition: [{
                type: Input
            }], yPosition: [{
                type: Input
            }], triggers: [{
                type: ViewChildren,
                args: [MatMenuTrigger]
            }], enabled: [{
                type: Input
            }], enabledModel: [{
                type: Input
            }] } });

var TrackBy;
(function (TrackBy) {
    TrackBy.byIndex = (index, item) => index;
    /**
     * @deprecated use #track(MyType).by("property") instead.
     * @param property
     */
    function trackByProperty(property) {
        return (index, item) => item[property];
    }
    TrackBy.trackByProperty = trackByProperty;
    function track(type) {
        return {
            by(property) {
                return (index, item) => item[property];
            }
        };
    }
    TrackBy.track = track;
})(TrackBy || (TrackBy = {}));

class CommandContainer extends GarbageCollector {
    constructor(parent) {
        super();
        this.parent = parent;
    }
    get depth() {
        return this.hasParent() ? this.parent.depth + 1 : 0;
    }
    hasParent() {
        return !!this.parent;
    }
    get orientation() {
        return CommandContainer.Orientation.VERTICAL;
    }
}
(function (CommandContainer) {
    CommandContainer.Orientation = Enum({ HORIZONTAL: 'horizontal', VERTICAL: 'vertical' });
})(CommandContainer || (CommandContainer = {}));

/**
 *
 */
class ToolBarComponent extends CommandContainer {
    constructor() {
        super();
    }
    get orientation() {
        return CommandContainer.Orientation.HORIZONTAL;
    }
    // @Trace()
    ngOnInit() {
    }
    // @Trace()
    ngAfterContentInit() {
        // this.group.initialise();
    }
    // @Trace()
    ngAfterViewInit() {
    }
}
ToolBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ToolBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ToolBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ToolBarComponent, selector: "aup-tool-bar", usesInheritance: true, ngImport: i0, template: '<div class="toolbar-content"><ng-content></ng-content></div>', isInline: true, styles: [":host{display:inline-block}.toolbar-content{display:inline-flex;flex-direction:row;align-items:center}.toolbar-content>aup-separator{align-self:stretch;margin:4px 0 4px 8px}.toolbar-content>aup-flex{flex:1}.toolbar-content>*+*{margin-left:8px}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ToolBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-tool-bar', template: '<div class="toolbar-content"><ng-content></ng-content></div>', encapsulation: ViewEncapsulation.None, styles: [":host{display:inline-block}.toolbar-content{display:inline-flex;flex-direction:row;align-items:center}.toolbar-content>aup-separator{align-self:stretch;margin:4px 0 4px 8px}.toolbar-content>aup-flex{flex:1}.toolbar-content>*+*{margin-left:8px}\n"] }]
        }], ctorParameters: function () { return []; } });

/**
 *
 */
class SeparatorComponent extends PopupAwareComponent {
    constructor(element, popupContainer, containerParent) {
        super(element, popupContainer);
        this.containerParent = containerParent;
    }
    isHorizontalContainer() {
        return this.containerParent instanceof ToolBarComponent && this.containerParent.orientation === CommandContainer.Orientation.HORIZONTAL;
    }
    ngOnInit() {
    }
}
SeparatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SeparatorComponent, deps: [{ token: i0.ElementRef }, { token: POPUP_CONTAINER, optional: true }, { token: CommandContainer, optional: true }], target: i0.ɵɵFactoryTarget.Component });
SeparatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SeparatorComponent, selector: "aup-separator", host: { properties: { "class.horizontal-container": "this.isHorizontalContainer" } }, usesInheritance: true, ngImport: i0, template: `
    <mat-divider [vertical]="!isHorizontalContainer()"></mat-divider>`, isInline: true, styles: ["", ":host(.horizontal-container){display:inline-flex;flex-direction:row;align-items:stretch}\n"], dependencies: [{ kind: "component", type: i2$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SeparatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-separator', template: `
    <mat-divider [vertical]="!isHorizontalContainer()"></mat-divider>`, styles: [":host(.horizontal-container){display:inline-flex;flex-direction:row;align-items:stretch}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [POPUP_CONTAINER]
                }] }, { type: CommandContainer, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { isHorizontalContainer: [{
                type: HostBinding,
                args: ['class.horizontal-container']
            }] } });

class PopupMenuRendererComponent extends DisposableComponent {
    constructor() {
        super();
        this._childList = this.registerDisposable(new DelegatingListModel());
        this.commandFired = new EventEmitter();
        this.TrackBy = TrackBy;
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        // this.children = chain(this.groupViewDataModel).pluckList('children');
        // this.hasMixedIcons = chain(this.groupViewDataModel).pluck('hasMixedIcons');
        const faces = chain(this._childList).map(child => {
            return child.getFace();
        }).rejectNil();
        const icons = faces.select(face => !!CommandFace.getIconOf(face));
        const iconCount = icons.count();
        const totalFaces = faces.count();
        this.hasMixedIcons = valueOf.all(iconCount.isGreaterThan(0), totalFaces.doesNotEqual(iconCount)).areTruthy();
    }
    get parent() {
        return this._parentComponent;
    }
    set parent(comp) {
        this._parentComponent = comp;
        this._childList.setDelegate(comp.children);
    }
    get children() {
        return this.parent.children.value;
    }
    executeCommand(data) {
        if (this.isCommand(data)) {
            data.command.execute().finally(() => {
                this.commandFired.emit();
            });
        }
    }
    isCommandEnabled(data) {
        return this.isCommand(data) && data.command.enabled$.value;
    }
    // @Trace()
    onCommandFired() {
        this.commandFired.emit();
        this.triggers.forEach(trigger => {
            if (trigger.menuOpen) {
                trigger.closeMenu();
            }
        });
    }
    isCommand(child) {
        return child instanceof CommandComponent;
    }
    isPopupMenu(child) {
        return child instanceof AbstractPopupMenuComponent;
    }
    isPopupMenuEnabled(child) {
        return this.isPopupMenu(child) && child.enabled;
    }
    isSeparator(child) {
        return child instanceof SeparatorComponent;
    }
    getTooltip(child) {
        return this.isCommand(child) ? CommandFace.getTooltipOf(child.face) : undefined;
    }
    getFaces(child) {
        return this.isCommand(child) ?
            child.faces$.value :
            this.isPopupMenu(child) ?
                child.faces$.value :
                undefined;
    }
}
PopupMenuRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupMenuRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PopupMenuRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PopupMenuRendererComponent, selector: "aup-popup-menu-renderer", inputs: { parent: "parent" }, outputs: { commandFired: "commandFired" }, viewQueries: [{ propertyName: "menuComponent", first: true, predicate: ["menu"], descendants: true, static: true }, { propertyName: "triggers", predicate: MatMenuTrigger, descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-menu #menu [xPosition]=\"parent.xPosition\" [yPosition]=\"parent.yPosition\">\n  <ng-template matMenuContent>\n    <ng-container *ngFor=\"let child of children; trackBy: TrackBy.byIndex\" >\n      <button *ngIf=\"isCommand(child)\"\n              (click)=\"executeCommand(child)\"\n              [disabled]=\"!isCommandEnabled(child)\"\n              [matTooltip]=\"getTooltip(child)\"\n              mat-menu-item>\n                <aup-command-face [faces]=\"getFaces(child)\"\n                                  [includeMissingIconInLayout]=\"hasMixedIcons.value\"></aup-command-face>\n      </button>\n\n      <ng-container *ngIf=\"isPopupMenu(child)\">\n        <button mat-menu-item\n                matMenuTrigger\n                [disabled]=\"!isPopupMenuEnabled(child)\"\n                [matMenuTriggerFor]=\"innerPanel.menuComponent\"\n        >\n                    <aup-command-face [faces]=\"getFaces(child)\"\n                                      [includeMissingIconInLayout]=\"hasMixedIcons.value\"></aup-command-face>\n        </button>\n        <aup-popup-menu-renderer #innerPanel\n                                 [parent]=\"child\"\n                                 (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n      </ng-container>\n\n      <mat-divider *ngIf=\"isSeparator(child)\"></mat-divider>\n\n    </ng-container>\n\n  </ng-template>\n</mat-menu>\n", dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i3.MatMenu, selector: "mat-menu", exportAs: ["matMenu"] }, { kind: "component", type: i3.MatMenuItem, selector: "[mat-menu-item]", inputs: ["disabled", "disableRipple", "role"], exportAs: ["matMenuItem"] }, { kind: "directive", type: i3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "directive", type: i3.MatMenuContent, selector: "ng-template[matMenuContent]" }, { kind: "component", type: i2$3.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }, { kind: "component", type: PopupMenuRendererComponent, selector: "aup-popup-menu-renderer", inputs: ["parent"], outputs: ["commandFired"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupMenuRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-popup-menu-renderer", template: "<mat-menu #menu [xPosition]=\"parent.xPosition\" [yPosition]=\"parent.yPosition\">\n  <ng-template matMenuContent>\n    <ng-container *ngFor=\"let child of children; trackBy: TrackBy.byIndex\" >\n      <button *ngIf=\"isCommand(child)\"\n              (click)=\"executeCommand(child)\"\n              [disabled]=\"!isCommandEnabled(child)\"\n              [matTooltip]=\"getTooltip(child)\"\n              mat-menu-item>\n                <aup-command-face [faces]=\"getFaces(child)\"\n                                  [includeMissingIconInLayout]=\"hasMixedIcons.value\"></aup-command-face>\n      </button>\n\n      <ng-container *ngIf=\"isPopupMenu(child)\">\n        <button mat-menu-item\n                matMenuTrigger\n                [disabled]=\"!isPopupMenuEnabled(child)\"\n                [matMenuTriggerFor]=\"innerPanel.menuComponent\"\n        >\n                    <aup-command-face [faces]=\"getFaces(child)\"\n                                      [includeMissingIconInLayout]=\"hasMixedIcons.value\"></aup-command-face>\n        </button>\n        <aup-popup-menu-renderer #innerPanel\n                                 [parent]=\"child\"\n                                 (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n      </ng-container>\n\n      <mat-divider *ngIf=\"isSeparator(child)\"></mat-divider>\n\n    </ng-container>\n\n  </ng-template>\n</mat-menu>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { parent: [{
                type: Input
            }], menuComponent: [{
                type: ViewChild,
                args: ["menu", { static: true }]
            }], commandFired: [{
                type: Output
            }], triggers: [{
                type: ViewChildren,
                args: [MatMenuTrigger]
            }] } });

/**
 *
 */
class MoreMenuComponent extends AbstractPopupMenuComponent {
    constructor(element, parent) {
        super(element, parent);
        this.tooltipModel = new MutableValueModel();
        const { chain } = Dsl.disposeWith(this);
        this.faceModelDelegate.setDelegate(chain(this.tooltipModel).map(tooltip => {
            return {
                icon: () => 'mat:more_vert',
                tooltip() {
                    return tooltip;
                }
            };
        }, { allowNil: true }));
    }
    get face() {
        return this.faceModelDelegate.value;
    }
}
MoreMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MoreMenuComponent, deps: [{ token: i0.ElementRef }, { token: POPUP_CONTAINER, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component });
MoreMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: MoreMenuComponent, selector: "aup-more-menu", inputs: { tooltip: "tooltip" }, providers: [
        { provide: POPUP_CONTAINER, useExisting: MoreMenuComponent }
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"content\" style=\"display: none\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"isRoot()\">\n  <ng-container *ngIf=\"faceAdapter.text\" [ngSwitch]=\"faceAdapter.style\">\n    <ng-container *ngSwitchCase=\"'stroked'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-stroked-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'raised'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-raised-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu [parent]=\"this\" (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n  </ng-container>\n\n  <ng-container *ngIf=\"!faceAdapter.text\">\n    <button matMenuTrigger\n            mat-icon-button\n            [matMenuTriggerFor]=\"subMenu.menuComponent\"\n            (click) = \"$event.stopPropagation()\"\n            [matTooltip]=\"faceAdapter.tooltip\"\n            [color]=\"faceAdapter.color\"\n            [disabled]=\"!enabled\"\n    >\n      <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n    </button>\n    <aup-popup-menu-renderer #subMenu\n                             [parent]=\"this\"\n                            (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }, { kind: "component", type: PopupMenuRendererComponent, selector: "aup-popup-menu-renderer", inputs: ["parent"], outputs: ["commandFired"] }] });
__decorate([
    StoreInValueModel('tooltipModel'),
    __metadata("design:type", String)
], MoreMenuComponent.prototype, "tooltip", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MoreMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-more-menu', providers: [
                        { provide: POPUP_CONTAINER, useExisting: MoreMenuComponent }
                    ], template: "<div class=\"content\" style=\"display: none\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"isRoot()\">\n  <ng-container *ngIf=\"faceAdapter.text\" [ngSwitch]=\"faceAdapter.style\">\n    <ng-container *ngSwitchCase=\"'stroked'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-stroked-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'raised'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-raised-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu [parent]=\"this\" (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n  </ng-container>\n\n  <ng-container *ngIf=\"!faceAdapter.text\">\n    <button matMenuTrigger\n            mat-icon-button\n            [matMenuTriggerFor]=\"subMenu.menuComponent\"\n            (click) = \"$event.stopPropagation()\"\n            [matTooltip]=\"faceAdapter.tooltip\"\n            [color]=\"faceAdapter.color\"\n            [disabled]=\"!enabled\"\n    >\n      <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n    </button>\n    <aup-popup-menu-renderer #subMenu\n                             [parent]=\"this\"\n                            (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [POPUP_CONTAINER]
                }, {
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; }, propDecorators: { tooltip: [{
                type: Input
            }] } });

/**
 *
 */
class PopupMenuComponent extends AbstractPopupMenuComponent {
    constructor(element, parent) {
        super(element, parent);
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        // group.faceListModel = chain(this.faceModel).mapToList(face => [face]);
    }
}
PopupMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupMenuComponent, deps: [{ token: i0.ElementRef }, { token: POPUP_CONTAINER, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component });
PopupMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PopupMenuComponent, selector: "aup-popup-menu", inputs: { faceModel: "faceModel", face: "face" }, providers: [
        { provide: POPUP_CONTAINER, useExisting: PopupMenuComponent }
    ], usesInheritance: true, ngImport: i0, template: "<div class=\"content\" style=\"display: none\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"isRoot()\">\n  <ng-container *ngIf=\"faceAdapter.text\" [ngSwitch]=\"faceAdapter.style\">\n    <ng-container *ngSwitchCase=\"'stroked'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-stroked-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'raised'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-raised-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu [parent]=\"this\" (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n  </ng-container>\n\n  <ng-container *ngIf=\"!faceAdapter.text\">\n    <button matMenuTrigger\n            mat-icon-button\n            [matMenuTriggerFor]=\"subMenu.menuComponent\"\n            (click) = \"$event.stopPropagation()\"\n            [matTooltip]=\"faceAdapter.tooltip\"\n            [color]=\"faceAdapter.color\"\n            [disabled]=\"!enabled\"\n    >\n      <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n    </button>\n    <aup-popup-menu-renderer #subMenu\n                             [parent]=\"this\"\n                            (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n  </ng-container>\n</ng-container>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: i3.MatMenuTrigger, selector: "[mat-menu-trigger-for], [matMenuTriggerFor]", exportAs: ["matMenuTrigger"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }, { kind: "component", type: PopupMenuRendererComponent, selector: "aup-popup-menu-renderer", inputs: ["parent"], outputs: ["commandFired"] }] });
__decorate([
    TrackExternal({ delegateTo: 'faceModelDelegate' }),
    __metadata("design:type", ValueModel)
], PopupMenuComponent.prototype, "faceModel", void 0);
__decorate([
    StoreInValueModel('faceModel'),
    __metadata("design:type", Object)
], PopupMenuComponent.prototype, "face", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-popup-menu', providers: [
                        { provide: POPUP_CONTAINER, useExisting: PopupMenuComponent }
                    ], template: "<div class=\"content\" style=\"display: none\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"isRoot()\">\n  <ng-container *ngIf=\"faceAdapter.text\" [ngSwitch]=\"faceAdapter.style\">\n    <ng-container *ngSwitchCase=\"'stroked'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-stroked-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchCase=\"'raised'\">\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-raised-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu\n                               [parent]=\"this\"\n                              (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <button matMenuTrigger\n              [matMenuTriggerFor]=\"subMenu.menuComponent\"\n              (click) = \"$event.stopPropagation()\"\n              [matTooltip]=\"faceAdapter.tooltip\"\n              [color]=\"faceAdapter.color\"\n              [disabled]=\"!enabled\"\n              mat-button>\n        <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n      </button>\n      <aup-popup-menu-renderer #subMenu [parent]=\"this\" (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n    </ng-container>\n\n  </ng-container>\n\n  <ng-container *ngIf=\"!faceAdapter.text\">\n    <button matMenuTrigger\n            mat-icon-button\n            [matMenuTriggerFor]=\"subMenu.menuComponent\"\n            (click) = \"$event.stopPropagation()\"\n            [matTooltip]=\"faceAdapter.tooltip\"\n            [color]=\"faceAdapter.color\"\n            [disabled]=\"!enabled\"\n    >\n      <aup-command-face [faces]=\"faces$.value\"></aup-command-face>\n    </button>\n    <aup-popup-menu-renderer #subMenu\n                             [parent]=\"this\"\n                            (commandFired)=\"onCommandFired()\"></aup-popup-menu-renderer>\n  </ng-container>\n</ng-container>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [POPUP_CONTAINER]
                }, {
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; }, propDecorators: { faceModel: [{
                type: Input
            }], face: [{
                type: Input
            }] } });

class EmptyStateComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
EmptyStateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: EmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
EmptyStateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: EmptyStateComponent, selector: "aup-empty-state", ngImport: i0, template: `
      <div class="container">
          <ng-content></ng-content>
      </div>
  `, isInline: true, styles: [":host{display:flex;flex-direction:column;justify-content:center;align-items:center}.container{display:flex;flex-direction:column;align-items:stretch;padding:var(--aup-default-padding);border:2px dashed rgba(0,0,0,.2);border-radius:5px;font-size:14px;font-weight:300}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: EmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-empty-state', template: `
      <div class="container">
          <ng-content></ng-content>
      </div>
  `, styles: [":host{display:flex;flex-direction:column;justify-content:center;align-items:center}.container{display:flex;flex-direction:column;align-items:stretch;padding:var(--aup-default-padding);border:2px dashed rgba(0,0,0,.2);border-radius:5px;font-size:14px;font-weight:300}\n"] }]
        }], ctorParameters: function () { return []; } });

class FocusContainerComponent extends DisposableComponent {
    constructor(focusManager) {
        super();
        this.focusManager = focusManager;
        this.restoreFocusCommand = Command.create(() => {
            this.restoreFocus();
        });
        this.tabIndex = -1;
    }
    ngOnInit() {
    }
    // @Trace()
    restoreFocus() {
        this.focusManager.restoreFocus();
    }
}
FocusContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusContainerComponent, deps: [{ token: i1$3.FocusManager, self: true }], target: i0.ɵɵFactoryTarget.Component });
FocusContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FocusContainerComponent, selector: "aup-focus-container", host: { properties: { "attr.tabindex": "this.tabIndex" } }, providers: [
        { provide: FocusManager }
    ], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-focus-container', providers: [
                        { provide: FocusManager }
                    ], template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.FocusManager, decorators: [{
                    type: Self
                }] }]; }, propDecorators: { tabIndex: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }] } });

class FocusableComponent extends DisposableComponent {
    constructor(el, focusManager, focusBindingFactory) {
        super();
        this.el = el;
        this.focusManager = focusManager;
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        if (this.focusManager) {
            this._focusContext = this.focusManager.registerFocusable(this);
            this.registerDisposable(this._focusContext);
            this.registerDisposable(focusBindingFactory.createBinding(el.nativeElement, this.focusContext));
        }
    }
    get focusable() {
        return !!this.focusContext ? 0 : undefined;
    }
    onFocus() {
        this.focusContext?.notifyFocusIn();
    }
    onBlur() {
        this.focusContext?.notifyFocusOut();
    }
    get focusContext() {
        return this._focusContext;
    }
}
FocusableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusableComponent, deps: [{ token: i0.ElementRef }, { token: i1$3.FocusManager }, { token: FocusBindingFactory }], target: i0.ɵɵFactoryTarget.Component });
FocusableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: FocusableComponent, selector: "ng-component", host: { listeners: { "focus": "onFocus()", "blur": "onBlur()" }, properties: { "attr.tabindex": "this.focusable" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: FocusableComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$3.FocusManager }, { type: FocusBindingFactory }]; }, propDecorators: { focusable: [{
                type: HostBinding,
                args: ['attr.tabindex']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

/* tslint:disable:no-input-rename */
class AbstractInputComponent extends DisposableComponent {
    constructor() {
        super();
        this.onValueEditedListeners = new EventListenerList();
        this.userFloatLabel = 'always'; // TODO: make this an injectable default
        this.dense = false;
        // TODO: fix this.
        // tslint:disable-next-line:no-output-native
        this.focus = new EventEmitter();
        // tslint:disable-next-line:no-output-native
        this.blur = new EventEmitter();
        // tslint:disable-next-line:no-output-native
        this.enterKey = new EventEmitter();
        // tslint:disable-next-line:no-output-native
        this.escapeKey = new EventEmitter();
        this.baseClassName = 'aup-input-component';
        const self = this;
        this.errorStateMatcher = {
            isErrorState(control, form) {
                return self.hasErrors();
            }
        };
    }
    notifyClick() {
        this.safelyInvoke(this.clickCommand);
    }
    notifyFocusIn() {
        this.safelyInvoke(this.focusCommand);
        this.focus.emit();
    }
    notifyFocusOut() {
        this.safelyInvoke(this.blurCommand);
        this.blur.emit();
    }
    notifyEnterKey() {
        this.safelyInvoke(this.enterCommand);
        this.enterKey.emit();
    }
    notifyEscapeKey() {
        this.safelyInvoke(this.escapeCommand);
        this.escapeKey.emit();
    }
    safelyInvoke(command) {
        if (command && command.enabled$.value) {
            command.execute();
        }
    }
    ngOnInit() {
    }
    isEnabled() {
        return this.enabled$.value;
    }
    get enabled$() {
        return this.formValue$.enabled;
    }
    hasErrors() {
        return !this.errorList$.query().isEmpty();
    }
    get errorList$() {
        return this.formValue$.errorList;
    }
    get firstError() {
        return this.hasErrors() ? this.errorList$.value[0] : null;
    }
    get focusContext() {
        return this.formValue$.focusContext;
    }
    get floatLabel() {
        return this.dense ? 'never' : this.userFloatLabel;
    }
    get showHint() {
        return this.dense ? false : !!this.hint;
    }
    /**
     * Invokes the callback when this components value is changed by a user edit.
     * @param callback
     */
    onValueEdited(callback) {
        return this.onValueEditedListeners.add(callback);
    }
}
AbstractInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AbstractInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractInputComponent, selector: "ng-component", inputs: { label: "label", userFloatLabel: ["floatLabel", "userFloatLabel"], hint: "hint", placeholder: "placeholder", dense: "dense", focusCommand: ["command.focus", "focusCommand"], blurCommand: ["command.blur", "blurCommand"], enterCommand: ["command.enter", "enterCommand"], escapeCommand: ["command.escape", "escapeCommand"], clickCommand: ["command.click", "clickCommand"] }, outputs: { focus: "focus", blur: "blur", enterKey: "enterKey", escapeKey: "escapeKey" }, host: { listeners: { "click": "notifyClick()", "focusin": "notifyFocusIn()", "focusout": "notifyFocusOut()" }, properties: { "class.dense": "this.dense", "class": "this.baseClassName" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractInputComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], userFloatLabel: [{
                type: Input,
                args: ['floatLabel']
            }], hint: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], dense: [{
                type: HostBinding,
                args: ['class.dense']
            }, {
                type: Input
            }], focusCommand: [{
                type: Input,
                args: ['command.focus']
            }], blurCommand: [{
                type: Input,
                args: ['command.blur']
            }], enterCommand: [{
                type: Input,
                args: ['command.enter']
            }], escapeCommand: [{
                type: Input,
                args: ['command.escape']
            }], clickCommand: [{
                type: Input,
                args: ['command.click']
            }], focus: [{
                type: Output
            }], blur: [{
                type: Output
            }], enterKey: [{
                type: Output
            }], escapeKey: [{
                type: Output
            }], baseClassName: [{
                type: HostBinding,
                args: ['class']
            }], notifyClick: [{
                type: HostListener,
                args: ['click']
            }], notifyFocusIn: [{
                type: HostListener,
                args: ['focusin']
            }], notifyFocusOut: [{
                type: HostListener,
                args: ['focusout']
            }] } });

class AbstractListInputComponent extends AbstractInputComponent {
    constructor() {
        super();
        /**
         * A backing model for all our @Input() valueModel properties which should be defined as follows.
         *
         *    @Input() @TrackExternal({useExisting: "inputModel"})
         *    valueModel: Form.ListModelBase<string> | MutableListModel<string>;
         *
         * This approach allows the input to accept plain or form models but all backed by a form
         * friendly delegate.  We have to use an existing delegate for union types as pectin just
         * gets told it's an Object and can't scan for a base type annotated with @DelegateUsing(..).
         */
        // We have to register it as a disposable so it ditches any listeners when we're disposed.
        this.formValue$ = this.registerDisposable(new Form.DelegatingFormListModel());
        this.componentList$ = new MutableListModel();
        this.setValueIsInProgress$ = new Guard();
        this.valueChange = new EventEmitter();
        const { when, valueOf, chain } = Dsl.disposeWith(this);
        const binding = new Binding.Identity(this.formValue$, this.componentList$).writeRight();
        const inExternalChange = valueOf.any(this.setValueIsInProgress$, chain(binding.direction).equals(Binding.Direction.RIGHT)).areTruthy();
        when(this.componentList$).changes((is, was) => {
            this.valueChange.emit(is);
            this.onValueEditedListeners.fire(l => l(is, was));
        }, {
            initialValue: "ignore",
            // we never fire events during an external changes to the value. This allows
            // the component to behave when used in the conventional angular
            // fashion, i.e. [(value)]="..."
            unless: inExternalChange
        });
        DebugContext.tag(this.formValue$, `${this.constructor.name}.formValueModel`);
    }
    // We add support for simple direct display of values by allowing components to be used
    // by `component.value = ...`  This use of the component without a value model in tables
    // and the like.
    set value(value) {
        this.setValueIsInProgress$.whileTrue(() => {
            if (!this.listHolder$) {
                this.listHolder$ = new MutableListModel(value);
                this.list$ = this.listHolder$;
            }
            else {
                this.listHolder$.value = value;
            }
        });
    }
}
AbstractListInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractListInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AbstractListInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractListInputComponent, selector: "ng-component", inputs: { list$: "list$", listModel: "listModel", value: "value" }, outputs: { valueChange: "valueChange" }, usesInheritance: true, ngImport: i0, template: "", isInline: true });
__decorate([
    TrackExternal({ delegateTo: "formValue$" }),
    __metadata("design:type", Object)
], AbstractListInputComponent.prototype, "list$", void 0);
__decorate([
    TrackExternal({ delegateTo: "formValue$" }),
    __metadata("design:type", Object)
], AbstractListInputComponent.prototype, "listModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractListInputComponent, decorators: [{
            type: Component,
            args: [{ template: "" }]
        }], ctorParameters: function () { return []; }, propDecorators: { list$: [{
                type: Input
            }], listModel: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class AbstractValueInputComponent extends AbstractInputComponent {
    constructor() {
        super();
        /**
         * A backing model for all our @Input() valueModel properties which should be defined as follows.
         *
         *    @Input() @TrackExternal({useExisting: "inputModel"})
         *    value$:  DirtyTrackingForm.ValueModel<string> | MutableValueModel<string>;
         *
         * This approach allows the input to accept plain or form models but all backed by a form
         * friendly delegate.  We have to use an existing delegate for union types as pectin just
         * gets told it's an Object and can't scan for a base type annotated with @DelegateUsing(..).
         */
        // We have to register it as a disposable so it ditches any listeners when we're disposed.
        this.formValue$ = this.registerDisposable(new Form.DelegatingFormValueModel());
        this.setValueInProgress$ = new Guard();
        this.componentValue$ = new MutableValueModel();
        this.valueChange = new EventEmitter();
        const { when, chain, valueOf } = Dsl.disposeWith(this);
        const binding = new Binding.Identity(this.formValue$, this.componentValue$).writeRight();
        const inExternalChange = valueOf.any(this.setValueInProgress$, chain(binding.direction).equals(Binding.Direction.RIGHT)).areTruthy();
        when(this.componentValue$).changes((is, was) => {
            this.valueChange.emit(is);
            this.onValueEditedListeners.fire(l => l(is, was));
        }, {
            initialValue: 'ignore',
            // we never fire events during an external set value operation. This allows
            // the component to behave when used in the conventional angular
            // fashion, i.e. [(value)]="..."
            unless: inExternalChange
        });
        DebugContext.tag(this.formValue$, `${this.constructor.name}.formValueModel`);
    }
    // We add support for simple direct display of values by allowing components to be used
    // by `component.value = ...`  This use of the component without a value model in tables
    // and the like.
    set value(value) {
        this.setValueInProgress$.whileTrue(() => {
            if (!this.plainValueHolder$) {
                this.plainValueHolder$ = new MutableValueModel(value);
                this.value$ = this.plainValueHolder$;
            }
            else {
                this.plainValueHolder$.value = value;
            }
        });
    }
}
AbstractValueInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractValueInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AbstractValueInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractValueInputComponent, selector: "ng-component", inputs: { value$: "value$", valueModel: "valueModel", value: "value" }, outputs: { valueChange: "valueChange" }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    TrackExternal({ delegateTo: 'formValue$' }),
    __metadata("design:type", Object)
], AbstractValueInputComponent.prototype, "value$", void 0);
__decorate([
    TrackExternal({ delegateTo: 'formValue$' }),
    __metadata("design:type", Object)
], AbstractValueInputComponent.prototype, "valueModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractValueInputComponent, decorators: [{
            type: Component,
            args: [{ template: '' }]
        }], ctorParameters: function () { return []; }, propDecorators: { value$: [{
                type: Input
            }], valueModel: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

/**
 * Using templates (not only supported for nil values:
 * <aup-autocomplete-input [valueModel]="myModel" [options]="myOptions">
 *   <ng-template #nilOptionTemplate let-option>{{option.thePropertyYouWant}}</ng-template>
 * </aup-autocomplete-input>
 */
class AutocompleteInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        this._options$ = new DelegatingListModel();
        this.autoActiveFirstOption = true;
        this.autoFilter = true;
        this.inSearchUpdate$ = new Guard();
        this.filterValue = new MutableValueModel();
        this.optionLabelFormat = (option) => (option && this.optionLabel) ? option[this.optionLabel] : option;
        this.filterFactory = (filterText) => {
            const lowerCaseFilterValue = isString(filterText) ? filterText.toLowerCase() : '';
            return (option) => {
                const matches = !isEmpty(this.filterValue.value) && this.optionLabelFormat(option).toString().toLowerCase().includes(lowerCaseFilterValue);
                return matches;
            };
        };
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        const filter$ = chain(this.filterValue).map(v => this.filterFactory(v), { allowNil: true });
        this.filteredOptions = chain(this.options$)
            .select(option => !this.autoFilter || filter$.value(option), { dependsOn: filter$ });
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        const { when } = Dsl.disposeWith(this);
        when(this.rawTextContent$).changes(content => {
            this.matInputComponent.value = content;
        }, {
            unless: this.inSearchUpdate$
        });
    }
    formatOption(option) {
        return this.optionLabelFormat(option);
    }
    updateFilter($event) {
        this.inSearchUpdate$.whileTrue(() => {
            this.rawTextContent$.value = $event;
            this.filterValue.value = $event;
        });
    }
    onSelect($event) {
        this.inSearchUpdate$.whileTrue(() => {
            this.rawTextContent$.value = undefined;
            // @ts-ignore
            this.value$["value"] = $event.option.value;
        });
    }
}
AutocompleteInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AutocompleteInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AutocompleteInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AutocompleteInputComponent, selector: "aup-autocomplete-input", inputs: { rawTextContent$: "rawTextContent$", options$: "options$", optionsModel: "optionsModel", options: "options", optionLabel: "optionLabel", allowNil: "allowNil", autoActiveFirstOption: "autoActiveFirstOption", autoFilter: "autoFilter", optionLabelFormat: "optionLabelFormat", filterFactory: "filterFactory" }, queries: [{ propertyName: "optionTemplateRef", first: true, predicate: ["optionTemplate"], descendants: true }, { propertyName: "nilOptionTemplateRef", first: true, predicate: ["nilOptionTemplate"], descendants: true }], viewQueries: [{ propertyName: "matInputComponent", first: true, predicate: MatInput, descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"string\"\n         matInput\n         [matAutocomplete]=\"autocomplete\"\n         placeholder=\"{{placeholder}}\"\n         [ngModel]=\"componentValue$.value\"\n         (ngModelChange)=\"updateFilter($event)\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-autocomplete #autocomplete [displayWith]=\"optionLabelFormat\"\n                    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n                    (optionSelected)=\"onSelect($event)\">\n    <mat-option *ngFor=\"let option of filteredOptions.value; let i = index\"\n                [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{formatOption(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n                    [ngTemplateOutlet]=\"optionTemplateRef\"\n                    [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n    <mat-option *ngIf=\"allowNil\">{{placeholder}}</mat-option>\n  </mat-autocomplete>\n\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div>{{placeholder}}</div>\n  <div class=\"item\" *ngFor=\"let item of options\">\n    <ng-container *ngIf=\"!optionTemplateRef\">{{formatOption(item)}}</ng-container>\n    <ng-container *ngIf=\"optionTemplateRef\"\n                  [ngTemplateOutlet]=\"optionTemplateRef\"\n                  [ngTemplateOutletContext]=\"{ $implicit: item, index: 0 }\"\n    >\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: i5.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }, { kind: "component", type: i7.MatAutocomplete, selector: "mat-autocomplete", inputs: ["disableRipple"], exportAs: ["matAutocomplete"] }, { kind: "directive", type: i7.MatAutocompleteTrigger, selector: "input[matAutocomplete], textarea[matAutocomplete]", exportAs: ["matAutocompleteTrigger"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", MutableValueModel)
], AutocompleteInputComponent.prototype, "rawTextContent$", void 0);
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], AutocompleteInputComponent.prototype, "options$", void 0);
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], AutocompleteInputComponent.prototype, "optionsModel", void 0);
__decorate([
    StoreInListModel('optionsModel'),
    __metadata("design:type", Array)
], AutocompleteInputComponent.prototype, "options", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AutocompleteInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-autocomplete-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"string\"\n         matInput\n         [matAutocomplete]=\"autocomplete\"\n         placeholder=\"{{placeholder}}\"\n         [ngModel]=\"componentValue$.value\"\n         (ngModelChange)=\"updateFilter($event)\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-autocomplete #autocomplete [displayWith]=\"optionLabelFormat\"\n                    [autoActiveFirstOption]=\"autoActiveFirstOption\"\n                    (optionSelected)=\"onSelect($event)\">\n    <mat-option *ngFor=\"let option of filteredOptions.value; let i = index\"\n                [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{formatOption(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n                    [ngTemplateOutlet]=\"optionTemplateRef\"\n                    [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n    <mat-option *ngIf=\"allowNil\">{{placeholder}}</mat-option>\n  </mat-autocomplete>\n\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div>{{placeholder}}</div>\n  <div class=\"item\" *ngFor=\"let item of options\">\n    <ng-container *ngIf=\"!optionTemplateRef\">{{formatOption(item)}}</ng-container>\n    <ng-container *ngIf=\"optionTemplateRef\"\n                  [ngTemplateOutlet]=\"optionTemplateRef\"\n                  [ngTemplateOutletContext]=\"{ $implicit: item, index: 0 }\"\n    >\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { rawTextContent$: [{
                type: Input
            }], options$: [{
                type: Input
            }], optionsModel: [{
                type: Input
            }], options: [{
                type: Input
            }], optionLabel: [{
                type: Input
            }], allowNil: [{
                type: Input
            }], autoActiveFirstOption: [{
                type: Input
            }], autoFilter: [{
                type: Input
            }], matInputComponent: [{
                type: ViewChild,
                args: [MatInput]
            }], optionTemplateRef: [{
                type: ContentChild,
                args: ['optionTemplate']
            }], nilOptionTemplateRef: [{
                type: ContentChild,
                args: ['nilOptionTemplate']
            }], optionLabelFormat: [{
                type: Input
            }], filterFactory: [{
                type: Input
            }] } });

class CheckboxInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        // @Input() @TrackExternal({ delegateTo: 'inputModel' })
        // valueModel: Form.ValueModelBase<boolean> | MutableValueModel<boolean>;
        this.color = 'accent';
        this.labelPosition = 'after';
    }
    ngOnInit() {
    }
}
CheckboxInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CheckboxInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
CheckboxInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: CheckboxInputComponent, selector: "aup-checkbox-input", inputs: { color: "color", labelPosition: "labelPosition" }, usesInheritance: true, ngImport: i0, template: "<!-- TODO: add focus binding -->\n<mat-checkbox\n  [(ngModel)]=\"componentValue$.value\"\n  [color]=\"color\"\n  [labelPosition]=\"labelPosition\"\n  [disabled]=\"!isEnabled()\"\n>{{label}}</mat-checkbox>\n<mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n<mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n", styles: [":host{display:inline-flex;flex-direction:column;padding:24px 0 16px}:host.dense{padding:6px 0 2px}mat-hint,mat-error{margin-top:4px;margin-left:24px;font-size:12px;font-weight:400;line-height:13.5px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "component", type: i4$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: CheckboxInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-checkbox-input', template: "<!-- TODO: add focus binding -->\n<mat-checkbox\n  [(ngModel)]=\"componentValue$.value\"\n  [color]=\"color\"\n  [labelPosition]=\"labelPosition\"\n  [disabled]=\"!isEnabled()\"\n>{{label}}</mat-checkbox>\n<mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n<mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n", styles: [":host{display:inline-flex;flex-direction:column;padding:24px 0 16px}:host.dense{padding:6px 0 2px}mat-hint,mat-error{margin-top:4px;margin-left:24px;font-size:12px;font-weight:400;line-height:13.5px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { color: [{
                type: Input
            }], labelPosition: [{
                type: Input
            }] } });

/**
 * Using templates:
 * <aup-multiple-select-input [valueModel]="myModel" [options]="myOptions">
 *   <ng-template #optionTemplate let-option>{{option.thePropertyYouWant}}</ng-template>
 *   <ng-template #nilOptionTemplate let-option>{{option.thePropertyYouWant}}</ng-template>
 * </aup-multiple-select_input>
 */
class MultipleSelectInputComponent extends AbstractListInputComponent {
    constructor() {
        super();
        this._options$ = new DelegatingListModel();
        this.optionLabelFormat = (option) => (option && this.optionLabel) ? option[this.optionLabel] : option;
    }
    ngOnInit() {
    }
}
MultipleSelectInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MultipleSelectInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
MultipleSelectInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: MultipleSelectInputComponent, selector: "aup-multiple-select-input", inputs: { options$: "options$", optionsModel: "optionsModel", options: "options", optionLabel: "optionLabel", optionLabelFormat: "optionLabelFormat" }, queries: [{ propertyName: "optionTemplateRef", first: true, predicate: ["optionTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <mat-select placeholder=\"{{placeholder}}\"\n              multiple\n              [(ngModel)]=\"componentList$.value\"\n              [disabled]=\"!enabled$.value\"\n              (keydown.enter)=\"notifyEnterKey()\"\n              (keydown.escape)=\"notifyEscapeKey()\"\n              [pectinFocusBinding]=\"focusContext\"\n              [errorStateMatcher]=\"errorStateMatcher\"\n  >\n    <mat-option *ngFor=\"let option of options$.value; let i = index\" [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n        [ngTemplateOutlet]=\"optionTemplateRef\"\n        [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n  </mat-select>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div>{{placeholder}}</div>\n  <div class=\"item\" *ngFor=\"let item of options\">{{optionLabelFormat(item)}}</div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:30px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "component", type: i4$3.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i5.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }] });
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], MultipleSelectInputComponent.prototype, "options$", void 0);
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], MultipleSelectInputComponent.prototype, "optionsModel", void 0);
__decorate([
    StoreInListModel('optionsModel'),
    __metadata("design:type", Array)
], MultipleSelectInputComponent.prototype, "options", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MultipleSelectInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-multiple-select-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <mat-select placeholder=\"{{placeholder}}\"\n              multiple\n              [(ngModel)]=\"componentList$.value\"\n              [disabled]=\"!enabled$.value\"\n              (keydown.enter)=\"notifyEnterKey()\"\n              (keydown.escape)=\"notifyEscapeKey()\"\n              [pectinFocusBinding]=\"focusContext\"\n              [errorStateMatcher]=\"errorStateMatcher\"\n  >\n    <mat-option *ngFor=\"let option of options$.value; let i = index\" [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n        [ngTemplateOutlet]=\"optionTemplateRef\"\n        [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n  </mat-select>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div>{{placeholder}}</div>\n  <div class=\"item\" *ngFor=\"let item of options\">{{optionLabelFormat(item)}}</div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:30px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { options$: [{
                type: Input
            }], optionsModel: [{
                type: Input
            }], options: [{
                type: Input
            }], optionLabel: [{
                type: Input
            }], optionTemplateRef: [{
                type: ContentChild,
                args: ['optionTemplate']
            }], optionLabelFormat: [{
                type: Input
            }] } });

class NumberInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        this.min = Number.MIN_SAFE_INTEGER;
        this.max = Number.MAX_SAFE_INTEGER;
    }
    ngOnInit() {
    }
}
NumberInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NumberInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NumberInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: NumberInputComponent, selector: "aup-number-input", inputs: { autocomplete: "autocomplete", min: "min", max: "max", iconPrefix: "iconPrefix" }, usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"number\"\n         matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n         [min]=\"min\"\n         [max]=\"max\"\n  >\n  <mat-hint *ngIf=\"hint && !dense\" >{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n  <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>\n</mat-form-field>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i2$4.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NumberInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-number-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"number\"\n         matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n         [min]=\"min\"\n         [max]=\"max\"\n  >\n  <mat-hint *ngIf=\"hint && !dense\" >{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n  <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>\n</mat-form-field>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { autocomplete: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], iconPrefix: [{
                type: Input
            }] } });

class PasswordInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
}
PasswordInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PasswordInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PasswordInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PasswordInputComponent, selector: "aup-password-input", inputs: { autocomplete: "autocomplete" }, usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"password\"\n         matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PasswordInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-password-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input type=\"password\"\n         matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { autocomplete: [{
                type: Input
            }] } });

/**
 * Using templates:
 * <aup-select-input [valueModel]="myModel" [options]="myOptions">
 *   <ng-template #optionTemplate let-option>{{option.thePropertyYouWant}}</ng-template>
 *   <ng-template #nilOptionTemplate let-option>{{option.thePropertyYouWant}}</ng-template>
 * </aup-select_input>
 */
class SelectInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        this._options$ = new DelegatingListModel();
        this.optionLabelFormat = (option) => (option && this.optionLabel) ? option[this.optionLabel] : option;
    }
    ngOnInit() {
    }
}
SelectInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SelectInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SelectInputComponent, selector: "aup-select-input", inputs: { options$: "options$", optionsModel: "optionsModel", options: "options", optionLabel: "optionLabel", allowNil: "allowNil", optionLabelFormat: "optionLabelFormat" }, queries: [{ propertyName: "selectedOptionTemplateRef", first: true, predicate: ["selectedOptionTemplate"], descendants: true }, { propertyName: "optionTemplateRef", first: true, predicate: ["optionTemplate"], descendants: true }, { propertyName: "nilOptionTemplateRef", first: true, predicate: ["nilOptionTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <mat-select placeholder=\"{{placeholder}}\"\n              [(ngModel)]=\"componentValue$.value\"\n              [disabled]=\"!enabled$.value\"\n              (keydown.enter)=\"notifyEnterKey()\"\n              (keydown.escape)=\"notifyEscapeKey()\"\n              [pectinFocusBinding]=\"focusContext\"\n              [errorStateMatcher]=\"errorStateMatcher\"\n  >\n    <mat-select-trigger *ngIf=\"selectedOptionTemplateRef\">\n      <ng-container [ngTemplateOutlet]=\"selectedOptionTemplateRef\" [ngTemplateOutletContext]=\"{ $implicit: componentValue$.value}\"></ng-container>\n    </mat-select-trigger>\n\n    <mat-option *ngIf=\"allowNil\">\n      <ng-container *ngIf=\"!nilOptionTemplateRef\">{{placeholder}}</ng-container>\n      <ng-container *ngIf=\"nilOptionTemplateRef\" [ngTemplateOutlet]=\"nilOptionTemplateRef\"></ng-container>\n    </mat-option>\n    <mat-option *ngFor=\"let option of options$.value; let i = index\" [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n                    [ngTemplateOutlet]=\"optionTemplateRef\"\n                    [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n  </mat-select>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div class=\"item\" *ngFor=\"let item of options\">\n    <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(item)}}</ng-container>\n    <ng-container *ngIf=\"optionTemplateRef\"\n                  [ngTemplateOutlet]=\"optionTemplateRef\"\n                  [ngTemplateOutletContext]=\"{ $implicit: item, index: 0 }\"\n    >\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:0}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "component", type: i4$3.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "directive", type: i4$3.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "component", type: i5.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }] });
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], SelectInputComponent.prototype, "options$", void 0);
__decorate([
    TrackExternal({ delegateTo: "_options$" }),
    __metadata("design:type", ListModel)
], SelectInputComponent.prototype, "optionsModel", void 0);
__decorate([
    StoreInListModel('optionsModel'),
    __metadata("design:type", Array)
], SelectInputComponent.prototype, "options", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-select-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <mat-select placeholder=\"{{placeholder}}\"\n              [(ngModel)]=\"componentValue$.value\"\n              [disabled]=\"!enabled$.value\"\n              (keydown.enter)=\"notifyEnterKey()\"\n              (keydown.escape)=\"notifyEscapeKey()\"\n              [pectinFocusBinding]=\"focusContext\"\n              [errorStateMatcher]=\"errorStateMatcher\"\n  >\n    <mat-select-trigger *ngIf=\"selectedOptionTemplateRef\">\n      <ng-container [ngTemplateOutlet]=\"selectedOptionTemplateRef\" [ngTemplateOutletContext]=\"{ $implicit: componentValue$.value}\"></ng-container>\n    </mat-select-trigger>\n\n    <mat-option *ngIf=\"allowNil\">\n      <ng-container *ngIf=\"!nilOptionTemplateRef\">{{placeholder}}</ng-container>\n      <ng-container *ngIf=\"nilOptionTemplateRef\" [ngTemplateOutlet]=\"nilOptionTemplateRef\"></ng-container>\n    </mat-option>\n    <mat-option *ngFor=\"let option of options$.value; let i = index\" [value]=\"option\">\n      <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(option)}}</ng-container>\n      <ng-container *ngIf=\"optionTemplateRef\"\n                    [ngTemplateOutlet]=\"optionTemplateRef\"\n                    [ngTemplateOutletContext]=\"{ $implicit: option, index: i }\"\n      >\n      </ng-container>\n    </mat-option>\n  </mat-select>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n<div class=\"width-strut\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <div class=\"item\" *ngFor=\"let item of options\">\n    <ng-container *ngIf=\"!optionTemplateRef\">{{optionLabelFormat(item)}}</ng-container>\n    <ng-container *ngIf=\"optionTemplateRef\"\n                  [ngTemplateOutlet]=\"optionTemplateRef\"\n                  [ngTemplateOutletContext]=\"{ $implicit: item, index: 0 }\"\n    >\n    </ng-container>\n  </div>\n</div>\n", styles: [":host{display:inline-block}mat-form-field{width:100%}.width-strut{display:block;height:0;max-height:0;width:auto;visibility:hidden;overflow:hidden;padding-right:35px}.width-strut mat-label{font-size:75%}.width-strut>.item{font-size:16px;padding-left:0}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { options$: [{
                type: Input
            }], optionsModel: [{
                type: Input
            }], options: [{
                type: Input
            }], optionLabel: [{
                type: Input
            }], allowNil: [{
                type: Input
            }], selectedOptionTemplateRef: [{
                type: ContentChild,
                args: ['selectedOptionTemplate']
            }], optionTemplateRef: [{
                type: ContentChild,
                args: ['optionTemplate']
            }], nilOptionTemplateRef: [{
                type: ContentChild,
                args: ['nilOptionTemplate']
            }], optionLabelFormat: [{
                type: Input
            }] } });

class StringInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.clearCommand = Command.create(() => {
            this.componentValue$.value = "";
        });
        this.clearCommand.disableWhile(chain.stringValue(this.componentValue$).isBlank());
    }
    ngOnInit() {
    }
}
StringInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
StringInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: StringInputComponent, selector: "aup-string-input", inputs: { autocomplete: "autocomplete", enableClear$: "enableClear$", enableClear: "enableClear", iconPrefix: "iconPrefix" }, usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n  <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>\n  <button mat-button mat-icon-button matSuffix *ngIf=\"enableClear\" [pectinCommand]=\"clearCommand\">\n    <aup-icon icon=\"mat:close\"></aup-icon>\n  </button>\n</mat-form-field>\n\n", styles: ["button[disabled]{visibility:hidden}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i3$1.MatPrefix, selector: "[matPrefix]" }, { kind: "directive", type: i3$1.MatSuffix, selector: "[matSuffix]" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }] });
__decorate([
    TrackExternal({ defaultValue: false }),
    __metadata("design:type", ValueModel)
], StringInputComponent.prototype, "enableClear$", void 0);
__decorate([
    StoreInValueModel('enableClear$'),
    __metadata("design:type", Boolean)
], StringInputComponent.prototype, "enableClear", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-string-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <input matInput\n         placeholder=\"{{placeholder}}\"\n         [attr.autocomplete]=\"autocomplete\"\n         [(ngModel)]=\"componentValue$.value\"\n         [disabled]=\"!enabled$.value\"\n         (keydown.enter)=\"notifyEnterKey()\"\n         (keydown.escape)=\"notifyEscapeKey()\"\n         [pectinFocusBinding]=\"focusContext\"\n         [errorStateMatcher]=\"errorStateMatcher\"\n  >\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n  <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>\n  <button mat-button mat-icon-button matSuffix *ngIf=\"enableClear\" [pectinCommand]=\"clearCommand\">\n    <aup-icon icon=\"mat:close\"></aup-icon>\n  </button>\n</mat-form-field>\n\n", styles: ["button[disabled]{visibility:hidden}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { autocomplete: [{
                type: Input
            }], enableClear$: [{
                type: Input
            }], enableClear: [{
                type: Input
            }], iconPrefix: [{
                type: Input
            }] } });

class TextInputComponent extends AbstractValueInputComponent {
    constructor() {
        super();
        // @Input() @TrackExternal({ delegateTo: 'inputModel' })
        // valueModel: Form.ValueModelBase<string> | MutableValueModel<string>;
        this.rows = 2;
        // const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
    }
    ngOnInit() {
    }
}
TextInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TextInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TextInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TextInputComponent, selector: "aup-text-input", inputs: { rows: "rows", cols: "cols" }, usesInheritance: true, ngImport: i0, template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <textarea matInput\n            placeholder=\"{{placeholder}}\"\n            [(ngModel)]=\"componentValue$.value\"\n            [disabled]=\"!enabled$.value\"\n            (keydown.enter)=\"notifyEnterKey()\"\n            (keydown.escape)=\"notifyEscapeKey()\"\n            [pectinFocusBinding]=\"focusContext\"\n            [errorStateMatcher]=\"errorStateMatcher\"\n            [rows]=\"rows\"\n            [cols]=\"cols\"\n  >\n  </textarea>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n\n", styles: ["button[disabled]{visibility:hidden}textarea{overflow:auto}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "directive", type: i3$1.MatError, selector: "mat-error", inputs: ["id"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatHint, selector: "mat-hint", inputs: ["align", "id"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: FocusBindingDirective, selector: "[pectinFocusBinding]", inputs: ["pectinFocusBinding", "focusBindingTarget"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TextInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-text-input', template: "<mat-form-field appearance=\"standard\" [floatLabel]=\"floatLabel\">\n  <mat-label *ngIf=\"label\">{{label}}</mat-label>\n  <textarea matInput\n            placeholder=\"{{placeholder}}\"\n            [(ngModel)]=\"componentValue$.value\"\n            [disabled]=\"!enabled$.value\"\n            (keydown.enter)=\"notifyEnterKey()\"\n            (keydown.escape)=\"notifyEscapeKey()\"\n            [pectinFocusBinding]=\"focusContext\"\n            [errorStateMatcher]=\"errorStateMatcher\"\n            [rows]=\"rows\"\n            [cols]=\"cols\"\n  >\n  </textarea>\n  <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>\n  <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>\n</mat-form-field>\n\n", styles: ["button[disabled]{visibility:hidden}textarea{overflow:auto}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { rows: [{
                type: Input
            }], cols: [{
                type: Input
            }] } });

class LoadingContainerComponent extends GarbageCollector {
    constructor() {
        super();
    }
    get state() {
        return this.loadingModel.value ? "loaded" : "loading";
    }
    ngOnInit() {
    }
}
LoadingContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LoadingContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoadingContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: LoadingContainerComponent, selector: "aup-loading-container", inputs: { loadingModel: "loadingModel", loading: "loading", messageModel: "messageModel", message: "message" }, host: { properties: { "class": "this.state" } }, usesInheritance: true, ngImport: i0, template: "<ng-content *ngIf=\"!loadingModel.value\"></ng-content>\n<section *ngIf=\"loadingModel.value\" class=\"loading-indicator-overlay\">\n  <div class=\"loading-message\">\n    <p>{{messageModel.value}}</p>\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n  </div>\n</section>\n", styles: [":host{display:block;position:relative}section.loading-indicator-overlay{position:absolute;top:0;left:0;bottom:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.loading-message{display:inline-block;text-align:center;width:10em}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2$5.MatProgressBar, selector: "mat-progress-bar", inputs: ["color", "value", "bufferValue", "mode"], outputs: ["animationEnd"], exportAs: ["matProgressBar"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], LoadingContainerComponent.prototype, "loadingModel", void 0);
__decorate([
    StoreInValueModel("loadingModel"),
    __metadata("design:type", Boolean)
], LoadingContainerComponent.prototype, "loading", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], LoadingContainerComponent.prototype, "messageModel", void 0);
__decorate([
    StoreInValueModel("messageModel"),
    __metadata("design:type", String)
], LoadingContainerComponent.prototype, "message", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LoadingContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-loading-container', template: "<ng-content *ngIf=\"!loadingModel.value\"></ng-content>\n<section *ngIf=\"loadingModel.value\" class=\"loading-indicator-overlay\">\n  <div class=\"loading-message\">\n    <p>{{messageModel.value}}</p>\n    <mat-progress-bar mode=\"indeterminate\"></mat-progress-bar>\n  </div>\n</section>\n", styles: [":host{display:block;position:relative}section.loading-indicator-overlay{position:absolute;top:0;left:0;bottom:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center}.loading-message{display:inline-block;text-align:center;width:10em}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { loadingModel: [{
                type: Input
            }], loading: [{
                type: Input
            }], messageModel: [{
                type: Input
            }], message: [{
                type: Input
            }], state: [{
                type: HostBinding,
                args: ["class"]
            }] } });

class NoopComponent {
    constructor() {
    }
}
NoopComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NoopComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NoopComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: NoopComponent, selector: "aup-noop", ngImport: i0, template: "", styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NoopComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-noop', template: "", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return []; } });

class SectionHeaderComponent extends DisposableComponent {
    constructor() {
        super();
        // readonly i18n = I18nMarsUi.components.layout.header;
        this.size = 'medium';
        this.borderTop = false;
        this.borderBottom = false;
    }
    ngOnInit() {
    }
}
SectionHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SectionHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SectionHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SectionHeaderComponent, selector: "aup-section-header", inputs: { size: "size", borderTop: "borderTop", borderBottom: "borderBottom" }, host: { properties: { "class": "this.size", "class.border-top": "this.borderTop", "class.border-bottom": "this.borderBottom" } }, usesInheritance: true, ngImport: i0, template: "<span class=\"container-start\"><ng-content select=\"[header-start]\"></ng-content><ng-content></ng-content></span>\n<span class=\"container-middle\"><ng-content select=\"[header-center]\"></ng-content></span>\n<span class=\"container-end\"><ng-content select=\"[header-end]\"></ng-content></span>\n", styles: [":host{display:flex;flex-direction:row;align-items:center;--resolved-padding: var(--padding, var(--default-padding));--resolved-padding-right: var(--padding-right, calc(var(--default-padding)/2));padding-left:var(--resolved-padding);padding-right:var(--resolved-padding-right);box-sizing:border-box}:host.has-back-button{padding-left:0}:host.toolbar{height:56px;min-height:56px}:host.toolbar span{font-weight:500;font-size:18px;color:#000000ab}:host.large{height:48px;min-height:48px}:host.large span{font-weight:500;font-size:14px;color:#000000ab}:host.medium{height:48px;min-height:48px}:host.medium span{font-weight:500;font-size:13px;color:#000000ab}:host.small{height:30px;min-height:30px}:host.small span{font-weight:300;font-size:12px;color:#000000ab}:host.border-top{border-top:var(--pinstripe-border)}:host.border-bottom{border-bottom:var(--pinstripe-border)}span{white-space:nowrap;display:inline-flex;flex-direction:row;align-items:center}span.container-start{justify-content:flex-start}span.container-middle{justify-content:center;flex:1;width:0;overflow:hidden}span.container-end{justify-content:flex-end}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SectionHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-section-header', template: "<span class=\"container-start\"><ng-content select=\"[header-start]\"></ng-content><ng-content></ng-content></span>\n<span class=\"container-middle\"><ng-content select=\"[header-center]\"></ng-content></span>\n<span class=\"container-end\"><ng-content select=\"[header-end]\"></ng-content></span>\n", styles: [":host{display:flex;flex-direction:row;align-items:center;--resolved-padding: var(--padding, var(--default-padding));--resolved-padding-right: var(--padding-right, calc(var(--default-padding)/2));padding-left:var(--resolved-padding);padding-right:var(--resolved-padding-right);box-sizing:border-box}:host.has-back-button{padding-left:0}:host.toolbar{height:56px;min-height:56px}:host.toolbar span{font-weight:500;font-size:18px;color:#000000ab}:host.large{height:48px;min-height:48px}:host.large span{font-weight:500;font-size:14px;color:#000000ab}:host.medium{height:48px;min-height:48px}:host.medium span{font-weight:500;font-size:13px;color:#000000ab}:host.small{height:30px;min-height:30px}:host.small span{font-weight:300;font-size:12px;color:#000000ab}:host.border-top{border-top:var(--pinstripe-border)}:host.border-bottom{border-bottom:var(--pinstripe-border)}span{white-space:nowrap;display:inline-flex;flex-direction:row;align-items:center}span.container-start{justify-content:flex-start}span.container-middle{justify-content:center;flex:1;width:0;overflow:hidden}span.container-end{justify-content:flex-end}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { size: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class']
            }], borderTop: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.border-top']
            }], borderBottom: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.border-bottom']
            }] } });

class SwitchCaseOption {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
    get name() {
        return this.constructor.name;
    }
}
class SwitchCaseWhenDirective extends SwitchCaseOption {
    constructor(templateRef) {
        super(templateRef);
        this.isDefault = false;
    }
    matches(value) {
        return this.aupSwitchCaseWhen === value;
    }
}
SwitchCaseWhenDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseWhenDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
SwitchCaseWhenDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: SwitchCaseWhenDirective, selector: "[aupSwitchCaseWhen]", inputs: { aupSwitchCaseWhen: "aupSwitchCaseWhen" }, providers: [{ provide: SwitchCaseOption, useExisting: SwitchCaseWhenDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseWhenDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aupSwitchCaseWhen]',
                    providers: [{ provide: SwitchCaseOption, useExisting: SwitchCaseWhenDirective }]
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; }, propDecorators: { aupSwitchCaseWhen: [{
                type: Input
            }] } });
class SwitchCaseDefaultDirective extends SwitchCaseOption {
    constructor(templateRef) {
        super(templateRef);
        this.isDefault = true;
    }
    matches(value) {
        return false;
    }
}
SwitchCaseDefaultDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseDefaultDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
SwitchCaseDefaultDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: SwitchCaseDefaultDirective, selector: "[aupSwitchCaseDefault]", providers: [{ provide: SwitchCaseOption, useExisting: SwitchCaseDefaultDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseDefaultDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aupSwitchCaseDefault]',
                    providers: [{ provide: SwitchCaseOption, useExisting: SwitchCaseDefaultDirective }]
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
/**
 * @example
 * <aup-switch-case [switchModel]="booleanModel">
 *    <div *aupSwitchCaseWhen="true"></div>
 *    <div *aupSwitchCaseDefault>The default content</div>
 * </aup-switch-case>
 */
class SwitchCaseComponent extends DisposableComponent {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.selectedIndex = 0;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        const subscription = this.switchCaseOptions.changes.subscribe(change => this.updateSelection());
        this.onDispose(() => subscription.unsubscribe());
        const { chain, when } = Dsl.disposeWith(this);
        when(this.switchModel).changes(() => this.updateSelection(), { initialValue: 'triggerChange' });
        this.cdr.detectChanges();
    }
    updateSelection() {
        const matchingIndicies = [];
        this.switchCaseOptions.forEach((option, index) => {
            if (option.matches(this.switchModel.value)) {
                matchingIndicies.push(index);
            }
        });
        if (matchingIndicies.length > 1) {
            console.warn(`found ${matchingIndicies.length} matching case values, displaying the first.`);
        }
        if (matchingIndicies.length === 0) {
            this.switchCaseOptions.forEach((option, index) => {
                if (option.isDefault) {
                    matchingIndicies.push(index);
                }
            });
            if (matchingIndicies.length > 1) {
                console.warn(`found ${matchingIndicies.length} default case values, displaying the first.`);
            }
        }
        if (matchingIndicies.length > 0) {
            this.selectedIndex = matchingIndicies[0];
        }
        else {
            console.warn(`found no matching or default case values.`);
            this.selectedIndex = -1;
        }
    }
}
SwitchCaseComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
SwitchCaseComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SwitchCaseComponent, selector: "aup-switch-case", inputs: { switchModel: "switchModel", switch: "switch" }, queries: [{ propertyName: "switchCaseOptions", predicate: SwitchCaseOption }], usesInheritance: true, ngImport: i0, template: "<mat-tab-group class=\"content-wrapper\" no-tab-header full-height-tabs [selectedIndex]=\"selectedIndex\">\n  <mat-tab *ngFor=\"let option of switchCaseOptions\">\n    <ng-template [ngTemplateOutlet]=\"option.templateRef\"></ng-template>\n  </mat-tab>\n</mat-tab-group>\n\n\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}mat-tab-group{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], SwitchCaseComponent.prototype, "switchModel", void 0);
__decorate([
    StoreInValueModel('switchModel'),
    __metadata("design:type", Object)
], SwitchCaseComponent.prototype, "switch", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SwitchCaseComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-switch-case', template: "<mat-tab-group class=\"content-wrapper\" no-tab-header full-height-tabs [selectedIndex]=\"selectedIndex\">\n  <mat-tab *ngFor=\"let option of switchCaseOptions\">\n    <ng-template [ngTemplateOutlet]=\"option.templateRef\"></ng-template>\n  </mat-tab>\n</mat-tab-group>\n\n\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}mat-tab-group{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { switchModel: [{
                type: Input
            }], switch: [{
                type: Input
            }], switchCaseOptions: [{
                type: ContentChildren,
                args: [SwitchCaseOption]
            }] } });

const HEADER_CELL_RENDERER_PORTAL = Symbol('aup-cell-header-renderer-component-ref');
const CELL_RENDERER_PORTAL = Symbol('aup-cell-renderer-component-ref');
const CELL_EDITOR_PORTAL = Symbol('aup-cell-editor-component-ref');
const PORTAL_RENDERER_COMPONENT = Symbol('aup-cell-renderer-portal-component');
const PORTAL_EDITOR_COMPONENT = Symbol('aup-cell-editor-portal-component');
class CellPortalRef {
    constructor() {
    }
}
class CellHeaderPortalRef extends CellPortalRef {
    constructor(componentType, initialiseHeader) {
        super();
        this.componentType = componentType;
        this.initialiseHeader = initialiseHeader;
    }
    initialiseHost(host, columnModel) {
        assert$1.isTruthy(host);
        host[HEADER_CELL_RENDERER_PORTAL] = new ComponentPortal(this.componentType);
    }
    // @Trace()
    onPortalAttached(host, portalComponent) {
        this.initialiseHeader(portalComponent, host.column);
    }
}
class CellRendererPortalRef extends CellPortalRef {
}
class ComponentCellRendererPortalRef extends CellRendererPortalRef {
    constructor(componentType, updateComponent) {
        super();
        this.componentType = componentType;
        this.updateComponent = updateComponent;
    }
    initialiseHost(host, columnModel) {
        host[CELL_RENDERER_PORTAL] = new ComponentPortal(this.componentType);
    }
    // @Trace()
    onPortalAttached(host, portalComponent) {
        host[PORTAL_RENDERER_COMPONENT] = portalComponent;
        this.updateComponent(portalComponent, host.getRowData(), true);
    }
    // @Trace()
    pushState(host) {
        if (host[PORTAL_RENDERER_COMPONENT]) {
            this.updateComponent(host[PORTAL_RENDERER_COMPONENT], host.getRowData(), false);
        }
    }
}
class CellEditorPortalRef extends CellPortalRef {
    constructor(componentType, initialiseEditorSession) {
        super();
        this.componentType = componentType;
        this.initialiseEditorSession = initialiseEditorSession;
    }
    initialiseHost(host, columnModel) {
        assert$1.isTruthy(host);
        host[CELL_EDITOR_PORTAL] = new ComponentPortal(this.componentType);
    }
    // @Trace()
    onPortalAttached(host, portalComponent) {
        host[PORTAL_EDITOR_COMPONENT] = portalComponent;
        this.initialiseEditorSession(portalComponent, host.editSession);
    }
}
class TemplateCellRendererPortalRef extends CellRendererPortalRef {
    constructor() {
        super();
    }
    registerPortal(templateRef, viewContainer, fillCell, padChild) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.fillCell = fillCell;
        this.padChild = padChild;
    }
    initialiseHost(host, columnModel) {
        assert$1.isTruthy(host);
    }
    // @Trace()
    onPortalAttached(host, portalComponent) {
        //  don't care
    }
    // @Trace()
    pushState(host) {
        host[CELL_RENDERER_PORTAL] = this.createPortal(host.getRowData());
        host.fillCell = this.fillCell;
        host.padChild = this.padChild;
    }
    createPortal(data) {
        return new TemplatePortal(this.templateRef, this.viewContainer, { ...(data), $implicit: data.row });
    }
}

class DefaultHeaderCellRendererComponent {
    constructor() {
    }
}
DefaultHeaderCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DefaultHeaderCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DefaultHeaderCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: DefaultHeaderCellRendererComponent, selector: "aup-default-header-renderer", inputs: { headerText: "headerText" }, ngImport: i0, template: "{{headerText}}\n", styles: [""] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DefaultHeaderCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-default-header-renderer', template: "{{headerText}}\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { headerText: [{
                type: Input
            }] } });

class ColumnTextSearchFormatter {
}
(function (ColumnTextSearchFormatter) {
    class Delegate extends ColumnTextSearchFormatter {
    }
    ColumnTextSearchFormatter.Delegate = Delegate;
    class Delegating extends ColumnTextSearchFormatter.Delegate {
        constructor(delegateClass) {
            super();
            this.delegateClass = delegateClass;
        }
        initialise(injector) {
            this._delegate = injector.get(this.delegateClass);
            if (this._delegate instanceof Delegating) {
                this._delegate.initialise(injector);
            }
        }
        format(row) {
            return this._delegate ? this._delegate.format(row) : "";
        }
    }
    ColumnTextSearchFormatter.Delegating = Delegating;
    function forFormatter(formatter) {
        return new class extends ColumnTextSearchFormatter {
            format(value) {
                return formatter(value);
            }
        };
    }
    ColumnTextSearchFormatter.forFormatter = forFormatter;
    class Null extends ColumnTextSearchFormatter {
        format(value) {
            return "";
        }
    }
    ColumnTextSearchFormatter.Null = Null;
    class DefaultValueFormatter extends ColumnTextSearchFormatter {
        format(value) {
            // console.log("DefaultValueFormatter", { value, text: s })
            return value?.toString() ?? "";
        }
    }
    ColumnTextSearchFormatter.DefaultValueFormatter = DefaultValueFormatter;
    class DefaultArrayFormatter extends ColumnTextSearchFormatter {
        format(value) {
            return value ? value.map(it => it?.toString()).join(",") : "";
        }
    }
    ColumnTextSearchFormatter.DefaultArrayFormatter = DefaultArrayFormatter;
})(ColumnTextSearchFormatter || (ColumnTextSearchFormatter = {}));

const noop = () => {
};
class ColumnTextSearchWrapper extends ColumnTextSearchFormatter.Delegate {
    constructor() {
        super(...arguments);
        this._map = Functions.identity;
    }
    initialise(injector) {
        if (this._delegate instanceof ColumnTextSearchFormatter.Delegate) {
            this._delegate.initialise(injector);
        }
    }
    format(row) {
        let value = this._map(row);
        let result = this._delegate ? this._delegate.format(value) : "";
        // console.log({format: row, value, text:result})
        return result;
    }
    setDelegate(formatter, mapper) {
        this._delegate = formatter;
        this._map = mapper ?? Functions.identity;
    }
}
class ColumnModel extends GarbageCollector {
    constructor(columnId, textPropertiesProvider) {
        super();
        this.columnId = columnId;
        this.textPropertiesProvider = textPropertiesProvider;
        this._enableRowSelection = true;
        this._flex = false;
        this._defaultVisibility$ = this.registerDisposable(new DelegatingValueModel().withDefault(true));
        this._masterVisibility$ = this.registerDisposable(new DelegatingValueModel().withDefault(true));
        this._userVisible$ = this.registerDisposable(new DelegatingValueModel().withDefault(this._defaultVisibility$));
        this.textSearchDelegate = new ColumnTextSearchWrapper();
        const { valueOf } = Dsl.disposeWith(this);
        this.installHeaderRenderer();
        this.dasherisedColumnId = Stringy.from(columnId).dasherize().toString();
        this.visible$ = valueOf.all(this._userVisible$, this._masterVisibility$).areTruthy();
    }
    installHeaderRenderer() {
        this.cellHeaderRenderer(DefaultHeaderCellRendererComponent, (component, column) => {
            component.headerText = column.getHeaderText();
        });
    }
    getHeaderText() {
        return this.getColumnTextProperties()?.headerText() || this.getDefaultHeaderText();
    }
    isVisible() {
        return this.visible$.value;
    }
    visibleWhile(visible) {
        this._userVisible$.setDelegate(visible);
        return this;
    }
    setDefaultVisibility(visible) {
        this._defaultVisibility$.setDelegate(visible);
    }
    setMasterVisibility(visible) {
        this._masterVisibility$.setDelegate(visible);
    }
    getDefaultHeaderText() {
        return this.columnId;
    }
    getColumnTextProperties() {
        return this._columnTextProperties || this.textPropertiesProvider();
    }
    /**
     * @deprecated use #columnTextProperties instead
     * @param columnTextProperties
     */
    textProperties(columnTextProperties) {
        return this.columnTextProperties(columnTextProperties);
    }
    columnTextProperties(columnTextProperties) {
        this._columnTextProperties = columnTextProperties;
        return this;
    }
    getSearchTextFor(row) {
        return this.textSearchDelegate.format(row);
    }
    configureColumnTextSearch(formatter, mapper) {
        assert$1.notNil(formatter);
        // console.log({col: this.columnId, formatter});
        this.textSearchDelegate.setDelegate(formatter, mapper);
        return this;
    }
    configureHeaderRenderer(config) {
        this._columnHeaderPortalRef = config;
    }
    configureCellRenderer(config) {
        this._cellRendererPortalRef = config;
    }
    configureCellEditor(cellEditor) {
        this._cellEditorPortalRef = cellEditor;
    }
    cellHeaderRenderer(componentType, initialiser) {
        this.configureHeaderRenderer(new CellHeaderPortalRef(componentType, initialiser));
        return this;
    }
    flex(flex = true) {
        this._flex = flex;
    }
    isFlex() {
        return this._flex;
    }
    hasEditorPortal() {
        return !!this._cellEditorPortalRef;
    }
    attachHeaderCell(host) {
        this._columnHeaderPortalRef.initialiseHost(host, this);
    }
    attachCell(host) {
        this._cellRendererPortalRef.initialiseHost(host, this);
        if (this.hasEditorPortal()) {
            this._cellEditorPortalRef.initialiseHost(host, this);
        }
    }
    onHeaderAttached(host, ref) {
        const component = this.getComponent(ref);
        this._columnHeaderPortalRef.onPortalAttached(host, component);
    }
    onRendererAttached(host, ref) {
        const component = this.getComponentOrEmbeddedView(ref);
        this._cellRendererPortalRef.onPortalAttached(host, component);
    }
    // @Trace()
    onEditorAttached(host, ref) {
        this._cellEditorPortalRef.onPortalAttached(host, this.getComponent(ref));
    }
    updatePortalContent(host) {
        this._cellRendererPortalRef.pushState(host);
    }
    _selectRowOnClick(selectRowOnClick) {
        this._enableRowSelection = selectRowOnClick;
        return this;
    }
    isRowSelectionEnabled() {
        return this._enableRowSelection;
    }
    getComponent(ref) {
        if (ref instanceof ComponentRef) {
            return ref.instance;
        }
        else {
            console.error("headers only support component portals, got", ref);
            lang$1.illegalState(`headers only support component portals, got ${ref}`);
        }
    }
    getComponentOrEmbeddedView(ref) {
        if (ref instanceof ComponentRef) {
            return ref.instance;
        }
        else {
            return ref;
        }
    }
    initialise(injector) {
        this.textSearchDelegate.initialise(injector);
    }
}
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], ColumnModel.prototype, "getHeaderText", null);
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Object)
], ColumnModel.prototype, "getColumnTextProperties", null);
(function (ColumnModel) {
    ColumnModel.CELL_RENDERER_COMPONENT_ROW_CACHE = Symbol('aup-cell-renderer:row-data-cache');
})(ColumnModel || (ColumnModel = {}));

class CustomTemplateColumnModel extends ColumnModel {
    constructor(columnId, defaults) {
        super(columnId, defaults);
        this.config = new TemplateCellRendererPortalRef();
        this.configureCellRenderer(this.config);
    }
    setTemplate(templateRef, viewContainer, fillCell, padChild) {
        this.config.registerPortal(templateRef, viewContainer, fillCell, padChild);
    }
    selectRowOnClick(selectOnRowClick) {
        return this._selectRowOnClick(selectOnRowClick);
    }
}

/**
 * Create your model:
 * @example
 * this.heroTableModel = new TableModel(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 * });
 *
 * Create your table
 * @example
 * <aup-table [tableModel]="heroTableModel"></aup-table>
 *
 * Column templates
 * @example
 * this.heroTableModel = new TableModel(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addTemplateColumn("specialColumn");
 * });
 * <aup-table [tableModel]="heroTableModel">
 *   <div *aupColumnTemplate="let hero; columnId: 'specialColumn'; fillCell: true; padChild:false">
 *     {{hero.name}}
 *   </div>
 * </aup-table>
 *
 * Styling
 * @example
 *  // global settings
 * :root {
 *   --aup-table-column-gap: 10px; // defaults to 24px
 *   --aup-table-row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --aup-table-row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --aup-table-first-column-padding-left: 18px // defaults to --column-gap
 *   --aup-table-last-column-padding-right: 18px // defaults to --column-gap
 * }
 *
 * // per table settings.
 * aup-table {
 *   --column-gap: 10px; // defaults to 24px
 *   --row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --first-column-padding-left: 18px // defaults to --column-gap
 *   --last-column-padding-right: 18px // defaults to --column-gap
 *
 *   aup-table-header-cell-renderer,
 *   aup-table-cell-renderer {
 *     &.aup-col-my-dasherised-column-id {
 *       // do stuff
 *     }
 *     &.first-visible-column {
 *       // do stuff
 *     }
 *     &.last-visible-column {
 *       // do stuff
 *     }
 *   }
 * }
 */
class AbstractTableComponent extends DisposableComponent {
    constructor(injector) {
        super();
        this.injector = injector;
        /**
         * Set to true to enable scrolling.  Once enabled the table will have 0 implicit height.  You will either
         * need to set it explicitly e.g. height: 400px; or by using flex or grid layout to make it fill it's
         * containment area.
         */
        this.enableScrolling = false;
        // TODO: support user defined header and row heights via css vars.
        this.headerHeight = new MutableValueModel(56);
        this.rowHeight = new MutableValueModel(48);
        this.baseCssClass = 'aup-table-component';
        const { chain, when } = Dsl.disposeWith(this);
    }
    ngOnInit() {
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        const model = this.getModel();
        model.initialise(this.injector);
        this.columnsById = chain(model.columns).indexBy('columnId');
    }
    getModel() {
        return lang$1.abstractMethod(this.constructor);
    }
    registerColumnTemplate(columnId, templateRef, viewContainer, fillCell, padChild) {
        const column = this.columnsById.get(columnId);
        if (column instanceof CustomTemplateColumnModel) {
            column.setTemplate(templateRef, viewContainer, fillCell, padChild);
        }
    }
}
AbstractTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractTableComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
AbstractTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractTableComponent, selector: "aup-abstract-table", inputs: { showHeader$: "showHeader$", showHeader: "showHeader", enableScrolling: "enableScrolling" }, host: { properties: { "class": "this.baseCssClass" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    TrackExternal({ defaultValue: true }),
    __metadata("design:type", ValueModel)
], AbstractTableComponent.prototype, "showHeader$", void 0);
__decorate([
    StoreInValueModel("showHeader$"),
    __metadata("design:type", Boolean)
], AbstractTableComponent.prototype, "showHeader", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'aup-abstract-table',
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { showHeader$: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], enableScrolling: [{
                type: Input
            }], baseCssClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ColumnTemplateDirective {
    constructor(host, templateRef, viewContainer) {
        this.host = host;
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.aupColumnTemplateFillCell = false;
        this.aupColumnTemplateAutoPadChild = undefined;
    }
    ngOnInit() {
        assert.isTruthy(this.aupColumnTemplateColumnId);
        this.host.registerColumnTemplate(this.aupColumnTemplateColumnId, this.templateRef, this.viewContainer, this.aupColumnTemplateFillCell, this.aupColumnTemplateAutoPadChild ?? this.aupColumnTemplateFillCell);
    }
}
ColumnTemplateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ColumnTemplateDirective, deps: [{ token: AbstractTableComponent }, { token: i0.TemplateRef }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
ColumnTemplateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: ColumnTemplateDirective, selector: "[aupColumnTemplate]", inputs: { aupColumnTemplate: "aupColumnTemplate", aupColumnTemplateColumnId: "aupColumnTemplateColumnId", aupColumnTemplateFillCell: "aupColumnTemplateFillCell", aupColumnTemplateAutoPadChild: "aupColumnTemplateAutoPadChild" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ColumnTemplateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aupColumnTemplate]'
                }]
        }], ctorParameters: function () { return [{ type: AbstractTableComponent }, { type: i0.TemplateRef }, { type: i0.ViewContainerRef }]; }, propDecorators: { aupColumnTemplate: [{
                type: Input
            }], aupColumnTemplateColumnId: [{
                type: Input
            }], aupColumnTemplateFillCell: [{
                type: Input
            }], aupColumnTemplateAutoPadChild: [{
                type: Input
            }] } });

class DefaultCellRendererComponent {
    constructor() {
    }
    set value(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
}
DefaultCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DefaultCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DefaultCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: DefaultCellRendererComponent, selector: "aup-default-cell-renderer", inputs: { value: "value" }, ngImport: i0, template: "<span [innerHTML]=\"value| aupHighlight\"></span>\n", styles: [""], dependencies: [{ kind: "pipe", type: HighlightPipe, name: "aupHighlight" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DefaultCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-default-cell-renderer", template: "<span [innerHTML]=\"value| aupHighlight\"></span>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }] } });

class EditSession extends GarbageCollector {
    constructor(rowId, row, form, saveCommand) {
        super();
        this.rowId = rowId;
        this.form = form;
        this.saveCommand = saveCommand;
        this._liveRowValue$ = new MutableValueModel();
        this.liveRowValue$ = this._liveRowValue$.readonly;
        this.form.load(row);
        this._liveRowValue$.value = row;
        this.form.onEdit(() => {
            // if (!this._liveRowValue.value[immerable]) {
            //   console.warn()
            // }
            this._liveRowValue$.value = produce(this._liveRowValue$.value, draft => {
                this.form.writeDirtyStateTo(draft);
            });
        });
    }
}

class EditRowControls extends DisposableComponent {
    constructor() {
        super();
        this.saveCommand = Command.create(async () => {
            const finished = await this.editSession.saveCommand.execute();
            if (finished) {
                this.editSession.dispose();
            }
        });
        this.cancelCommand = Command.create(() => {
            this.editSession.dispose();
        }).disableWhile(this.saveCommand.busy$);
    }
    set editSession(session) {
        if (session) {
            session.form.disableWhile(this.saveCommand.busy$);
        }
        this._session = session;
    }
    get editSession() {
        return this._session;
    }
    ngOnInit() {
    }
    get form() {
        return this.editSession?.form;
    }
}
EditRowControls.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: EditRowControls, deps: [], target: i0.ɵɵFactoryTarget.Component });
EditRowControls.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: EditRowControls, selector: "aup-row-editor-controls", inputs: { row: "row", editRowCommand: "editRowCommand", editSession: "editSession" }, usesInheritance: true, ngImport: i0, template: "<button *ngIf=\"!editSession\" mat-icon-button [pectinCommand]=\"editRowCommand\" class=\"edit-button\"><aup-icon icon=\"mat:edit\"></aup-icon></button>\n<button *ngIf=\"editSession\" mat-icon-button [pectinCommand]=\"saveCommand\"><aup-icon icon=\"mat:done\"></aup-icon></button>\n<button *ngIf=\"editSession\" mat-icon-button [pectinCommand]=\"cancelCommand\"><aup-icon icon=\"mat:clear\"></aup-icon></button>\n", styles: [":host{display:block;width:80px}.edit-button{visibility:hidden}:host-context(tr:hover) .edit-button{visibility:visible}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], EditRowControls.prototype, "editRowCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: EditRowControls, decorators: [{
            type: Component,
            args: [{ selector: 'aup-row-editor-controls', template: "<button *ngIf=\"!editSession\" mat-icon-button [pectinCommand]=\"editRowCommand\" class=\"edit-button\"><aup-icon icon=\"mat:edit\"></aup-icon></button>\n<button *ngIf=\"editSession\" mat-icon-button [pectinCommand]=\"saveCommand\"><aup-icon icon=\"mat:done\"></aup-icon></button>\n<button *ngIf=\"editSession\" mat-icon-button [pectinCommand]=\"cancelCommand\"><aup-icon icon=\"mat:clear\"></aup-icon></button>\n", styles: [":host{display:block;width:80px}.edit-button{visibility:hidden}:host-context(tr:hover) .edit-button{visibility:visible}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { row: [{
                type: Input
            }], editRowCommand: [{
                type: Input
            }], editSession: [{
                type: Input
            }] } });

class SelectionCellComponent extends DisposableComponent {
    constructor() {
        super();
        this.selectCommand = Command.create(() => {
            this.selectionModel.selectCommand.execute(this.row);
        }, { enableWhile: this.selectionModel.enabled$ });
    }
    isSelected() {
        return this.selectionModel.isSelected(this.row);
    }
}
SelectionCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectionCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SelectionCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SelectionCellComponent, selector: "aup-selection-cell", inputs: { row: "row" }, usesInheritance: true, ngImport: i0, template: "<mat-checkbox [pectinCommand]=\"selectCommand\" [checked]=\"isSelected()\"  [color]=\"color\"></mat-checkbox>\n", styles: [""], dependencies: [{ kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: i4$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", SelectionModel)
], SelectionCellComponent.prototype, "selectionModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectionCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-selection-cell', template: "<mat-checkbox [pectinCommand]=\"selectCommand\" [checked]=\"isSelected()\"  [color]=\"color\"></mat-checkbox>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { row: [{
                type: Input
            }], selectionModel: [] } });

class SelectionHeaderCellComponent extends DisposableComponent {
    constructor() {
        super();
        this.selectCommand = Command.create(() => {
            this.selectionModel.toggleAllCommand.execute();
        });
    }
    isSelected() {
        return this.ifMultiSelectionModel(m => m.allSelected$.value, false);
    }
    isIntermediate() {
        return this.ifMultiSelectionModel(m => m.someSelected$.value, false);
    }
    isVisible() {
        return this.enableHeaderControls && this.isMultiSelectionModel();
    }
    isMultiSelectionModel() {
        return HasDelegate.findRoot(this.selectionModel) instanceof MultipleSelectionModel;
    }
    ifMultiSelectionModel(runnable, otherwise) {
        if (this.isMultiSelectionModel()) {
            return runnable(this.selectionModel);
        }
        else {
            return otherwise;
        }
    }
}
SelectionHeaderCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectionHeaderCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SelectionHeaderCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SelectionHeaderCellComponent, selector: "aup-selection-header-cell", usesInheritance: true, ngImport: i0, template: "<mat-checkbox *ngIf=\"isVisible()\" [pectinCommand]=\"selectCommand\" [checked]=\"isSelected()\" [indeterminate]=\"this.isIntermediate()\" [color]=\"color\"></mat-checkbox>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: i4$2.MatCheckbox, selector: "mat-checkbox", inputs: ["disableRipple", "color", "tabIndex"], exportAs: ["matCheckbox"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", SelectionModel)
], SelectionHeaderCellComponent.prototype, "selectionModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectionHeaderCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-selection-header-cell', template: "<mat-checkbox *ngIf=\"isVisible()\" [pectinCommand]=\"selectCommand\" [checked]=\"isSelected()\" [indeterminate]=\"this.isIntermediate()\" [color]=\"color\"></mat-checkbox>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { selectionModel: [] } });

class ColumnListModel extends AbstractComputedListModel {
    constructor() {
        super();
        this._allColumns$ = new MutableListModel();
        const { chain } = Dsl.disposeWith(this);
        this.columnsById$ = chain(this._allColumns$).indexBy('columnId');
    }
    get allColumns$() {
        return this._allColumns$.readonly;
    }
    getColumn(id) {
        return this.columnsById$.get(id);
    }
    hasColumn(id) {
        return !!this.columnsById$.get(id);
    }
    hasMatchingColumn(row, regex) {
        // only search the visible columns
        return !!this.value.find(c => regex.test(c.getSearchTextFor(row)));
    }
    addColumn(column, index) {
        if (this.hasColumn(column.columnId)) {
            lang.illegalState(`Column with id=${column.columnId} already exists`);
        }
        this.registerDisposable(column);
        this.runInTransaction(() => {
            if (!isNil(index)) {
                this._allColumns$.insert(index, column);
            }
            else {
                this._allColumns$.push(column);
            }
            this.registerDisposable(this.trackSource(column.visible$));
        });
        return column;
    }
    doComputeValue() {
        return this._allColumns$.value.filter(c => c.visible$.value);
    }
}

const TEXT_SEARCH_FORMATTER_KEY = `aup:table:textSearchFormatter`;
const Keys = Enum("useFunction", "useInstance", "useClass");
function EnableCellTextSearch(options) {
    assert$1.notNil(options);
    return (constructor) => {
        const klass = Klass.get(constructor);
        assert$1.isFalsey(klass.hasOwnMetadata(TEXT_SEARCH_FORMATTER_KEY), "class already decorated with @EnableCellTextSearch");
        klass.defineMetadata(TEXT_SEARCH_FORMATTER_KEY, options);
    };
}
(function (EnableCellTextSearch) {
    function getFormatter(renderer, useDefault) {
        const options = Klass.get(renderer).getMetadata(TEXT_SEARCH_FORMATTER_KEY) ?? {};
        if (options[Keys.useFunction]) {
            return ColumnTextSearchFormatter.forFormatter(options[Keys.useFunction]);
        }
        if (options[Keys.useInstance]) {
            return options[Keys.useInstance];
        }
        if (options[Keys.useClass]) {
            return new ColumnTextSearchFormatter.Delegating(options[Keys.useClass]);
        }
        return useDefault();
    }
    EnableCellTextSearch.getFormatter = getFormatter;
})(EnableCellTextSearch || (EnableCellTextSearch = {}));

class CustomValueColumnModel extends ColumnModel {
    constructor(columnId, defaults, getValue) {
        super(columnId, defaults);
        this.getValue = getValue;
        this.cellRenderer(DefaultCellRendererComponent);
    }
    cellRenderer(componentType, onComponentInitOrOptions) {
        this.configureColumnTextSearch(EnableCellTextSearch.getFormatter(componentType, () => new ColumnTextSearchFormatter.Null()), row => this.getValue(row));
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData, firstTime) => {
            if (firstTime) {
                if (isFunction$1(onComponentInitOrOptions)) {
                    onComponentInitOrOptions(component);
                }
                else {
                    if (isFunction$1(onComponentInitOrOptions?.onComponentInit)) {
                        onComponentInitOrOptions.onComponentInit(component);
                    }
                }
            }
            component.value = this.getValue(rowData.row);
            if (!isFunction$1(onComponentInitOrOptions) && isFunction$1(onComponentInitOrOptions?.onRowUpdate)) {
                onComponentInitOrOptions.onRowUpdate(component, rowData.row);
            }
        }));
        return this;
    }
    selectRowOnClick(selectOnRowClick) {
        return this._selectRowOnClick(selectOnRowClick);
    }
}

class EditorControlColumnModel extends ColumnModel {
    constructor(columnId, saveCommandFactory, defaults) {
        super(columnId, defaults);
        this.cellRenderer(EditRowControls);
    }
    cellRenderer(componentType) {
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData) => {
            component.row = rowData.row;
            component.editSession = rowData.editSession;
            component.editRowCommand = rowData.editRowCommand;
        }));
        return this;
    }
    getDefaultHeaderText() {
        return '';
    }
}

class ListPropertyColumnModel extends ColumnModel {
    constructor(id, property, defaults) {
        super(id, defaults);
        this.property = property;
        this._defaultSearchTextFormat = value => {
            const intermediate = (this._userFormat ?? Functions.identity)(value);
            return Array.isArray(intermediate) ?
                intermediate.map(v => v?.toString()).join(", ") :
                intermediate?.toString();
        };
        this.cellRenderer(DefaultCellRendererComponent);
    }
    cellRenderer(componentType) {
        this.configureColumnTextSearch(EnableCellTextSearch.getFormatter(componentType, () => ColumnTextSearchFormatter.forFormatter(this._defaultSearchTextFormat)), row => row[this.property]);
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData) => {
            const rowValue = rowData.row[this.property];
            // @ts-ignore Started complaining in ts 4.5.. but I think my logic is correct...
            component.value = (this._userFormat) ? this._userFormat(rowValue) : rowValue;
        }));
        return this;
    }
    cellEditor(editor, validatorsOrInitialiser, initialiseComponent) {
        const validators = Array.isArray(validatorsOrInitialiser) ? validatorsOrInitialiser : undefined;
        const initialiser = isFunction$1(validatorsOrInitialiser) ? validatorsOrInitialiser : initialiseComponent;
        this.configureCellEditor(new CellEditorPortalRef(editor, (component, editSession) => {
            const formListModel = editSession.form.pluckList(this.property);
            if (validators) {
                formListModel.validateUsing(validators);
            }
            component.listModel = formListModel;
            if (initialiser) {
                initialiser(component);
            }
        }));
        return this;
    }
    format(formatter) {
        assert$1.isFunction(formatter);
        this._userFormat = formatter;
        return this;
    }
    selectRowOnClick(selectRowOnClick) {
        return this._selectRowOnClick(selectRowOnClick);
    }
}

class PropertyColumnModel extends ColumnModel {
    constructor(id, property, defaults) {
        super(id, defaults);
        this.property = property;
        this._defaultSearchTextFormatter = (value) => {
            return (this._userFormat ?? Functions.identity)(value)?.toString();
        };
        this.cellRenderer(DefaultCellRendererComponent);
    }
    cellRenderer(componentType, onComponentInitOrOptions) {
        this.configureColumnTextSearch(EnableCellTextSearch.getFormatter(componentType, () => ColumnTextSearchFormatter.forFormatter(this._defaultSearchTextFormatter)), row => row[this.property]);
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData, firstTime) => {
            if (firstTime) {
                if (isFunction$1(onComponentInitOrOptions)) {
                    onComponentInitOrOptions(component);
                }
                else {
                    if (isFunction$1(onComponentInitOrOptions?.onComponentInit)) {
                        onComponentInitOrOptions.onComponentInit(component);
                    }
                }
            }
            const rowValue = rowData.row[this.property];
            component.value = this._userFormat ? this._userFormat(rowValue) : rowValue;
        }));
        return this;
    }
    liveEditCellRenderer(componentType, options) {
        return this.mutableCellRenderer(componentType, options);
    }
    /**
     * Deprecated.  Use #liveEditCellRenderer instead.
     * @param componentType
     * @param options
     */
    mutableCellRenderer(componentType, options) {
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData, firstTime) => {
            // keep a local copy most recent row value so it's available to teh
            // edit callback without having to add/remove subscribers all the time.
            component[ColumnModel.CELL_RENDERER_COMPONENT_ROW_CACHE] = rowData.row;
            let disableEditCallback = false;
            if (firstTime) {
                if (isFunction$1(options?.onComponentInit)) {
                    options.onComponentInit(component);
                }
                // install our edit callback
                component.onValueEdited((is, was) => {
                    if (!disableEditCallback) {
                        options.onValueEdit(component[ColumnModel.CELL_RENDERER_COMPONENT_ROW_CACHE], is, was);
                    }
                });
            }
            // now push the value the component and disable the callback just incase the component misbehaves
            // and fires a value change during the operation.
            disableEditCallback = true;
            component.value = rowData.row[this.property];
            disableEditCallback = false;
            if (!isFunction$1(options) && isFunction$1(options?.onRowUpdate)) {
                options.onRowUpdate(component, rowData.row);
            }
        }));
        return this;
    }
    cellEditor(editor, validatorsOrInitialiser, onComponentInit) {
        const validators = Array.isArray(validatorsOrInitialiser) ? validatorsOrInitialiser : undefined;
        const initialiser = isFunction$1(validatorsOrInitialiser) ? validatorsOrInitialiser : onComponentInit;
        this.configureCellEditor(new CellEditorPortalRef(editor, (component, editSession) => {
            const formValueModel = editSession.form.pluck(this.property);
            if (validators) {
                formValueModel.validateUsing(validators);
            }
            component.valueModel = formValueModel;
            if (initialiser) {
                initialiser(component);
            }
        }));
        return this;
    }
    format(formatter) {
        assert$1.isFunction(formatter);
        this._userFormat = formatter;
        return this;
    }
    selectRowOnClick(selectOnRowClick) {
        return this._selectRowOnClick(selectOnRowClick);
    }
}

class SelectionColumnModel extends ColumnModel {
    constructor(columnId, defaults, selectionModel) {
        super(columnId, defaults);
        this._enableHeaderControls = true;
        this._color = "accent";
        this.selectionModel = DelegatingSelectionModel.createDelegate();
        this._selectRowOnClick(false);
        this.cellHeaderRenderer(SelectionHeaderCellComponent, (component) => {
            component.selectionModel = this.selectionModel;
            component.enableHeaderControls = this._enableHeaderControls;
            component.color = this._color;
        });
        this.configureCellRenderer(new ComponentCellRendererPortalRef(SelectionCellComponent, (component, rowData) => {
            component.row = rowData.row;
            component.selectionModel = this.selectionModel;
            component.color = this._color;
        }));
        this.setSelectionModel(selectionModel);
        this.setMasterVisibility(this.selectionModel.enabled$);
    }
    setSelectionModel(selectionModel) {
        this.selectionModel.setDelegate(selectionModel);
        this.setDefaultVisibility(selectionModel instanceof MultipleSelectionModel ? ValueModel.TRUE : ValueModel.FALSE);
    }
    getDefaultHeaderText() {
        return '';
    }
    enableHeaderControls(enable) {
        this._enableHeaderControls = enable;
        return this;
    }
    /**
     * Set the checkbox to use a theme color e.g. "primary" | "accent" | "warn"
     */
    color(color) {
        this._color = color;
    }
    selectRow(row) {
        this.selectionModel.selectCommand.execute(row);
    }
    isSelected(row) {
        return this.selectionModel.isSelected(row);
    }
}

// TODO: Merge MarsUi FilterRegistry into this.
class AbstractTableFilterModel extends GarbageCollector {
}
TrackExternal.useDelegate(AbstractTableFilterModel, options => {
    return DelegateProxyHandler.create("AbstractTableFilterModel", b => {
        b.forProperty("rowFilter$", () => new DelegatingValueModel());
        b.forProperty("highlightText$", () => new DelegatingValueModel());
    });
});

var DefaultArrayFormatter = ColumnTextSearchFormatter.DefaultArrayFormatter;
var DefaultValueFormatter = ColumnTextSearchFormatter.DefaultValueFormatter;
// export type StringPropertiesOf<T> = { [K in keyof T]: T[K] extends string ? K : never }[keyof T];
// export type NumberPropertiesOf<T> = { [K in keyof T]: T[K] extends number ? K : never }[keyof T];
class RowClass {
    constructor(className, matches) {
        this.className = className;
        this.matches = matches;
    }
}
class AbstractTableModel extends GarbageCollector {
    constructor() {
        super();
        this._rawDataSource = this.registerDisposable(new DelegatingListModel());
        this._visibleRows$ = this.registerDisposable(new DelegatingListModel());
        this._columnList = this.registerDisposable(new ColumnListModel());
        this._editorSessions = new MutableListModel();
        this.rowClassNamePredicates = [];
        this.rowClickListeners = new EventListenerList();
        this._createForm = (row) => new DirtyTrackingForm();
        this.trackBy = (index, item) => {
            return this.identityOf ? this.identityOf(item) : index;
        };
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this._rowsBeingEdited$ = new MutableListModel([], {
            identifiedWith: row => this.identityOf(row)
        });
        this._editorSessionByRowId = chain(this._editorSessions).indexBy("rowId");
        this.editing$ = chain(this._editorSessions).count().isGreaterThan(0);
        this._filteredRows$ = chain(this._rawDataSource)
            .reduceToList(items => {
            const filter = this.filterModel.rowFilter$.value; // filter can be null
            return !filter ? items : items.filter(item => filter.matches(item, this.columns.value));
        }, {
            dependsOn: [this.filterModel.rowFilter$, this.columns]
        })
            .replaceAll(this.rowsBeingEdited$)
            .identifiedWith(this._rawDataSource.identityOf);
        this._visibleRows$.setDelegate(this._filteredRows$);
        this.firstEditableColumn$ = chain(this.columns).select(c => c.hasEditorPortal()).first();
        this.firstVisibleColumn$ = chain(this._columnList).first();
        this.lastVisibleColumn$ = chain(this._columnList).last();
        this.rowSelectionDisabledOnAllColumns$ = chain(this._columnList).select(column => column.isRowSelectionEnabled()).count().equals(0);
        when(chain(this._rawDataSource).first()).becomesTruthy(it => {
            if (it === this.identityOf(it)) {
                console.warn("Table model identity function is using reference equality.  This can cause lots of table re-rendering", {
                    row: it
                });
            }
        }, { once: true });
    }
    initialise(injector) {
        // not sure if I should define these at the module level or not...
        const customInjector = Injector.create({
            providers: [
                { provide: DefaultValueFormatter },
                { provide: DefaultArrayFormatter }
            ],
            parent: injector
        });
        this.columns.value.forEach(c => c.initialise(customInjector));
    }
    get visibleRows$() {
        return this._visibleRows$.readonly;
    }
    setDataSource(sourceOfTruth) {
        this._rawDataSource.setDelegate(sourceOfTruth);
    }
    identityOf(row) {
        return this._rawDataSource.identityOf(row);
    }
    get rowsBeingEdited$() {
        return this._rowsBeingEdited$.readonly;
    }
    get columns() {
        return this._columnList.allColumns$;
    }
    get visibleColumns() {
        return this._columnList.readonly;
    }
    pluck(property, options) {
        const columnId = options?.columnId || property.toString();
        return this.addColumn(new PropertyColumnModel(columnId, property, () => this.getColumnTextProperties(columnId)));
    }
    pluckList(property, options) {
        const columnId = options?.columnId || property.toString();
        return this.addColumn(new ListPropertyColumnModel(columnId, property, () => this.getColumnTextProperties(columnId)));
    }
    _addSelectionColumn(selectionModel, visible) {
        assert.isNil(this.selectionColumnModel);
        const columnId = "selection-column";
        this.selectionColumnModel = new SelectionColumnModel(columnId, () => this.getColumnTextProperties(columnId), selectionModel);
        this.addRowClass("aup-row-selected", row => this.selectionColumnModel.isSelected(row));
        const selectionColumnModel = this.addColumn(this.selectionColumnModel, 0);
        if (!isNil$1(visible)) {
            selectionColumnModel.visibleWhile(visible instanceof ValueModel ? visible : ValueModel.constant(visible));
        }
        return selectionColumnModel;
    }
    addEditControls(saveCommandFactory, formFactory) {
        this.saveCommandFactory = saveCommandFactory;
        if (isFunction$1(formFactory)) {
            this._createForm = formFactory;
        }
        const columnId = "editControls";
        return this.addColumn(new EditorControlColumnModel(columnId, saveCommandFactory, () => this.getColumnTextProperties(columnId)));
    }
    addCustomColumn(columnId, dataAccessor) {
        return this.addColumn(new CustomValueColumnModel(columnId, () => this.getColumnTextProperties(columnId), dataAccessor));
    }
    addComponentColumn(columnId, component, onComponentInitOrOptions) {
        return this.addColumn(new CustomValueColumnModel(columnId, () => this.getColumnTextProperties(columnId), row => row)).cellRenderer(component, onComponentInitOrOptions);
    }
    addTemplateColumn(columnId) {
        return this.addColumn(new CustomTemplateColumnModel(columnId, () => this.getColumnTextProperties(columnId)));
    }
    addRowClass(className, predicate) {
        this.rowClassNamePredicates.push(new RowClass(className, predicate));
    }
    getRowClasses(row) {
        const classNames = [];
        this.rowClassNamePredicates.forEach(i => {
            if (i.matches(row)) {
                classNames.push(i.className);
            }
        });
        return classNames;
    }
    useFormFactory(factory) {
        this._createForm = factory;
        return this;
    }
    addColumn(column, index) {
        return this._columnList.addColumn(column, index);
    }
    // removeColumn(column: ColumnModel<Row>) {
    //
    // }
    columnTextProperties(columnTextProperties) {
        this._columnTextPropertiesLookup = columnTextProperties;
    }
    getColumnTextProperties(columnId) {
        return this._columnTextPropertiesLookup ? this._columnTextPropertiesLookup[columnId] : undefined;
    }
    startEditSession(row) {
        const rowId = this.identityOf(row);
        if (this._rowsBeingEdited$.query().indexOf(row) > -1) {
            return lang.illegalState(`Row with id=${rowId} already being edited`);
        }
        // todo: pass the factories to the edit session so we can make the whole lot pluggable?
        const form = this._createForm(row);
        const saveCommand = this.saveCommandFactory.create(form, { disposedWith: this });
        const editSession = new EditSession(rowId, row, form, saveCommand);
        const { when } = Dsl.disposeWith(editSession);
        when(editSession.liveRowValue$).changes((editedValue) => {
            this._rowsBeingEdited$.replaceOrPush(editedValue);
        }, { initialValue: "triggerChangeUnlessNil" });
        this._editorSessions.push(editSession);
        editSession.onDispose(() => {
            this._rowsBeingEdited$.remove(editSession.liveRowValue$.value);
            this._editorSessions.remove(editSession);
        });
        return editSession;
    }
    getEditSessionFor(row) {
        return this._editorSessionByRowId.get(this.identityOf(row));
    }
    cancelAllEditorSessions() {
        this._editorSessions.runInTransaction((draft) => {
            this._rowsBeingEdited$.runInTransaction(() => {
                draft.value.forEach(session => session.dispose());
            });
        });
    }
    isRowSelectionEnabledFor(column) {
        return this.isRowSelectionEnabled() && column.isRowSelectionEnabled();
    }
    isRowSelectionEnabled() {
        return this.hasUserSelectionModelThatIsEnabled() && !this.rowSelectionDisabledOnAllColumns$.value;
    }
    hasUserSelectionModelThatIsEnabled() {
        const userSelectionModel = this.selectionColumnModel?.selectionModel.getDelegate();
        return !!userSelectionModel && userSelectionModel.enabled$.value;
    }
    getSelectionModel() {
        return this.selectionColumnModel?.selectionModel;
    }
    isHoverEnabled() {
        return this.isRowSelectionEnabled() || this.rowClickListeners.listenerCount > 0;
    }
    isCursorEnabled(column) {
        return this.isRowSelectionEnabledFor(column) || this.rowClickListeners.listenerCount > 0;
    }
    selectRow(row) {
        this.selectionColumnModel?.selectRow(row);
    }
    onRowClicked(callback) {
        return this.rowClickListeners.add(callback);
    }
    _notifyCellClicked(columnModel, row) {
        if (this.isRowSelectionEnabledFor(columnModel)) {
            this.selectRow(row);
        }
        this.rowClickListeners.fire(l => l(row));
    }
}
__decorate([
    TrackExternal() // hack instead of creating a delegating one from scratch.  Would be nice if this easier to do automated... or better named? @UseProxy or @UseDelegate??
    ,
    __metadata("design:type", AbstractTableFilterModel)
], AbstractTableModel.prototype, "filterModel", void 0);
TrackExternal.oneTimeBinding(AbstractTableModel);

class TableCellComponent extends DisposableComponent {
    constructor() {
        super();
        this.defaultClassNames = 'aup-cell-renderer';
        this.fillCell = false;
        this.padChild = false;
        this.editRowCommand = Command.create(() => {
            this.tableModel.startEditSession(this.row);
        });
    }
    ngOnInit() {
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.firstEditableColumn = chain(this.tableModel.firstEditableColumn$).equals(this.column); // this would break if the column changed.
        this.column.attachCell(this);
    }
    hasActiveEditor() {
        return !!this.editSession && !!this.column.hasEditorPortal();
    }
    initialiseRenderer(ref) {
        this.column.onRendererAttached(this, ref);
    }
    initialiseEditor(ref) {
        this.column.onEditorAttached(this, ref);
        if (this.firstEditableColumn.value) {
            // @see https://github.com/angular/components/issues/12070
            setTimeout(() => this.tryAndFocusEditor(ref));
        }
    }
    tryAndFocusEditor(ref) {
        if (ref instanceof ComponentRef) {
            const editor = ref.instance;
            // CellEditorComponent<Row> | CellListEditorComponent<Row>
            if (editor.requestFocus) {
                editor.requestFocus();
            }
            else {
                const model = (editor['valueModel'] || editor['listModel']);
                model?.focusContext?.requestFocus();
            }
        }
    }
    // @Trace()
    ngOnChanges(changes) {
        this.column.updatePortalContent(this);
    }
    getRendererPortal() {
        return this[CELL_RENDERER_PORTAL];
    }
    getEditorPortal() {
        return this[CELL_EDITOR_PORTAL];
    }
    getRowData() {
        return {
            row: this.row,
            editSession: this.editSession,
            editRowCommand: this.editRowCommand
        };
    }
}
TableCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TableCellComponent, selector: "aup-table-cell", inputs: { row: "row", column: "column", editSession: "editSession", tableModel: "tableModel" }, host: { properties: { "class": "this.defaultClassNames", "class.fillCell": "this.fillCell", "class.padChild": "this.padChild" } }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<ng-container *ngIf=\"!hasActiveEditor()\" [cdkPortalOutlet]=\"getRendererPortal()\" (attached)=\"initialiseRenderer($event)\"></ng-container>\n<ng-container *ngIf=\"hasActiveEditor()\" [cdkPortalOutlet]=\"getEditorPortal()\" (attached)=\"initialiseEditor($event)\"></ng-container>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$7.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-table-cell', template: "<ng-container *ngIf=\"!hasActiveEditor()\" [cdkPortalOutlet]=\"getRendererPortal()\" (attached)=\"initialiseRenderer($event)\"></ng-container>\n<ng-container *ngIf=\"hasActiveEditor()\" [cdkPortalOutlet]=\"getEditorPortal()\" (attached)=\"initialiseEditor($event)\"></ng-container>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { row: [{
                type: Input
            }], column: [{
                type: Input
            }], editSession: [{
                type: Input
            }], tableModel: [{
                type: Input
            }], defaultClassNames: [{
                type: HostBinding,
                args: ['class']
            }], fillCell: [{
                type: HostBinding,
                args: ['class.fillCell']
            }], padChild: [{
                type: HostBinding,
                args: ['class.padChild']
            }] } });

class TableHeaderCellComponent {
    constructor() {
        this.defaultClassNames = 'aup-header-cell-renderer';
    }
    ngOnInit() {
        this.column.attachHeaderCell(this);
    }
    // @Trace()
    initialiseHeader(ref) {
        this.column.onHeaderAttached(this, ref);
    }
    getPortal() {
        return this[HEADER_CELL_RENDERER_PORTAL];
    }
}
TableHeaderCellComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableHeaderCellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableHeaderCellComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TableHeaderCellComponent, selector: "aup-table-header-cell", inputs: { column: "column" }, host: { properties: { "class": "this.defaultClassNames" } }, ngImport: i0, template: "<ng-container [cdkPortalOutlet]=\"getPortal()\" (attached)=\"initialiseHeader($event)\"></ng-container>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch;justify-content:center;height:100%}\n"], dependencies: [{ kind: "directive", type: i2$7.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableHeaderCellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-table-header-cell', template: "<ng-container [cdkPortalOutlet]=\"getPortal()\" (attached)=\"initialiseHeader($event)\"></ng-container>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch;justify-content:center;height:100%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { column: [{
                type: Input
            }], defaultClassNames: [{
                type: HostBinding,
                args: ['class']
            }] } });

class MenuItemData {
    constructor(factory, face) {
        this.factory = factory;
        this.face = face;
    }
}
/**
 *
 */
class TableRowMenuComponent extends DisposableComponent {
    constructor() {
        super();
        this.actions = [];
        this.moreActions = [];
    }
    registerAction(commandFactory, properties) {
        this.actions.push(new MenuItemData(commandFactory, properties));
    }
    registerMoreAction(commandFactory, properties) {
        this.moreActions.push(new MenuItemData(commandFactory, properties));
    }
    createMoreMenuCommand(item, value) {
        const { when } = Dsl.disposeWith(this);
        const command = item.factory.create(value, { disposedWith: this });
        when(command.busy$).becomesFalsey(() => {
            this.closeMoreMenu();
        });
        return command;
    }
    closeMoreMenu() {
        this.menu.closeMenu();
    }
}
TableRowMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableRowMenuComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TableRowMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TableRowMenuComponent, selector: "aup-table-row-menu", inputs: { value: "value" }, viewQueries: [{ propertyName: "menu", first: true, predicate: MatMenuTrigger, descendants: true }], usesInheritance: true, ngImport: i0, template: `
    <aup-tool-bar>
      <aup-command *ngFor="let action of actions" #comp [command]="action.factory.create(value, {disposedWith: comp})"
                   [face]="action.face"></aup-command>
    </aup-tool-bar>
    <ng-container *ngIf="moreActions.length > 0">
      <aup-more-menu>
        <aup-command *ngFor="let action of moreActions" #comp [command]="action.factory.create(value, {disposedWith: comp})"
                     [face]="action.face"></aup-command>
      </aup-more-menu>
    </ng-container>
  `, isInline: true, styles: [":host{display:inline-flex;flex-direction:row;align-items:center}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ToolBarComponent, selector: "aup-tool-bar" }, { kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }, { kind: "component", type: MoreMenuComponent, selector: "aup-more-menu", inputs: ["tooltip"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableRowMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-table-row-menu', template: `
    <aup-tool-bar>
      <aup-command *ngFor="let action of actions" #comp [command]="action.factory.create(value, {disposedWith: comp})"
                   [face]="action.face"></aup-command>
    </aup-tool-bar>
    <ng-container *ngIf="moreActions.length > 0">
      <aup-more-menu>
        <aup-command *ngFor="let action of moreActions" #comp [command]="action.factory.create(value, {disposedWith: comp})"
                     [face]="action.face"></aup-command>
      </aup-more-menu>
    </ng-container>
  `, styles: [":host{display:inline-flex;flex-direction:row;align-items:center}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }], menu: [{
                type: ViewChild,
                args: [MatMenuTrigger]
            }] } });

/**
 * Example:
 * @example
 * const model = new TableModel(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 * });
 *
 * Editable tables
 * @example
 * const saveCommand = UnaryCommand.create((form: Form<Hero>) => {
 *   if (form.validate()) {
 *     // normal form save stuff
 *     return true; // finish editing
 *   }
 *   return false; // continue editiing
 * }
 * const colorsNames: ListModel<string> = ...;
 * const model = TableModel.fromList(heroList, table => {
 *   table.pluck("firstName").cellEditor(StringInputComponent); <-- interface CellEditor { valueModel:  DirtyTrackingForm.ValueModel<string> | ValueModel<string>; }
 *   table.pluck("lastName").cellEditor(StringInputComponent, {
 *     validators: [Validator.present("We need a last name")]
 *   });
 *   table.pluck("age").cellEditor(NumberInputComponent);
 *   table.pluck("favoriteColor").cellEditor(SelectInputComponent, {
 *     initialiseComponent(component: SelectInputComponent) {
 *       selectInput.optionsModel = colorsNames; // <- initialise our component
 *     }
 *   });
 *   table.addEditControls(saveCommand); // <- required to enable editing
 * });
 *
 * Selection models
 * @example
 * const model = new TableModel(heroList, table => {
 *   table.addSelectionColumn(selectionModel); // <- can be single or multiple selection model
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 * });
 *
 * Custom cell renderers and editors
 * @example
 * const model = new TableModel(heroList, table => {
 *   table.pluck("favoriteColor")
 *      .cellHeaderRenderer(CellHeaderRendererComponent, (component, column) => {
 *        // configure your component with what ever you need.
 *      });
 *      .cellRenderer(CellRendererComponent) // <-- interface CellEditor { value: string; }
 *      .cellEditor(CellEditorComponent.); // <-- interface CellEditor { valueModel:  DirtyTrackingForm.ValueModel<string> | ValueModel<string>; }
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 * });
 *
 * Template columns
 * @example
 * const model = new TableModel(heroList, table => {
 *   table.addSelectionColumn(selectionModel); // <- can be single or multiple selection model
 *   table.addTemplateColumn("myTemplate");
 * });
 *
 * <div *aupColumnTemplate="let hero; columnId: 'myTemplate'">{{hero.age}}</div>
 *
 * I18n
 * @example
 * [table.yml]
 * table:
 *   columns(ColumnTextProperties[]):
 *      firstName:
 *         headerText: "First Name"
 *      fullName:
 *         headerText: "Full Name"
 *
 * const model = new TableModel(heroList, table => {
 *   table.pluck("favoriteColor").cellRenderer(...).cellEditor(...);
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 *
 *   table.columnTextProperties(I18n.table.columns); // <- configures all columns
 * });
 */
class TableModel extends AbstractTableModel {
    constructor(sourceOfTruth, builder) {
        super();
        this._pageSize = new MutableValueModel();
        if (builder) {
            builder(this);
        }
        if (sourceOfTruth) {
            this.setDataSource(sourceOfTruth);
        }
    }
    get pageController() {
        return this._pageController;
    }
    enablePaging() {
        if (isNil$1(this.pageController)) {
            const pagedListModel = this.registerDisposable(PagedListModel.create(this._visibleRows$.getDelegate(), this._pageSize));
            this._visibleRows$.setDelegate(pagedListModel);
            this._pageController = pagedListModel.pageController;
        }
    }
    // TODO: the selection model needs the option to limit selecction to the filtered items.  Currently the selection remains
    //       when the item is no longer in the visible list of items.
    // addSingleSelectionColumn<Id>(options: SingleSelectionModel.Options<Row, Id>, showSelectionColumn?: ValueModel<boolean> | boolean): SingleSelectionModel<Row> {
    //   return null;
    // }
    addSelectionColumn(selectionModel, showSelectionColumn) {
        return this._addSelectionColumn(selectionModel, showSelectionColumn);
    }
    updatePageSize(count) {
        this._pageSize.value = count;
    }
}

class PaginatorComponent extends DisposableComponent {
    constructor() {
        super();
    }
    ngOnInit() {
    }
    get totalPages() {
        return this.pageController.totalPages$.value;
    }
    get pageNumber() {
        return this.pageController.pageNumber$.value;
    }
    get previousCommand() {
        return this.pageController.previousCommand;
    }
    get nextCommand() {
        return this.pageController.nextCommand;
    }
}
PaginatorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PaginatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PaginatorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PaginatorComponent, selector: "aup-paginator", inputs: { pageController: "pageController" }, usesInheritance: true, ngImport: i0, template: "<p>Page {{pageNumber}} of {{totalPages}}</p>\n<button mat-icon-button [pectinCommand]=\"previousCommand\"><aup-icon icon=\"mat:keyboard_arrow_left\"></aup-icon></button>\n<button mat-icon-button [pectinCommand]=\"nextCommand\"><aup-icon icon=\"mat:keyboard_arrow_right\"></aup-icon></button>\n\n", styles: [":host{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;font-size:12px;padding:0 8px;color:#0009}:host p{color:inherit;margin:0 8px 0 0}:host button.md-button.md-icon-button{padding:0;margin:0;width:30px;height:30px}\n"], dependencies: [{ kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: i2.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", PageController)
], PaginatorComponent.prototype, "pageController", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PaginatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-paginator', template: "<p>Page {{pageNumber}} of {{totalPages}}</p>\n<button mat-icon-button [pectinCommand]=\"previousCommand\"><aup-icon icon=\"mat:keyboard_arrow_left\"></aup-icon></button>\n<button mat-icon-button [pectinCommand]=\"nextCommand\"><aup-icon icon=\"mat:keyboard_arrow_right\"></aup-icon></button>\n\n", styles: [":host{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;font-size:12px;padding:0 8px;color:#0009}:host p{color:inherit;margin:0 8px 0 0}:host button.md-button.md-icon-button{padding:0;margin:0;width:30px;height:30px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { pageController: [{
                type: Input
            }] } });

class Dimension {
    constructor(width, height) {
        this.width = width;
        this.height = height;
    }
}

class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    static from(data) {
        return new Point(data.x, data.y);
    }
    translate(x, y) {
        return new Point(this.x + x, this.y + y);
    }
}

class Bounds extends Dimension {
    constructor(top, left, width, height) {
        super(width, height);
        this.top = top;
        this.left = left;
        this.width = width;
        this.height = height;
    }
    relativePositionOf(point) {
        if (point instanceof MouseEvent) {
            return new Point(point.clientX - this.left, point.clientY - this.top);
        }
        else {
            return new Point(point.x - this.left, point.y - this.top);
        }
    }
}
(function (Bounds) {
    function ofElement(element) {
        const rect = element.getBoundingClientRect();
        return new Bounds(rect.top, rect.left, rect.width, rect.height);
    }
    Bounds.ofElement = ofElement;
})(Bounds || (Bounds = {}));

class ResizeAwareComponent extends DisposableComponent {
    constructor(elementRef, ngZone) {
        super();
        this.elementRef = elementRef;
        this.ngZone = ngZone;
        this._boundsModel = new MutableValueModel(new Bounds(0, 0, 0, 0));
    }
    ngAfterViewInit() {
        const element = this.elementRef.nativeElement;
        const ro = new ResizeObserver((entries, observer) => {
            this.ngZone.run(() => this._updateBounds());
        });
        ro.observe(element);
        this.onDispose(() => ro.disconnect());
        setTimeout(() => this._updateBounds());
    }
    get boundsModel() {
        return this._boundsModel.readonly;
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    // TODO: Make this handle body scroll
    relativePositionOf(point) {
        return this.bounds.relativePositionOf(point);
    }
    get bounds() {
        return this._boundsModel.value;
    }
    _updateBounds() {
        this._boundsModel.value = Bounds.ofElement(this.nativeElement);
    }
}
ResizeAwareComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ResizeAwareComponent, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
ResizeAwareComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: ResizeAwareComponent, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ResizeAwareComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; } });

class TableBodyComponent extends ResizeAwareComponent {
    constructor(elementRef, ngZone) {
        super(elementRef, ngZone);
        this.visibleRowCount = new EventEmitter();
        /**
         * Set to true to enable scrolling.  Once enabled the table will have 0 implicit height.  You will either
         * need to set it explicitly e.g. height: 400px; or by using flex or grid layout to make it fill it's
         * containment area.
         */
        this.enableScrolling = false;
        // TODO: support user defined header and row heights via css vars.
        this.headerHeight = new MutableValueModel(56);
        this.rowHeight = new MutableValueModel(48);
        this.baseCssClass = "aup-table-component";
        const { chain, when } = Dsl.disposeWith(this);
        const actualHeaderHeight = chain(this.showHeader$).map(show => {
            return show ? this.headerHeight.value : 0;
        }, { dependsOn: this.headerHeight });
        this._visibleRowCount = chain(this.boundsModel).map(bounds => {
            // TODO: this doesn't take into account any css styling adjustments etc.  Will investigate if it's an issue.
            const rawRowCount = (bounds.height - actualHeaderHeight.value) / this.rowHeight.value;
            return rawRowCount < 1 ? 0 : Math.floor(rawRowCount);
        }, {
            dependsOn: [actualHeaderHeight, this.rowHeight],
            postponeWhile: chain(this.boundsModel).pluckNumeric("height").isLessThan(1)
        });
        when(this._visibleRowCount).changes(visibleRows => {
            this.visibleRowCount.emit(visibleRows);
        }, { initialValue: "triggerChangeUnlessNil" });
    }
    get hideHeader() {
        return !this.showHeader;
    }
    ngOnInit() {
        const { chain } = Dsl.disposeWith(this);
        this.columns = chain(this.tableModel.columns);
        this.columnIds = chain(this.columns).pluck("columnId");
        this.columnsById = chain(this.columns).indexBy('columnId');
    }
    isEditing(row) {
        return !!this.tableModel.getEditSessionFor(row);
    }
    notifyCellClicked(columnModel, row) {
        this.tableModel._notifyCellClicked(columnModel, row);
    }
    // @Trace()
    isFirstVisibleColumn(columnId) {
        return this.tableModel.firstVisibleColumn$.query().value?.columnId === columnId;
    }
    // @Trace()
    isLastVisibleColumn(columnId) {
        return this.tableModel.lastVisibleColumn$.query().value?.columnId === columnId;
    }
    getColumnClasses(columnId) {
        const classes = [`aup-col-${this.columnsById.get(columnId).dasherisedColumnId}`];
        if (this.isFirstVisibleColumn(columnId)) {
            classes.push("first-visible-column");
        }
        if (this.isLastVisibleColumn(columnId)) {
            classes.push("last-visible-column");
        }
        return classes;
    }
}
TableBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableBodyComponent, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component });
TableBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TableBodyComponent, selector: "aup-table-body", inputs: { tableModel: "tableModel", showHeader$: "showHeader$", showHeader: "showHeader", enableScrolling: "enableScrolling" }, outputs: { visibleRowCount: "visibleRowCount" }, host: { properties: { "class.enable-scrolling": "this.enableScrolling", "class": "this.baseCssClass", "class.hide-header": "this.hideHeader" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"scroll-container\">\n  <table mat-table [dataSource]=\"tableModel.visibleRows$.value\" [trackBy]=\"tableModel.trackBy\">\n\n    <ng-container *ngFor=\"let column of columns.value; index as index; first as first; last as last\"\n                  matColumnDef=\"{{column.columnId}}\">\n      <th mat-header-cell *matHeaderCellDef [class.flex]=\"column.isFlex()\" [class.hide]=\"!column.isVisible()\">\n        <aup-table-header-cell [column]=\"column\"\n                               [attr.column-index]=\"index\"\n                               [attr.column-id]=\"column.columnId\"\n                               [class]=\"getColumnClasses(column.columnId)\"\n        ></aup-table-header-cell>\n      </th>\n      <td mat-cell *matCellDef=\"let row\" (click)=\"notifyCellClicked(column, row)\"\n          [class.enable-cursor]=\"tableModel.isCursorEnabled(column)\"\n          [class.flex]=\"column.isFlex()\"\n          [class.hide]=\"!column.isVisible()\"\n      >\n        <aup-table-cell [column]=\"column\"\n                        [row]=\"row\"\n                        [tableModel]=\"tableModel\"\n                        [editSession]=\"tableModel.getEditSessionFor(row)\"\n                        [attr.column-index]=\"index\"\n                        [attr.column-id]=\"column.columnId\"\n                        [class]=\"getColumnClasses(column.columnId)\"\n        ></aup-table-cell>\n      </td>\n    </ng-container>\n\n    <tr mat-header-row *matHeaderRowDef=\"columnIds.value; sticky: true\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: columnIds.value; let i = index\"\n        [ngClass]=\"tableModel.getRowClasses(row)\"\n        [class.enable-hover]=\"tableModel.isHoverEnabled()\"\n        [attr.aup-row-id]=\"tableModel.trackBy(i, row)\"\n    ></tr>\n\n  </table>\n</div>\n\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host table{width:100%}:host.enable-scrolling{min-height:0}:host.enable-scrolling .scroll-container{flex:1;flex-basis:0;overflow-y:auto;display:flex;flex-direction:column;align-items:stretch}\n"], dependencies: [{ kind: "directive", type: i1$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$8.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i2$8.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i2$8.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i2$8.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i2$8.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i2$8.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i2$8.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i2$8.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i2$8.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i2$8.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "component", type: TableCellComponent, selector: "aup-table-cell", inputs: ["row", "column", "editSession", "tableModel"] }, { kind: "component", type: TableHeaderCellComponent, selector: "aup-table-header-cell", inputs: ["column"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", AbstractTableModel)
], TableBodyComponent.prototype, "tableModel", void 0);
__decorate([
    TrackExternal({ defaultValue: true }),
    __metadata("design:type", ValueModel)
], TableBodyComponent.prototype, "showHeader$", void 0);
__decorate([
    StoreInValueModel("showHeader$"),
    __metadata("design:type", Boolean)
], TableBodyComponent.prototype, "showHeader", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-table-body", template: "<div class=\"scroll-container\">\n  <table mat-table [dataSource]=\"tableModel.visibleRows$.value\" [trackBy]=\"tableModel.trackBy\">\n\n    <ng-container *ngFor=\"let column of columns.value; index as index; first as first; last as last\"\n                  matColumnDef=\"{{column.columnId}}\">\n      <th mat-header-cell *matHeaderCellDef [class.flex]=\"column.isFlex()\" [class.hide]=\"!column.isVisible()\">\n        <aup-table-header-cell [column]=\"column\"\n                               [attr.column-index]=\"index\"\n                               [attr.column-id]=\"column.columnId\"\n                               [class]=\"getColumnClasses(column.columnId)\"\n        ></aup-table-header-cell>\n      </th>\n      <td mat-cell *matCellDef=\"let row\" (click)=\"notifyCellClicked(column, row)\"\n          [class.enable-cursor]=\"tableModel.isCursorEnabled(column)\"\n          [class.flex]=\"column.isFlex()\"\n          [class.hide]=\"!column.isVisible()\"\n      >\n        <aup-table-cell [column]=\"column\"\n                        [row]=\"row\"\n                        [tableModel]=\"tableModel\"\n                        [editSession]=\"tableModel.getEditSessionFor(row)\"\n                        [attr.column-index]=\"index\"\n                        [attr.column-id]=\"column.columnId\"\n                        [class]=\"getColumnClasses(column.columnId)\"\n        ></aup-table-cell>\n      </td>\n    </ng-container>\n\n    <tr mat-header-row *matHeaderRowDef=\"columnIds.value; sticky: true\"></tr>\n    <tr mat-row *matRowDef=\"let row; columns: columnIds.value; let i = index\"\n        [ngClass]=\"tableModel.getRowClasses(row)\"\n        [class.enable-hover]=\"tableModel.isHoverEnabled()\"\n        [attr.aup-row-id]=\"tableModel.trackBy(i, row)\"\n    ></tr>\n\n  </table>\n</div>\n\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host table{width:100%}:host.enable-scrolling{min-height:0}:host.enable-scrolling .scroll-container{flex:1;flex-basis:0;overflow-y:auto;display:flex;flex-direction:column;align-items:stretch}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { tableModel: [{
                type: Input
            }], showHeader$: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], visibleRowCount: [{
                type: Output
            }], enableScrolling: [{
                type: Input
            }, {
                type: HostBinding,
                args: ["class.enable-scrolling"]
            }], baseCssClass: [{
                type: HostBinding,
                args: ["class"]
            }], hideHeader: [{
                type: HostBinding,
                args: ["class.hide-header"]
            }] } });

/**
 * Create your model:
 * @example
 * this.heroTableModel = new TableModel(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 * });
 *
 * Create your table
 * @example
 * <aup-table [tableModel]="heroTableModel"></aup-table>
 *
 * Column templates
 * @example
 * this.heroTableModel = new TableModel(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addTemplateColumn("specialColumn");
 * });
 * <aup-table [tableModel]="heroTableModel">
 *   <div *aupColumnTemplate="let hero; columnId: 'specialColumn'; fillCell: true; padChild:false">
 *     {{hero.name}}
 *   </div>
 * </aup-table>
 *
 * Styling
 * @example
 *  // global settings
 * :root {
 *   --aup-table-column-gap: 10px; // defaults to 24px
 *   --aup-table-row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --aup-table-row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --aup-table-first-column-padding-left: 18px // defaults to --column-gap
 *   --aup-table-last-column-padding-right: 18px // defaults to --column-gap
 * }
 *
 * // per table settings.
 * aup-table {
 *   --column-gap: 10px; // defaults to 24px
 *   --row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --first-column-padding-left: 18px // defaults to --column-gap
 *   --last-column-padding-right: 18px // defaults to --column-gap
 *   ::ng-deep {
 *      aup-table-header-cell-renderer,
 *      aup-table-cell-renderer {
 *        &.aup-col-my-dasherised-column-id {
 *          // do stuff
 *        }
 *        &.first-visible-column {
 *          // do stuff
 *        }
 *        &.last-visible-column {
 *          // do stuff
 *        }
 *      }
 *   }
 * }
 */
class TableComponent extends AbstractTableComponent {
    constructor() {
        super(...arguments);
        this._footerContentAdded = false;
    }
    getModel() {
        return this.tableModel;
    }
    footerContentChanged($event) {
        // console.log($event);
        this._footerContentAdded = true;
    }
    //@Trace()
    updatePageSize(count) {
        this.tableModel.updatePageSize(count);
    }
}
TableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
TableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TableComponent, selector: "aup-table", inputs: { tableModel: "tableModel" }, providers: [
        { provide: AbstractTableComponent, useExisting: TableComponent }
    ], usesInheritance: true, ngImport: i0, template: "<aup-table-body [tableModel]=\"tableModel\"\n                [showHeader$]=\"showHeader$\"\n                [enableScrolling]=\"enableScrolling\"\n                (visibleRowCount)=\"updatePageSize($event)\"\n                [aupHighlightTextModel]=\"tableModel.filterModel.highlightText$\"\n></aup-table-body>\n<section class=\"table-footer\">\n  <div class=\"footer-content\"><ng-content select=\"[footer]\"></ng-content></div>\n  <aup-paginator *ngIf=\"tableModel.pageController\" [pageController]=\"tableModel.pageController\"></aup-paginator>\n</section>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}aup-table-body{flex:1}.table-footer{display:flex;flex-direction:row;align-items:center}.table-footer .footer-content{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: HighlightTextModelDirective, selector: "[aupHighlightTextModel]", inputs: ["aupHighlightTextModel"] }, { kind: "component", type: PaginatorComponent, selector: "aup-paginator", inputs: ["pageController"] }, { kind: "component", type: TableBodyComponent, selector: "aup-table-body", inputs: ["tableModel", "showHeader$", "showHeader", "enableScrolling"], outputs: ["visibleRowCount"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", TableModel)
], TableComponent.prototype, "tableModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-table', providers: [
                        { provide: AbstractTableComponent, useExisting: TableComponent }
                    ], template: "<aup-table-body [tableModel]=\"tableModel\"\n                [showHeader$]=\"showHeader$\"\n                [enableScrolling]=\"enableScrolling\"\n                (visibleRowCount)=\"updatePageSize($event)\"\n                [aupHighlightTextModel]=\"tableModel.filterModel.highlightText$\"\n></aup-table-body>\n<section class=\"table-footer\">\n  <div class=\"footer-content\"><ng-content select=\"[footer]\"></ng-content></div>\n  <aup-paginator *ngIf=\"tableModel.pageController\" [pageController]=\"tableModel.pageController\"></aup-paginator>\n</section>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}aup-table-body{flex:1}.table-footer{display:flex;flex-direction:row;align-items:center}.table-footer .footer-content{flex:1}\n"] }]
        }], propDecorators: { tableModel: [{
                type: Input
            }] } });

const SVG_HEIGHT = 60;
class TreeInheritanceIconComponent {
    constructor() {
        this.pixelWidth = 24;
        this.pixelHeight = 48;
    }
    get heightOffset() {
        return SVG_HEIGHT - this.pixelHeight;
    }
    get viewBox() {
        return `${0} ${this.heightOffset} ${this.pixelWidth} ${this.pixelHeight - this.heightOffset}`;
    }
    hasHead() {
        return TreeInheritanceIconComponent.HAS_HEAD.includes(this.type);
    }
    hasTerminal() {
        return TreeInheritanceIconComponent.HAS_TERMINAL.includes(this.type);
    }
    hasLeadIn() {
        return TreeInheritanceIconComponent.HAS_LEAD_IN.includes(this.type);
    }
    hasTail() {
        return TreeInheritanceIconComponent.HAS_TAIL.includes(this.type);
    }
}
TreeInheritanceIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeInheritanceIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TreeInheritanceIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TreeInheritanceIconComponent, selector: "aup-tree-inheritance-icon", inputs: { type: "type", pixelWidth: "pixelWidth", pixelHeight: "pixelHeight" }, host: { properties: { "class": "this.type" } }, ngImport: i0, template: "<svg xmlns=\"http://www.w3.org/2000/svg\" [attr.width]=\"pixelWidth\" [attr.height]=\"pixelHeight\" [attr.viewBox]=\"viewBox\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <rect *ngIf=\"hasHead()\"  width=\"1\" height=\"32.5\" x=\"11.5\" fill=\"currentColor\"/>\n    <rect *ngIf=\"hasTail()\" width=\"1\" height=\"32.5\" x=\"11.5\" y=\"31.5\" fill=\"currentColor\"/>\n\n    <rect *ngIf=\"hasLeadIn()\" width=\"12\" height=\"1\" y=\"31.5\" fill=\"currentColor\"/>\n    <rect *ngIf=\"hasTerminal()\" width=\"12\" height=\"1\" x=\"12\" y=\"31.5\" fill=\"currentColor\"/>\n  </g>\n</svg>\n", styles: [":host{position:relative;color:inherit}svg{color:var(--line-color);display:block}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeInheritanceIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-tree-inheritance-icon', template: "<svg xmlns=\"http://www.w3.org/2000/svg\" [attr.width]=\"pixelWidth\" [attr.height]=\"pixelHeight\" [attr.viewBox]=\"viewBox\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <rect *ngIf=\"hasHead()\"  width=\"1\" height=\"32.5\" x=\"11.5\" fill=\"currentColor\"/>\n    <rect *ngIf=\"hasTail()\" width=\"1\" height=\"32.5\" x=\"11.5\" y=\"31.5\" fill=\"currentColor\"/>\n\n    <rect *ngIf=\"hasLeadIn()\" width=\"12\" height=\"1\" y=\"31.5\" fill=\"currentColor\"/>\n    <rect *ngIf=\"hasTerminal()\" width=\"12\" height=\"1\" x=\"12\" y=\"31.5\" fill=\"currentColor\"/>\n  </g>\n</svg>\n", styles: [":host{position:relative;color:inherit}svg{color:var(--line-color);display:block}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { type: [{
                type: Input
            }, {
                type: HostBinding,
                args: ["class"]
            }], pixelWidth: [{
                type: Input
            }], pixelHeight: [{
                type: Input
            }] } });
(function (TreeInheritanceIconComponent) {
    TreeInheritanceIconComponent.Type = Enum({
        ICON_BLANK: 'blank',
        ICON_PARENT: 'parent',
        ICON_INHERITED_TERMINAL: 'inherited_terminal',
        ICON_INHERITED_THROUGH_TERMINAL: 'inherited_through_terminal',
        ICON_THROUGH: 'through' // |
    });
    TreeInheritanceIconComponent.HAS_LEAD_IN = [
        TreeInheritanceIconComponent.Type.ICON_PARENT
    ];
    TreeInheritanceIconComponent.HAS_TERMINAL = [
        TreeInheritanceIconComponent.Type.ICON_INHERITED_TERMINAL,
        TreeInheritanceIconComponent.Type.ICON_INHERITED_THROUGH_TERMINAL,
        TreeInheritanceIconComponent.Type.ICON_PARENT
    ];
    TreeInheritanceIconComponent.HAS_HEAD = [
        TreeInheritanceIconComponent.Type.ICON_THROUGH,
        TreeInheritanceIconComponent.Type.ICON_INHERITED_TERMINAL,
        TreeInheritanceIconComponent.Type.ICON_INHERITED_THROUGH_TERMINAL
    ];
    TreeInheritanceIconComponent.HAS_TAIL = [
        TreeInheritanceIconComponent.Type.ICON_PARENT,
        TreeInheritanceIconComponent.Type.ICON_THROUGH,
        TreeInheritanceIconComponent.Type.ICON_INHERITED_THROUGH_TERMINAL
    ];
})(TreeInheritanceIconComponent || (TreeInheritanceIconComponent = {}));

const treeNodeDecorator = Symbol('TreeDecorator');
var DecoratedTreeNode;
(function (DecoratedTreeNode) {
    function decorateRoot(node, extractChildren) {
        return new Decorator(undefined, node, extractChildren).decoratedNode;
    }
    DecoratedTreeNode.decorateRoot = decorateRoot;
    function getDecorator(node) {
        assert.notNil(node[treeNodeDecorator]);
        return node[treeNodeDecorator];
    }
    DecoratedTreeNode.getDecorator = getDecorator;
    class Decorator {
        constructor(parent, node, extractChildren) {
            this.parent = parent;
            this.node = node;
            this.extractChildren = extractChildren;
            node[treeNodeDecorator] = this; // inject our decorator.
        }
        get children() {
            return this.extractChildren(this.node)
                .map(child => child[treeNodeDecorator] ?? new Decorator(this.decoratedNode, child, this.extractChildren))
                .map(d => d.decoratedNode);
        }
        get decoratedNode() {
            return this.node;
        }
        siblingsBefore() {
            if (this.parent) {
                return this.parent[treeNodeDecorator].children.slice(0, this.myIndex());
            }
            else {
                return [];
            }
        }
        siblingsAfter() {
            if (this.parent) {
                return this.parent[treeNodeDecorator].children.slice(1 + this.myIndex());
            }
            else {
                return [];
            }
        }
        siblings() {
            return [].concat(this.siblingsBefore(), this.siblingsAfter());
        }
        isFirstChild() {
            return this.parent ? this.myIndex() === 0 : false;
        }
        myIndex() {
            const myIndex = this.parent[treeNodeDecorator].children.findIndex(child => this.node === child);
            assert.isTruthy(myIndex >= 0, 'illegal state, expected index to be >= 0');
            return myIndex;
        }
        isLastChild() {
            return this.parent ? this.myIndex() === this.parent[treeNodeDecorator].children.length - 1 : false;
        }
        hasSiblings() {
            return this.parent ? this.parent[treeNodeDecorator].children.length > 1 : false;
        }
        // find(predicate: Predicate<T>): T {
        //   return find(this.descendants(), predicate);
        // }
        //
        // select(predicate: Predicate<T>): T[] {
        //   return filter(this.descendants(), predicate);
        // }
        //
        // flattenInto(array: T[]): T[] {
        //   this.visitSelfAndDescendants(child => array.push(child));
        //   return array;
        // }
        ancestors() {
            return this.parent ? this.parent[treeNodeDecorator].ancestors().concat([this.parent]) : [];
        }
        // ancestorsAndSelf(): T[] {
        //   return this.memoize('ancestorsAndSelf', () => {
        //     return this.ancestors().concat([(this.decoratedSelf)]);
        //   });
        // }
        // pathToParent(parent: T): T[] {
        //   if (this.node === parent.node) {
        //     return [];
        //   } else if (this.parent) {
        //     const pathToParent = this.parent.pathToParent(parent);
        //     return pathToParent.concat([this.parent]);
        //   } else {
        //     throw new Error('parent is not an ancestor');
        //   }
        // }
        //
        // pathToParentAndSelf(parent): T[] {
        //   return this.pathToParent(parent).concat([this.decoratedSelf]);
        // }
        isRoot() {
            return !this.parent;
        }
        get depth() {
            return this.isRoot() ? 0 : this.parent[treeNodeDecorator].depth + 1;
        }
        isLeaf() {
            return !this.isRoot() && this.children.length < 1;
        }
        hasChildren() {
            return this.children.length > 0;
        }
    }
    __decorate([
        Memoize(),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], Decorator.prototype, "children", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Array)
    ], Decorator.prototype, "siblingsBefore", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Array)
    ], Decorator.prototype, "siblingsAfter", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Array)
    ], Decorator.prototype, "siblings", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], Decorator.prototype, "isFirstChild", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Decorator.prototype, "myIndex", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], Decorator.prototype, "isLastChild", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Boolean)
    ], Decorator.prototype, "hasSiblings", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Array)
    ], Decorator.prototype, "ancestors", null);
    __decorate([
        Memoize(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], Decorator.prototype, "depth", null);
    DecoratedTreeNode.Decorator = Decorator;
})(DecoratedTreeNode || (DecoratedTreeNode = {}));

class FlattenedTreeListModel extends ComputedListModel {
    constructor(source, childRef, expansionModel) {
        super(source, {
            initialValue: [],
            identifiedWith: row => source.identityOf(row)
        });
        this.source = source;
        this.childRef = childRef;
        this.expansionModel = expansionModel;
        this.trackSource(expansionModel.isExpandedPredicate);
    }
    compute(values) {
        const result = [];
        values.forEach(rootNode => {
            return this.addNodeAndVisibleChildren(DecoratedTreeNode.decorateRoot(rootNode, this.childRef), result);
        });
        return result;
    }
    addNodeAndVisibleChildren(node, result) {
        result.push(node);
        const decorator = node[treeNodeDecorator];
        if (decorator.hasChildren() && !this.expansionModel.isCollapsed(node)) {
            decorator.children.forEach(child => this.addNodeAndVisibleChildren(child, result));
        }
    }
}

class TreeExpansionModel {
    constructor(identityOf) {
        this.identityOf = identityOf;
        this.collapsedIds = new Set();
        this._isExpandedPredicate = new MutableValueModel(() => true);
        this.updatePredicate();
    }
    get isExpandedPredicate() {
        return this._isExpandedPredicate.readonly;
    }
    // @Trace()
    expand(node) {
        if (this.isCollapsed(node)) {
            this.collapsedIds.delete(this.identityOf(node));
            this.updatePredicate();
        }
    }
    // @Trace()
    collapse(node) {
        if (!this.isCollapsed(node)) {
            this.collapsedIds.add(this.identityOf(node));
            this.updatePredicate();
        }
    }
    canExpand(node) {
        return DecoratedTreeNode.getDecorator(node).hasChildren() && this.isCollapsed(node);
    }
    canCollapse(node) {
        return DecoratedTreeNode.getDecorator(node).hasChildren() && !this.isCollapsed(node);
    }
    isCollapsed(node) {
        return this.collapsedIds.has(this.identityOf(node));
    }
    isExpanded(node) {
        return !this.isCollapsed(node);
    }
    ensureAncestorsAndSelfVisible(node) {
        DecoratedTreeNode.getDecorator(node).ancestors()
            .map(a => this.identityOf(node))
            .forEach(id => this.collapsedIds.delete(id));
        this.updatePredicate();
    }
    updatePredicate() {
        this._isExpandedPredicate.value = (node) => !this.collapsedIds.has(this.identityOf(node));
    }
}

class TreeLabelColumnModel extends ColumnModel {
    constructor(columnId, textPropertiesProvider, expansionModel) {
        super(columnId, textPropertiesProvider);
        this.expansionModel = expansionModel;
        this.cellRenderer(TreeLabelCellRendererComponent);
    }
    pluck(property) {
        this.labelProperty = property;
    }
    /**
     * @deprecated use #useIcon instead.
     * @param factory
     */
    addIcon(factory) {
        this.useIcon(factory);
    }
    useIcon(factory) {
        this.iconFactory = factory;
    }
    cellRenderer(componentType) {
        this.configureCellRenderer(new ComponentCellRendererPortalRef(componentType, (component, rowData, firstTime) => {
            if (firstTime) {
                component.treeTableModel = this.expansionModel;
            }
            component.value = rowData.row;
            component.label = isNil(this.labelProperty) ? undefined : rowData.row[this.labelProperty];
            component.iconFactory = this.iconFactory;
        }));
        return this;
    }
    _selectRowOnClick(selectOnRowClick) {
        return super._selectRowOnClick(selectOnRowClick);
    }
}

// TODO:
//    Selection Models:
//      - as simple navigation tree
//      - as editable grid (selecte all, even hidden etc?)
//      - fixing selection on underlying model changes.
//      - rendering selection: row highlighting, checkboxes (in the tree renderer or in separate column), both.
//    Expansion Models:
//      - Add ability to auto show to depth
//      - Add a predicate to check default expansion (i.e. has children of a certain type)
//
class TreeTableModel extends AbstractTableModel {
    constructor(source, childAccessor, builder) {
        super();
        this.treeExpansionModel = new TreeExpansionModel(row => this.identityOf(row));
        if (builder)
            builder(this);
        const childExtractor = isFunction(childAccessor) ? childAccessor : row => row[childAccessor];
        this.flattenedDataSource = this.registerDisposable(new FlattenedTreeListModel(source, childExtractor, this.treeExpansionModel));
        this.setDataSource(this.flattenedDataSource);
        this.addRowClass('aup-node-collapsed', row => this.isCollapsed(row));
    }
    treeControlColumn(builder) {
        const columnId = 'tree-label';
        const column = new TreeLabelColumnModel(columnId, () => this.getColumnTextProperties(columnId), this);
        builder(column);
        this.addColumn(column);
    }
    expand(node) {
        this.treeExpansionModel.expand(node);
    }
    collapse(node) {
        this.treeExpansionModel.collapse(node);
    }
    isCollapsed(node) {
        return this.treeExpansionModel.isCollapsed(node);
    }
    ensureAncestorsAndSelfVisible(node) {
        this.treeExpansionModel.ensureAncestorsAndSelfVisible(node);
    }
    addSelectionColumn(selectionModel, showSelectionColumn) {
        return this._addSelectionColumn(selectionModel, showSelectionColumn);
    }
}
// export class FlattenStrategy<T extends VisitableTree<any>> extends SelfAndDescendantsVisitor<T> {
//
//   private _areas: T[] = [];
//   private _collapsed: Set<T>;
//
//   constructor(private collapsedIds: T[]) {
//     super();
//     this._collapsed = new Set<T>(collapsedIds);
//   }
//
//   protected onVisit(it: T) {
//     this._areas.push(it);
//   }
//
//   protected shouldVisitChildrenOf(it: T): boolean {
//     return !this._collapsed.has(it);
//   }
//
//   get flattenedAreas(): T[] {
//     return this._areas;
//   }
//
// }
// class DecoratorCache {
//
//     private map = new Map<number, T>();
//
//     get(area:T): T {
//
//         if (!area) return null;
//
//         let decoratedArea = this.map.get(area.id);
//         if (!decoratedArea) {
//             decoratedArea = TreeModel.AreaDecorator.decorate(area);
//             this.map.set(area.id, decoratedArea);
//         }
//         return decoratedArea;
//     }
//
//     clear() {
//         this.map.clear();
//     }
//
//
// }

class TreeLabelCellRendererComponent extends DisposableComponent {
    constructor() {
        super();
        this.nodeModel = new MutableValueModel();
        const { chain } = Dsl.disposeWith(this);
        this.iconList = chain(this.nodeModel).mapToList(node => {
            const icons = DecoratedTreeNode.getDecorator(node).ancestors().slice(1).map(ancestor => {
                return DecoratedTreeNode.getDecorator(ancestor).isLastChild() ? TreeInheritanceIconComponent.Type.ICON_BLANK : TreeInheritanceIconComponent.Type.ICON_THROUGH;
            });
            if (!DecoratedTreeNode.getDecorator(node).isRoot()) {
                icons.push(DecoratedTreeNode.getDecorator(node).isLastChild() ? TreeInheritanceIconComponent.Type.ICON_INHERITED_TERMINAL : TreeInheritanceIconComponent.Type.ICON_INHERITED_THROUGH_TERMINAL);
            }
            return icons;
        });
    }
    ngOnInit() {
        const { chain } = Dsl.disposeWith(this);
        this.canExpand = chain(this.nodeModel).map(node => {
            return DecoratedTreeNode.getDecorator(node).hasChildren() && this.treeTableModel.isCollapsed(node);
        }, { dependsOn: this.treeTableModel.treeExpansionModel.isExpandedPredicate });
        this.canCollapse = chain(this.nodeModel).map(node => {
            return DecoratedTreeNode.getDecorator(node).hasChildren() && !this.treeTableModel.isCollapsed(node);
        }, { dependsOn: this.treeTableModel.treeExpansionModel.isExpandedPredicate });
        this.iconModel = chain(this.nodeModel).map(node => {
            const expanded = this.treeTableModel.treeExpansionModel.isExpanded(this.node);
            const iconFactory = this.iconFactory ?? TreeLabelCellRendererComponent.DEFAULT_ICON_FACTORY;
            return iconFactory(node, expanded, TreeLabelCellRendererComponent.DEFAULT_ICON_FACTORY(node, expanded, undefined));
        }, { dependsOn: this.treeTableModel.treeExpansionModel.isExpandedPredicate });
    }
    get isRoot() {
        return DecoratedTreeNode.getDecorator(this.node).isRoot();
    }
    get isLeaf() {
        return DecoratedTreeNode.getDecorator(this.node).isLeaf();
    }
    get node() {
        return this.nodeModel.value;
    }
    // @Trace()
    expandOrCollapse($event, node) {
        $event.preventDefault();
        $event.stopPropagation();
        this.treeTableModel.isCollapsed(node) ? this.treeTableModel.expand(node) : this.treeTableModel.collapse(node);
    }
}
TreeLabelCellRendererComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeLabelCellRendererComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TreeLabelCellRendererComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TreeLabelCellRendererComponent, selector: "aup-tree-label-cell-renderer", inputs: { value: "value", label: "label", iconFactory: "iconFactory", treeTableModel: "treeTableModel" }, host: { properties: { "class.root": "this.isRoot", "class.leaf": "this.isLeaf" } }, usesInheritance: true, ngImport: i0, template: "<div class=\"tree-icons\">\n  <aup-tree-inheritance-icon *ngFor=\"let type of iconList.value\" [type]=\"type\"></aup-tree-inheritance-icon>\n  <aup-icon *ngIf=\"iconModel.value\"\n            [icon]=\"iconModel.value\"\n            [class.clickable]=\"canExpand.value || canCollapse.value\"\n            (click)=\"expandOrCollapse($event, node)\" ></aup-icon>\n</div>\n<div class=\"label\">{{label}}</div>\n", styles: [":host{--line-color: #ddd;--node-color: #999;display:inline-flex;flex-direction:row;align-items:stretch}:host div.label{display:flex;flex-direction:row;align-items:center;white-space:nowrap;padding-left:6px}:host div.tree-icons{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:1fr;align-items:stretch;justify-content:stretch}:host div.tree-icons aup-icon{align-self:center;color:var(--node-color)}:host div.tree-icons aup-icon.clickable{cursor:pointer}:host div.tree-icons aup-tree-inheritance-icon,:host div.tree-icons aup-icon{margin-left:4px}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }, { kind: "component", type: TreeInheritanceIconComponent, selector: "aup-tree-inheritance-icon", inputs: ["type", "pixelWidth", "pixelHeight"] }] });
__decorate([
    StoreInValueModel('nodeModel'),
    __metadata("design:type", Object)
], TreeLabelCellRendererComponent.prototype, "value", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeLabelCellRendererComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-tree-label-cell-renderer', template: "<div class=\"tree-icons\">\n  <aup-tree-inheritance-icon *ngFor=\"let type of iconList.value\" [type]=\"type\"></aup-tree-inheritance-icon>\n  <aup-icon *ngIf=\"iconModel.value\"\n            [icon]=\"iconModel.value\"\n            [class.clickable]=\"canExpand.value || canCollapse.value\"\n            (click)=\"expandOrCollapse($event, node)\" ></aup-icon>\n</div>\n<div class=\"label\">{{label}}</div>\n", styles: [":host{--line-color: #ddd;--node-color: #999;display:inline-flex;flex-direction:row;align-items:stretch}:host div.label{display:flex;flex-direction:row;align-items:center;white-space:nowrap;padding-left:6px}:host div.tree-icons{display:grid;grid-auto-flow:column;grid-auto-columns:auto;grid-template-rows:1fr;align-items:stretch;justify-content:stretch}:host div.tree-icons aup-icon{align-self:center;color:var(--node-color)}:host div.tree-icons aup-icon.clickable{cursor:pointer}:host div.tree-icons aup-tree-inheritance-icon,:host div.tree-icons aup-icon{margin-left:4px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }], label: [{
                type: Input
            }], iconFactory: [{
                type: Input
            }], treeTableModel: [{
                type: Input
            }], isRoot: [{
                type: HostBinding,
                args: ['class.root']
            }], isLeaf: [{
                type: HostBinding,
                args: ['class.leaf']
            }] } });
(function (TreeLabelCellRendererComponent) {
    TreeLabelCellRendererComponent.DEFAULT_ICON_FACTORY = (node, expanded, defaultIcon) => {
        const isLeaf = DecoratedTreeNode.getDecorator(node).isLeaf();
        return isLeaf ?
            undefined :
            expanded ?
                'mat:expand_more' :
                'mat:chevron_right';
    };
})(TreeLabelCellRendererComponent || (TreeLabelCellRendererComponent = {}));

/**
 * Create your model:
 * @example
 * this.heroTableModel = TableTreeModel.fromList(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addCustomColumn("fullName", hero => `${hero.firstName} ${hero.lastName}`);
 *   table.addTemplateColumn("specialColumn");
 * });
 *
 * Create your table
 * @example
 * <aup-tree-table [treeTableModel]="heroTableModel"></aup-table>
 *
 * Column templates
 * @example
 * this.heroTableModel = TableModel.fromList(heroList, table => {
 *   table.pluck("firstName");
 *   table.pluck("lastName");
 *   table.addTemplateColumn("specialColumn");
 * });
 * <aup-table [tableModel]="heroTableModel">
 *   <div *aupColumnTemplate="let hero; columnId: 'specialColumn'; fillCell: true; padChild:false">
 *     {{hero.name}}
 *   </div>
 * </aup-table>
 *
 * Styling
 * @example
 *  // global settings
 * :root {
 *   --aup-table-column-gap: 10px; // defaults to 24px
 *   --aup-table-row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --aup-table-row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --aup-table-first-column-padding-left: 18px // defaults to --column-gap
 *   --aup-table-last-column-padding-right: 18px // defaults to --column-gap
 * }
 *
 * // per table settings.
 * aup-table {
 *   --column-gap: 10px; // defaults to 24px
 *   --row-hover-background-color, rgba(0, 0, 0, 0.05)
 *   --row-selected-background-color: rebeccapurple; // defaults to transparent
 *   --first-column-padding-left: 18px // defaults to --column-gap
 *   --last-column-padding-right: 18px // defaults to --column-gap
 *
 *   aup-table-header-cell-renderer,
 *   aup-table-cell-renderer {
 *     &.aup-col-my-dasherised-column-id {
 *       // do stuff
 *     }
 *     &.first-visible-column {
 *       // do stuff
 *     }
 *     &.last-visible-column {
 *       // do stuff
 *     }
 *   }
 * }
 */
class TreeTableComponent extends AbstractTableComponent {
    constructor(injector) {
        super(injector);
    }
    getModel() {
        return this.treeTableModel;
    }
}
TreeTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeTableComponent, deps: [{ token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
TreeTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TreeTableComponent, selector: "aup-tree-table", inputs: { treeTableModel: "treeTableModel" }, providers: [
        { provide: AbstractTableComponent, useExisting: TreeTableComponent }
    ], usesInheritance: true, ngImport: i0, template: "<aup-table-body [tableModel]=\"treeTableModel\"\n                [showHeader$]=\"showHeader$\"\n                [enableScrolling]=\"enableScrolling\"\n                [aupHighlightTextModel]=\"treeTableModel.filterModel.highlightText$\"\n></aup-table-body>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host::ng-deep td.mat-cell{border-top-width:0!important;border-bottom-width:0!important}:host::ng-deep td.mat-column-tree-label,:host::ng-deep td.mat-column-tree-label{width:1px}:host::ng-deep aup-table-cell-renderer[column-id=tree-label]{padding-left:8px!important}:host::ng-deep aup-tree-label-cell-renderer{flex:1}aup-table-body{flex:1}\n"], dependencies: [{ kind: "directive", type: HighlightTextModelDirective, selector: "[aupHighlightTextModel]", inputs: ["aupHighlightTextModel"] }, { kind: "component", type: TableBodyComponent, selector: "aup-table-body", inputs: ["tableModel", "showHeader$", "showHeader", "enableScrolling"], outputs: ["visibleRowCount"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", TreeTableModel)
], TreeTableComponent.prototype, "treeTableModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TreeTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-tree-table', providers: [
                        { provide: AbstractTableComponent, useExisting: TreeTableComponent }
                    ], template: "<aup-table-body [tableModel]=\"treeTableModel\"\n                [showHeader$]=\"showHeader$\"\n                [enableScrolling]=\"enableScrolling\"\n                [aupHighlightTextModel]=\"treeTableModel.filterModel.highlightText$\"\n></aup-table-body>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch}:host::ng-deep td.mat-cell{border-top-width:0!important;border-bottom-width:0!important}:host::ng-deep td.mat-column-tree-label,:host::ng-deep td.mat-column-tree-label{width:1px}:host::ng-deep aup-table-cell-renderer[column-id=tree-label]{padding-left:8px!important}:host::ng-deep aup-tree-label-cell-renderer{flex:1}aup-table-body{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Injector }]; }, propDecorators: { treeTableModel: [{
                type: Input
            }] } });

class VerticalFocusContainerComponent extends FocusContainerComponent {
    constructor(focusManager) {
        super(focusManager);
        this.focusManager = focusManager;
    }
    arrowLeft(event) {
        if (this.leftArrowCommand.enabled$.value) {
            event.preventDefault();
            event.stopPropagation();
            this.leftArrowCommand.execute();
        }
    }
    arrowRight(event) {
        if (this.rightArrowCommand.enabled$.value) {
            event.preventDefault();
            event.stopPropagation();
            this.rightArrowCommand.execute();
        }
    }
    arrowDown(event) {
        event.preventDefault();
        event.stopPropagation();
        this.focusManager.focusNext();
    }
    arrowUp(event) {
        event.preventDefault();
        event.stopPropagation();
        this.focusManager.focusPrevious();
    }
    ngOnInit() {
    }
}
VerticalFocusContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: VerticalFocusContainerComponent, deps: [{ token: i1$3.FocusManager, self: true }], target: i0.ɵɵFactoryTarget.Component });
VerticalFocusContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: VerticalFocusContainerComponent, selector: "aup-vertical-focus-container", inputs: { rightArrowCommand: ["command.arrowRight", "rightArrowCommand"], leftArrowCommand: ["command.arrowLeft", "leftArrowCommand"] }, host: { listeners: { "keyup.arrowLeft": "arrowLeft($event)", "keyup.arrowRight": "arrowRight($event)", "keyup.arrowDown": "arrowDown($event)", "keyup.arrowUp": "arrowUp($event)" } }, providers: [
        { provide: FocusManager }
    ], usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], VerticalFocusContainerComponent.prototype, "rightArrowCommand", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], VerticalFocusContainerComponent.prototype, "leftArrowCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: VerticalFocusContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-vertical-focus-container', providers: [
                        { provide: FocusManager }
                    ], template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$3.FocusManager, decorators: [{
                    type: Self
                }] }]; }, propDecorators: { rightArrowCommand: [{
                type: Input,
                args: ['command.arrowRight']
            }], leftArrowCommand: [{
                type: Input,
                args: ['command.arrowLeft']
            }], arrowLeft: [{
                type: HostListener,
                args: ['keyup.arrowLeft', ['$event']]
            }], arrowRight: [{
                type: HostListener,
                args: ['keyup.arrowRight', ['$event']]
            }], arrowDown: [{
                type: HostListener,
                args: ['keyup.arrowDown', ['$event']]
            }], arrowUp: [{
                type: HostListener,
                args: ['keyup.arrowUp', ['$event']]
            }] } });

class LabelledValueComponent extends DisposableComponent {
    constructor() {
        super();
        // const {chain} = Dsl.disposeWith(this);
    }
    ngOnInit() {
    }
}
LabelledValueComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LabelledValueComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LabelledValueComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: LabelledValueComponent, selector: "aup-labelled-value", inputs: { label: "label" }, usesInheritance: true, ngImport: i0, template: "<label>{{label}}</label>\n<ng-content></ng-content>\n", styles: [":host{display:inline-flex;flex-direction:column;align-items:flex-start}label{font-weight:400;font-size:12px;color:#00000091;margin-bottom:6px;white-space:nowrap}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: LabelledValueComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-labelled-value', template: "<label>{{label}}</label>\n<ng-content></ng-content>\n", styles: [":host{display:inline-flex;flex-direction:column;align-items:flex-start}label{font-weight:400;font-size:12px;color:#00000091;margin-bottom:6px;white-space:nowrap}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }] } });

// TODO: Look at using unified parser: https://javascript.plainenglish.io/markdown-to-angular-rendering-using-unified-and-remark-96835bb877
/**
 * @example
 * <aup-markdown [content]="..."></aup-markdown>
 * <aup-markdown [content$]="stringValueModel$"></aup-markdown>
 * <aup-markdown ngPreserveWhitespaces>
 *   # This is markdown content
 *
 *  With a list
 *    - a
 *    - b
 * </aup-markdown>
 */
class MarkdownComponent extends DisposableComponent {
    constructor(platform, element, markdownService) {
        super();
        this.platform = platform;
        this.element = element;
        this.markdownService = markdownService;
        this.inline = false;
        const { chain } = Dsl.disposeWith(this);
    }
    ngOnInit() {
        const { when } = Dsl.disposeWith(this);
        when(this.content$).changes(content => this.renderContent(content), { initialValue: 'triggerChangeUnlessNil' });
        if (isNil(this.content) && !isEmpty(this.element.nativeElement.innerHTML)) {
            this.renderContent(this.extractInnerContent(this.element.nativeElement.innerHTML));
        }
    }
    extractInnerContent(content) {
        const lines = content.split('\n');
        const prefix = lines.reduce((minPrefix, line) => {
            const leadingWhitespace = line.search(/\S/);
            return leadingWhitespace < 0 ? minPrefix : Math.min(minPrefix, leadingWhitespace);
        }, Number.MAX_SAFE_INTEGER);
        return lines.map(l => l.substr(prefix)).join('\n');
    }
    renderContent(content) {
        if (!isNil(content)) {
            const markdown = this.inline ?
                this.markdownService.renderInline(content) :
                this.markdownService.render(content);
            this.element.nativeElement.innerHTML = markdown;
        }
    }
}
MarkdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MarkdownComponent, deps: [{ token: PLATFORM_ID }, { token: i0.ElementRef }, { token: MarkdownService }], target: i0.ɵɵFactoryTarget.Component });
MarkdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: MarkdownComponent, selector: "aup-markdown, [aupMarkdown]", inputs: { content$: "content$", content: "content", inline: "inline" }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:inline-block}\n"] });
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], MarkdownComponent.prototype, "content$", void 0);
__decorate([
    StoreInValueModel('content$'),
    __metadata("design:type", String)
], MarkdownComponent.prototype, "content", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: MarkdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-markdown, [aupMarkdown]', template: "<ng-content></ng-content>\n", styles: [":host{display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.ElementRef }, { type: MarkdownService }]; }, propDecorators: { content$: [{
                type: Input
            }], content: [{
                type: Input
            }], inline: [{
                type: Input
            }] } });

class ComponentsModule {
}
ComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: ComponentsModule, declarations: [AbstractInputComponent,
        AbstractValueInputComponent,
        AbstractListInputComponent,
        NumberInputComponent,
        StringInputComponent,
        TextInputComponent,
        PasswordInputComponent,
        SelectInputComponent,
        MultipleSelectInputComponent,
        AutocompleteInputComponent,
        CheckboxInputComponent,
        ScrollContainerComponent,
        NoopComponent,
        SwitchCaseComponent,
        SwitchCaseWhenDirective,
        SwitchCaseDefaultDirective,
        FocusContainerComponent,
        VerticalFocusContainerComponent,
        FocusableComponent,
        CardContainerComponent,
        TableComponent,
        EditRowControls,
        ColumnTemplateDirective,
        DefaultCellRendererComponent,
        TableCellComponent,
        SelectionCellComponent,
        SelectionHeaderCellComponent,
        DefaultHeaderCellRendererComponent,
        TableHeaderCellComponent,
        IconComponent,
        SectionHeaderComponent,
        TableRowMenuComponent,
        ToolBarComponent,
        CommandComponent,
        PopupMenuComponent,
        CommandFaceComponent,
        MoreMenuComponent,
        SeparatorComponent,
        FlexComponent,
        AbstractPopupMenuComponent,
        PopupMenuRendererComponent,
        TreeTableComponent,
        TreeInheritanceIconComponent,
        TreeLabelCellRendererComponent,
        BusyOverlayComponent,
        EmptyStateComponent,
        PaginatorComponent,
        AbstractTableComponent,
        AbstractCardContainerComponent,
        CardStackComponent,
        LabelledValueComponent,
        LoadingContainerComponent,
        MarkdownComponent,
        TableBodyComponent], imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        DirectivesModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatTableModule,
        PortalModule,
        CdkScrollableModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatMenuModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatProgressBarModule], exports: [NumberInputComponent,
        StringInputComponent,
        TextInputComponent,
        PasswordInputComponent,
        CheckboxInputComponent,
        SelectInputComponent,
        MultipleSelectInputComponent,
        AutocompleteInputComponent,
        ScrollContainerComponent,
        NoopComponent,
        SwitchCaseComponent,
        SwitchCaseWhenDirective,
        SwitchCaseDefaultDirective,
        FocusContainerComponent,
        VerticalFocusContainerComponent,
        FocusableComponent,
        CardContainerComponent,
        TableComponent,
        EditRowControls,
        ColumnTemplateDirective,
        IconComponent,
        SectionHeaderComponent,
        TableRowMenuComponent,
        ToolBarComponent,
        CommandComponent,
        PopupMenuComponent,
        CommandFaceComponent,
        MoreMenuComponent,
        SeparatorComponent,
        FlexComponent,
        TreeTableComponent,
        BusyOverlayComponent,
        EmptyStateComponent,
        PaginatorComponent,
        CardStackComponent,
        LabelledValueComponent,
        LoadingContainerComponent,
        MarkdownComponent] });
ComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ComponentsModule, providers: [
        FocusBindingFactory,
        MarkdownService
    ], imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        DirectivesModule,
        MatIconModule,
        MatButtonModule,
        MatCheckboxModule,
        MatTableModule,
        PortalModule,
        CdkScrollableModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatMenuModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatProgressBarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatTabsModule,
                        DirectivesModule,
                        MatIconModule,
                        MatButtonModule,
                        MatCheckboxModule,
                        MatTableModule,
                        PortalModule,
                        CdkScrollableModule,
                        MatTooltipModule,
                        MatAutocompleteModule,
                        MatMenuModule,
                        MatDividerModule,
                        MatProgressSpinnerModule,
                        MatProgressBarModule
                    ],
                    declarations: [
                        AbstractInputComponent,
                        AbstractValueInputComponent,
                        AbstractListInputComponent,
                        NumberInputComponent,
                        StringInputComponent,
                        TextInputComponent,
                        PasswordInputComponent,
                        SelectInputComponent,
                        MultipleSelectInputComponent,
                        AutocompleteInputComponent,
                        CheckboxInputComponent,
                        ScrollContainerComponent,
                        NoopComponent,
                        SwitchCaseComponent,
                        SwitchCaseWhenDirective,
                        SwitchCaseDefaultDirective,
                        FocusContainerComponent,
                        VerticalFocusContainerComponent,
                        FocusableComponent,
                        CardContainerComponent,
                        TableComponent,
                        EditRowControls,
                        ColumnTemplateDirective,
                        DefaultCellRendererComponent,
                        TableCellComponent,
                        SelectionCellComponent,
                        SelectionHeaderCellComponent,
                        DefaultHeaderCellRendererComponent,
                        TableHeaderCellComponent,
                        IconComponent,
                        SectionHeaderComponent,
                        TableRowMenuComponent,
                        ToolBarComponent,
                        CommandComponent,
                        PopupMenuComponent,
                        CommandFaceComponent,
                        MoreMenuComponent,
                        SeparatorComponent,
                        FlexComponent,
                        AbstractPopupMenuComponent,
                        PopupMenuRendererComponent,
                        TreeTableComponent,
                        TreeInheritanceIconComponent,
                        TreeLabelCellRendererComponent,
                        BusyOverlayComponent,
                        EmptyStateComponent,
                        PaginatorComponent,
                        AbstractTableComponent,
                        AbstractCardContainerComponent,
                        CardStackComponent,
                        LabelledValueComponent,
                        LoadingContainerComponent,
                        MarkdownComponent,
                        TableBodyComponent
                    ],
                    exports: [
                        NumberInputComponent,
                        StringInputComponent,
                        TextInputComponent,
                        PasswordInputComponent,
                        CheckboxInputComponent,
                        SelectInputComponent,
                        MultipleSelectInputComponent,
                        AutocompleteInputComponent,
                        ScrollContainerComponent,
                        NoopComponent,
                        SwitchCaseComponent,
                        SwitchCaseWhenDirective,
                        SwitchCaseDefaultDirective,
                        FocusContainerComponent,
                        VerticalFocusContainerComponent,
                        FocusableComponent,
                        CardContainerComponent,
                        TableComponent,
                        EditRowControls,
                        ColumnTemplateDirective,
                        IconComponent,
                        SectionHeaderComponent,
                        TableRowMenuComponent,
                        ToolBarComponent,
                        CommandComponent,
                        PopupMenuComponent,
                        CommandFaceComponent,
                        MoreMenuComponent,
                        SeparatorComponent,
                        FlexComponent,
                        TreeTableComponent,
                        BusyOverlayComponent,
                        EmptyStateComponent,
                        PaginatorComponent,
                        CardStackComponent,
                        LabelledValueComponent,
                        LoadingContainerComponent,
                        MarkdownComponent
                    ],
                    providers: [
                        FocusBindingFactory,
                        MarkdownService
                    ]
                }]
        }] });

/**
 * @example
 * <aup-activity-actions [confirmFace]="saveFace" [cancelFace]="cancelFace">
 * </aup-activity-actions>
 *
 *  <aup-activity-actions [faces]="{confirm: saveFace, cancel: cancelFace}">
 *  </aup-activity-actions>
 *
 * // Running `ng g @coolon/angular-ui-powerups:aup-i18n` will install default
 * // style definitions
 * <aup-activity-actions [faces]="I18n.aup.components.activityActions.styles.okCancelIcons">
 * </aup-activity-actions>
 *
 * // you can also add additional content that will be displayed along with the buttons.
 * // The location of the content depends on the alignment attribute.
 * <aup-activity-actions
 *     align="stretch"
 *     [faces]="I18n.aup.components.activityActions.styles.okCancelIcons">
 *     <span>This content will be between the two commands</span>
 * </aup-activity-actions>
 */
class ActivityActionsComponent extends DisposableComponent {
    constructor(cdr) {
        super();
        this.cdr = cdr;
        this.layout = ActivityActionsComponent.Layout.BLOCK;
        this.align = ActivityActionsComponent.Align.STRETCH;
    }
    set faces(faces) {
        this.confirmFace = faces.confirm;
        this.cancelFace = faces.cancel;
    }
    /**
     * @deprecated use #faces instead.
     */
    set style(style) {
        this.faces = style;
    }
    ngOnInit() {
    }
    hasConfirmFace() {
        return !!this.confirmFace;
    }
    hasCancelFace() {
        return !!this.cancelFace;
    }
    initCommands(activity) {
        this.confirmCommand = activity.confirmCommand;
        this.cancelCommand = activity.cancelCommand;
        this.cdr.detectChanges();
    }
    focusConfirm() {
        this.confirmCommandComponent.requestFocus();
    }
    focusCancel() {
        this.cancelCommandComponent.requestFocus();
    }
}
ActivityActionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityActionsComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
ActivityActionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: { confirmCommand: "confirmCommand", cancelCommand: "cancelCommand", faces: "faces", confirmFace: "confirmFace", cancelFace: "cancelFace", style: "style", layout: "layout", align: "align" }, host: { properties: { "attr.layout": "this.layout", "attr.align": "this.align" } }, viewQueries: [{ propertyName: "confirmCommandComponent", first: true, predicate: ["confirmCommandComponent"], descendants: true }, { propertyName: "cancelCommandComponent", first: true, predicate: ["cancelCommandComponent"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"content\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"hasConfirmFace()\">\n  <aup-command #confirmCommandComponent class=\"confirm\" [command]=\"confirmCommand\" [face]=\"confirmFace\" data-cy=\"confirm-command\"></aup-command>\n</ng-container>\n<ng-container *ngIf=\"hasCancelFace()\">\n  <aup-command #cancelCommandComponent class=\"cancel\" [command]=\"cancelCommand\" [face]=\"cancelFace\" data-cy=\"cancel-command\"></aup-command>\n</ng-container>\n", styles: [":host{display:grid;grid-template-rows:auto;align-items:center;justify-content:end;--resolved-activity-actions-gap: var(--activity-actions-gap, 8px)}:host[layout=block][align=start]{grid-template-areas:\"cancel confirm content\";grid-template-columns:auto auto 1fr}:host[layout=block][align=start] .confirm{margin-left:var(--resolved-activity-actions-gap)}:host[layout=block][align=end]{grid-template-areas:\"content cancel confirm\";grid-template-columns:1fr auto auto}:host[layout=block][align=end] .confirm{margin-left:var(--resolved-activity-actions-gap)}:host[layout=block][align=stretch]{grid-template-areas:\"cancel content confirm\";grid-template-columns:auto 1fr auto}:host[layout=inline]{grid-template-areas:\"confirm cancel content\";grid-template-columns:auto auto 1fr}:host[layout=inline] .cancel{margin-left:var(--resolved-activity-actions-gap)}.cancel{grid-area:cancel}.confirm{grid-area:confirm}.content{grid-area:content;text-align:left}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], ActivityActionsComponent.prototype, "confirmCommand", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], ActivityActionsComponent.prototype, "cancelCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityActionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-activity-actions', template: "<div class=\"content\">\n  <ng-content></ng-content>\n</div>\n<ng-container *ngIf=\"hasConfirmFace()\">\n  <aup-command #confirmCommandComponent class=\"confirm\" [command]=\"confirmCommand\" [face]=\"confirmFace\" data-cy=\"confirm-command\"></aup-command>\n</ng-container>\n<ng-container *ngIf=\"hasCancelFace()\">\n  <aup-command #cancelCommandComponent class=\"cancel\" [command]=\"cancelCommand\" [face]=\"cancelFace\" data-cy=\"cancel-command\"></aup-command>\n</ng-container>\n", styles: [":host{display:grid;grid-template-rows:auto;align-items:center;justify-content:end;--resolved-activity-actions-gap: var(--activity-actions-gap, 8px)}:host[layout=block][align=start]{grid-template-areas:\"cancel confirm content\";grid-template-columns:auto auto 1fr}:host[layout=block][align=start] .confirm{margin-left:var(--resolved-activity-actions-gap)}:host[layout=block][align=end]{grid-template-areas:\"content cancel confirm\";grid-template-columns:1fr auto auto}:host[layout=block][align=end] .confirm{margin-left:var(--resolved-activity-actions-gap)}:host[layout=block][align=stretch]{grid-template-areas:\"cancel content confirm\";grid-template-columns:auto 1fr auto}:host[layout=inline]{grid-template-areas:\"confirm cancel content\";grid-template-columns:auto auto 1fr}:host[layout=inline] .cancel{margin-left:var(--resolved-activity-actions-gap)}.cancel{grid-area:cancel}.confirm{grid-area:confirm}.content{grid-area:content;text-align:left}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { confirmCommandComponent: [{
                type: ViewChild,
                args: ["confirmCommandComponent"]
            }], cancelCommandComponent: [{
                type: ViewChild,
                args: ["cancelCommandComponent"]
            }], confirmCommand: [{
                type: Input
            }], cancelCommand: [{
                type: Input
            }], faces: [{
                type: Input
            }], confirmFace: [{
                type: Input
            }], cancelFace: [{
                type: Input
            }], style: [{
                type: Input
            }], layout: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.layout']
            }], align: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.align']
            }] } });
(function (ActivityActionsComponent) {
    ActivityActionsComponent.Layout = Enum({
        INLINE: 'inline',
        BLOCK: 'block'
    });
    ActivityActionsComponent.Align = Enum({
        START: 'start',
        END: 'end',
        STRETCH: 'stretch'
    });
})(ActivityActionsComponent || (ActivityActionsComponent = {}));

const ACTIVITY_DATA = new InjectionToken("InteractionActivityData");
class Activity extends DisposableComponent {
    constructor() {
        super();
        this.activityData = inject(ACTIVITY_DATA);
        this.activityReadyListeners = new EventListenerList();
        this._busy$ = this.registerDisposable(new DelegatingValueModel().withDefault(false));
        this._focused$ = this.registerDisposable(new DelegatingValueModel());
        this._ready$ = new MutableValueModel(false);
        this.class = "aup-activity";
        this.busyWhile(this.confirmCommand.busy$);
    }
    get isFocused() {
        return this._focused$.value;
    }
    initialise(nestedInteractionContext, activityContext) {
        const { chain, when } = Dsl.disposeWith(this);
        assert$1.isNil(this._activityContext);
        this._activityContext = activityContext;
        this._interactionContext = nestedInteractionContext;
        this._focused$.setDelegate(activityContext.focused);
        when(this._focused$).becomesTruthy(() => {
            this.notifyActivityReady();
        });
    }
    ngAfterViewInit() {
        if (this.activityActions) {
            this.initialiseActivityAction(this.activityActions);
        }
    }
    initialiseActivityAction(activityActions) {
        activityActions.initCommands(this);
    }
    get interactionContext() {
        assert$1.isTruthy(this.isInitialised());
        return this._interactionContext;
    }
    done(result) {
        return this._activityContext.onDone(result);
    }
    cancel(error) {
        this._activityContext.onCancel(error);
    }
    notifyActivityReady() {
        this.activityReadyListeners.fire(l => l(this));
        this._ready$.value = true;
    }
    onActivityReady(callback) {
        return this.activityReadyListeners.add(callback);
    }
    autoFocus(focusable) {
        return this.onActivityReady(() => focusable.requestFocus());
    }
    /**
     * @deprecated use #autoFocus instead
     * @param focusable
     */
    autoFocusOnActivityReady(focusable) {
        return this.autoFocus(focusable);
    }
    get ready$() {
        return this._ready$.readonly;
    }
    get busy$() {
        return this._busy$.readonly;
    }
    get focused$() {
        return this._focused$.readonly;
    }
    busyWhile(busyModel) {
        this._busy$.setDelegate(busyModel);
    }
    isBusy() {
        return this._busy$.value;
    }
    isInitialised() {
        return !!this._activityContext;
    }
}
Activity.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: Activity, deps: [], target: i0.ɵɵFactoryTarget.Component });
Activity.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: Activity, selector: "ng-component", host: { properties: { "class": "this.class", "attr.focused": "this.isFocused" } }, viewQueries: [{ propertyName: "activityActions", first: true, predicate: ActivityActionsComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "", isInline: true });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], Activity.prototype, "confirmCommand", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], Activity.prototype, "cancelCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: Activity, decorators: [{
            type: Component,
            args: [{
                    template: ""
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { activityActions: [{
                type: ViewChild,
                args: [ActivityActionsComponent]
            }], confirmCommand: [], cancelCommand: [], class: [{
                type: HostBinding,
                args: ["class"]
            }], isFocused: [{
                type: HostBinding,
                args: ["attr.focused"]
            }] } });

var Alert;
(function (Alert) {
    function getContent(alert) {
        const content = alert.content();
        return Array.isArray(content) ? content : [content];
    }
    Alert.getContent = getContent;
    function getTitle(alert) {
        return isFunction(alert.title) ? alert.title() : undefined;
    }
    Alert.getTitle = getTitle;
    function getColor(alert) {
        return isFunction(alert.color) ? alert.color() : undefined;
    }
    Alert.getColor = getColor;
})(Alert || (Alert = {}));

const ALERT_CONFIG = new InjectionToken('AlertConfig');
class AbstractDialogComponent extends Activity {
    constructor(config) {
        super();
        this.config = config;
        assert.notNil(config);
        this.title = Alert.getTitle(config);
        this.color = this.checkColor(Alert.getColor(config));
        this.content = Alert.getContent(config);
        this.confirmFace = {
            text: () => config.ok(),
            color: () => this.color || 'primary',
            style: () => 'raised'
        };
        this.onActivityReady(() => {
            if (this.activityActions) {
                this.isDestructive() ? this.activityActions.focusCancel() : this.activityActions.focusConfirm();
            }
        });
    }
    getConfig() {
        return lang$1.abstractMethod(this.constructor);
    }
    checkColor(rawColor) {
        if (this.isDestructive()) {
            return 'warn';
        }
        else {
            if (['primary', 'accent', 'warn'].includes(rawColor)) {
                return rawColor;
            }
            else {
                console.warn(`Invalid color string ${rawColor}`);
                return undefined;
            }
        }
    }
    isDestructive() {
        // @ts-ignore
        return isFunction$1(this.config['destructive']) && this.config.destructive();
    }
}
AbstractDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractDialogComponent, deps: [{ token: ALERT_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
AbstractDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractDialogComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ALERT_CONFIG]
                }] }]; } });

class AbstractConfirmDialogComponent extends AbstractDialogComponent {
    constructor(config) {
        super(config);
        this.cancelFace = {
            text: () => config.cancel()
        };
        this.cancelCommand = Command.create(() => {
            return this.cancel();
        });
    }
}
AbstractConfirmDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractConfirmDialogComponent, deps: [{ token: ALERT_CONFIG }], target: i0.ɵɵFactoryTarget.Component });
AbstractConfirmDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractConfirmDialogComponent, selector: "ng-component", usesInheritance: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ALERT_CONFIG]
                }] }]; } });

class InteractionServiceRoutingAdapter {
    constructor(activeInteractionContextIds, activeModalContext, createExclusiveInteractionContext) {
        this.activeInteractionContextIds = activeInteractionContextIds;
        this.activeModalContext = activeModalContext;
        this.createExclusiveInteractionContext = createExclusiveInteractionContext;
    }
    isActive() {
        return this.getActiveInteractionContextIds().length > 0;
    }
    isModalActive() {
        return !!this.activeModalContext.value;
    }
    // @Trace()
    isComponentInteracting(component) {
        return component.interactionContext && component.interactionContext.isActive();
    }
    getActiveInteractionContextIds() {
        return this.activeInteractionContextIds.value;
    }
    // @Trace()
    cancelCurrentModalInteraction() {
        return this.activeModalContext.value.cancelActiveActivity();
    }
    // @Trace()
    cancelComponentInteraction(component) {
        return component.interactionContext.cancelActiveActivity();
    }
}

class ModalInteractionContextFactory {
}

let inplaceMonitorCount = 0;
class InteractionService {
    constructor(modelInteractionContextFactory) {
        this.modelInteractionContextFactory = modelInteractionContextFactory;
        this.garbage = new GarbageCollector();
        // private readonly _activeModalContext = new MutableValueModel<InteractionContext>();
        // private readonly _activeInlineContext = new MutableValueModel<InteractionContext>();
        // private readonly _activeContext: ValueModelChain<InteractionContext>;
        this._navigationInProgress = new DelegatingValueModel().withDefault(false);
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this.garbage);
        this.exclusiveInteractionRegistry = new InteractionService.ContextRegistry();
        this.modalInteractionRegistry = new InteractionService.ContextRegistry();
        this.inPlaceInteractionRegistry = new InteractionService.ContextRegistry();
        this.modalInteractionRegistry.disableWhen(valueOf.any(this.exclusiveInteractionRegistry.active, this.modalInteractionRegistry.active).areTruthy());
        this.inPlaceInteractionRegistry.disableWhen(valueOf.any(this.exclusiveInteractionRegistry.active, this.modalInteractionRegistry.active, this.inPlaceInteractionRegistry.active).areTruthy());
        this.active = valueOf.any(this.inPlaceInteractionRegistry.active, this.modalInteractionRegistry.active).areTruthy();
        // TODO: chain.concat(listOrValueModels) would be nice.
        this.activeInteractionContextIds = chain(this.inPlaceInteractionRegistry.interactionContextIds)
            .concat(this.modalInteractionRegistry.interactionContextIds);
        this.activeModalContext = chain(this.modalInteractionRegistry.interactionContexts).first();
        this.inModalInteraction = chain(this.activeModalContext).isNotNil();
    }
    isActive() {
        return this.active.value;
    }
    /**
     * @deprecated use #createModalInteractionContextDisposedWith instead.
     * @param disposable
     */
    createModalInteractionContextFor(disposable) {
        return this.createModalInteractionContextDisposedWith(disposable);
    }
    /**
     * Creates a new model interaction context that will be disposed along with the component.
     * @param disposable
     */
    createModalInteractionContextDisposedWith(disposable) {
        // TODO: look at making the registry the factory..
        return this.modelInteractionContextFactory.createInteractionContext("modal", new InteractionService.ApiAdapter(this.placeRouter, this.modalInteractionRegistry));
    }
    registerInplaceInteractionContext(interactionContext) {
        // TODO: look at making the registry the factory..
        // Todo: check for double registration.
        // Todo: allow multiple inplace interactions..
        interactionContext.onInplaceInteractionContextRegistered(`ip${++inplaceMonitorCount}`, new InteractionService.ApiAdapter(this.placeRouter, this.inPlaceInteractionRegistry));
    }
    /**
     * Creates an interaction context that will prevent any other contexts from starting an
     * activity until it is disposed.  This is intended for use by the router for passing
     * to PlaceComponent.canDeactivate(interactionContext).  This ensures components don't
     * try and interact in a way that we can't track and synchronise with the browser back
     * button.
     */
    registerPlaceRouter(router) {
        assert$1.isFalsey(this.placeRouter);
        this.placeRouter = router;
        this._navigationInProgress.setDelegate(this.placeRouter.navigationInProgress$);
        const self = this;
        return new InteractionServiceRoutingAdapter(this.activeInteractionContextIds, this.activeModalContext, () => {
            return self.modelInteractionContextFactory.createInteractionContext("exclusive", new InteractionService.ApiAdapter(this.placeRouter, this.exclusiveInteractionRegistry));
        });
    }
}
InteractionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionService, deps: [{ token: ModalInteractionContextFactory }], target: i0.ɵɵFactoryTarget.Injectable });
InteractionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionService, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: ModalInteractionContextFactory }]; } });
(function (InteractionService) {
    /**
     * Provides a mechanism for the service to keep track of what the API adapters are doing to
     * ensure the rules are followed, i.e. modal or in-place interaction aren't started while
     * an exclusive routing interaction is active.
     */
    class ContextRegistry extends GarbageCollector {
        constructor() {
            super();
            this._interactions = new MutableListModel();
            this._disabledDelegate = this.registerDisposable(new DelegatingValueModel().withDefault(false));
            const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
            this.active = chain(this._interactions).isNotEmpty();
            this.interactionContextIds = chain(this._interactions).pluck("identifier");
        }
        get interactionContexts() {
            return this._interactions.readonly;
        }
        start(context) {
            this._interactions.push(context);
        }
        finish(context) {
            this._interactions.remove(context);
        }
        isActive() {
            return this.active.value;
        }
        disableWhen(disabled) {
            this._disabledDelegate.setDelegate(disabled);
        }
    }
    InteractionService.ContextRegistry = ContextRegistry;
    class ApiAdapter extends GarbageCollector {
        constructor(placeRouter, contextRegistry) {
            super();
            this.placeRouter = placeRouter;
            this.contextRegistry = contextRegistry;
        }
        // @Trace()
        notifyActive(context) {
            assert$1.isTruthy(context.identifier);
            this.contextRegistry.start(context);
            return this.isNavigationInProgress() ? Promise.resolve() : this.placeRouter.syncInteractionContextIdsWithRouter();
        }
        // @Trace()
        isNavigationInProgress() {
            return this.placeRouter.navigationInProgress$.value;
        }
        // @Trace()
        notifyFinished(context) {
            this.contextRegistry.finish(context);
            // :: Important ::
            // This method will be traversed by both the place router (during can canDeactivate guards) and user land code
            // (both when routing is idle and while it is active in PlaceComponent.canDeactivate()).
            // The result of pushInteractionIdsToRoute will not start until after the current route finishes, and the
            // current route won't finish until after this promise returns... Deadlock.
            // So in order to keep this logic out of the activities we perform the check here and ensure that
            // any interactions with the context while routing is active returns immediately.
            return this.isNavigationInProgress() ?
                Promise.resolve() :
                this.placeRouter.syncInteractionContextIdsWithRouter();
        }
    }
    InteractionService.ApiAdapter = ApiAdapter;
})(InteractionService || (InteractionService = {}));

/**
 * This class handles the logic around canDeactivate for a given router state transition.  It's core responsibilities are:
 * 1. Ensure we only ask the component to deactivate once on a given navigation cycle (since visit sanitisation can result in multiple round trips to through the router.)
 * 2. Ensure only the primary place component is asked when there are nested places.  The primary component is the one at the top
 *    of the routing change tree.
 * 3. Automatically handle standard interaction scenarios on the components behalf.
 */
class PlaceComponentDeactivationHandler {
    constructor(component, navigationSession, isPrimaryComponent) {
        this.component = component;
        this.navigationSession = navigationSession;
        this.isPrimaryComponent = isPrimaryComponent;
        assert.notNil(component);
    }
    get routerInteractionAdapter() {
        return this.navigationSession.interactionServiceAdapter;
    }
    get urlService() {
        return this.navigationSession.urlService;
    }
    get placeDefinition() {
        return this.component.placeDefinition;
    }
    // @Trace()
    async canDeactivate(currentUrl, nextState) {
        // We'll get called multiple times if there's any parameter sanitisation so
        // we always return true if we accepted promise from a previous cycle of the current
        // navigation session.
        if (!this.canDeactivatePromise) {
            // console.log(`creating deactivate promise for -> ${this.component.constructor.name}`);
            this.canDeactivatePromise = this.canDeactivateComponent(currentUrl, nextState);
        }
        return this.canDeactivatePromise;
    }
    // @Trace()
    async canDeactivateComponent(currentUrl, nextState) {
        // Automatically cancel any active activities if the navigation session was triggered by the back button.
        // If we handled more than just the pop state then it leads to the UI ignoring clicks and just cancelling things which is deeply disconcerting.
        if (this.navigationSession.isPopState) {
            if (this.isPrimaryComponent && this.routerInteractionAdapter.isModalActive()) {
                const routeIds = this.urlService.getActiveInteractionIdsFromUrl(nextState.url);
                const currentIds = this.routerInteractionAdapter.getActiveInteractionContextIds();
                if (!isEqual(currentIds, routeIds)) { // why am I checking this????
                    await this.routerInteractionAdapter.cancelCurrentModalInteraction();
                    return false;
                }
            }
            else {
                // check if the component has an in place interaction
                if (this.routerInteractionAdapter.isComponentInteracting(this.component)) {
                    await this.routerInteractionAdapter.cancelComponentInteraction(this.component);
                    return false;
                }
            }
        }
        // No interaction in progress, so ask the component .
        // This may start an interaction, hence checking the interaction context before now. I.e. if the place pops up the dialog, and
        // the user clicks back again, we'll re-enter here and go bang when the component tries to open another dialog.
        if (this.isGoingToADifferentPlace(nextState)) {
            const canLeave = await this.component._canLeavePlace(this.navigationSession.canDeactivateInteractionContext);
            // The component has an active interaction but no deactivation hook.  Rather than guessing what to do
            // we'll just cancel the navigation and print a warning.
            if (canLeave && this.routerInteractionAdapter.isComponentInteracting(this.component)) {
                console.warn('Route changed while component has active interaction, cancelling navigation');
                return false;
            }
            return canLeave;
        }
        else {
            // either an interaction or visit parameter change.
            return await this.component._canChangeRouteParameters(this.navigationSession.canDeactivateInteractionContext, nextState);
        }
    }
    isGoingToADifferentPlace(nextState) {
        // Because places with a route-id cover two route segments we get asked to deactivate
        // if the route id is added or removed.  So if our path is still present the url
        // then we shouldn't deactivate the place.
        return !nextState.includesPathOf(this.component.placeDefinition);
    }
}

/**
 * Transient states
 */
class NavigationSession extends GarbageCollector {
    constructor(context, startingUrl) {
        super();
        this.context = context;
        this.startingUrl = startingUrl;
        this.debugPropertyKeys = [];
        this._visits = new Map();
        this.componentDeactivationHandlers = new Map();
        // TODO: can I get away without creating one every time?
        this._interactionContext = this.context.routerInteractionAdapter.createExclusiveInteractionContext();
        this.onDispose(() => {
            // the interaction context can be detached during the back button cancellation state transition
            // as the transition is synchronous and activityCancellation isn't.  Otherwise dispose will be
            // called before the context has been cancelled.  It might be work having the interaction context
            // automatically cancel if the context is disposed so we don't have worry about detaching etc.
            if (this._interactionContext) {
                this._interactionContext.dispose(); // or do something like cancelAndDispose?
            }
        });
    }
    get isInteractionSync() {
        return false;
    }
    get name() {
        return this.constructor.name;
    }
    get urlService() {
        return this.context.urlService;
    }
    get interactionServiceAdapter() {
        return this.context.routerInteractionAdapter;
    }
    storeVisit(visit) {
        // console.log(`Storing visit for ${visit.placeDefinition.component.name}`, {visit});
        this._visits.set(visit.placeDefinition, visit);
    }
    getVisitFor(placeDef) {
        const visit = this._visits.get(placeDef);
        // console.log(`Getting visit for ${placeDef.component.name}`, {visit});
        return visit;
    }
    get canDeactivateInteractionContext() {
        return this._interactionContext;
    }
    notifyActive() {
        // noop.
    }
    onRouterStarted(event) {
        // navigation sessions can have many cancel start cycles due to place guard redirects
        this.ignore(event);
    }
    // @Trace()
    onUrlChange(url) {
        // Normally we just ignore these but they are the only way of detecting if the back button
        // was clicked during a canDeactivate promise.
        // 1. a route is in progress and awaiting a canDeactivateGuard
        // 2. the user the clicks the back button.
        // So to handle that scenario we need to check if we've got a can deactivate interaction in
        // progress and the do the appropriate clean up.
        if (this.canDeactivateInteractionContext && this.canDeactivateInteractionContext.isActive()) {
            this.cancelCanDeactivateInteraction(url);
        }
    }
    onPopState(event) {
        return this.illegalTransition(event);
    }
    onRouterCancelled(event) {
        return this.illegalTransition(event);
    }
    onRouterError(event) {
        return this.illegalTransition(event);
    }
    onRouterEnd(event) {
        return this.illegalTransition(event);
    }
    getVisits() {
        return Array.from(this._visits.values());
    }
    illegalTransition(message) {
        return lang.illegalState(`${message.toString()} not supported by ${this.toString()}`);
    }
    currentRouterUrl() {
        return this.urlService.getCurrentRouterUrl();
    }
    resetBrowserLocation(url, options = { replaceCurrent: false }) {
        // console.log(`---> resetting browser location to: ${url}`);
        this.urlService.resetBrowserLocation(url, options);
    }
    // @Trace()
    repairBrowserHistoryAndUrlAfterGuardCancellation(poppedHistoryToReplace, activeUrl) {
        // Important: I tried to perform this fix at a later point int he routing cycle but it created all kinds of
        // strangeness.
        Logger.get(this).info("WORK-AROUND: Updating browser location after pop state - see angular issue #13586");
        // console.log(`replacing ${this.urlService.getCurrentLocationUrlSnapshot().url} with ${poppedHistoryToReplace}`);
        this.urlService.resetBrowserLocation(poppedHistoryToReplace, { replaceCurrent: true });
        // console.log(`pushing ${activeUrl} back onto the history.`);
        this.urlService.resetBrowserLocation(activeUrl, { replaceCurrent: false });
    }
    ignore(event, reason) {
        reason = reason ? ` -> ${reason}` : "";
        // Logger.get(this).info(`Ignoring router event${reason}: ${event.constructor.name} -> ${event.url} :: ${this.toString()}`);
    }
    toString() {
        return `${this.constructor.name}(${this.debugState()})`;
    }
    debugState(properties) {
        return (properties || this.debugPropertyKeys).map(p => {
            return `${p}: ${this[p]}`;
        }).join(", ");
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        // console.log(`---> canDeactivatePlace(${component.placeDefinition.path}, ${currentUrl.url} -> ${nextUrl.url})`);
        // lookup the handler and create it if we've not seen it yet
        let handler = this.componentDeactivationHandlers.get(component);
        if (!handler) {
            const isPrimaryHandler = this.componentDeactivationHandlers.size === 0; // only primary handler cancels the app model interations
            handler = new PlaceComponentDeactivationHandler(component, this, isPrimaryHandler);
            this.componentDeactivationHandlers.set(component, handler);
        }
        return handler.canDeactivate(currentUrl, nextUrl).then(result => {
            // console.log(`<--- canDeactivatePlace(${component.placeDefinition.path}): ${result}`);
            return result;
        }).catch(error => {
            throw error;
        });
    }
    cancelCanDeactivateInteraction(newUrl) {
        Logger.get(this).info(`back button pressed during navigation session interaction promise`);
        // detach the interaction from the session so it doesn't get disposed until the activity has finished
        // all it's things.
        const canDeactivateInteractionContext = this.detachCanDeactivateInteractionContext();
        // TODO: I need to make the exclusive interaction context disallow nested activities or
        //       that would mess things up entirely. Or, can I do a context.abortAll().then(..)
        Logger.get(this).info("cancelling current navigation activity..");
        canDeactivateInteractionContext.cancelActiveActivity().then(() => {
            canDeactivateInteractionContext.dispose();
        });
        this.handleCanDeactivateCancelledEventScenario(newUrl);
    }
    reinstateUrlAfterAngularChangedItOnCancellation(url) {
        // Angular calls _this.resetUrlToCurrentUrlTree() on cancelling and fucks our history.
        // So this means that the top of the stack is the url we want to go back to, and not the one that was on
        // it before the cancel event fired.
        // So we need to:
        // - replace the just inserted url with the one that used to be there.
        // - push our actual url back onto the top of the stack.
        this.resetBrowserLocation(url, { replaceCurrent: true });
    }
    detachCanDeactivateInteractionContext() {
        const context = this._interactionContext;
        this._interactionContext = null;
        return context;
    }
}

class EventCleanUpSession extends NavigationSession {
    handleCanDeactivateCancelledEventScenario(newUrl) {
        lang$1.illegalState('onCanDeactivateInteractionCancelled not supported for event clean up states');
    }
}

/**
 * The sequence of router events are:
 * NavigationError -> url = url of navigation link
 * NavigationEnd
 * onPopState url = Our currentUrl sans and interaction query params
 * NavigationCancel url == same as above.
 */
class WaitUntilLeavingInteractionTransitionCancelled extends EventCleanUpSession {
    constructor(context, startingUrl, locationChangeTriggerUrl) {
        super(context, startingUrl);
        this.locationChangeTriggerUrl = locationChangeTriggerUrl;
        this.isPopState = false;
        this.firstCancelHandled = false;
        this.popStateHandled = false;
        this.debugPropertyKeys = ['idle', 'startingUrl', 'poppedHistoryUrl', 'locationChangeTriggerUrl', 'popStateEventUrl', 'firstCancelHandled', 'popStateHandled'];
    }
    // @Trace()
    onRouterStarted(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        this.repairBrowserHistoryAndUrlAfterGuardCancellation(this.locationChangeTriggerUrl, this.startingUrl);
        this.context.finishRoutingSession();
    }
    // @Trace()
    onRouterEnd(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterError(event) {
        this.ignore(event);
    }
    // @Trace()
    onPopState(event) {
        this.ignore(event);
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        return false;
    }
}

/**
 * This session tracks the process of removing the last interaction context from the URL and provides a promise
 * the resolves when the process and completed.  This case is special as the process involves a regular routing cycle
 * followed by a call to location.back().  The later triggers a url change with no other routing events.  So this
 * class tracks when the first routing cycle finishes and then waits for the subsequent lone url change event.
 */
class RemoveLastInteractionFromUrlNavigationSession extends NavigationSession {
    constructor(context, startingUrl) {
        super(context, startingUrl);
        this.isPopState = true;
        this.debugPropertyKeys = ['startingUrl', 'poppedHistoryUrl'];
        this.finished = Deferred.defer();
    }
    get isInteractionSync() {
        return true;
    }
    // @Trace()
    onPopState(event) {
        this.gotPopState = true;
    }
    // @Trace()
    onRouterStarted(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        this.ignore(event);
    }
    // @Trace()
    onUrlChange(url) {
    }
    finishUp() {
        this.context.finishRoutingSession();
        this.finished.resolve(true);
    }
    // @Trace()
    onRouterEnd(event) {
        if (this.gotPopState) {
            this.finishUp();
        }
    }
    // @Trace()
    handleCanDeactivateCancelledEventScenario(locationTriggerUrl) {
        lang.illegalState('onCanDeactivateInteractionCancelled not supported for activity context synchronisation since we should never leave a place');
    }
    get finishedPromise() {
        return this.finished.promise;
    }
}

class SynchroniseInteractionContextIdsWithRoute extends NavigationSession {
    constructor(context, startingUrl, wasTriggeredByPopState) {
        super(context, startingUrl);
        this.wasTriggeredByPopState = wasTriggeredByPopState;
        this.isPopState = false;
    }
    get isInteractionSync() {
        return true;
    }
    notifyActive() {
        // TODO: Do I still need this??
        setTimeout(() => {
            this.syncInteractionIdsWithRouter();
        });
    }
    // @Trace()
    onRouterEnd(event) {
        this.context.finishRoutingSession();
    }
    // @Trace()
    onRouterCancelled(event) {
        this.context.finishRoutingSession();
    }
    // @Trace()
    syncInteractionIdsWithRouter() {
        const currentIds = this.interactionServiceAdapter.getActiveInteractionContextIds();
        const previousIds = this.urlService.getCurrentLocationUrlSnapshot().getInteractionIds();
        // console.log(`---> synchroniseInteractionIds`, { is: currentIds.join(','), was: previousIds.join(',') });
        if (isEqual(currentIds, previousIds)) {
            // console.log('### Activity context ids were the same, skipping');
            this.context.finishRoutingSession();
        }
        else {
            if (currentIds.length > previousIds.length) {
                const isFirstActivity = currentIds.length > previousIds.length && previousIds.length < 1;
                this.addActivityContextToRoute(currentIds, isFirstActivity);
            }
            else {
                this.removeActivityContextFromRoute(currentIds);
            }
        }
    }
    // @Trace()
    addActivityContextToRoute(activeInteractionContextIds, isFirst) {
        const urlSnapshot = this.urlService.getCurrentRouterSnapshot().updateInteractionIds(activeInteractionContextIds);
        this.context.navigateByUrl(urlSnapshot, {
            replaceUrl: !isFirst
        }).then(result => {
            if (!this.urlService.getCurrentLocationUrlSnapshot().hasInteractionIds(activeInteractionContextIds)) {
                lang$1.illegalState(`Expected url to be ${urlSnapshot.url} but was ${this.urlService.getCurrentLocationUrl()}`);
                // this.urlService.resetBrowserLocation(urlSnapshot.url, {replaceCurrent: !isFirst})
            }
        });
    }
    // @Trace()
    removeActivityContextFromRoute(activeInteractionContextId) {
        const urlSnapshot = this.urlService.getCurrentRouterSnapshot().updateInteractionIds(activeInteractionContextId);
        const isRemovingLastActivity = activeInteractionContextId.length < 1;
        if (isRemovingLastActivity) {
            if (this.wasTriggeredByPopState) {
                // console.log('removal was triggered by pop state, nothing to do.');
                //   noop.  Our url will be back to the non interaction version now so we dont' need to do anything.
            }
            else {
                // now we just pop our interaction id's from the browser history.
                // console.log(`Removal of the last activity wasn't triggered by pop state so we have to trigger one to clean the history`);
                const session = new RemoveLastInteractionFromUrlNavigationSession(this.context, this.urlService.getCurrentRouterUrl());
                this.context.transitionTo(session);
                this.urlService.back();
            }
        }
        else {
            // we've removed an interaction, but we still have remaining activities so we
            // update the url in place if it wasn't a pop state. If it was a pop state we need
            // to  push it back up.
            // this.urlService.resetBrowserLocation(urlSnapshot.url, { replaceCurrent: !this.wasTriggeredByPopState });
            this.context.navigateByUrl(urlSnapshot, { replaceUrl: !this.wasTriggeredByPopState });
        }
    }
    handleCanDeactivateCancelledEventScenario(newUrl) {
        lang$1.methodNotSupported();
    }
}

/**
 * This state exists to handle all events while any kind of navigation is in progress.  That way all other states can
 * happily ignore interaction contexts.
 * NOTE: This state is activated when ever an interaction is started.  It might be better to split it into
 *       different states for different scenarios, e.g. starting model, starting model during route guard etc.
 */
class NavigatingDuringInteraction extends NavigationSession {
    constructor() {
        super(...arguments);
        this.isPopState = false;
    }
    // @Trace()
    onRouterCancelled(event) {
        this.context.finishRoutingSession();
    }
    // @Trace()
    onRouterError(event) {
        // navigation was aborted.
        this.context.finishRoutingSession();
    }
    // @Trace()
    onRouterEnd(event) {
        if (this.context.routerInteractionAdapter.isActive()) {
            this.context.transitionTo(new SynchroniseInteractionContextIdsWithRoute(this.context, this.startingUrl, false));
        }
        else {
            this.context.finishRoutingSession(this.getVisits());
        }
    }
    // @Trace()
    handleCanDeactivateCancelledEventScenario(locationTriggerUrl) {
        this.context.transitionTo(new WaitUntilLeavingInteractionTransitionCancelled(this.context, this.startingUrl, locationTriggerUrl));
    }
}

class AbstractPopStateNavigation extends NavigationSession {
    constructor(context, startingUrl, poppedHistoryUrl) {
        super(context, startingUrl);
        this.poppedHistoryUrl = poppedHistoryUrl;
        this.isPopState = true;
        this.debugPropertyKeys = ['startingUrl', 'poppedHistoryUrl'];
    }
    // @Trace()
    repairBrowserHistoryAndUrlAfterGuardCancellation() {
        super.repairBrowserHistoryAndUrlAfterGuardCancellation(this.poppedHistoryUrl, this.startingUrl);
    }
}

/**
 * This state exists to handle all events while any kind of navigation is in progress.  That way all other states can
 * happily ignore interaction contexts.
 */
class PopStateDuringInteractionNavigation extends AbstractPopStateNavigation {
    constructor(context, startingUrl, poppedHistoryUrl) {
        super(context, startingUrl, poppedHistoryUrl);
    }
    /**
     * Invoked when the place refuses to deactivate because of an unfinished interaction.
     * @param event
     */
    // @Trace()
    onRouterCancelled(event) {
        this.repairBrowserHistoryAndUrlAfterGuardCancellation();
        // NOTE: for now we need to wasTriggeredByPopState=false because we're resetting the url and history in the previous line.
        this.context.transitionTo(new SynchroniseInteractionContextIdsWithRoute(this.context, this.poppedHistoryUrl, false));
    }
    // @Trace()
    onRouterEnd(event) {
        // this.context.transitionTo(new SynchroniseInteractionContextIdsWithRoute(this.context, this.poppedHistoryUrl, false));
        this.context.finishRoutingSession();
    }
    handleCanDeactivateCancelledEventScenario(newUrl) {
        this.illegalTransition('Leaving interaction after pop-state should\'t block so should never see a back button click');
    }
}

/**
 * This state handles the scenario where a link navigation triggered an interaction and the user clicked back a to cancel it.
 * The routing event sequence is different depending on the link that was clicked.
 *
 * NOTE: In angular prior to 10 the sequence of routing events was different depending on the initial link that was clicked.
 *       This class used have ugle if/else code to handle it and a not that it should be split into sub states.
 *       During the update to angular 10 I did this (as the tests for this scenario were failings). After doing so
 *       it appears that angular now behaves the same in both cases. But rather that revert the changes I've left the
 *       sub-state handling in in case it ever comes back.
 */
class WaitUntilLinkTriggeredNavigationInteractionCancellationTypeDetermined extends EventCleanUpSession {
    constructor(context, startingUrl, clickedLinkUrl) {
        super(context, startingUrl);
        this.clickedLinkUrl = clickedLinkUrl;
        this.isPopState = false;
        this.clickedLinkMatchedBackButtonUrl = false;
        this.debugPropertyKeys = ['idle', 'startingUrl', 'clickedLinkUrl', 'firstCancelEventUrl', 'clickedLinkMatchedBackButtonUrl', 'popStateEventUrl'];
    }
    // @Trace()
    onRouterStarted(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        if (event.url === this.clickedLinkUrl) {
            this.context.transitionTo(new WaitForLinkSameAsBackToPlayOut(this.context, this.startingUrl, this.clickedLinkUrl));
        }
        else {
            this.context.transitionTo(new WaitForLinkDifferentFromBackToPlayOut(this.context, this.startingUrl, this.clickedLinkUrl));
        }
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        return false;
    }
}
class WaitForLinkSameAsBackToPlayOut extends EventCleanUpSession {
    constructor(context, startingUrl, clickedLinkUrl) {
        super(context, startingUrl);
        this.clickedLinkUrl = clickedLinkUrl;
        this.isPopState = false;
        this.debugPropertyKeys = ['idle', 'startingUrl', 'clickedLinkUrl', 'popStateEventUrl'];
    }
    // @Trace()
    onRouterEnd(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterError(event) {
        this.ignore(event);
    }
    // @Trace()
    onPopState(event) {
        this.popStateEventUrl = event.url;
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        if (this.popStateEventUrl) {
            this.finaliseRouting();
        }
    }
    // @Trace()
    finaliseRouting() {
        this.repairBrowserHistoryAndUrlAfterGuardCancellation(this.clickedLinkUrl, this.startingUrl);
        return this.context.finishRoutingSession();
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        return false;
    }
}
// See the note above.  This class is identical to the previous but I've left it here in case angular decides to
// route differently in this scenario going forward.
class WaitForLinkDifferentFromBackToPlayOut extends EventCleanUpSession {
    constructor(context, startingUrl, clickedLinkUrl) {
        super(context, startingUrl);
        this.clickedLinkUrl = clickedLinkUrl;
        this.isPopState = false;
        this.debugPropertyKeys = ['idle', 'startingUrl', 'clickedLinkUrl', 'popStateEventUrl'];
    }
    // @Trace()
    onRouterEnd(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterError(event) {
        this.ignore(event);
    }
    // @Trace()
    onPopState(event) {
        this.popStateEventUrl = event.url;
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        if (this.popStateEventUrl) {
            this.finaliseRouting();
        }
    }
    // @Trace()
    finaliseRouting() {
        this.repairBrowserHistoryAndUrlAfterGuardCancellation(this.clickedLinkUrl, this.startingUrl);
        return this.context.finishRoutingSession();
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        return false;
    }
}
//
// ### Router State Transition: null -> Navigating(startingUrl: /activities/dialogs;l=en, urlAfterRedirects: undefined)
//  ### ###### Router Event: NavigationStart
//  NavigationStart(id: 6, url: '/home')
//  NavigationStart {id: 6, url: "/home", navigationTrigger: "imperative", restoredState: null}
// logger.js:39 Ignoring router event: NavigationStart -> /home :: Navigating(startingUrl: /activities/dialogs;l=en, urlAfterRedirects: undefined)
//  ### ###### Router Event: RoutesRecognized
//  RoutesRecognized(id: 6, url: '/home', urlAfterRedirects: '/home', state: Route(url:'', path:'') { Route(url:'home', path:'home') } )
//  RoutesRecognized {id: 6, url: "/home", urlAfterRedirects: "/home", state: RouterStateSnapshot}
//  ###### Router Event: GuardsCheckStart
//  GuardsCheckStart(id: 6, url: '/home', urlAfterRedirects: '/home', state: Route(url:'', path:'') { Route(url:'home', path:'home') } )
//  GuardsCheckStart {id: 6, url: "/home", urlAfterRedirects: "/home", state: RouterStateSnapshot}
// logger.js:39 back button pressed during navigation session interaction promise
// logger.js:39 cancelling current navigation activity..
//   logger.js:39 ### Router State Transition: Navigating(startingUrl: /activities/dialogs;l=en, urlAfterRedirects: undefined) -> WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish(idle: undefined, startingUrl: /activities/dialogs;l=en, clickedLinkUrl: /home, firstCancelEventUrl: undefined, clickedLinkMatchedBackButtonUrl: false, popStateEventUrl: undefined)
//  ###### Router Event: GuardsCheckEnd
//  GuardsCheckEnd(id: 6, url: '/home', urlAfterRedirects: '/home', state: Route(url:'', path:'') { Route(url:'home', path:'home') } , shouldActivate: false)
//  GuardsCheckEnd {id: 6, url: "/home", urlAfterRedirects: "/home", state: RouterStateSnapshot, shouldActivate: false}
//  ###### Router Event: NavigationCancel
//  NavigationCancel(id: 6, url: '/home')
//  NavigationCancel {id: 6, url: "/home", reason: ""}
// logger.js:54 WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.onRouterCancelled
// logger.js:19 args NavigationCancel {id: 6, url: "/home", reason: ""}
// logger.js:39 Ignoring router event: NavigationCancel -> /home :: WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish(idle: undefined, startingUrl: /activities/dialogs;l=en, clickedLinkUrl: /home, firstCancelEventUrl: /home, clickedLinkMatchedBackButtonUrl: true, popStateEventUrl: undefined)
// logger.js:28 <-- WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.onRouterCancelled undefined
// logger.js:54 WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.onRouterEnd
// logger.js:19 args NavigationEnd {id: -1, url: "", urlAfterRedirects: ""}
// logger.js:54 WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.finaliseRouting
// logger.js:39 WORK-AROUND: Updating browser location after pop state - see angular issue #13586
// navigation-session.ts:129 replacing /activities/dialogs;l=en with /home
//   navigation-session.ts:131 pushing /activities/dialogs;l=en back onto the history.
//  ????? place-router.ts:281 ### Router Session Finished (was WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish(idle: undefined, startingUrl: /activities/dialogs;l=en, clickedLinkUrl: /home, firstCancelEventUrl: /home, clickedLinkMatchedBackButtonUrl: true, popStateEventUrl: undefined))
// logger.js:28 <-- WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.finaliseRouting undefined
// logger.js:28 <-- WaitUntilLinkTriggeredNavigationInteractionCancellationEventsFinish.onRouterEnd undefined
//  ###### Router Event: NavigationStart
//  NavigationStart(id: 7, url: '/home')
//  NavigationStart {id: 7, url: "/home", navigationTrigger: "popstate", restoredState: {…}}
// logger.js:39 ### Router State Transition: null -> PopStateNavigation(startingUrl: /activities/dialogs;l=en, poppedHistoryUrl: /home)
//  ###### Router Event: RoutesRecognized
//  RoutesRecognized(id: 7, url: '/home', urlAfterRedirects: '/home', state: Route(url:'', path:'') { Route(url:'home', path:'home') } )
//  RoutesRecognized {id: 7, url: "/home", urlAfterRedirects: "/home", state: RouterStateSnapshot}
//  ###### Router Event: GuardsCheckStart
//  GuardsCheckStart(id: 7, url: '/home', urlAfterRedirects: '/home', state: Route(url:'', path:'') { Route(url:'home', path:'home') } )

class Navigating extends NavigationSession {
    constructor() {
        super(...arguments);
        this.isPopState = false;
        this.debugPropertyKeys = ['startingUrl', 'urlAfterRedirects'];
    }
    onRouterCancelled(event) {
    }
    onRouterError(event) {
        // navigation was aborted.
        this.context.finishRoutingSession();
    }
    onRouterEnd(event) {
        this.urlAfterRedirects = event.urlAfterRedirects;
        this.context.finishRoutingSession(this.getVisits());
    }
    handleCanDeactivateCancelledEventScenario(newUrl) {
        this.context.transitionTo(new WaitUntilLinkTriggeredNavigationInteractionCancellationTypeDetermined(this.context, this.startingUrl, newUrl));
    }
}

var NavigationContext;
(function (NavigationContext) {
    class Impl {
        constructor(urlService, routerInteractionAdapter, navigateByUrl, transitionTo, finishRoutingSession) {
            this.urlService = urlService;
            this.routerInteractionAdapter = routerInteractionAdapter;
            this.navigateByUrl = navigateByUrl;
            this.transitionTo = transitionTo;
            this.finishRoutingSession = finishRoutingSession;
        }
    }
    NavigationContext.Impl = Impl;
})(NavigationContext || (NavigationContext = {}));

/**
 * This state handles the scenario where a pop state triggered and interaction and the user clickeb back a second time to cancel it.
 * The sequence of routing events/state transitions is as follows.
 * -> Idle -> PopStateTransition (poppedHistoryUrl == page to go to, startingUrl = page to stay on )
 * -> confirm dialog shown.
 * -> click back
 * -> PopStateTransition -> CancelledDuringBackButtonNavigationInteraction(trigger url is the page before the popped history url)
 * -> NavigationCancel (for the previous back)
 * -> PopState
 * -> NavigationCancel
 */
class WaitUntilPopStateDuringCanDeactivateInteractionFinishes extends EventCleanUpSession {
    constructor(context, startingUrl, locationChangeTriggerUrl, poppedHistoryUrl) {
        super(context, startingUrl);
        this.locationChangeTriggerUrl = locationChangeTriggerUrl;
        this.poppedHistoryUrl = poppedHistoryUrl;
        this.isPopState = false;
        this.firstCancelHandled = false;
        this.popStateHandled = false;
        this.debugPropertyKeys = ['idle', 'startingUrl', 'poppedHistoryUrl', 'locationChangeTriggerUrl', 'popStateEventUrl', 'firstCancelHandled', 'popStateHandled'];
    }
    // @Trace()
    onRouterStarted(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterCancelled(event) {
        if (!this.firstCancelHandled) {
            this.firstCancelHandled = true;
            this.parentPageUrl = event.url;
            this.ignore(event);
        }
        else {
            if (this.popStateHandled) {
                const grandParentPageUrl = event.url;
                this.repairBrowserHistoryAndUrlAfterGuardCancellation(grandParentPageUrl, this.parentPageUrl);
                // we've had one more back click than normal so we need to add our initial url back in as well.
                this.resetBrowserLocation(this.startingUrl, { replaceCurrent: false });
                return this.context.finishRoutingSession();
            }
        }
    }
    // @Trace()
    onRouterEnd(event) {
        this.ignore(event);
    }
    // @Trace()
    onRouterError(event) {
        void this.ignore(event);
    }
    // @Trace()
    onPopState(event) {
        this.popStateHandled = true;
        this.popStateEventUrl = event.url;
        this.ignore(event);
    }
    async canDeactivatePlace(component, currentUrl, nextUrl) {
        return false;
    }
}

class PopStateNavigation extends AbstractPopStateNavigation {
    onRouterCancelled(event) {
        this.repairBrowserHistoryAndUrlAfterGuardCancellation();
        this.context.finishRoutingSession();
    }
    onRouterEnd(event) {
        this.context.finishRoutingSession(this.getVisits());
    }
    handleCanDeactivateCancelledEventScenario(locationTriggerUrl) {
        this.context.transitionTo(new WaitUntilPopStateDuringCanDeactivateInteractionFinishes(this.context, this.startingUrl, locationTriggerUrl, this.poppedHistoryUrl));
    }
}

var PlaceAccessGuard;
(function (PlaceAccessGuard) {
    class NoAuth {
        // @Trace()
        isAuthenticated() {
            return true;
        }
        // @Trace()
        isAuthorised(placeDefinition) {
            return true;
        }
    }
    PlaceAccessGuard.NoAuth = NoAuth;
})(PlaceAccessGuard || (PlaceAccessGuard = {}));

class PlaceHistory {
    constructor() {
        this._archive = new Map();
        this.placeHistoryDepth = 4;
    }
    notifyNavigationStarted() {
        if (this._activeVisits) {
            this.archive(this._activeVisits.visits);
            this._previousVisits = this._activeVisits;
        }
    }
    notifyNavigationFinished(visits) {
        this._activeVisits = new PlaceHistory.VisitRecord(visits);
    }
    updateVisit(visit) {
        assert.isTruthy(this._activeVisits);
        this._activeVisits.update(visit);
    }
    lastVisitIncluded(placeDef) {
        return !!this._previousVisits?.getVisitFor(placeDef);
    }
    getMostRecentVisitFor(placeDef) {
        return first(this.getHistory(placeDef));
    }
    getHistory(placeDef) {
        let history = this._archive.get(placeDef);
        if (!history) {
            history = [];
            this.setHistory(placeDef, history);
        }
        return history;
    }
    setHistory(placeDef, history) {
        this._archive.set(placeDef, history);
    }
    archive(visits) {
        visits.forEach(state => {
            const history = this.getHistory(state.placeDefinition);
            const previousState = first(history);
            if (!previousState || state.hasChangedFrom(previousState)) {
                history.unshift(state); // LIFO
                this.setHistory(state.placeDefinition, history.slice(0, this.placeHistoryDepth));
            }
        });
    }
}
PlaceHistory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceHistory, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
PlaceHistory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceHistory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceHistory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });
(function (PlaceHistory) {
    class VisitRecord {
        constructor(visits) {
            this.visits = visits;
        }
        update(visit) {
            this.visits = this.visits.filter(v => v.placeDefinition !== visit.placeDefinition).concat(visit);
        }
        getVisitFor(placeDef) {
            return this.visits.find(v => v.placeDefinition === placeDef);
        }
    }
    PlaceHistory.VisitRecord = VisitRecord;
    // export class Query {
    //   private _history: Visit.State[];
    //   private _places: Place[];
    //   private _predicate: (visit: any) => boolean;
    //   private _limit: number;
    //
    //   constructor(history, limit = history.length) {
    //     this._history = history;
    //     this._places = [];
    //     this._predicate = (visit => true);
    //     this._limit = limit;
    //   }
    //
    //   to(...places:Place[]):this {
    //     this._places = places;
    //     return this;
    //   }
    //
    //   with(parameters: { [parameter: string]: any }): this {
    //     this.matching(state => {
    //       return Object.keys(parameters).reduce((acc, key) => {
    //         const matchValue = parameters[key];
    //         const visitValue = state.get(key);
    //         const matched = matchValue === '*' ? !isNil(visitValue) : visitValue == matchValue;
    //         // Logger.get(this).info(`matched=${matched}`, parameters, visitValue);
    //         return acc && matched;
    //       }, true);
    //     });
    //     return this;
    //   }
    //
    //   last(): Visit.State {
    //     return findLast(this._history, visit => this._matches(visit))
    //   }
    //
    //   // @trace
    //   allThatMatch(): Visit.State[] {
    //     return filter(this._history, visit => this._matches(visit)).slice(-this._limit);
    //   }
    //
    //   // @trace
    //   mostRecentValueOf<T=any>(param: string, defaultValue: T = null): T {
    //     const lastStateWithParam = findLast(this.allThatMatch(), state => !isNil(state.get(param)));
    //     return isNil(lastStateWithParam) ? defaultValue : lastStateWithParam.get(param);
    //   }
    //
    //   limit(limit: number): this {
    //     this._limit = limit;
    //     return this;
    //   }
    //
    //   matching(predicate: (visit: Visit.State) => boolean): this {
    //     this._predicate = predicate;
    //     return this;
    //   }
    //
    //   _matches(visit: Visit.State) {
    //     return this._isPlaceMatch(visit) && this._predicate(visit);
    //   }
    //
    //   _isPlaceMatch(visit: Visit.State) {
    //     return this._places.length < 1 || this._places.includes(visit.place)
    //   }
    //
    // }
})(PlaceHistory || (PlaceHistory = {}));

/**
 * This a work around for the fact that an activated route with multiple segments doesn't
 * include the segment params in the paramMap as well as each segment returns an empty
 * param map even when `parameter`s has content.
 */
class ConsolidatedParameterMap {
    constructor(urlSegments, paramMap) {
        this.paramMaps = [];
        // TODO: can we get all our params from teh url segments? If so we can drop the paramMap altogether.
        const segmentParams = (urlSegments || []).map(s => new ParamMapAdapter(s.parameters));
        this.paramMaps = segmentParams
            .concat(paramMap)
            .filter(m => !!m); // the activated route param map can be null
    }
    get(name) {
        const paramMap = this.paramMaps.find(m => m.has(name));
        return paramMap.get(name);
    }
    getAll(name) {
        const paramMap = this.paramMaps.find(m => m.has(name));
        return paramMap.getAll(name);
    }
    has(name) {
        return !!this.paramMaps.find(m => m.has(name));
    }
    get keys() {
        return uniq(this.paramMaps.reduce((result, params) => result.concat(params.keys), []));
    }
}
__decorate([
    Memoize(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], ConsolidatedParameterMap.prototype, "keys", null);
class ParamMapAdapter {
    constructor(params) {
        this.params = params;
    }
    get(name) {
        return this.params[name];
    }
    getAll(name) {
        const value = this.get(name);
        return Array.isArray(value) ? value : [value];
    }
    has(name) {
        return this.keys.includes(name);
    }
    get keys() {
        return Object.keys(this.params);
    }
}

class Visit {
    constructor(placeDefinition, visitParameters = {}) {
        this.placeDefinition = placeDefinition;
        this.visitParameters = visitParameters;
    }
    // @Trace()
    getRouteId() {
        return this.placeDefinition.getRouteIdFrom(this);
    }
    // @Trace()
    hasRouteId() {
        return !isNil(this.getRouteId());
    }
    /**
     * Returns the value of the place parameter with the specified name.  The parameter
     * name is taken from the `as` option, e.g. {as: 'aCustomName'} otherwise it is the
     * same as the the ValueModel property name.
     * @param parameter the visit parameter definition
     */
    getParameterValue(parameter) {
        return isString(parameter) ? this.visitParameters[parameter] : this.visitParameters[parameter.name];
    }
    // @Trace()
    hasParameter(parameterDef) {
        return Object.keys(this.visitParameters).includes(parameterDef.name);
    }
    replace(parameter, value) {
        return new Visit(this.placeDefinition, { ...this.visitParameters, [parameter.name]: value });
    }
    mergeRouteParameters(routeParams) {
        // todo: whitelist parameters.
        const routeParameterKeys = Object.keys(routeParams);
        const params = {};
        this.placeDefinition.getVisitParameterDefs().forEach(def => {
            if (def.isRouteId || def.isRouteParameter) {
                if (routeParameterKeys.includes(def.name)) {
                    params[def.name] = routeParams[def.name];
                }
            }
            else {
                // copy non route params as is, but only if they already exist otherwise we'll inject nil values and break the
                // defaults and remember sanitisation process.
                const value = this.getParameterValue(def);
                if (this.hasParameter(def)) {
                    params[def.name] = value;
                }
            }
        });
        return new Visit(this.placeDefinition, params);
    }
    // @Trace()
    hasRoutingChangedFrom(other) {
        const samePlace = other.placeDefinition === this.placeDefinition;
        const currentParams = this.placeDefinition.getFormattedRouteParameters(this, true);
        const otherParams = this.placeDefinition.getFormattedRouteParameters(other, true);
        // console.log({currentParams, otherParams});
        const sameRouteParameters = isEqual(currentParams, otherParams);
        return !samePlace || !sameRouteParameters;
    }
    hasChangedFrom(other) {
        const sameNonRouteParameters = isEqual(this.placeDefinition.getNonRouteParameters(this), this.placeDefinition.getNonRouteParameters(other));
        return !sameNonRouteParameters || this.hasRoutingChangedFrom(other);
    }
    toDebugString() {
        return Object.keys(this.visitParameters).map(k => `${k}=${this.visitParameters[k]}`).join(',');
    }
}

function extractPrimarySegments(urlTree) {
    return urlTree.root.children.primary?.segments ?? [];
}
class UrlSnapshot {
    // TODO: Update this accept a url Parser so it can be immutable and generate new trees on mutation using toString() are parseUrl.
    constructor(urlSerializer, url) {
        this.urlSerializer = urlSerializer;
        this.url = url;
        this.urlTree = urlSerializer.parse(url);
    }
    // @Trace()
    updateVisitSegments(visit) {
        const newUrlTree = this.urlSerializer.parse(this.url);
        // Ugly, but it works for now.
        const segments = [...extractPrimarySegments(newUrlTree)];
        const visitSegments = this.getSegmentsFor(visit);
        const replaceAt = segments.findIndex(segment => segment.path === visitSegments[0].path);
        // do not use the return value, it's the items that were removed!
        segments.splice(replaceAt, visitSegments.length, ...visitSegments);
        newUrlTree.root.children.primary.segments = segments;
        return new UrlSnapshot(this.urlSerializer, newUrlTree.toString());
    }
    appendVisit(visit) {
        // TODO: make this work properly with visit parameters
        return new UrlSnapshot(this.urlSerializer, this.url + "/" + visit.placeDefinition.path);
    }
    getPrimarySegments() {
        return extractPrimarySegments(this.urlTree);
    }
    /**
     * Converts the visit into segments.  Please not that these segments are not e
     * @param visit
     */
    getSegmentsFor(visit) {
        return visit.placeDefinition.hasRouteId() ?
            [
                // NOTE:
                // It's important to attach the params to the root path and not the id.  If we attach them
                // to an empty id then the angular router won't match the pattern.
                new UrlSegment(visit.placeDefinition.path, visit.placeDefinition.getFormattedRouteParameters(visit)),
                new UrlSegment(visit.placeDefinition.getFormattedRouteId(visit), {})
            ]
            :
                [
                    new UrlSegment(visit.placeDefinition.path, visit.placeDefinition.getFormattedRouteParameters(visit))
                ];
    }
    includesPathOf(placeDef) {
        return this.getPrimarySegments().find(s => s.path === placeDef.path);
    }
    isLastPlaceInUrl(placeDef) {
        return last(this.getPrimarySegments()).path === placeDef.path;
    }
    createVisitFor(placeDef) {
        return new Visit(placeDef, new ConsolidatedParameterMap(this.getPrimarySegments()));
    }
    getInteractionIds() {
        const queryParam = this.urlTree.queryParams[UrlSnapshot.INTERACTION_QUERY_PARAM];
        if (queryParam) {
            return UrlSnapshot.parseInteractionIds(queryParam);
        }
        else {
            return [];
        }
    }
    hasInteractions() {
        return this.getInteractionIds().length > 0;
    }
    hasInteractionIds(ids) {
        return isEqual(this.getInteractionIds(), ids);
    }
    // @Trace()
    updateInteractionIds(ids) {
        if (ids.length === 0) {
            return this.removeInteractionIds();
        }
        else {
            const urlTree = this.urlSerializer.parse(this.url);
            urlTree.queryParams[UrlSnapshot.INTERACTION_QUERY_PARAM] = UrlSnapshot.createPathIdFor(ids);
            return new UrlSnapshot(this.urlSerializer, urlTree.toString());
        }
    }
    // @Trace()
    removeInteractionIds() {
        const urlTree = this.urlSerializer.parse(this.url);
        if (urlTree.queryParams && urlTree.queryParams[UrlSnapshot.INTERACTION_QUERY_PARAM]) {
            urlTree.queryParams = {}; //[UrlSnapshot.INTERACTION_ROUTER_OUTLET]
        }
        return new UrlSnapshot(this.urlSerializer, urlTree.toString());
    }
    toString() {
        return `UrlSnapshot(${this.url})`;
    }
}
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Array)
], UrlSnapshot.prototype, "getPrimarySegments", null);
(function (UrlSnapshot) {
    UrlSnapshot.INTERACTION_QUERY_PARAM = 'aup-interactions';
    UrlSnapshot.INTERACTION_ID_SEPARATOR = '--';
    function parseInteractionIds(path) {
        return path.split(UrlSnapshot.INTERACTION_ID_SEPARATOR);
    }
    UrlSnapshot.parseInteractionIds = parseInteractionIds;
    function createPathIdFor(interactionIds) {
        return interactionIds.join(UrlSnapshot.INTERACTION_ID_SEPARATOR);
    }
    UrlSnapshot.createPathIdFor = createPathIdFor;
})(UrlSnapshot || (UrlSnapshot = {}));

class UrlService {
    constructor(angularRouter, angularLocation, urlSerializer) {
        this.angularRouter = angularRouter;
        this.angularLocation = angularLocation;
        this.urlSerializer = urlSerializer;
    }
    parseUrl(url) {
        return new UrlSnapshot(this.urlSerializer, url);
    }
    createUrlSnapshot(...visits) {
        const bits = [];
        visits.forEach(v => {
            bits.push(this.parseUrl(`${v.placeDefinition.path}`).updateVisitSegments(v).url);
        });
        return this.parseUrl(bits.join(''));
    }
    getCurrentRouterUrl() {
        return this.angularRouter.routerState ? this.angularRouter.routerState.snapshot.url : null;
    }
    getCurrentLocationUrl() {
        return this.angularLocation.path();
    }
    /**
     * Return the a UrlSnapshot using the browsers current location.  Note this may not be the same
     * as the routers current url.
     */
    getCurrentLocationUrlSnapshot() {
        return this.parseUrl(this.getCurrentLocationUrl());
    }
    /**
     * Return the a UrlSnapshot using the routers current state.  This may not be the same as
     * the browsers actual url.
     */
    getCurrentRouterSnapshot() {
        return this.parseUrl(this.getCurrentRouterUrl());
    }
    getActiveInteractionIdsFromUrl(url) {
        return this.parseUrl(url).getInteractionIds();
    }
    hasActiveInteractions(url) {
        return this.getActiveInteractionIdsFromUrl(url).length > 0;
    }
    resetBrowserLocation(url, options) {
        options.replaceCurrent ? this.angularLocation.replaceState(url) : this.angularLocation.go(url);
    }
    back() {
        this.angularLocation.back();
    }
}
UrlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UrlService, deps: [{ token: i1$4.Router }, { token: i1$1.Location }, { token: i1$4.UrlSerializer }], target: i0.ɵɵFactoryTarget.Injectable });
UrlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UrlService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: UrlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Router }, { type: i1$1.Location }, { type: i1$4.UrlSerializer }]; } });

function asArray(item) {
    return Array.isArray(item) ? item : [item];
}
class PlaceRouter extends GarbageCollector {
    constructor(angularRouter, angularLocation, interactionService, urlService, placeHistory) {
        super();
        this.angularRouter = angularRouter;
        this.angularLocation = angularLocation;
        this.interactionService = interactionService;
        this.urlService = urlService;
        this.placeHistory = placeHistory;
        this.navigationSession$ = new MutableValueModel();
        this._activeVisits$ = new MutableListModel();
        this.sessionFinishedJobs = [];
        /**
         * An observable model containing the authoriser function.  This allows places to react to changes
         * in permissions when any underlying auth logic changes, e.g. a role being removed from a user.
         */
        this._accessGuard = this.registerDisposable(new DelegatingValueModel().withDefault(new PlaceAccessGuard.NoAuth()));
        if (window["Cypress"]) {
            window["aup.PlaceRouter"] = this;
        }
        this.routerInteractionAdapter = interactionService.registerPlaceRouter(this);
        // TODO: Make this an interface and use 'this' instead.
        this.navigationContext = new NavigationContext.Impl(this.urlService, this.routerInteractionAdapter, (urlSnapshot, options) => {
            return this.navigateByUrl(urlSnapshot, options);
        }, state => {
            this.transitionTo(state);
        }, visits => {
            this.routingSessionFinished(visits);
        });
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.navigationInProgress$ = chain(this.navigationSession$).isNotNil();
        this.interactionSyncInProgress$ = chain(this.navigationSession$).pluck("isInteractionSync");
        const idleStateName = chain(this.interactionService.active).map(active => active ? "IdleDuringInteraction" : "Idle");
        this.navigationSessionName$ = chain(this.navigationSession$)
            .pluck("name")
            .otherwise(idleStateName);
        DebugContext.tag(this._activeVisits$, "PlaceRouter.activeVisits");
        this.state$ = chain(this._activeVisits$).reduce(visits => new PlaceRouter.State(visits));
        // TODO: make setup the callbacks in during module initiation to make this testable.
        angularRouter.events.subscribe(event => {
            // Routing event sequence
            // ======================
            // NavigationStart -> .... -> NavigationCancel --> redirect, go around again in the same session
            // NavigationStart -> .... -> NavigationEnd --> navigation complete, end session.
            // NavigationStart -> .... -> NavigationError --> navigation aborted, end session.
            // =======================
            if (event instanceof NavigationStart) {
                // console.log(`---> NavigationStart[${event.id}]: ${event.url} (${event.navigationTrigger})`);
                if (event.navigationTrigger === "popstate") {
                    this.onPopState(event);
                }
                else {
                    this.onRouterStarted(event);
                }
                // console.log(`<--- NavigationStart[${event.id}]: ${event.url} (${event.navigationTrigger})`);
            }
            if (event instanceof NavigationEnd) {
                // console.log(`---> NavigationEnd[${event.id}]: ${event.url}`);
                this.onRouterEnd(event);
                // console.log(`<--- NavigationEnd[${event.id}]: ${event.url}`);
            }
            if (event instanceof NavigationError) {
                // console.log(`---> NavigationError[${event.id}]: ${event.url}`);
                this.onRouterError(event);
                // console.log(`<--- NavigationError[${event.id}]: ${event.url}`);
            }
            if (event instanceof NavigationCancel) {
                // console.log(`---> NavigationCancel[${event.id}]: ${event.url}`);
                this.onRouterCancelled(event);
                // console.log(`<--- NavigationCancel[${event.id}]: ${event.url}`);
            }
        });
        // The router needs to know about url changes and in some cases they are the only way the router can know if
        // the back button was clicked.
        angularLocation.onUrlChange(url => this.onUrlChanged(url));
    }
    get accessGuard() {
        return this._accessGuard.readonly;
    }
    // @Trace()
    configureAuth(accessGrant, redirections) {
        // We need a shitty mutable model until setDelegate is clever enough to work with readonly models.
        const hackyMutableModel = new MutableValueModel();
        const binding = new Binding(hackyMutableModel, accessGrant, {
            toRight(leftValue) {
                return lang.illegalState("hackyMutableModel is read only");
            },
            toLeft: (rightValue) => rightValue
        });
        binding.writeLeft();
        this._accessGuard.setDelegate(hackyMutableModel);
        this.redirections = redirections;
    }
    getAuthenticationFailureRedirect(activatedRoute, state) {
        return this.redirections.onAuthenticationFailure(activatedRoute, state);
    }
    get navigationSession() {
        return this.navigationSession$.value;
    }
    get currentSession() {
        return this.navigationSession$.value;
    }
    isNavigating() {
        return this.navigationInProgress$.value;
    }
    waitUntilIdle() {
        const { when } = Dsl.disposeWith(this);
        return new Promise(resolve => {
            when(this.navigationInProgress$).becomesFalsey(() => resolve(this), {
                initialValue: "evaluate",
                once: true
            });
        });
    }
    async waitActivitiesSynchronised() {
        const { when } = Dsl.disposeWith(this);
        return new Promise(resolve => {
            when(this.interactionSyncInProgress$).becomesFalsey(() => resolve(this), {
                initialValue: "evaluate",
                once: true
            });
        });
    }
    // @Trace()
    onPopState(event) {
        assert.isTruthy(event.navigationTrigger === "popstate");
        if (this.currentSession) {
            this.currentSession.onPopState(event);
        }
        else {
            const poppedHistoryUrl = event.url;
            const currentRouterUrl = this.urlService.getCurrentRouterUrl();
            const session = this.interactionService.isActive() ?
                new PopStateDuringInteractionNavigation(this.navigationContext, currentRouterUrl, poppedHistoryUrl) :
                new PopStateNavigation(this.navigationContext, currentRouterUrl, poppedHistoryUrl);
            this.transitionTo(session);
        }
    }
    // @Trace()
    onRouterStarted(event) {
        assert.isFalsey(event.navigationTrigger === "popstate");
        const inInteraction = this.interactionService.isActive();
        if (this.currentSession) {
            this.currentSession.onRouterStarted(event);
        }
        else {
            this.transitionTo(this.createNavigationSession(this.urlService.getCurrentRouterUrl()));
        }
    }
    // @Trace()
    onUrlChanged(newUrl) {
        // the back button can trigger a url change without a navigation session in progress so we
        // console.log(`---> Url Changed ${newUrl}`);
        if (this.currentSession) {
            this.currentSession.onUrlChange(newUrl);
        }
        else {
            console.log("FYI: url changed without a navigation session in progress");
        }
        // console.log(`<--- Url Changed`);
    }
    // @Trace()
    onRouterCancelled(event) {
        this.currentSession.onRouterCancelled(event);
    }
    // @Trace()
    onRouterError(event) {
        this.currentSession.onRouterError(event);
    }
    // @Trace()
    onRouterEnd(event) {
        this.currentSession.onRouterEnd(event);
    }
    navigate(visit, options) {
        const commands = asArray(visit).reduce((result, v) => {
            const path = v.placeDefinition.path;
            return isEmpty$1(path) ?
                [...result, path] : // Angular doesn't support route params on empty path segments
                [...result, path, ...this.createRouteParameters(v)];
        }, []);
        return this.doNavigation(visit, async (router) => {
            await this.angularRouter.navigate(commands, {
                relativeTo: options ? options.relativeTo : null
            });
        });
    }
    // @Trace()
    async doNavigation(visit, runNavigationCommands) {
        if (this.navigationInProgress$.value) {
            Logger.get().error("Navigation already in progress", {
                visit: visit,
                session: this.navigationSession
            });
            lang.illegalState("Navigation already in progress");
        }
        const navigation = this.createNavigationSession(this.urlService.getCurrentRouterUrl());
        asArray(visit).forEach(v => navigation.storeVisit(v));
        this.transitionTo(navigation);
        try {
            await runNavigationCommands(this.angularRouter);
        }
        finally {
            // Check if the router has finished (in the case where no router change required) and we're still in  a
            // transient state and finish of the transition.
            if (!this.angularRouter.getCurrentNavigation() && this.currentSession) {
                this.currentSession.onRouterEnd(new NavigationEnd(-1, "", ""));
            }
        }
    }
    navigateByUrl(urlSnapshot, navigationExtras) {
        // console.log(`### navigationByUrl -> ${urlSnapshot.urlTree.toString()}`);
        return this.angularRouter.navigateByUrl(urlSnapshot.urlTree, navigationExtras);
    }
    get activeVisits$() {
        return this._activeVisits$.readonly;
    }
    // @Trace()
    async pushVisitChangesToRoute(previous, next) {
        this.placeHistory.updateVisit(next);
        // FIXME: no route id -> route id duplicates route parameters
        if (next.hasRoutingChangedFrom(previous)) {
            return this.doNavigation(next, router => {
                const urlSnapshot = this.urlService.parseUrl(this.angularRouter.routerState.snapshot.url).updateVisitSegments(next);
                // console.log('### Push Changes to route Redirect', { commands: urlSnapshot.url });
                return this.navigateByUrl(urlSnapshot);
            });
        }
    }
    createNavigationSession(currentRouterUrl) {
        const inInteraction = this.interactionService.isActive();
        return inInteraction ?
            new NavigatingDuringInteraction(this.navigationContext, currentRouterUrl) :
            new Navigating(this.navigationContext, currentRouterUrl);
    }
    // @Trace()
    transitionTo(next) {
        const previous = this.navigationSession$.value;
        if (!previous) {
            this.placeHistory.notifyNavigationStarted();
        }
        assert.isTruthy(next !== previous);
        // Logger.get(this).info(`### Router State Transition: ${previous ? previous.toString() : 'null'} -> ${next.toString()}`);
        this.navigationSession$.value = next;
        if (!!previous) {
            previous.dispose();
        }
        next.notifyActive();
    }
    // @Trace()
    routingSessionFinished(visits) {
        if (visits && visits.length > 0) {
            assert.isTruthy(this.navigationInProgress$.value);
            this.placeHistory.notifyNavigationFinished(visits);
            // We update the active visits before we finish the session so the
            // place outlets can ignore the incoming changes until things are
            // settled. TODO: can we removed the event'ness here and just do a push?
            this._activeVisits$.value = visits;
        }
        const session = this.currentSession;
        session.dispose();
        this.navigationSession$.value = null;
        // console.log(`### Router Session Finished (was ${session.toString()})`);
        this.sessionFinishedJobs.forEach(job => job());
        this.sessionFinishedJobs = [];
    }
    runAfterRoutingSessionFinishes(func) {
        assert.isTruthy(this.navigationInProgress$);
        this.sessionFinishedJobs.push(func);
    }
    /**
     * Sync's the current interaction state with the URL.  We need to push something in the URL in order
     * to be able to capture the back button on the first page.  If we don't then the back click will exit
     * the app directly and we don't get to ask.
     */
    // @Trace()
    syncInteractionContextIdsWithRouter(onSyncComplete = () => { }) {
        if (this.navigationSession) {
            // console.log(`Navigation active -> ${this.navigationSession.toString()}, sync delayed until finished.`);
            const session = this.navigationSession;
            return new Promise((resolve, reject) => {
                this.runAfterRoutingSessionFinishes(() => {
                    this.runAfterRoutingSessionFinishes(() => {
                        onSyncComplete();
                        resolve();
                    });
                    const syncSession = new SynchroniseInteractionContextIdsWithRoute(this.navigationContext, this.urlService.getCurrentRouterUrl(), false);
                    this.transitionTo(syncSession);
                });
            });
        }
        else {
            return new Promise(((resolve, reject) => {
                // console.log(`No navigation in progress, starting synchronisation job`);
                this.runAfterRoutingSessionFinishes(() => {
                    onSyncComplete();
                    resolve();
                });
                const session = new SynchroniseInteractionContextIdsWithRoute(this.navigationContext, this.urlService.getCurrentRouterUrl(), false);
                this.transitionTo(session);
            }));
        }
    }
    createRouteParameters(visit) {
        const def = visit.placeDefinition;
        return visit.hasRouteId() ?
            [def.getFormattedRouteId(visit), def.getFormattedRouteParameters(visit)] :
            [def.getFormattedRouteParameters(visit)];
    }
}
PlaceRouter.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceRouter, deps: [{ token: i1$4.Router }, { token: i1$1.Location }, { token: InteractionService }, { token: UrlService }, { token: PlaceHistory }], target: i0.ɵɵFactoryTarget.Injectable });
PlaceRouter.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceRouter, providedIn: "root" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceRouter, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: "root"
                }]
        }], ctorParameters: function () { return [{ type: i1$4.Router }, { type: i1$1.Location }, { type: InteractionService }, { type: UrlService }, { type: PlaceHistory }]; } });
(function (PlaceRouter) {
    class State {
        constructor(activeVisits) {
            this.activeVisits = activeVisits;
        }
        isPlaceActive(placeDefinition) {
            return !!this.getVisitFor(placeDefinition);
        }
        getVisitFor(placeDefinition) {
            return this.activeVisits.find(v => v.placeDefinition === placeDefinition);
        }
    }
    PlaceRouter.State = State;
})(PlaceRouter || (PlaceRouter = {}));

class ActivityTitleComponent extends DisposableComponent {
    /**
     * Adjusts layout to ensure the title and body are cleanly separated with even
     * gaps for teh case where the title component has a painted background.
     */
    set hasTransparentBackground(value) {
        this._hasUserTransparentBackground = value;
    }
    get hasTransparentBackground() {
        return isNil(this._hasUserTransparentBackground) ? !this._color : this._hasUserTransparentBackground;
    }
    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }
    ngOnInit() {
    }
}
ActivityTitleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityTitleComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
ActivityTitleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ActivityTitleComponent, selector: "aup-activity-title", inputs: { hasTransparentBackground: "hasTransparentBackground", color: "color" }, host: { properties: { "class.transparent-background": "this.hasTransparentBackground", "attr.color": "this.color" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityTitleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-activity-title', template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"] }]
        }], propDecorators: { hasTransparentBackground: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.transparent-background']
            }], color: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.color']
            }] } });

class ActivityBodyComponent extends DisposableComponent {
    constructor() {
        super(...arguments);
        this.fullWidth = false;
    }
    ngOnInit() {
    }
}
ActivityBodyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityBodyComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
ActivityBodyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ActivityBodyComponent, selector: "aup-activity-body", inputs: { fullWidth: "fullWidth" }, host: { properties: { "class.full-width": "this.fullWidth" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["<ng-content></ng-content>\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityBodyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-activity-body', template: "<ng-content></ng-content>\n", styles: ["<ng-content></ng-content>\n"] }]
        }], propDecorators: { fullWidth: [{
                type: Input
            }, {
                type: HostBinding,
                args: ["class.full-width"]
            }] } });

class AlertDialogComponent extends AbstractDialogComponent {
    constructor(alert) {
        super(alert);
        this.confirmCommand = Command.create(() => {
            this.done();
        });
    }
}
AlertDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AlertDialogComponent, deps: [{ token: ACTIVITY_DATA }], target: i0.ɵɵFactoryTarget.Component });
AlertDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AlertDialogComponent, selector: "aup-alert-dialog", usesInheritance: true, ngImport: i0, template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MarkdownComponent, selector: "aup-markdown, [aupMarkdown]", inputs: ["content$", "content", "inline"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }, { kind: "component", type: ActivityTitleComponent, selector: "aup-activity-title", inputs: ["hasTransparentBackground", "color"] }, { kind: "component", type: ActivityBodyComponent, selector: "aup-activity-body", inputs: ["fullWidth"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AlertDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-alert-dialog', template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"] }]
        }], ctorParameters: function () { return [{ type: Alert, decorators: [{
                    type: Inject,
                    args: [ACTIVITY_DATA]
                }] }]; } });

class ConfirmThenDialogComponent extends AbstractConfirmDialogComponent {
    constructor(config) {
        super(config.confirm);
        this.confirmCommand = Command.create(() => {
            this.interactionContext.startActivity(config.activityType, config.data)
                .then((result) => this.done(result))
                .catch(error => this.cancel(error));
        });
    }
}
ConfirmThenDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmThenDialogComponent, deps: [{ token: ACTIVITY_DATA }], target: i0.ɵɵFactoryTarget.Component });
ConfirmThenDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ConfirmThenDialogComponent, selector: "aup-confirmation-dialog", usesInheritance: true, ngImport: i0, template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MarkdownComponent, selector: "aup-markdown, [aupMarkdown]", inputs: ["content$", "content", "inline"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }, { kind: "component", type: ActivityTitleComponent, selector: "aup-activity-title", inputs: ["hasTransparentBackground", "color"] }, { kind: "component", type: ActivityBodyComponent, selector: "aup-activity-body", inputs: ["fullWidth"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmThenDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-confirmation-dialog', template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ACTIVITY_DATA]
                }] }]; } });

class ConfirmThenExecuteDialogComponent extends AbstractConfirmDialogComponent {
    constructor(data) {
        super(data.confirm);
        this.confirmCommand = Command.create(async () => {
            try {
                const result = await data.operation(this.interactionContext);
                this.done(result);
            }
            catch (e) {
                this.cancel(e);
            }
        });
    }
}
ConfirmThenExecuteDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmThenExecuteDialogComponent, deps: [{ token: ACTIVITY_DATA }], target: i0.ɵɵFactoryTarget.Component });
ConfirmThenExecuteDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ConfirmThenExecuteDialogComponent, selector: "aup-confirmation-execute-dialog", usesInheritance: true, ngImport: i0, template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MarkdownComponent, selector: "aup-markdown, [aupMarkdown]", inputs: ["content$", "content", "inline"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }, { kind: "component", type: ActivityTitleComponent, selector: "aup-activity-title", inputs: ["hasTransparentBackground", "color"] }, { kind: "component", type: ActivityBodyComponent, selector: "aup-activity-body", inputs: ["fullWidth"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmThenExecuteDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-confirmation-execute-dialog', template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ACTIVITY_DATA]
                }] }]; } });

class ConfirmationDialogComponent extends AbstractConfirmDialogComponent {
    constructor(confirm) {
        super(confirm);
        this.confirm = confirm;
        this.confirmCommand = Command.create(() => {
            return this.done();
        });
    }
}
ConfirmationDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmationDialogComponent, deps: [{ token: ACTIVITY_DATA }], target: i0.ɵɵFactoryTarget.Component });
ConfirmationDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ConfirmationDialogComponent, selector: "aup-confirmation-dialog", usesInheritance: true, ngImport: i0, template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: MarkdownComponent, selector: "aup-markdown, [aupMarkdown]", inputs: ["content$", "content", "inline"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }, { kind: "component", type: ActivityTitleComponent, selector: "aup-activity-title", inputs: ["hasTransparentBackground", "color"] }, { kind: "component", type: ActivityBodyComponent, selector: "aup-activity-body", inputs: ["fullWidth"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ConfirmationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-confirmation-dialog', template: "<aup-activity-title *ngIf=\"title\" [color]=\"color\"><aup-markdown [content]=\"title\" [inline]=\"true\"></aup-markdown></aup-activity-title>\n<aup-activity-body>\n  <aup-markdown *ngFor=\"let line of content\" [content]=\"line\"></aup-markdown>\n</aup-activity-body>\n<aup-activity-actions [confirmFace]=\"confirmFace\" [cancelFace]=\"cancelFace\"></aup-activity-actions>\n\n", styles: [":host{display:block}.mat-dialog-content{margin:0;padding:0}.mat-dialog-actions{margin-bottom:0!important;padding:0;align-items:flex-end;justify-content:flex-end}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ACTIVITY_DATA]
                }] }]; } });

class AbstractInteractionContext {
    startActivity(activityType, data, options) {
        return this.createAndLaunchActivity(activityType, data, Opts.get(options).getOptional('disableClose', false));
    }
    confirm(confirm) {
        // Important: we have to implement confirmOrReject as the main entry point
        // as the canDeactivation guards need to be able to cancel an interaction
        // without caring about returning a value.
        return this.confirmOrReject(confirm).then(() => true).catch(() => false);
    }
    alert(alert) {
        // TODO: Test disableClose === false
        return this.createAndLaunchActivity(AlertDialogComponent, alert, false);
    }
    confirmOrReject(confirm) {
        return this.createAndLaunchActivity(ConfirmationDialogComponent, confirm, true);
    }
    /**
     * Presents the confirmation to the user and runs the activity only if the user confirms.
     * @param confirm:Confirm the confirmation to display.
     * @param activityType the activity to run if confirmed.
     * @param data the activity data.
     */
    confirmThen(confirm, activityType, data) {
        return this.createAndLaunchActivity(ConfirmThenDialogComponent, {
            confirm,
            activityType: activityType,
            data: data
        }, true);
    }
    confirmThenExecute(confirm, operation) {
        return this.createAndLaunchActivity(ConfirmThenExecuteDialogComponent, {
            confirm,
            operation: operation
        }, true);
    }
}

class ActivityRef {
    constructor(activityClass, activityData, onComplete) {
        this.activityClass = activityClass;
        this.activityData = activityData;
        this.onComplete = onComplete;
        this._complete = false;
        this.deferredResult = Deferred.defer();
        this.focusedModel = new MutableValueModel();
        this._activityBusy = new DelegatingValueModel().withDefault(false);
    }
    isActivityRealised() {
        return !!this._activity;
    }
    isComplete() {
        return this._complete;
    }
    get activity() {
        assert.isTruthy(this.isActivityRealised());
        return this._activity;
    }
    setFocused(focused) {
        this.focusedModel.value = focused;
    }
    get focused() {
        return this.focusedModel.value;
    }
    notifyActivityCreated(activity, nestedInteractionContext) {
        assert.isNil(this._activity);
        this._activity = activity;
        const self = this;
        this._activity.initialise(nestedInteractionContext, {
            onDone(result) {
                self.finishActivity(deferred => deferred.resolve(result));
            },
            onCancel(error) {
                self.finishActivity(deferred => deferred.reject(error));
            },
            focused: this.focusedModel.readonly
        });
        this._activityBusy.setDelegate(this._activity.busy$);
    }
    // @Trace()
    finishActivity(resolveOrReject) {
        assert.isFalsey(this.isComplete());
        resolveOrReject(this.deferredResult);
        this._complete = true;
        this.onComplete(this);
        this._activityBusy.dispose();
    }
    cancel() {
        this.activity.cancel();
    }
    get activityResult() {
        return this.deferredResult.promise;
    }
    get activityBusy() {
        return this._activityBusy.readonly;
    }
}

/**
 * ActivityOutletComponent creates and displays an activity and delegates the interaction context functionality to an
 * external service.
 */
class ActivityOutletComponent {
    constructor(componentFactoryResolver, viewContainerRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
    }
    set activityRef(activityRef) {
        if (this.activityRef && !this.activityRef.isComplete()) {
            lang$1.illegalState('changing activity before previous one has completed');
        }
        this._activityRef = activityRef;
        this.loadActivity(activityRef);
    }
    ;
    get activityRef() {
        return this._activityRef;
    }
    ngOnInit() {
    }
    loadActivity(activityRef) {
        const injector = Injector.create({
            providers: [
                {
                    provide: ACTIVITY_DATA,
                    useValue: activityRef.activityData
                }
            ],
            parent: this.injector
        });
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(activityRef.activityClass);
        this.viewContainerRef.clear();
        // console.log(`creating component -> ${activityRef.activityClass.name}`);
        this.activityComponentRef = this.viewContainerRef.createComponent(componentFactory, 0, injector);
        this.activityRef.notifyActivityCreated(this.activityComponentRef.instance, this.nestedInteractionContext);
    }
    get component() {
        return this.activityComponentRef.instance;
    }
}
ActivityOutletComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityOutletComponent, deps: [{ token: i0.ComponentFactoryResolver }, { token: i0.ViewContainerRef }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Component });
ActivityOutletComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ActivityOutletComponent, selector: "aup-activity-outlet", inputs: { nestedInteractionContext: "nestedInteractionContext", activityRef: "activityRef" }, ngImport: i0, template: '', isInline: true, styles: [":host{display:block}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityOutletComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-activity-outlet', template: '', styles: [":host{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ComponentFactoryResolver }, { type: i0.ViewContainerRef }, { type: i0.Injector }]; }, propDecorators: { nestedInteractionContext: [{
                type: Input
            }], activityRef: [{
                type: Input
            }] } });

class ActivityContainerComponent extends AbstractInteractionContext {
    constructor(placeRouter) {
        super();
        this.placeRouter = placeRouter;
        this.dynamicHeight = false;
        this.activityRefs = [];
        this.garbage = new GarbageCollector();
        this.inAnimation = new MutableValueModel(false);
        this.busy = this.registerDisposable(new DelegatingValueModel().withDefault(false));
        this.registerDisposable(this.busy);
    }
    initialise(identifier, api) {
        assert.isFalsey(this.isInitialised());
        assert.notNil(identifier);
        assert.notNil(api);
        this._identifier = identifier;
        this.interactionServiceApi = api;
    }
    get identifier() {
        return this._identifier;
    }
    isInitialised() {
        return !!this.identifier;
    }
    /**
     * Returns true if an activity is currently running.
     */
    isActive() {
        return this.getActiveActivityCount() > 0;
    }
    registerDisposable(disposable) {
        return this.garbage.registerDisposable(disposable);
    }
    // @Trace()
    dispose() {
        // TODO: think about auto cancelling any outstanding activity on dispose.
        //       See NavigationState.Navigating for a use-case.
        assert.isFalsey(this.isActive());
        this.garbage.dispose();
    }
    getActiveActivityRef() {
        if (!this.isActive()) {
            lang$1.illegalState("no activity in progress");
        }
        return findLast(this.activityRefs, tab => !tab.isComplete());
    }
    /**
     * Cancels the current activity and returns true the context is no longer active, false if
     * there is still another activity running.
     */
    // @Trace()
    async cancelActiveActivity() {
        const activity = this.getActiveActivityRef();
        activity.cancel();
        if (this.isCleaningUp()) {
            return this.waitForInteractionContextCleanupToFinish();
        }
        else {
            return !this.isActive();
        }
    }
    // TODO: this handling of multiple nested activities is only used by the activity component and is not a general case.
    // @Trace()
    async createAndLaunchActivity(activityType, data, disableClose) {
        assert.isTruthy(this.isInitialised()); // make sure we've been initialised
        const activityRef = new ActivityRef(activityType, data, () => {
            const isActive = this.getActiveActivityCount() > 0;
            if (isActive) {
                this.triggerTabSynchronisation();
            }
            else {
                this.finishAndStartCleanup();
            }
        });
        this.launchActivity(activityRef);
        // if this is the first activity let the interaction service know.
        if (this.activityRefs.length === 1) {
            this.interactionServiceApi.notifyActive(this);
        }
        try {
            return await activityRef.activityResult;
        }
        finally {
            // console.log("closing activity", activityType.name, this.activityRefs)
            if (!this.isActive()) {
                // wait until the activity route syncing has finished
                await this.placeRouter.waitActivitiesSynchronised();
                // console.log("activity syncing finished")
            }
        }
    }
    getActiveActivityCount() {
        return this.activityRefs.filter(ref => !ref.isComplete()).length;
    }
    /**
     * Checks if this interaction context has finished an is in the process of waiting
     * for all the infrastructure (including route updates) to be completed.
     */
    isCleaningUp() {
        return !!this._deferredCleanUp;
    }
    async waitForInteractionContextCleanupToFinish() {
        return this._deferredCleanUp ?
            this._deferredCleanUp :
            true;
    }
    finishAndStartCleanup() {
        if (!this._deferredCleanUp) {
            // Important:
            // Clear our tabs so the next activity triggers a tab change.
            // Without this our animation done wasn't called when a single
            // new activity followed a single tab activity (since we're tracking
            // by activity index)
            setTimeout(() => {
                this.activityRefs = []; // we have to do it after the animation timeout or the activity disappears before the animatin finsihes
            }, this.getTabAnimationDuration());
            const promise = this.interactionServiceApi.notifyFinished(this);
            this._deferredCleanUp = promise
                .finally(() => {
                this._deferredCleanUp = null;
            });
        }
    }
    // @Trace()
    launchActivity(activityRef) {
        const cleanedTabs = this.activityRefs.filter(tab => !tab.isComplete());
        this.activityRefs = cleanedTabs.concat(activityRef);
        this.synchroniseSelectedTabIndex();
    }
    activityIndex(index, activityRef) {
        return index;
    }
    ;
    /**
     * Synchronises the selected tab index.
     */
    // @Trace()
    synchroniseSelectedTabIndex() {
        assert.isTruthy(this.isActive());
        const previousIndex = this.tabs.selectedIndex;
        const newIndex = this.getActiveActivityCount() - 1;
        if (previousIndex !== newIndex) {
            this.inAnimation.value = true;
            this.activityRefs[newIndex].setFocused(false);
            this.busy.setDelegate(this.activityRefs[newIndex].activityBusy);
            this.tabs.selectedIndex = newIndex;
            // Note: We're not using the animation done event as it's firing almost immeadiately.
            setTimeout(() => {
                this.activityRefs = this.activityRefs.filter(tab => !tab.isComplete());
                this.inAnimation.value = false;
                this.activityRefs.forEach((ref, index) => {
                    ref.setFocused(index === newIndex);
                });
            }, this.getTabAnimationDuration());
        }
    }
    getSelectedOutlet() {
        return this.activityOutlets.toArray()[this.tabs.selectedIndex];
    }
    getTabAnimationDuration() {
        const match = this.tabs.animationDuration.match(/(\d+)(.*)/);
        const numericValue = parseFloat(match[1]);
        switch (match[2].trim()) {
            case "ms":
                return numericValue;
            case "s":
                return 1000 * numericValue;
        }
        return lang$1.illegalState(`unsupported duration string: ${this.tabs.animationDuration}`);
    }
    // @Trace()
    getSelectedTabIndex() {
        return this.tabs.selectedIndex;
    }
    // @Trace()
    triggerTabSynchronisation() {
        if (this.syncSelectedTabTimeout) {
            clearTimeout(this.syncSelectedTabTimeout);
        }
        this.syncSelectedTabTimeout = setTimeout(() => {
            this.syncSelectedTabTimeout = null;
            if (this.isActive()) {
                this.synchroniseSelectedTabIndex();
            }
        }, 75);
    }
}
ActivityContainerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityContainerComponent, deps: [{ token: PlaceRouter }], target: i0.ɵɵFactoryTarget.Component });
ActivityContainerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ActivityContainerComponent, selector: "aup-activity-container", inputs: { dynamicHeight: "dynamicHeight" }, viewQueries: [{ propertyName: "tabs", first: true, predicate: ["tabs"], descendants: true, static: true }, { propertyName: "activityOutlets", predicate: ActivityOutletComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-tab-group #tabs no-tab-header\n               [dynamicHeight]=\"dynamicHeight\"\n               [class.full-height-tabs]=\"!dynamicHeight\">\n  <mat-tab *ngFor=\"let activityRef of activityRefs; let i = index; trackBy: activityIndex\">\n    <aup-busy-overlay [busyModel]=\"busy\" cdkTrapFocus cdkTrapFocusAutoCapture>\n      <!--\n      We have issues where angular is triggering a leave animation when an\n      new activity is started, but is not running the enter animation\n      when it is scrolled back into view.  So we track the tab changes and\n      disable all animations inside the tab while we're animating.\n      -->\n      <div class=\"activity-outlet-wrapper\" [@.disabled]=\"!activityRef.focused\">\n        <aup-activity-outlet [nestedInteractionContext]=\"this\" [activityRef]=\"activityRef\"></aup-activity-outlet>\n      </div>\n    </aup-busy-overlay>\n  </mat-tab>\n</mat-tab-group>\n", styles: [":host{display:flex;flex-direction:column}mat-tab-group{flex:1}aup-busy-overlay{flex:1}.activity-outlet-wrapper{flex:1}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "component", type: BusyOverlayComponent, selector: "aup-busy-overlay", inputs: ["busyModel", "busy"] }, { kind: "directive", type: i5$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "component", type: ActivityOutletComponent, selector: "aup-activity-outlet", inputs: ["nestedInteractionContext", "activityRef"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ActivityContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-activity-container", template: "<mat-tab-group #tabs no-tab-header\n               [dynamicHeight]=\"dynamicHeight\"\n               [class.full-height-tabs]=\"!dynamicHeight\">\n  <mat-tab *ngFor=\"let activityRef of activityRefs; let i = index; trackBy: activityIndex\">\n    <aup-busy-overlay [busyModel]=\"busy\" cdkTrapFocus cdkTrapFocusAutoCapture>\n      <!--\n      We have issues where angular is triggering a leave animation when an\n      new activity is started, but is not running the enter animation\n      when it is scrolled back into view.  So we track the tab changes and\n      disable all animations inside the tab while we're animating.\n      -->\n      <div class=\"activity-outlet-wrapper\" [@.disabled]=\"!activityRef.focused\">\n        <aup-activity-outlet [nestedInteractionContext]=\"this\" [activityRef]=\"activityRef\"></aup-activity-outlet>\n      </div>\n    </aup-busy-overlay>\n  </mat-tab>\n</mat-tab-group>\n", styles: [":host{display:flex;flex-direction:column}mat-tab-group{flex:1}aup-busy-overlay{flex:1}.activity-outlet-wrapper{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: PlaceRouter }]; }, propDecorators: { dynamicHeight: [{
                type: Input
            }], tabs: [{
                type: ViewChild,
                args: ["tabs", { static: true }]
            }], activityOutlets: [{
                type: ViewChildren,
                args: [ActivityOutletComponent]
            }] } });

class AbstractActivityTriggerComponent extends DisposableComponent {
    constructor() {
        super();
        this.alignFace = HorizontalAlignment.CENTER;
        this.confirmEvent = new EventEmitter();
        this.cancelEvent = new EventEmitter();
        this.startActivityCommand = Command.create(() => {
            assert.notNil(this.activityClass);
            assert.notNil(this.interactionContext);
            this.interactionContext.startActivity(this.activityClass, this.activityData)
                .then(result => {
                this.confirmEvent.emit(result);
            }).catch(error => {
                this.cancelEvent.emit(error);
            });
        });
    }
    get interactionContext() {
        return lang$1.abstractMethod(this.constructor);
    }
    ngOnInit() {
    }
    get isActive() {
        return this.interactionContext?.isActive();
    }
}
AbstractActivityTriggerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractActivityTriggerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AbstractActivityTriggerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractActivityTriggerComponent, selector: "aup-abstract-activity-trigger", inputs: { activityClass: "activityClass", activityClassModel: "activityClassModel", activityData: "activityData", activityDataModel: "activityDataModel", face: "face", faceModel: "faceModel", alignFace: "alignFace" }, outputs: { confirmEvent: "confirmEvent", cancelEvent: "cancelEvent" }, host: { properties: { "class.active": "this.isActive" } }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    StoreInValueModel('activityClassModel'),
    __metadata("design:type", Object)
], AbstractActivityTriggerComponent.prototype, "activityClass", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], AbstractActivityTriggerComponent.prototype, "activityClassModel", void 0);
__decorate([
    StoreInValueModel('activityDataModel'),
    __metadata("design:type", Object)
], AbstractActivityTriggerComponent.prototype, "activityData", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], AbstractActivityTriggerComponent.prototype, "activityDataModel", void 0);
__decorate([
    StoreInValueModel('faceModel'),
    __metadata("design:type", Object)
], AbstractActivityTriggerComponent.prototype, "face", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], AbstractActivityTriggerComponent.prototype, "faceModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractActivityTriggerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'aup-abstract-activity-trigger',
                    template: ''
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { activityClass: [{
                type: Input
            }], activityClassModel: [{
                type: Input
            }], activityData: [{
                type: Input
            }], activityDataModel: [{
                type: Input
            }], face: [{
                type: Input
            }], faceModel: [{
                type: Input
            }], alignFace: [{
                type: Input
            }], confirmEvent: [{
                type: Output
            }], cancelEvent: [{
                type: Output
            }], isActive: [{
                type: HostBinding,
                args: ['class.active']
            }] } });

class ModalActivityTriggerComponent extends AbstractActivityTriggerComponent {
    constructor(interactionService) {
        super();
        this._interactionContext = interactionService.createModalInteractionContextDisposedWith(this);
    }
    get interactionContext() {
        return this._interactionContext;
    }
}
ModalActivityTriggerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ModalActivityTriggerComponent, deps: [{ token: InteractionService }], target: i0.ɵɵFactoryTarget.Component });
ModalActivityTriggerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ModalActivityTriggerComponent, selector: "aup-modal-activity-trigger", usesInheritance: true, ngImport: i0, template: "<aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n", styles: [":host{display:inline-block}\n"], dependencies: [{ kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ModalActivityTriggerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-modal-activity-trigger', template: "<aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n", styles: [":host{display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: InteractionService }]; } });

/**
 * @example
 *   <aup-in-place-interaction-context #inPlaceInteractionContext>
 *   </aup-in-place-interaction-context>
 *
 *   in your component
 *     @ViewChild('inPlaceInteractionContext', { static: true })
 *     interactionContext: InteractionContext;
 *
 *
 */
class InPlaceInteractionContextComponent extends DisposableComponent {
    constructor(interactionService, tabConfig) {
        super();
        this.interactionService = interactionService;
        this.tabConfig = tabConfig;
        /**
         * If true then the first startActivity call will slide the activity into view. If false
         * the activity will replace the existing content immediately.
         */
        this.animateFirstActivity = true;
        /**
         * If true the activity will sync with the router to enable back button support.  This is a work around for
         * deeply nested activities that can't be linked with the root place interactionContext hook for cancelling
         * active interactions.
         */
        this.syncWithRoutes = true;
    }
    get animationDuration() {
        return this.animateFirstActivity ? (this.tabConfig?.animationDuration || "500ms") : "0ms";
    }
    get active() {
        return this.isActive();
    }
    ngAfterViewInit() {
        // NOTE: this is a temp work around to detach inplace contexts from the router until AUP-88 is implemented.
        // https://coolon.atlassian.net/browse/AUP-88?atlOrigin=eyJpIjoiOTg5YjEzZGUzZjRmNDg0NmExOWU3ZGJmMzJiNTRmNGYiLCJwIjoiaiJ9
        if (this.syncWithRoutes) {
            this.interactionService.registerInplaceInteractionContext(this);
        }
        else {
            this.activityContainerComponent.initialise("dont-care", {
                async notifyActive(interactionContext) {
                    return undefined;
                },
                async notifyFinished(interactionContext) {
                    return undefined;
                }
            });
        }
    }
    // this is a regsitration callback from the interaction service
    onInplaceInteractionContextRegistered(id, api) {
        this.activityContainerComponent.initialise(id, api);
    }
    get identifier() {
        return this.activityContainerComponent.identifier;
    }
    alert(alert) {
        return this.activityContainerComponent.alert(alert);
    }
    cancelActiveActivity() {
        return this.activityContainerComponent.cancelActiveActivity();
    }
    confirm(confirm) {
        return this.activityContainerComponent.confirm(confirm);
    }
    confirmOrReject(confirm) {
        return this.activityContainerComponent.confirmOrReject(confirm);
    }
    confirmThen(confirm, activityType, data) {
        return this.activityContainerComponent.confirmThen(confirm, activityType);
    }
    confirmThenExecute(confirm, operation) {
        return this.activityContainerComponent.confirmThenExecute(confirm, operation);
    }
    isActive() {
        return this.activityContainerComponent.isActive();
    }
    startActivity(activityType, data, options) {
        return this.activityContainerComponent.startActivity(activityType, data, options);
    }
}
InPlaceInteractionContextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InPlaceInteractionContextComponent, deps: [{ token: InteractionService }, { token: MAT_TABS_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Component });
InPlaceInteractionContextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: InPlaceInteractionContextComponent, selector: "aup-in-place-interaction-context", inputs: { animateFirstActivity: "animateFirstActivity", syncWithRoutes: "syncWithRoutes" }, host: { properties: { "class.active": "this.active" } }, viewQueries: [{ propertyName: "activityContainerComponent", first: true, predicate: ["activityContainer"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<mat-tab-group no-tab-header [selectedIndex]=\"isActive() ? 1 : 0\" full-height-tabs [dynamicHeight]=\"false\" [animationDuration]=\"animationDuration\">\n  <mat-tab>\n    <ng-content></ng-content>\n  </mat-tab>\n  <mat-tab>\n    <aup-activity-container #activityContainer [dynamicHeight]=\"false\"></aup-activity-container>\n  </mat-tab>\n</mat-tab-group>\n\n", styles: [":host{display:flex;flex-direction:column}mat-tab-group{flex:1}aup-activity-container{flex:1}\n"], dependencies: [{ kind: "component", type: i2$6.MatTabGroup, selector: "mat-tab-group", inputs: ["color", "disableRipple"], exportAs: ["matTabGroup"] }, { kind: "component", type: i2$6.MatTab, selector: "mat-tab", inputs: ["disabled", "label", "aria-label", "aria-labelledby", "labelClass", "bodyClass"], exportAs: ["matTab"] }, { kind: "component", type: ActivityContainerComponent, selector: "aup-activity-container", inputs: ["dynamicHeight"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InPlaceInteractionContextComponent, decorators: [{
            type: Component,
            args: [{ selector: "aup-in-place-interaction-context", template: "<mat-tab-group no-tab-header [selectedIndex]=\"isActive() ? 1 : 0\" full-height-tabs [dynamicHeight]=\"false\" [animationDuration]=\"animationDuration\">\n  <mat-tab>\n    <ng-content></ng-content>\n  </mat-tab>\n  <mat-tab>\n    <aup-activity-container #activityContainer [dynamicHeight]=\"false\"></aup-activity-container>\n  </mat-tab>\n</mat-tab-group>\n\n", styles: [":host{display:flex;flex-direction:column}mat-tab-group{flex:1}aup-activity-container{flex:1}\n"] }]
        }], ctorParameters: function () { return [{ type: InteractionService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_TABS_CONFIG]
                }, {
                    type: Optional
                }] }]; }, propDecorators: { activityContainerComponent: [{
                type: ViewChild,
                args: ["activityContainer", { static: true }]
            }], animateFirstActivity: [{
                type: Input
            }], syncWithRoutes: [{
                type: Input
            }], active: [{
                type: HostBinding,
                args: ["class.active"]
            }] } });

/**
 *
 */
class AddCardActivityComponent extends AbstractActivityTriggerComponent {
    constructor(interactionService) {
        super();
        this.interactionStyle = AddCardActivityComponent.InteractionType.MODAL;
        this.renderAs = AddCardActivityComponent.RenderAs.CARD;
        this.notCard = true;
        const { chain } = Dsl.disposeWith(this);
        this.modalInteractionContext = interactionService.createModalInteractionContextDisposedWith(this);
        this.faceList = chain(this.faceModel).mapToList(face => [face]);
    }
    get renderAsClass() {
        return `render-as-${this.renderAs}`;
    }
    get activityTypeClass() {
        return `${this.interactionStyle}-activity`;
    }
    isRenderAsCard() {
        return this.renderAs === 'card';
    }
    isRenderAsButton() {
        return this.renderAs === 'button';
    }
    ngOnInit() {
    }
    get interactionContext() {
        switch (this.interactionStyle) {
            case 'inline':
                return this.inlineInteractionContext;
            default:
                return this.modalInteractionContext;
        }
    }
    isModal() {
        return this.interactionStyle === 'modal';
    }
    isInline() {
        return this.interactionStyle === 'inline';
    }
}
AddCardActivityComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AddCardActivityComponent, deps: [{ token: InteractionService }], target: i0.ɵɵFactoryTarget.Component });
AddCardActivityComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AddCardActivityComponent, selector: "aup-add-card-activity", inputs: { interactionStyle: "interactionStyle", renderAs: "renderAs" }, host: { properties: { "class": "this.activityTypeClass", "class.not-card": "this.notCard" } }, viewQueries: [{ propertyName: "inlineInteractionContext", first: true, predicate: InPlaceInteractionContextComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<aup-in-place-interaction-context [animateFirstActivity]=\"false\" [pectinCommand]=\"startActivityCommand\">\n  <aup-command *ngIf=\"isRenderAsButton()\" [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n  <section *ngIf=\"isRenderAsCard()\" class=\"face-wrapper\">\n    <aup-command-face class=\"mat-button\" [faces]=\"faceList.value\"></aup-command-face>\n  </section>\n</aup-in-place-interaction-context>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch;background-color:#fff}:host[interactionStyle=inline][renderas=card]:not(.active){transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}:host[interactionStyle=inline][renderas=card]:not(.active):hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host[interactionStyle=inline][renderas=card]:not(.active):hover{border-color:transparent;background-color:#fff;color:#0000008a}:host[interactionStyle=modal][renderas=card]{transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}:host[interactionStyle=modal][renderas=card]:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host[interactionStyle=modal][renderas=card]:hover{border-color:transparent;background-color:#fff;color:#0000008a}:host-context(aup-card-container)[renderas=button]{align-self:start}section.face-wrapper{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center}aup-in-place-interaction-context{flex:1}aup-in-place-interaction-context.active{border:3px solid #6273c7;border-radius:4px;overflow:hidden}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }, { kind: "component", type: InPlaceInteractionContextComponent, selector: "aup-in-place-interaction-context", inputs: ["animateFirstActivity", "syncWithRoutes"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AddCardActivityComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-add-card-activity', template: "<aup-in-place-interaction-context [animateFirstActivity]=\"false\" [pectinCommand]=\"startActivityCommand\">\n  <aup-command *ngIf=\"isRenderAsButton()\" [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n  <section *ngIf=\"isRenderAsCard()\" class=\"face-wrapper\">\n    <aup-command-face class=\"mat-button\" [faces]=\"faceList.value\"></aup-command-face>\n  </section>\n</aup-in-place-interaction-context>\n", styles: [":host{display:flex;flex-direction:column;align-items:stretch;background-color:#fff}:host[interactionStyle=inline][renderas=card]:not(.active){transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}:host[interactionStyle=inline][renderas=card]:not(.active):hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host[interactionStyle=inline][renderas=card]:not(.active):hover{border-color:transparent;background-color:#fff;color:#0000008a}:host[interactionStyle=modal][renderas=card]{transition:box-shadow .28s cubic-bezier(.4,0,.2,1);box-sizing:border-box;border:2px dashed rgba(0,0,0,.1);border-radius:6px;font-weight:300;cursor:pointer;color:#0000008a;background-color:#fffc}:host[interactionStyle=modal][renderas=card]:hover{box-shadow:0 3px 1px -2px #0003,0 2px 2px #00000024,0 1px 5px #0000001f}:host[interactionStyle=modal][renderas=card]:hover{border-color:transparent;background-color:#fff;color:#0000008a}:host-context(aup-card-container)[renderas=button]{align-self:start}section.face-wrapper{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center}aup-in-place-interaction-context{flex:1}aup-in-place-interaction-context.active{border:3px solid #6273c7;border-radius:4px;overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: InteractionService }]; }, propDecorators: { inlineInteractionContext: [{
                type: ViewChild,
                args: [InPlaceInteractionContextComponent, { static: true }]
            }], interactionStyle: [{
                type: Input
            }], renderAs: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class']
            }], notCard: [{
                type: HostBinding,
                args: ['class.not-card']
            }], renderAsClass: [{
                type: HostBinding,
                args: ['class']
            }], activityTypeClass: [{
                type: HostBinding,
                args: ['class']
            }] } });
(function (AddCardActivityComponent) {
    AddCardActivityComponent.InteractionType = Enum({
        MODAL: 'modal',
        INLINE: 'inline'
    });
    AddCardActivityComponent.RenderAs = Enum({
        CARD: 'card',
        BUTTON: 'button'
    });
})(AddCardActivityComponent || (AddCardActivityComponent = {}));

/**
 * Css Vars.
 *   --link-color
 *   --link-color-hover
 *   --link-background
 *   --link-background-hover
 *   --link-border-radius
 *   --link-padding
 */
class AddItemInteractionContextComponent extends DisposableComponent {
    constructor() {
        super();
        this.icon = "mat:add";
        this.tabindex = 0;
        this.clickCommand = Command.create((context) => {
            if (this.activityClass) {
                this.startActivity(this.activityClass, this.activityData).catch(e => {
                    //  don't care.
                });
            }
            else {
                this.addCommand.withContext(context).execute();
            }
        });
    }
    get active() {
        return this.interactionContext ? this.interactionContext.isActive() : false;
    }
    startActivity(activityType, data) {
        return this.interactionContext.startActivity(activityType, data);
    }
    ngOnInit() {
    }
}
AddItemInteractionContextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AddItemInteractionContextComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AddItemInteractionContextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AddItemInteractionContextComponent, selector: "aup-add-item-interaction-context", inputs: { label: "label", icon: "icon", activityClass: "activityClass", activityData: "activityData", addCommand: "addCommand" }, host: { properties: { "class.interaction-active": "this.active", "tabindex": "this.tabindex" } }, viewQueries: [{ propertyName: "interactionContext", first: true, predicate: InPlaceInteractionContextComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<aup-in-place-interaction-context [animateFirstActivity]=\"false\">\n    <a part=\"link\" class=\"link\" [pectinCommand]=\"clickCommand\"><aup-icon [icon]=\"icon\"></aup-icon> {{label}}</a>\n</aup-in-place-interaction-context>\n", styles: [":host{--def-link-color: var(--link-color, currentColor);--def-link-color-hover: var(--link-color-hover, currentColor);--def-link-background: var(--link-background, transparent);--def-link-background-hover: var(--link-background-hover, rgba(0, 0, 0, .05));--def-link-border-radius: var(--link-border-radius, 4px);--def-link-padding: var(--link-padding, calc(var(--aup-default-padding) / 2));display:flex;flex-direction:column;border-radius:var(--def-link-border-radius);box-sizing:border-box;outline:none}:host:hover a.link{color:var(--def-link-color-hover);background-color:var(--def-link-background-hover)}aup-in-place-interaction-context{border-radius:var(--def-link-border-radius)}a.link{display:flex;flex-direction:row;align-items:center;border-radius:var(--def-link-border-radius);color:var(--def-link-color);background:var(--def-link-background);padding:var(--def-link-padding);cursor:pointer;text-decoration:none}a.link mat-icon{margin-right:8px}\n"], dependencies: [{ kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }, { kind: "component", type: InPlaceInteractionContextComponent, selector: "aup-in-place-interaction-context", inputs: ["animateFirstActivity", "syncWithRoutes"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", Command)
], AddItemInteractionContextComponent.prototype, "addCommand", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AddItemInteractionContextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-add-item-interaction-context', template: "<aup-in-place-interaction-context [animateFirstActivity]=\"false\">\n    <a part=\"link\" class=\"link\" [pectinCommand]=\"clickCommand\"><aup-icon [icon]=\"icon\"></aup-icon> {{label}}</a>\n</aup-in-place-interaction-context>\n", styles: [":host{--def-link-color: var(--link-color, currentColor);--def-link-color-hover: var(--link-color-hover, currentColor);--def-link-background: var(--link-background, transparent);--def-link-background-hover: var(--link-background-hover, rgba(0, 0, 0, .05));--def-link-border-radius: var(--link-border-radius, 4px);--def-link-padding: var(--link-padding, calc(var(--aup-default-padding) / 2));display:flex;flex-direction:column;border-radius:var(--def-link-border-radius);box-sizing:border-box;outline:none}:host:hover a.link{color:var(--def-link-color-hover);background-color:var(--def-link-background-hover)}aup-in-place-interaction-context{border-radius:var(--def-link-border-radius)}a.link{display:flex;flex-direction:row;align-items:center;border-radius:var(--def-link-border-radius);color:var(--def-link-color);background:var(--def-link-background);padding:var(--def-link-padding);cursor:pointer;text-decoration:none}a.link mat-icon{margin-right:8px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { label: [{
                type: Input
            }], icon: [{
                type: Input
            }], activityClass: [{
                type: Input
            }], activityData: [{
                type: Input
            }], addCommand: [{
                type: Input
            }], interactionContext: [{
                type: ViewChild,
                args: [InPlaceInteractionContextComponent]
            }], active: [{
                type: HostBinding,
                args: ['class.interaction-active']
            }], tabindex: [{
                type: HostBinding,
                args: ['tabindex']
            }] } });

class InlineActivityTriggerComponent extends AbstractActivityTriggerComponent {
    constructor() {
        super();
    }
    get interactionContext() {
        return this._interactionContext;
    }
}
InlineActivityTriggerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InlineActivityTriggerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
InlineActivityTriggerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: InlineActivityTriggerComponent, selector: "aup-inline-activity-trigger", viewQueries: [{ propertyName: "_interactionContext", first: true, predicate: InPlaceInteractionContextComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<aup-in-place-interaction-context #interactionContext [animateFirstActivity]=\"false\">\n  <aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n</aup-in-place-interaction-context>\n", styles: [":host{display:inline-block}\n"], dependencies: [{ kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }, { kind: "component", type: InPlaceInteractionContextComponent, selector: "aup-in-place-interaction-context", inputs: ["animateFirstActivity", "syncWithRoutes"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InlineActivityTriggerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-inline-activity-trigger', template: "<aup-in-place-interaction-context #interactionContext [animateFirstActivity]=\"false\">\n  <aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n</aup-in-place-interaction-context>\n", styles: [":host{display:inline-block}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { _interactionContext: [{
                type: ViewChild,
                args: [InPlaceInteractionContextComponent, { static: true }]
            }] } });

/**
 * <aup-popup-interaction-context #ctx></aup-popup-interaction-context>
 *
 * in your component
 * @ViewChild('inPlaceInteractionContext', { static: true })
 * interactionContext: InteractionContext;
 * or
 * @ViewChild('ctx', { static: true })
 * interactionContext: InteractionContext;
 */
class PopupInteractionContextComponent extends DisposableComponent {
    constructor(_element, _overlay, scrollable) {
        super();
        this._element = _element;
        this._overlay = _overlay;
        this.outputPortal = new ComponentPortal(InPlaceInteractionContextComponent);
        this.anchorX = 'start';
        this.anchorY = 'bottom';
        this.scrollContainers = scrollable ? [scrollable] : [];
    }
    get active() {
        return this.isActive();
    }
    startActivity(activityType, data) {
        // console.log({ element: this._element });
        const self = this;
        const overlayRef = this._overlay.create({
            hasBackdrop: false,
            disposeOnNavigation: true,
            panelClass: 'aup-popup-interaction-panel',
            positionStrategy: this._overlay.position()
                .flexibleConnectedTo(this._element)
                .withPush(true)
                .withPositions(this.computePositions())
                .withGrowAfterOpen(true)
                .withScrollableContainers(self.scrollContainers) // this isn't working. sigh.
        });
        const subs = this.scrollContainers.map(sc => sc.elementScrolled().subscribe(() => {
            overlayRef.updatePosition();
        }));
        const componentRef = overlayRef.attach(this.outputPortal);
        this.interactionContext = componentRef.instance;
        return new Promise((resolve, reject) => {
            // HACK: afterViewInit won't have been called yet.  Need to add when(interactionContext.ready).becomesTruthy(...)
            setTimeout(() => {
                this.interactionContext.startActivity(activityType, data)
                    .then(resolve)
                    .catch(reject)
                    .finally(() => {
                    subs.forEach(s => s.unsubscribe());
                    overlayRef.dispose();
                });
                setTimeout(() => {
                    overlayRef.updatePosition();
                });
            });
        });
    }
    computePositions() {
        const overlayX = this.anchorX === 'start' ? 'start' : 'end';
        const overlayY = this.anchorY === 'top' ? 'bottom' : 'top';
        return [
            { originX: this.anchorX, originY: this.anchorY, overlayX: overlayX, overlayY: overlayY }
            // TODO: compute some meaningful alternatives.
            // { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
            // { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
            // { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
            // { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' }
        ];
    }
    cancelActiveActivity() {
        return this.interactionContext.cancelActiveActivity();
    }
    isActive() {
        return this.interactionContext && this.interactionContext.isActive();
    }
    ngOnInit() {
    }
}
PopupInteractionContextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupInteractionContextComponent, deps: [{ token: i0.ElementRef }, { token: i1$5.Overlay }, { token: i1$5.CdkScrollable, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.Component });
PopupInteractionContextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PopupInteractionContextComponent, selector: "aup-popup-interaction-context", inputs: { anchorX: "anchorX", anchorY: "anchorY" }, host: { properties: { "class.interaction-active": "this.active" } }, usesInheritance: true, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:inline-block}:host.interaction-active{background:rgba(0,0,0,.05)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupInteractionContextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-popup-interaction-context', template: "<ng-content></ng-content>\n", styles: [":host{display:inline-block}:host.interaction-active{background:rgba(0,0,0,.05)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$5.Overlay }, { type: i1$5.CdkScrollable, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; }, propDecorators: { active: [{
                type: HostBinding,
                args: ['class.interaction-active']
            }], anchorX: [{
                type: Input
            }], anchorY: [{
                type: Input
            }] } });

class InteractionContextTriggerFor extends GarbageCollector {
    constructor() {
        super();
        this.activityDone = new EventEmitter();
        this.activityCancelled = new EventEmitter();
    }
    onEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.aupInteractionContextTriggerFor.isActive()) {
            this.startActivity();
        }
        else {
            this.aupInteractionContextTriggerFor.cancelActiveActivity();
        }
    }
    onClick(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.aupInteractionContextTriggerFor.isActive()) {
            this.startActivity();
        }
        else {
            this.aupInteractionContextTriggerFor.cancelActiveActivity();
        }
    }
    startActivity() {
        assert.isTruthy(this.aupInteractionContextTriggerFor);
        assert.isFalsey(this.aupInteractionContextTriggerFor.isActive());
        assert.isTruthy(this.activityClass);
        this.aupInteractionContextTriggerFor.startActivity(this.activityClass, this.activityData)
            .then(result => {
            this.activityDone.emit(result);
        })
            .catch(error => {
            this.activityCancelled.emit(error);
        });
    }
    prepareActivityData() {
        return isFunction(this.activityDataFactory()) ? this.activityDataFactory() : this.activityData;
    }
}
InteractionContextTriggerFor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionContextTriggerFor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
InteractionContextTriggerFor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: InteractionContextTriggerFor, selector: "[aupInteractionContextTriggerFor]", inputs: { aupInteractionContextTriggerFor: "aupInteractionContextTriggerFor", activityClass: "activityClass", activityData: "activityData", activityDataFactory: "activityDataFactory" }, outputs: { activityDone: "activityDone", activityCancelled: "activityCancelled" }, host: { listeners: { "keyup.enter": "onEnter($event)", "click": "onClick($event)" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionContextTriggerFor, decorators: [{
            type: Directive,
            args: [{
                    selector: '[aupInteractionContextTriggerFor]'
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { aupInteractionContextTriggerFor: [{
                type: Input
            }], activityClass: [{
                type: Input
            }], activityData: [{
                type: Input
            }], activityDataFactory: [{
                type: Input
            }], activityDone: [{
                type: Output
            }], activityCancelled: [{
                type: Output
            }], onEnter: [{
                type: HostListener,
                args: ['keyup.enter', ['$event']]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

// @see https://github.com/ng-packagr/ng-packagr/issues/641 and  https://github.com/angular/angular/issues/21123
// we're getting a metadata error for D for no reason that I can find and only during the build (ng serve works fine)
// @dynamic
class InputActivity extends Activity {
    constructor() {
        super();
        this.class = 'aup-input-activity';
        const form = new DirtyTrackingForm();
        this.valueModel = form.valueModel(this.activityData.initialValue);
        this.valueModel.validateUsing(this.activityData.validators || []);
        // TODO: move to global configuration
        this.confirmFace = this.activityData.confirmFace ?? {
            icon: () => 'mat:check'
        };
        this.cancelFace = this.activityData.cancelFace ?? {
            icon: () => 'mat:clear'
        };
        this.confirmCommand = Command.create(async () => {
            if (this.valueModel.validate()) {
                if (this.activityData.save) {
                    const self = this;
                    try {
                        let allGood = true;
                        const result = await this.activityData.save(this.valueModel.value, {
                            injectError(error) {
                                allGood = false;
                                self.valueModel.injectErrors([error]);
                            }
                        });
                        if (allGood) {
                            this.done(this.valueModel.value);
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else {
                    this.done(this.valueModel.value);
                }
            }
        });
        this.cancelCommand = Command.create(() => {
            this.cancel();
        });
        this.busyWhile(this.confirmCommand.busy$);
        this.onActivityReady(() => this.valueModel.focusContext.requestFocus());
    }
    get layout() {
        return this.activityData?.layout ?? InputActivity.Layout.BLOCK;
    }
    get additionalCssClassName() {
        return this.activityData.cssClassName ?? '';
    }
    onEscape() {
        if (this.shouldCancelOnEscape() && this.cancelCommand.enabled$.value) {
            this.cancelCommand.execute();
        }
    }
    shouldCancelOnEscape() {
        return isNil(this.activityData.cancelOnEscape) // we default to true..
            || this.activityData.cancelOnEscape;
    }
}
InputActivity.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InputActivity, deps: [], target: i0.ɵɵFactoryTarget.Component });
InputActivity.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: InputActivity, selector: "ng-component", inputs: { layout: "layout" }, host: { listeners: { "keydown.escape": "onEscape()" }, properties: { "class": "this.additionalCssClassName", "attr.layout": "this.layout" } }, usesInheritance: true, ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InputActivity, decorators: [{
            type: Component,
            args: [{ template: `` }]
        }], ctorParameters: function () { return []; }, propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }], layout: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.layout']
            }], additionalCssClassName: [{
                type: HostBinding,
                args: ["class"]
            }], onEscape: [{
                type: HostListener,
                args: ['keydown.escape']
            }] } });
(function (InputActivity) {
    InputActivity.Layout = Enum({
        INLINE: 'inline',
        BLOCK: 'block'
    });
})(InputActivity || (InputActivity = {}));

class StringInputActivity extends InputActivity {
}
StringInputActivity.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringInputActivity, deps: null, target: i0.ɵɵFactoryTarget.Component });
StringInputActivity.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: StringInputActivity, selector: "aup-string-input-activity", usesInheritance: true, ngImport: i0, template: `
    <aup-string-input [value$]="valueModel"
                      [label]="activityData.label"
                      [placeholder]="activityData.placeholder"
                      [command.enter]="confirmCommand"
                      [command.escape]="cancelCommand"></aup-string-input>
    <aup-activity-actions [layout]="layout" align="end"
                          [confirmFace]="confirmFace"
                          [cancelFace]="cancelFace"
    ></aup-activity-actions>
  `, isInline: true, dependencies: [{ kind: "component", type: StringInputComponent, selector: "aup-string-input", inputs: ["autocomplete", "enableClear$", "enableClear", "iconPrefix"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: StringInputActivity, decorators: [{
            type: Component,
            args: [{
                    selector: 'aup-string-input-activity',
                    template: `
    <aup-string-input [value$]="valueModel"
                      [label]="activityData.label"
                      [placeholder]="activityData.placeholder"
                      [command.enter]="confirmCommand"
                      [command.escape]="cancelCommand"></aup-string-input>
    <aup-activity-actions [layout]="layout" align="end"
                          [confirmFace]="confirmFace"
                          [cancelFace]="cancelFace"
    ></aup-activity-actions>
  `
                }]
        }] });

class SelectInputActivity extends InputActivity {
    constructor() {
        super(...arguments);
        this.defaultOptionLabelFormat = (option) => {
            return this.activityData.optionLabel ? option[this.activityData.optionLabel] : option;
        };
    }
    get optionLabelFormat() {
        return this.activityData.optionLabelFormat ?? this.defaultOptionLabelFormat;
    }
    get options() {
        return this.activityData.optionsModel?.value || this.activityData.options;
    }
}
SelectInputActivity.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectInputActivity, deps: null, target: i0.ɵɵFactoryTarget.Component });
SelectInputActivity.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SelectInputActivity, selector: "aup-select-input-activity", usesInheritance: true, ngImport: i0, template: `
    <aup-select-input [value$]="valueModel"
                      [label]="activityData.label"
                      [placeholder]="activityData.placeholder"
                      [command.enter]="confirmCommand"
                      [command.escape]="cancelCommand"
                      [options]="options"
                      [optionLabelFormat]="optionLabelFormat"
    ></aup-select-input>
    <aup-activity-actions [layout]="layout" align="end"
                          [confirmFace]="confirmFace"
                          [cancelFace]="cancelFace"
    ></aup-activity-actions>
  `, isInline: true, dependencies: [{ kind: "component", type: SelectInputComponent, selector: "aup-select-input", inputs: ["options$", "optionsModel", "options", "optionLabel", "allowNil", "optionLabelFormat"] }, { kind: "component", type: ActivityActionsComponent, selector: "aup-activity-actions", inputs: ["confirmCommand", "cancelCommand", "faces", "confirmFace", "cancelFace", "style", "layout", "align"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SelectInputActivity, decorators: [{
            type: Component,
            args: [{
                    selector: 'aup-select-input-activity',
                    template: `
    <aup-select-input [value$]="valueModel"
                      [label]="activityData.label"
                      [placeholder]="activityData.placeholder"
                      [command.enter]="confirmCommand"
                      [command.escape]="cancelCommand"
                      [options]="options"
                      [optionLabelFormat]="optionLabelFormat"
    ></aup-select-input>
    <aup-activity-actions [layout]="layout" align="end"
                          [confirmFace]="confirmFace"
                          [cancelFace]="cancelFace"
    ></aup-activity-actions>
  `
                }]
        }] });

class TableFilterModel extends AbstractTableFilterModel {
    constructor(builder) {
        super();
        this._rowPredicate$ = this.registerDisposable(new DelegatingValueModel());
        this._searchText$ = this.registerDisposable(new DelegatingValueModel());
        this.inUpdate = new Guard();
        const { chain } = Dsl.disposeWith(this);
        if (builder) {
            this.registerModels(builder);
        }
        const textSearchRegex$ = chain(this._searchText$).map(text => {
            return isEmpty$1(text) ? undefined : new RegExp(escapeStringRegexp(text), "i");
        }, { allowNil: true });
        this._rowFilter$ = chain(this._rowPredicate$)
            .map(predicate => {
            const regex = textSearchRegex$.value;
            return {
                matches(row, columns) {
                    return (!predicate || predicate(row)) && (!regex || !!columns.find(c => regex.test(c.getSearchTextFor(row))));
                }
            };
        }, {
            allowNil: true,
            dependsOn: textSearchRegex$,
            postponeWhile: this.inUpdate
        });
    }
    get rowFilter$() {
        return this._rowFilter$.readonly;
    }
    get highlightText$() {
        return this._searchText$.readonly;
    }
    registerModels(builder) {
        // TODO: calling this twice without disposing woudl result in confusion... I should probably
        //       change how this works...
        const self = this;
        this.inUpdate.whileTrue(() => {
            builder({
                usePredicate(predicate$) {
                    self._rowPredicate$.setDelegate(predicate$);
                    return this;
                },
                useSearchText(searchText$) {
                    self._searchText$.setDelegate(searchText$);
                    return this;
                }
            });
        });
        return {
            dispose: () => self.clear()
        };
    }
    clear() {
        this.inUpdate.whileTrue(() => {
            this._rowPredicate$.setDelegate(undefined);
            this._searchText$.setDelegate(undefined);
        });
    }
}
(function (TableFilterModel) {
    class BuilderImp {
        usePredicate(predicate$) {
            this.rowPredicate$ = predicate$;
            return this;
        }
        useSearchText(searchText$) {
            this.searchText$ = searchText$;
            return this;
        }
    }
    TableFilterModel.BuilderImp = BuilderImp;
})(TableFilterModel || (TableFilterModel = {}));

/**
 * @file Automatically generated by barrelsby.
 */

class PopupActivityTriggerComponent extends AbstractActivityTriggerComponent {
    constructor() {
        super();
        this.anchorX = 'start';
        this.anchorY = 'bottom';
    }
    get interactionContext() {
        return this._interactionContext;
    }
}
PopupActivityTriggerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupActivityTriggerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
PopupActivityTriggerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PopupActivityTriggerComponent, selector: "aup-popup-activity-trigger", inputs: { anchorX: "anchorX", anchorY: "anchorY" }, viewQueries: [{ propertyName: "_interactionContext", first: true, predicate: PopupInteractionContextComponent, descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<aup-popup-interaction-context [anchorX]=\"anchorX\" [anchorY]=\"anchorY\">\n  <aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n</aup-popup-interaction-context>\n", styles: [":host{display:inline-block}\n"], dependencies: [{ kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }, { kind: "component", type: PopupInteractionContextComponent, selector: "aup-popup-interaction-context", inputs: ["anchorX", "anchorY"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PopupActivityTriggerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-popup-activity-trigger', template: "<aup-popup-interaction-context [anchorX]=\"anchorX\" [anchorY]=\"anchorY\">\n  <aup-command [command]=\"startActivityCommand\" [faceModel]=\"faceModel\" [alignFace]=\"alignFace\"></aup-command>\n</aup-popup-interaction-context>\n", styles: [":host{display:inline-block}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { anchorX: [{
                type: Input
            }], anchorY: [{
                type: Input
            }], _interactionContext: [{
                type: ViewChild,
                args: [PopupInteractionContextComponent, { static: true }]
            }] } });

class InlineEditorModel extends GarbageCollector {
    constructor(valueModel, saveCallback) {
        super();
        this.valueModel = valueModel;
        this.saveCallback = saveCallback;
        this.editing = new MutableValueModel(false);
        this._validators = new MutableListModel();
        this._editingEnabled = this.registerDisposable(new DelegatingValueModel().withDefault(true));
        assert.notNil(valueModel);
        const { when } = Dsl.disposeWith(this);
        when(this.editingEnabled).becomesFalsey(() => this.cancelEdit());
    }
    get editingEnabled() {
        return this._editingEnabled.readonly;
    }
    disableWhile(condition) {
        const { chain } = Dsl.disposeWith(this);
        this.enableWhile(chain(condition).isFalsey());
        return this;
    }
    enableWhile(condition) {
        this._editingEnabled.setDelegate(condition);
        return this;
    }
    get validators() {
        return this._validators.readonly;
    }
    validateUsing(validator) {
        this._validators.push(validator);
        return this;
    }
    isEditing() {
        return this.editing.value;
    }
    cancelEdit() {
        this.editing.value = false;
    }
    startEditing() {
        this.editing.value = true;
    }
}
(function (InlineEditorModel) {
    function create(valueModel, options) {
        return new InlineEditorModel(valueModel, options.save);
    }
    InlineEditorModel.create = create;
})(InlineEditorModel || (InlineEditorModel = {}));
TrackExternal.oneTimeBinding(InlineEditorModel);

/**
 * @example
 * const source: ValueModel<string> = ...;
 * const model = InlineEditorModel.create(source, {
 *   save(updated:string, context: EditContext) => {
 *      try {
 *        try and save the thing...
 *      } catch(error) {
 *        context.injectError(error)
 *      }
 * }).validateUsing(Validator.present("We'll need a value");
 *
 * # in the view
 * <aup-inline-string-editor
 *       label="My field"
 *       placeHolder="I'm ready for a string..."
 *       [editorModel]="model"></aup-inline-string-editor>
 */
class InlineStringEditorComponent extends DisposableComponent {
    constructor(interactionService) {
        super();
        this.editingEnabled = this.registerDisposable(new DelegatingValueModel());
        const { chain, when, valueOf } = Dsl.disposeWith(this);
        const modalIC = interactionService.createModalInteractionContextDisposedWith(this);
        const resolvedFacesModel = chain(this.facesModel).map(userFaces => {
            return {
                ...InlineStringEditorComponent.DEFAULT_FACES,
                ...userFaces
            };
        }, { allowNil: true });
        this.editFaceModel = resolvedFacesModel.pluck('edit');
        this.saveFace = resolvedFacesModel.pluck('save');
        this.cancelFace = resolvedFacesModel.pluck('cancel');
        const self = this;
        this.editCommand = Command.create(async () => {
            this.editorModel.editing.value = true;
            try {
                await this.interactionContext.startActivity(StringInputActivity, this.createInputActivityData());
            }
            catch (e) {
                // don't care if they cancelled, just hiding the console errors
            }
            finally {
                this.editorModel.editing.value = false;
            }
        }).enableWhile(this.editingEnabled);
        this.onDispose(() => this.cancelEdit());
    }
    ngOnInit() {
        // our editor model is a one time binding without delegates so we can only
        // use it once we've been initialised
        const { chain, when, valueOf } = Dsl.disposeWith(this);
        if (!this.editorModel) {
            lang$1.illegalState('editorModel is required');
        }
        this.editingEnabled.setDelegate(this.editorModel.editingEnabled);
        when(this.editorModel.editing).becomesTruthy(() => {
            this.editCommand.execute();
        }, { asLongAs: this.editCommand.enabled$ });
        when(this.editorModel.editing).becomesFalsey(() => this.cancelEdit());
        this.empty = valueOf.any(chain.stringValue(this.editorModel.valueModel).isBlank()
        // deviceDescription.isNil()
        ).areTruthy();
        this.displayValue = chain(this.editorModel.valueModel).map(v => {
            return isEmpty(v) ? this.placeHolderModel.value : v;
        }, { dependsOn: this.placeHolderModel, allowNil: true });
    }
    createInputActivityData() {
        const self = this;
        return {
            initialValue: self.editorModel.valueModel.value,
            confirmFace: self.saveFace.value,
            cancelFace: self.cancelFace.value,
            placeholder: self.placeHolderModel.value,
            label: self.label,
            layout: InputActivity.Layout.INLINE,
            validators: self.editorModel.validators.value,
            async save(value, inputContext) {
                await self.editorModel.saveCallback(value, inputContext);
            }
        };
    }
    cancelEdit() {
        if (this.isEditing()) {
            this.interactionContext.cancelActiveActivity();
        }
    }
    startEdit() {
        if (!this.isEditing() && this.editCommand.enabled$.value) {
            this.editCommand.execute();
        }
    }
    isEditing() {
        return this.interactionContext.isActive();
    }
    isEmpty() {
        return this.empty.value;
    }
}
InlineStringEditorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InlineStringEditorComponent, deps: [{ token: InteractionService }], target: i0.ɵɵFactoryTarget.Component });
InlineStringEditorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: InlineStringEditorComponent, selector: "aup-inline-string-editor", inputs: { editorModel: "editorModel", facesModel: "facesModel", faces: "faces", label: "label", placeHolder: "placeHolder", placeHolderModel: "placeHolderModel" }, viewQueries: [{ propertyName: "interactionContext", first: true, predicate: InPlaceInteractionContextComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div class=\"container\" *ngIf=\"!editorModel.isEditing()\">\n  <mat-form-field appearance=\"standard\" floatLabel=\"always\" (click)=\"startEdit()\"\n                  [class.editable]=\"editingEnabled.value\" [class.empty]=\"isEmpty()\">\n    <mat-label *ngIf=\"label\">{{label}}</mat-label>\n    <input matInput\n           placeholder=\"{{placeHolder}}\"\n           [ngModel]=\"editorModel.valueModel.value\"\n           [disabled]=\"true\"\n    >\n    <!--    <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>-->\n    <!--    <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>-->\n    <!--    <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>-->\n  </mat-form-field>\n  <aup-command *ngIf=\"editCommand.enabled$.value\" [command]=\"editCommand\" [faceModel]=\"editFaceModel\"></aup-command>\n</div>\n<aup-in-place-interaction-context [animateFirstActivity]=\"false\"></aup-in-place-interaction-context>\n", dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CommandComponent, selector: "aup-command", inputs: ["command", "faceModel", "face", "busyFaceModel", "busyFace", "alignFace"] }, { kind: "directive", type: i2$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i2$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i2$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: i3$1.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i3$1.MatLabel, selector: "mat-label" }, { kind: "directive", type: i4$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "component", type: InPlaceInteractionContextComponent, selector: "aup-in-place-interaction-context", inputs: ["animateFirstActivity", "syncWithRoutes"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", InlineEditorModel)
], InlineStringEditorComponent.prototype, "editorModel", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], InlineStringEditorComponent.prototype, "facesModel", void 0);
__decorate([
    StoreInValueModel('facesModel'),
    __metadata("design:type", Object)
], InlineStringEditorComponent.prototype, "faces", void 0);
__decorate([
    StoreInValueModel('placeHolderModel'),
    __metadata("design:type", String)
], InlineStringEditorComponent.prototype, "placeHolder", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], InlineStringEditorComponent.prototype, "placeHolderModel", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InlineStringEditorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-inline-string-editor', template: "<div class=\"container\" *ngIf=\"!editorModel.isEditing()\">\n  <mat-form-field appearance=\"standard\" floatLabel=\"always\" (click)=\"startEdit()\"\n                  [class.editable]=\"editingEnabled.value\" [class.empty]=\"isEmpty()\">\n    <mat-label *ngIf=\"label\">{{label}}</mat-label>\n    <input matInput\n           placeholder=\"{{placeHolder}}\"\n           [ngModel]=\"editorModel.valueModel.value\"\n           [disabled]=\"true\"\n    >\n    <!--    <mat-hint *ngIf=\"showHint\">{{hint}}</mat-hint>-->\n    <!--    <mat-error *ngIf=\"hasErrors\">{{firstError}}</mat-error>-->\n    <!--    <aup-icon *ngIf=\"iconPrefix\" matPrefix [icon]=\"iconPrefix\"></aup-icon>-->\n  </mat-form-field>\n  <aup-command *ngIf=\"editCommand.enabled$.value\" [command]=\"editCommand\" [faceModel]=\"editFaceModel\"></aup-command>\n</div>\n<aup-in-place-interaction-context [animateFirstActivity]=\"false\"></aup-in-place-interaction-context>\n" }]
        }], ctorParameters: function () { return [{ type: InteractionService }]; }, propDecorators: { editorModel: [{
                type: Input
            }], facesModel: [{
                type: Input
            }], faces: [{
                type: Input
            }], interactionContext: [{
                type: ViewChild,
                args: [InPlaceInteractionContextComponent]
            }], label: [{
                type: Input
            }], placeHolder: [{
                type: Input
            }], placeHolderModel: [{
                type: Input
            }] } });
(function (InlineStringEditorComponent) {
    InlineStringEditorComponent.DEFAULT_FACES = {
        edit: {
            icon: () => 'mat:edit'
        },
        save: {
            icon: () => 'mat:check'
        },
        cancel: {
            icon: () => 'mat:clear'
        }
    };
})(InlineStringEditorComponent || (InlineStringEditorComponent = {}));

class InteractionModule {
}
InteractionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
InteractionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: InteractionModule, declarations: [ActivityContainerComponent,
        ConfirmationDialogComponent,
        ConfirmThenDialogComponent,
        ConfirmThenExecuteDialogComponent,
        AlertDialogComponent,
        ActivityOutletComponent,
        InPlaceInteractionContextComponent,
        AddItemInteractionContextComponent,
        ActivityActionsComponent,
        PopupInteractionContextComponent,
        StringInputActivity,
        SelectInputActivity,
        InputActivity,
        InteractionContextTriggerFor,
        Activity,
        ActivityTitleComponent,
        ActivityBodyComponent,
        ActivityActionsComponent,
        AbstractActivityTriggerComponent,
        PopupActivityTriggerComponent,
        InlineActivityTriggerComponent,
        ModalActivityTriggerComponent,
        AddCardActivityComponent,
        InlineStringEditorComponent,
        AbstractDialogComponent,
        AbstractConfirmDialogComponent], imports: [CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatTabsModule,
        PortalModule,
        RouterModule,
        MatIconModule,
        DirectivesModule,
        FlexModule,
        GridModule,
        ComponentsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        A11yModule], exports: [ActivityContainerComponent,
        ActivityOutletComponent,
        ActivityTitleComponent,
        InPlaceInteractionContextComponent,
        AddItemInteractionContextComponent,
        ActivityActionsComponent,
        PopupInteractionContextComponent,
        InteractionContextTriggerFor,
        StringInputActivity,
        SelectInputActivity,
        ActivityBodyComponent,
        PopupActivityTriggerComponent,
        InlineActivityTriggerComponent,
        ModalActivityTriggerComponent,
        AddCardActivityComponent,
        InlineStringEditorComponent] });
InteractionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionModule, providers: [
        InteractionService
        // {
        //   provide: MAT_TABS_CONFIG, useValue: { animationDuration: "2s" }
        // }
    ], imports: [CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatTabsModule,
        PortalModule,
        RouterModule,
        MatIconModule,
        DirectivesModule,
        FlexModule,
        GridModule,
        ComponentsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        A11yModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: InteractionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatDialogModule,
                        MatTabsModule,
                        PortalModule,
                        RouterModule,
                        MatIconModule,
                        DirectivesModule,
                        FlexModule,
                        GridModule,
                        ComponentsModule,
                        FormsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        A11yModule
                    ],
                    declarations: [
                        ActivityContainerComponent,
                        ConfirmationDialogComponent,
                        ConfirmThenDialogComponent,
                        ConfirmThenExecuteDialogComponent,
                        AlertDialogComponent,
                        ActivityOutletComponent,
                        InPlaceInteractionContextComponent,
                        AddItemInteractionContextComponent,
                        ActivityActionsComponent,
                        PopupInteractionContextComponent,
                        StringInputActivity,
                        SelectInputActivity,
                        InputActivity,
                        InteractionContextTriggerFor,
                        Activity,
                        ActivityTitleComponent,
                        ActivityBodyComponent,
                        ActivityActionsComponent,
                        AbstractActivityTriggerComponent,
                        PopupActivityTriggerComponent,
                        InlineActivityTriggerComponent,
                        ModalActivityTriggerComponent,
                        AddCardActivityComponent,
                        InlineStringEditorComponent,
                        AbstractDialogComponent,
                        AbstractConfirmDialogComponent,
                    ],
                    exports: [
                        ActivityContainerComponent,
                        ActivityOutletComponent,
                        ActivityTitleComponent,
                        InPlaceInteractionContextComponent,
                        AddItemInteractionContextComponent,
                        ActivityActionsComponent,
                        PopupInteractionContextComponent,
                        InteractionContextTriggerFor,
                        StringInputActivity,
                        SelectInputActivity,
                        ActivityBodyComponent,
                        PopupActivityTriggerComponent,
                        InlineActivityTriggerComponent,
                        ModalActivityTriggerComponent,
                        AddCardActivityComponent,
                        InlineStringEditorComponent,
                    ],
                    providers: [
                        InteractionService
                        // {
                        //   provide: MAT_TABS_CONFIG, useValue: { animationDuration: "2s" }
                        // }
                    ]
                }]
        }] });

const PARAMETER_DEFINITION_KEY = Symbol('parameterDefinition');
class ParameterDefinition {
    constructor(propertyName, options, urlFormat) {
        this.propertyName = propertyName;
        this.urlFormat = urlFormat;
        this.options = Opts.get(options);
        this.remember = this.options.getOptional('remember', false);
        this.defaultValue = this.options.getOptional('defaultValue', null);
    }
    get name() {
        return this.options.getOptional('as', this.propertyName);
    }
    // @Trace()
    get isRouteParameter() {
        return !!this.urlFormat;
    }
    createBackingModel() {
        const model = this.backingModelFactory();
        model[PARAMETER_DEFINITION_KEY] = this;
        return model;
    }
    getOptionValue(key) {
        return this.options.getOptional(key, null);
    }
    // @Trace()
    async sanitise(value, visit, placeHistory, injector, isPopState) {
        // console.log(`sanitise(${this.propertyName})`)
        value = await this.sanitiseMissing(visit, placeHistory, value);
        value = await this.runCustomSanitiser(value, visit, placeHistory, injector, isPopState);
        return value;
    }
    async runCustomSanitiser(value, visit, placeHistory, injector, isPopState) {
        const customSanitiser = this.prepareCustomSanitiser(injector);
        return customSanitiser ? customSanitiser.sanitise(value, visit, injector) : value;
    }
    sanitiseMissing(visit, placeHistory, value) {
        if (this.isMissingFrom(visit)) {
            const returningFromSomewhereElse = !placeHistory.lastVisitIncluded(visit.placeDefinition);
            if (returningFromSomewhereElse) {
                const lastKnownVisit = placeHistory.getMostRecentVisitFor(visit.placeDefinition);
                if (this.remember && lastKnownVisit) {
                    value = lastKnownVisit.getParameterValue(this);
                }
                value = this.isEmptyValue(value) ? this.defaultValue : value;
            }
        }
        return value;
    }
    prepareCustomSanitiser(injector) {
        const customSanitiser = this.options.getOptional('sanitiser', null);
        if (isFunction(customSanitiser)) {
            return injector.get(customSanitiser);
        }
        if (isObject(customSanitiser)) {
            return isFunction(customSanitiser['sanitise']) ?
                customSanitiser :
                lang$1.illegalState(`expected @VisitParameter({sanitiser: ...}) for ${this.propertyName} to be a constructor or instance of ParameterSanitiser, got: ` + customSanitiser);
        }
        return undefined;
    }
    isMissingFrom(visit) {
        return !visit.hasParameter(this);
    }
}
(function (ParameterDefinition) {
    class RouteId extends ParameterDefinition {
        constructor() {
            super(...arguments);
            this.isRouteId = true;
            this.isArray = false;
            this.backingModelFactory = () => new MutableValueModel();
        }
        isEmptyValue(value) {
            return isNil(value);
        }
        hasChanged(a, b) {
            return a !== b;
        }
    }
    ParameterDefinition.RouteId = RouteId;
    class ValueParameter extends ParameterDefinition {
        constructor() {
            super(...arguments);
            this.isRouteId = false;
            this.isArray = false;
            this.backingModelFactory = () => new MutableValueModel();
        }
        isEmptyValue(value) {
            return isNil(value);
        }
        hasChanged(a, b) {
            return a !== b;
        }
    }
    ParameterDefinition.ValueParameter = ValueParameter;
    class ArrayParameter extends ParameterDefinition {
        constructor(parameterName, options, urlFormat) {
            super(parameterName, options, urlFormat);
            this.isRouteId = false;
            this.isArray = true;
            this.backingModelFactory = () => new MutableListModel();
        }
        isEmptyValue(value) {
            return isNil(value) || value.length < 1;
        }
        hasChanged(a, b) {
            return !isEqual(a, b);
        }
    }
    ParameterDefinition.ArrayParameter = ArrayParameter;
    function get(model) {
        const parameterDefinition = model[PARAMETER_DEFINITION_KEY];
        if (!parameterDefinition) {
            lang$1.illegalArgument('model hasn\'t been annotated with @VisitParameter, @VisitParameterList or @RouteId');
        }
        return parameterDefinition;
    }
    ParameterDefinition.get = get;
})(ParameterDefinition || (ParameterDefinition = {}));

class PlaceDefinition {
    constructor(component, path, authenticate, role, data, routeParameters, children, redirectToFirstChild) {
        this.component = component;
        this.path = path;
        this.authenticate = authenticate;
        this.role = role;
        this.data = data;
        this.routeParameters = routeParameters;
        this.children = children;
        this.redirectToFirstChild = redirectToFirstChild;
    }
    hasRouteId() {
        return !!this.getRouteIdParameterDef();
    }
    getRouteIdParameterDef() {
        return this.routeParameters.find(p => p.isRouteId);
    }
    getRouteParameterDefs(includeRouteId = false) {
        return this.getVisitParameterDefs({ includeRouteId, includeRouteParameters: true });
    }
    getVisitParameterDefs(include) {
        const opts = Opts.get(include);
        // includes
        const includeRouteId = !include || opts.getOptional('includeRouteId', false);
        const includeRouteParameters = !include || opts.getOptional('includeRouteParameters', false);
        const includeNonRouteParameters = !include || opts.getOptional('includeNonRouteParameters', false);
        return this.routeParameters.filter(p => {
            return (includeRouteId && p.isRouteId)
                || (includeRouteParameters && p.isRouteParameter && !p.isRouteId) // route id is included in the line above
                || (includeNonRouteParameters && !p.isRouteParameter);
        });
    }
    getPlaceData(key, defaultValue) {
        return this.data ?
            isNil(this.data[key]) ? defaultValue : this.data[key] :
            defaultValue;
    }
    searchPlaceData(keys, defaultValue) {
        if (this.data) {
            const found = keys.find(key => !isNil(this.data[key]));
            return found ? this.data[found] : defaultValue;
        }
        else {
            return defaultValue;
        }
    }
    getRouteIdFrom(visit) {
        const routeIdParameterDef = this.getRouteIdParameterDef();
        return routeIdParameterDef ? visit.getParameterValue(routeIdParameterDef) : null;
    }
    getFormattedRouteId(visit) {
        // Note: RouteIds are always present in the url and are just empty strings when not defined.  This is
        // mandated by the fact that redirects from <path> to <path>/:id always include the id parameter as
        // an empty string.
        return visit.hasRouteId() ? this.getRouteIdParameterDef().urlFormat.format(visit.getRouteId()) : "";
    }
    // @Trace()
    getFormattedRouteParameters(visit, includeRouteId = false) {
        const result = {};
        this.getVisitParameterDefs({
            includeRouteId, includeRouteParameters: true
        }).forEach(def => {
            const value = visit.getParameterValue(def);
            if (!def.isEmptyValue(value)) {
                if (def.isArray) {
                    assert.isArray(value);
                    result[def.name] = value.map(v => def.urlFormat.format(v));
                }
                else {
                    assert.isFalsey(Array.isArray(value));
                    result[def.name] = def.urlFormat.format(value);
                }
            }
        });
        return result;
    }
    getNonRouteParameters(visit) {
        const result = {};
        this.getVisitParameterDefs({ includeNonRouteParameters: true }).forEach(def => {
            const value = visit.getParameterValue(def);
            if (!def.isEmptyValue(value)) {
                result[def.name] = value;
            }
        });
        return result;
    }
    // @Trace()
    parseRouteParams(params) {
        const result = {};
        this.getVisitParameterDefs({
            includeRouteId: true,
            includeRouteParameters: true,
            includeNonRouteParameters: false
        }).forEach(def => {
            // params will return null for non existent names
            if (params.has(def.name)) {
                if (def.isArray) {
                    // const values = params.getAll(def.name); // TODO: EEEK getAll is returning ["1,2,3,4"] when we gave it ["1","2","3","4"].
                    const values = params.get(def.name).split(',').map(s => s.trim());
                    result[def.name] = values.map(v => def.urlFormat.parse(v));
                }
                else {
                    const value = params.get(def.name);
                    if (def.isRouteId) { // TODO: Move this to parameter def so it's a strategy pattern
                        // because our id routes redirect if the id isn't present we always have a id
                        // parameter in our params.  This will bugger our remember and defaultvalue sanitisation
                        // as it'll see that the id is present (event thought its a blank string).
                        if (!isEmpty(value)) {
                            result[def.name] = def.urlFormat.parse(value);
                        }
                    }
                    else {
                        result[def.name] = def.urlFormat.parse(value);
                    }
                }
            }
        });
        return result;
    }
}
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", ParameterDefinition)
], PlaceDefinition.prototype, "getRouteIdParameterDef", null);
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Array)
], PlaceDefinition.prototype, "getRouteParameterDefs", null);
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Array)
], PlaceDefinition.prototype, "getVisitParameterDefs", null);

// RAKE: making this Symbol(...) broke things.
const DEFINITION_META_DATA_KEY = 'PLACE_DEFINITION_OPTIONS';
// this one seems ok.
const ROUTE_PARAMETER_LIST_KEY = Symbol('place:route:parameters');
class ParameterChangeInterceptor {
    constructor(parameterDef, model, callback, options) {
    }
    async canProceed(nextState, interactionContext) {
        return true;
    }
}
class PlaceComponent extends DisposableComponent {
    constructor() {
        super();
        this._placeReadyCallbacks = [];
        this.visitModel = new MutableValueModel();
        this._inVisitUpdate = new Guard();
        this._active = new MutableValueModel(false);
        this._parameterChangeInterceptors = [];
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        when(this._active).becomesTruthy(() => this._notifyPlaceReady());
        this.childPlaces = this.placeDefinition.children.map(d => d.component);
    }
    initialiseVisit(visit, notifyVisitChanged) {
        assert.isNil(this.visitModel.value);
        const { when } = Dsl.disposeWith(this);
        this.visitModel.value = visit;
        DebugContext.getOrCreate(this.visitModel).tag(`${this.placeDefinition.component.name}.visitModel`);
        // we track if the any of the bindings updated the route.  If so we remember it and update the
        // route in one go at the end.
        this.placeDefinition
            .getVisitParameterDefs()
            .forEach(parameterDef => this.installAndInitialiseBinding(visit, parameterDef));
        when(this.visitModel).changes((current, previous) => {
            notifyVisitChanged(current, previous);
        }, { unless: this._inVisitUpdate });
        // TODO: this needs to do a replace url option so that the new url isn't put in the history.... for
        //       now we're not doing it as it's a fair bit of effort and will only affect people if they're
        //       cutting and pasting urls to each other.
        // // the binding process can update the visit (e.g. if a selection model has already selected during
        // // component construction) and there was no value specified in the route
        // if (visit.hasRoutingChangedFrom(this.visitModel.value)) {
        //   notifyVisitChanged(this.visitModel.value, visit)
        // }
    }
    updateVisit(visit) {
        assert.isTruthy(this.isInitialised());
        assert.notNil(visit);
        this._inVisitUpdate.whileTrue(() => {
            this.visitModel.value = visit;
        });
    }
    isInitialised() {
        return !!this.visitModel.value;
    }
    // @Trace()
    /**
     * Initialised the component bindings.  If any binding has an initial model value (e.g. a selection model
     * initialised during the constructor) and the route has nothing, then the visit will be udpated and this
     * method will return ture to nofiy the the visit has changed.
     */
    installAndInitialiseBinding(initialVisit, parameterDef) {
        const model = this[parameterDef.propertyName];
        DebugContext.tag(model, `${this.placeDefinition.component.name}.${parameterDef.propertyName}`);
        const binding = this.registerDisposable(new Binding(this.visitModel, model, {
            toRight(visit) {
                const value = visit.getParameterValue(parameterDef);
                // console.log('push to component', { name: parameterDef.name, value, visit });
                return value;
            },
            toLeft(value, currentVisit) {
                // console.log('push to route', { name: parameterDef.name, value, currentVisit });
                return currentVisit.replace(parameterDef, value);
            }
        }));
        // Now we need to initialise the binding direction.  If we have a value in the Url then we should always push
        // that to the view.  If we don't and the view already has a value (e.g. a selection model has already initialised in the
        // component constructor) then we should push that to the route.
        const isInVisit = !isNil(initialVisit.getParameterValue(parameterDef));
        const isInModel = !isNil(model.value);
        if (!isInVisit && isInModel) {
            binding.writeLeft(); // push it to the route
        }
        else {
            binding.writeRight(); // push it to the model
        }
    }
    get placeDefinition() {
        const definition = PlaceComponent.getDefinition(this.constructor);
        if (!definition) {
            lang.illegalState(`${this.constructor.name} extends PlaceComponent but doesn't have @Place({..}) decorator.`);
        }
        return definition;
    }
    get active() {
        return this._active.readonly;
    }
    /**
     * Called by the router to see if this component can deactivate.  This isn't called for route parameter changes.
     * @param interactionContext
     */
    async _canLeavePlace(interactionContext) {
        return this.canDeactivate ? this.canDeactivate(interactionContext) : true;
    }
    /**
     * Called by the router to see if this component can deactivate.  This isn't called for route parameter changes.
     * @param interactionContext
     * @param nextState
     */
    async _canChangeRouteParameters(interactionContext, nextState) {
        if (this._parameterChangeInterceptors.length > 0) {
            const visit = nextState.createVisitFor(this.placeDefinition);
            for (let i = 0; i < this._parameterChangeInterceptors.length; i++) {
                const interceptor = this._parameterChangeInterceptors[i];
                const keepGoing = await interceptor.canProceed(visit, interactionContext);
                if (!keepGoing) {
                    return false;
                }
            }
        }
        return true;
    }
    /**
     * Called by the router when the place is ready to interact after any animations have run.
     */
    _notifyActive(active) {
        this._active.value = active;
    }
    /**
     * Called by the router when the place is ready to interact after any animations have run.
     */
    _notifyPlaceReady() {
        if (this.onPlaceReady.length === 1) {
            this._placeReadyCallbacks.forEach(callback => callback());
        }
        else {
            console.warn('Overriding PlaceComponent.onPlaceReady has been deprecated.  Use PlaceComponent.onPlaceReady(() => {... do stuff...}) instead.');
            this.onPlaceReady(undefined);
        }
    }
    onPlaceReady(callback) {
        this._placeReadyCallbacks.push(callback);
    }
    interceptVisitParameterChange(model, callback, options) {
        const parameterDef = ParameterDefinition.get(model);
        this._parameterChangeInterceptors.push(new ParameterChangeInterceptor(parameterDef, model, callback, options));
    }
}
PlaceComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceComponent, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PlaceComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.1.2", type: PlaceComponent, usesInheritance: true, ngImport: i0 });
__decorate([
    Memoize(),
    __metadata("design:type", PlaceDefinition),
    __metadata("design:paramtypes", [])
], PlaceComponent.prototype, "placeDefinition", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return []; }, propDecorators: { placeDefinition: [] } });
(function (PlaceComponent) {
    function isPlaceComponentConstructor(target) {
        return lang.constructorChain(target).includes(PlaceComponent);
    }
    PlaceComponent.isPlaceComponentConstructor = isPlaceComponentConstructor;
    function getRouteParameters(klass) {
        return Klass.get(klass).getMetadataList(ROUTE_PARAMETER_LIST_KEY);
    }
    PlaceComponent.getRouteParameters = getRouteParameters;
    function getDefinition(snapshotOrConstructor) {
        if (snapshotOrConstructor instanceof ActivatedRouteSnapshot) {
            const component = snapshotOrConstructor.component;
            if (!isPlaceComponentConstructor(component)) {
                throw new Error(`ActivatedRouteSnapshot component is not a PlaceComponent, got ${component}`);
            }
            return Reflect.getMetadata(DEFINITION_META_DATA_KEY, component);
        }
        else {
            return Reflect.getMetadata(DEFINITION_META_DATA_KEY, snapshotOrConstructor);
        }
    }
    PlaceComponent.getDefinition = getDefinition;
    function injectDefinition(klass, definition) {
        Reflect.defineMetadata(DEFINITION_META_DATA_KEY, definition, klass);
    }
    PlaceComponent.injectDefinition = injectDefinition;
})(PlaceComponent || (PlaceComponent = {}));

const AUP_PLACE_CONFIG = new InjectionToken('AUP_PLACE_CONFIG');

class NotAuthorisedNoticeComponent {
    constructor() {
    }
}
NotAuthorisedNoticeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NotAuthorisedNoticeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NotAuthorisedNoticeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: NotAuthorisedNoticeComponent, selector: "aup-not-authorised-notice", ngImport: i0, template: "<p>You are not authorised to access this page</p>\n", styles: [":host{display:flex;flex-direction:column;align-items:center;justify-content:center}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NotAuthorisedNoticeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-not-authorised-notice', template: "<p>You are not authorised to access this page</p>\n", styles: [":host{display:flex;flex-direction:column;align-items:center;justify-content:center}\n"] }]
        }], ctorParameters: function () { return []; } });

// Freezes the state of the components at the start of the animation.
const animationStartStyle = style({ position: 'absolute', top: '0', left: '0', bottom: '0', right: '0' });
const left = [
    query(':enter, :leave', animationStartStyle, { optional: true }),
    group([
        query(':enter', [
            style({ transform: 'translateX(-100%)' }),
            animate('{{duration}} ease-out', style({ transform: 'translateX(0%)' }))
        ], {
            optional: true
        }),
        query(':leave', [
            style({ transform: 'translateX(0%)' }),
            animate('{{duration}} ease-out', style({ transform: 'translateX(100%)' }))
        ], {
            optional: true
        })
    ])
];
const right = [
    query(':enter, :leave', animationStartStyle, { optional: true }),
    group([
        query(':enter', [
            style({ transform: 'translateX(100%)', minHeight: '1px' }),
            animate('{{duration}} ease-out', style({ transform: 'translateX(0%)' }))
        ], {
            optional: true
        }),
        query(':leave', [style({ transform: 'translateX(0%)' }), animate('{{duration}} ease-out', style({
                transform: 'translateX(-100%)',
                minHeight: '1px'
            }))], {
            optional: true
        })
    ])
];
function leftRightPlaceAnimation(duration) {
    return trigger('routeAnimations', [
        transition(':increment', right, { params: { duration: duration } }),
        transition(':decrement', left, { params: { duration: duration } })
    ]);
}
const LEFT_RIGHT_PLACE_ANIMATION = leftRightPlaceAnimation('0.3s');

const AUP_UNAUTHORISED_PLACE_NOTICE_COMPONENT = new InjectionToken('AUP_UNAUTHORISED_PLACE_COMPONENT');
class PlaceOutletComponent extends DisposableComponent {
    constructor(router, placeRouter, placeConfig, unauthorisedPlaceNotice, parentOutlet, cdr) {
        super();
        this.router = router;
        this.placeRouter = placeRouter;
        this.placeConfig = placeConfig;
        this.cdr = cdr;
        this.placeChanged = new EventEmitter();
        this.outletActivated = new MutableValueModel(false);
        this._activatedRouteModel = new MutableValueModel();
        this._activePlaceModel = new MutableValueModel();
        this.initialPlaceIndex = null;
        this._isPushingVisitToRoute = new MutableValueModel(false);
        this.isVeryFirstLoad = true;
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.parentOutletModel = new MutableValueModel(parentOutlet);
        const defaultPlaceAnimationOrder = chain(this.parentOutletModel)
            .pullValueModel(o => o.activePlaceModel)
            .pluck('placeDefinition')
            .pluckList('children')
            .pluck('component');
        const activatePlaceType = chain(this.activePlaceModel).map(p => p.constructor);
        this.placesInAnimationOrder = chain(this.customPlaceAnimationOrderModel)
            .otherwise(defaultPlaceAnimationOrder);
        this.activePlaceAnimationPosition = this.placesInAnimationOrder
            .reduce((placesInOrder) => {
            let placeIndex = 0;
            if (activatePlaceType.value) {
                placeIndex = placesInOrder.indexOf(activatePlaceType.value);
                if (isNil(this.initialPlaceIndex)) {
                    this.initialPlaceIndex = placeIndex;
                }
            }
            return isNil(this.initialPlaceIndex) ? 0 : placeIndex - this.initialPlaceIndex;
        }, { dependsOn: activatePlaceType });
        this.animationSupported = this.placesInAnimationOrder.count().isGreaterThan(0);
        this.animationEnabled = valueOf.all(this.animateModel, this.animationSupported).areTruthy();
        // Extract our visit model from the place router.
        this._activePlaceDefinition = chain(this._activePlaceModel).pluck('placeDefinition');
        this.routerVisitModel = chain(placeRouter.state$).map(state => state.getVisitFor(this._activePlaceDefinition.value), { dependsOn: this._activePlaceDefinition });
        this.navigationInProgress = chain(this.placeRouter.navigationInProgress$);
        when(this.navigationInProgress).becomesFalsey(() => {
            this.checkStateAndInitialise();
        });
        when(this.outletActivated).becomesTruthy(() => {
            this.checkStateAndInitialise();
        });
        chain(this._activePlaceModel)
            .postponeWhile(this.navigationInProgress)
            .subscribe(place => this.placeChanged.emit(place));
        this.authorised = chain(placeRouter.accessGuard).map(guard => guard.isAuthorised(this._activePlaceDefinition.value), {
            dependsOn: this._activePlaceDefinition,
            postponeWhile: chain(this._activePlaceDefinition).isNil()
        }).otherwise(true); // if we don't have a place def yet we need to show the outlet so we get one injected.
        this.notAuthorisedNoticePortal = new ComponentPortal(unauthorisedPlaceNotice ?? NotAuthorisedNoticeComponent);
    }
    // @Trace()
    ngOnInit() {
    }
    // @Trace()
    getAnimationOrder() {
        return this.activePlaceAnimationPosition.value;
    }
    get animationDuration() {
        return this.placeConfig && this.placeConfig.animationDuration ? this.placeConfig.animationDuration : '500ms';
    }
    get isAuthorised() {
        return this.authorised.value;
    }
    // @Trace()
    navigate(visit) {
        // const place = this.placesInAnimationOrder.query().findMatching(p => visit.placeDefinition.component === p);
        // if (!place) {
        //     lang.illegalState()
        // }
        this.placeRouter.navigate(visit, {
            relativeTo: this.parentOutlet ? this.parentOutlet.activatedRouteModel.value : null
        });
    }
    get parentOutlet() {
        return this.parentOutletModel.value;
    }
    get activePlaceModel() {
        return this._activePlaceModel.readonly;
    }
    get activatedRouteModel() {
        return this._activatedRouteModel.readonly;
    }
    // @Trace()
    onOutletActivated(routerOutlet, place) {
        this._activatedRouteModel.value = routerOutlet.activatedRoute;
        this._activePlaceModel.value = place;
        this.validateAnimationState(place);
        this.outletActivated.value = true;
        this.checkStateAndInitialise();
    }
    validateAnimationState(place) {
        if (this.animateModel.value) {
            if (this.placesInAnimationOrder.length < 1) {
                console.error('PlaceOutlet.animate === true but placeAnimationOrder has not been set. Animation is disabled.');
            }
            else {
                if (!this.placesInAnimationOrder.query().includes(place.placeDefinition.component)) {
                    console.error(`PlaceOutlet.animate === true but placeAnimationOrder doesn't contain ${place.placeDefinition.component.name}.`);
                }
            }
        }
    }
    // @Trace()
    onOutletDeactivated() {
        this.outletActivated.value = false;
        this._activePlaceModel.value = null;
        this._activatedRouteModel.value = null;
    }
    // @Trace()
    checkStateAndInitialise() {
        const routerVisit = this.routerVisitModel.value;
        const activePlace = this.activePlaceModel.value;
        if (routerVisit && activePlace && !activePlace.isInitialised()) {
            if (routerVisit.placeDefinition !== activePlace.placeDefinition) {
                lang.illegalState('wrong visit!!!');
            }
            this.initialisePlace(routerVisit, activePlace);
            this.cdr.detectChanges();
        }
    }
    initialisePlace(routerVisit, activePlace) {
        const visitModel = new MutableValueModel(routerVisit);
        DebugContext.tag(visitModel, `PlaceOutletComponent[${activePlace.constructor.name})].visitModel`);
        activePlace.initialiseVisit(routerVisit, (current, previous) => {
            this.pushVisitChangeToRoute(previous, current);
        });
        const finishPlaceLoad = () => {
            this._activePlaceModel.value._notifyActive(true);
        };
        if (!this.animationEnabled.value || this.isVeryFirstLoad) {
            // if animation is disabled or this is the very first load then
            // we won't get our animation done callback so we finish the
            // process here and now.
            this.isVeryFirstLoad = false;
            finishPlaceLoad();
        }
        else {
            this.onAnimationFinishedJob = finishPlaceLoad;
        }
        const { when, chain, valueOf } = Dsl.disposeWith(activePlace);
        when(this.routerVisitModel)
            .changes(visit => {
            // console.log("routerVisitModel.change", { routerVisitModel: this.routerVisitModel.value })
            this.pushVisitChangeToComponent(activePlace, visit);
        }, {
            unless: valueOf.any(this._isPushingVisitToRoute, this.routerVisitModel.isNil()).areTruthy()
        });
    }
    pushVisitChangeToComponent(activePlace, visit) {
        activePlace.updateVisit(visit);
    }
    async pushVisitChangeToRoute(previous, current) {
        try {
            this._isPushingVisitToRoute.value = true;
            await this.placeRouter.pushVisitChangesToRoute(previous, current);
        }
        finally {
            this._isPushingVisitToRoute.value = false;
        }
        // sanitisers may have adjusted other values in the visit to we check and write it back.
        const routerVisit = this.routerVisitModel.value; // this is occasionally null... need to investigate if that's a normal state or not.
        if (routerVisit && current.hasRoutingChangedFrom(routerVisit)) {
            this.pushVisitChangeToComponent(this.activePlaceModel.value, routerVisit);
        }
    }
    // @Trace()
    animationStarted() {
        // console.log({ activePlace: this._activePlaceModel.value });
    }
    // @Trace()
    animationDone() {
        if (this.onAnimationFinishedJob) {
            this.onAnimationFinishedJob();
            this.onAnimationFinishedJob = undefined;
        }
    }
}
PlaceOutletComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceOutletComponent, deps: [{ token: i1$4.Router }, { token: PlaceRouter }, { token: AUP_PLACE_CONFIG, optional: true }, { token: AUP_UNAUTHORISED_PLACE_NOTICE_COMPONENT, optional: true }, { token: PlaceOutletComponent, optional: true, skipSelf: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
PlaceOutletComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: PlaceOutletComponent, selector: "aup-place-outlet", inputs: { animate: "animate", animateModel: "animateModel", customPlaceAnimationOrderModel: ["placeAnimationOrderModel", "customPlaceAnimationOrderModel"], customPlaceAnimationOrder: ["placeAnimationOrder", "customPlaceAnimationOrder"] }, outputs: { placeChanged: "placeChanged" }, host: { properties: { "class.authorised": "this.isAuthorised" } }, viewQueries: [{ propertyName: "routerOut", first: true, predicate: ["routeOutlet"], descendants: true, static: true }], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"animationEnabled.value\">\n  <div class=\"router-outlet-container\"\n       cdkScrollable\n       [@routeAnimations]=\"{value: getAnimationOrder(), params:{duration: animationDuration}}\"\n       (@routeAnimations.start)=\"animationStarted()\"\n       (@routeAnimations.done)=\"animationDone()\"\n  >\n    <router-outlet #routerOutlet=\"outlet\"\n                   (activate)=\"onOutletActivated(routerOutlet, $event)\"\n                   (deactivate)=\"onOutletDeactivated()\">\n    </router-outlet>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!animationEnabled.value\">\n  <div class=\"router-outlet-container\"\n       cdkScrollable>\n    <router-outlet #routerOutlet=\"outlet\"\n                   (activate)=\"onOutletActivated(routerOutlet, $event)\"\n                   (deactivate)=\"onOutletDeactivated()\">\n    </router-outlet>\n  </div>\n</ng-container>\n\n<div  class=\"not-authorised-component-container\" *ngIf=\"!authorised.value\">\n  <ng-template [cdkPortalOutlet]=\"notAuthorisedNoticePortal\"></ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:column;min-height:0}:host:not(.authorised) .router-outlet-container{display:none}.router-outlet-container{flex:1;display:block;position:relative;min-height:0;overflow-x:hidden;overflow-y:auto}router-outlet{display:none}.not-authorised-component-container{flex:1;display:grid;grid-template-columns:1fr;grid-template-rows:1fr}\n"], dependencies: [{ kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.RouterOutlet, selector: "router-outlet", outputs: ["activate", "deactivate", "attach", "detach"], exportAs: ["outlet"] }, { kind: "directive", type: i1$2.CdkScrollable, selector: "[cdk-scrollable], [cdkScrollable]" }, { kind: "directive", type: i2$7.CdkPortalOutlet, selector: "[cdkPortalOutlet]", inputs: ["cdkPortalOutlet"], outputs: ["attached"], exportAs: ["cdkPortalOutlet"] }], animations: [LEFT_RIGHT_PLACE_ANIMATION] });
__decorate([
    StoreInValueModel('animateModel'),
    __metadata("design:type", Boolean)
], PlaceOutletComponent.prototype, "animate", void 0);
__decorate([
    TrackExternal({ defaultValue: true }),
    __metadata("design:type", ValueModel)
], PlaceOutletComponent.prototype, "animateModel", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ListModel)
], PlaceOutletComponent.prototype, "customPlaceAnimationOrderModel", void 0);
__decorate([
    StoreInListModel('customPlaceAnimationOrderModel'),
    __metadata("design:type", Array)
], PlaceOutletComponent.prototype, "customPlaceAnimationOrder", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceOutletComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-place-outlet', animations: [LEFT_RIGHT_PLACE_ANIMATION], template: "<ng-container *ngIf=\"animationEnabled.value\">\n  <div class=\"router-outlet-container\"\n       cdkScrollable\n       [@routeAnimations]=\"{value: getAnimationOrder(), params:{duration: animationDuration}}\"\n       (@routeAnimations.start)=\"animationStarted()\"\n       (@routeAnimations.done)=\"animationDone()\"\n  >\n    <router-outlet #routerOutlet=\"outlet\"\n                   (activate)=\"onOutletActivated(routerOutlet, $event)\"\n                   (deactivate)=\"onOutletDeactivated()\">\n    </router-outlet>\n  </div>\n</ng-container>\n\n<ng-container *ngIf=\"!animationEnabled.value\">\n  <div class=\"router-outlet-container\"\n       cdkScrollable>\n    <router-outlet #routerOutlet=\"outlet\"\n                   (activate)=\"onOutletActivated(routerOutlet, $event)\"\n                   (deactivate)=\"onOutletDeactivated()\">\n    </router-outlet>\n  </div>\n</ng-container>\n\n<div  class=\"not-authorised-component-container\" *ngIf=\"!authorised.value\">\n  <ng-template [cdkPortalOutlet]=\"notAuthorisedNoticePortal\"></ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:column;min-height:0}:host:not(.authorised) .router-outlet-container{display:none}.router-outlet-container{flex:1;display:block;position:relative;min-height:0;overflow-x:hidden;overflow-y:auto}router-outlet{display:none}.not-authorised-component-container{flex:1;display:grid;grid-template-columns:1fr;grid-template-rows:1fr}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.Router }, { type: PlaceRouter }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AUP_PLACE_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [AUP_UNAUTHORISED_PLACE_NOTICE_COMPONENT]
                }] }, { type: PlaceOutletComponent, decorators: [{
                    type: SkipSelf
                }, {
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { animate: [{
                type: Input
            }], animateModel: [{
                type: Input
            }], customPlaceAnimationOrderModel: [{
                type: Input,
                args: ['placeAnimationOrderModel']
            }], customPlaceAnimationOrder: [{
                type: Input,
                args: ['placeAnimationOrder']
            }], placeChanged: [{
                type: Output
            }], routerOut: [{
                type: ViewChild,
                args: ['routeOutlet', { static: true }]
            }], isAuthorised: [{
                type: HostBinding,
                args: ["class.authorised"]
            }] } });

class AbstractPlaceNavigationComponent extends DisposableComponent {
    constructor(placeRouter) {
        super();
        this.placeRouter = placeRouter;
        this._activePlaceComponent = this.registerDisposable(new DelegatingValueModel());
        this.trackByPlaceDef = (index, data) => data.place;
        const { chain, valueOf, before, when, after, observe, switchOn } = Dsl.disposeWith(this);
        this.placeDefinitions = chain(this.placesModel)
            .map(c => PlaceComponent.getDefinition(c))
            .select(d => {
            const guard = placeRouter.accessGuard.value;
            const state = placeRouter.state$.value;
            return guard.isAuthorised(d) || state.isPlaceActive(d);
        }, { dependsOn: [placeRouter.accessGuard, placeRouter.state$] });
        this.commandFactory = Command.createFactory((placeDefinition) => {
            this.placeOutlet.navigate(new Visit(placeDefinition));
        });
        when(this.placeOutletModel).changes(outlet => this.handlePlaceOutLetChanged(outlet), { initialValue: "triggerChange" });
        this.activePlaceDefinition = chain(this._activePlaceComponent).pluck('placeDefinition');
        this.menuItems = chain(this.placeDefinitions).map(d => {
            return {
                place: d,
                active: this.activePlaceDefinition.value === d
            };
        }, {
            dependsOn: this.activePlaceDefinition
        });
        // const txo = new TransactionObserver({ verbose: true }).onEvent(e => console.log(e.name, e.payload));
        // txo.observe('this.placesModel', this.placesModel);
        // txo.observe('this.placeDefinitions', this.placeDefinitions);
        // txo.observe('this.activePlaceDefinition', this.activePlaceDefinition);
        // txo.observe('this.menuItems', this.menuItems);
    }
    handlePlaceOutLetChanged(outlet) {
        this._activePlaceComponent.setDelegate(outlet ? outlet.activePlaceModel : null);
    }
    getNavigationFace(placeDef) {
        const navItem = placeDef.getPlaceData('nav');
        return {
            text: () => navItem ? navItem.title() : placeDef.searchPlaceData(['navTitle', 'title']),
            tooltip: () => navItem && navItem.tooltip ? navItem.tooltip() : placeDef.getPlaceData('navTooltip', null),
            icon: () => navItem && navItem.icon ? navItem.icon() : placeDef.getPlaceData('navIcon', null)
        };
    }
    ngOnInit() {
    }
}
AbstractPlaceNavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractPlaceNavigationComponent, deps: [{ token: PlaceRouter }], target: i0.ɵɵFactoryTarget.Component });
AbstractPlaceNavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: AbstractPlaceNavigationComponent, selector: "ng-component", inputs: { places: "places", placesModel: "placesModel", placeOutlet: "placeOutlet", placeOutletModel: "placeOutletModel" }, usesInheritance: true, ngImport: i0, template: '', isInline: true });
__decorate([
    StoreInListModel('placesModel'),
    __metadata("design:type", Array)
], AbstractPlaceNavigationComponent.prototype, "places", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ListModel)
], AbstractPlaceNavigationComponent.prototype, "placesModel", void 0);
__decorate([
    StoreInValueModel('placeOutletModel'),
    __metadata("design:type", PlaceOutletComponent)
], AbstractPlaceNavigationComponent.prototype, "placeOutlet", void 0);
__decorate([
    TrackExternal(),
    __metadata("design:type", ValueModel)
], AbstractPlaceNavigationComponent.prototype, "placeOutletModel", void 0);
__decorate([
    Memoize(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PlaceDefinition]),
    __metadata("design:returntype", Object)
], AbstractPlaceNavigationComponent.prototype, "getNavigationFace", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AbstractPlaceNavigationComponent, decorators: [{
            type: Component,
            args: [{
                    template: ''
                }]
        }], ctorParameters: function () { return [{ type: PlaceRouter }]; }, propDecorators: { places: [{
                type: Input
            }], placesModel: [{
                type: Input
            }], placeOutlet: [{
                type: Input
            }], placeOutletModel: [{
                type: Input
            }], getNavigationFace: [] } });

class ListPlaceNavComponent extends AbstractPlaceNavigationComponent {
    constructor(router) {
        super(router);
    }
}
ListPlaceNavComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ListPlaceNavComponent, deps: [{ token: PlaceRouter }], target: i0.ɵɵFactoryTarget.Component });
ListPlaceNavComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: ListPlaceNavComponent, selector: "aup-list-place-nav", usesInheritance: true, ngImport: i0, template: "<mat-nav-list fxFlex>\n  <a mat-list-item *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [class.active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-command-face [faces]=\"[getNavigationFace(item.place)]\"></aup-command-face>\n  </a>\n</mat-nav-list>\n", styles: [":host{display:flex;flex-direction:column;--selected-border-color: #838383;--selected-color: inherit;--selected-background: #f1f1f1}mat-nav-list{padding-top:0}a{border-right:2px solid transparent}a.active{border-right:2px solid var(--selected-border-color);background:var(--selected-background);color:var(--selected-color)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i3$2.MatNavList, selector: "mat-nav-list", inputs: ["disableRipple", "disabled"], exportAs: ["matNavList"] }, { kind: "component", type: i3$2.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "directive", type: GarbageCollectorDirective, selector: "[aup-gc]", exportAs: ["aup-gc"] }, { kind: "directive", type: i7$1.DefaultFlexDirective, selector: "  [fxFlex], [fxFlex.xs], [fxFlex.sm], [fxFlex.md],  [fxFlex.lg], [fxFlex.xl], [fxFlex.lt-sm], [fxFlex.lt-md],  [fxFlex.lt-lg], [fxFlex.lt-xl], [fxFlex.gt-xs], [fxFlex.gt-sm],  [fxFlex.gt-md], [fxFlex.gt-lg]", inputs: ["fxFlex", "fxFlex.xs", "fxFlex.sm", "fxFlex.md", "fxFlex.lg", "fxFlex.xl", "fxFlex.lt-sm", "fxFlex.lt-md", "fxFlex.lt-lg", "fxFlex.lt-xl", "fxFlex.gt-xs", "fxFlex.gt-sm", "fxFlex.gt-md", "fxFlex.gt-lg"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: ListPlaceNavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-list-place-nav', template: "<mat-nav-list fxFlex>\n  <a mat-list-item *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [class.active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-command-face [faces]=\"[getNavigationFace(item.place)]\"></aup-command-face>\n  </a>\n</mat-nav-list>\n", styles: [":host{display:flex;flex-direction:column;--selected-border-color: #838383;--selected-color: inherit;--selected-background: #f1f1f1}mat-nav-list{padding-top:0}a{border-right:2px solid transparent}a.active{border-right:2px solid var(--selected-border-color);background:var(--selected-background);color:var(--selected-color)}\n"] }]
        }], ctorParameters: function () { return [{ type: PlaceRouter }]; } });

/**
 * @example
 * // Usage
 * <aup-vertical-place-navigation [places]="placeConstructorArray"
 *                                [placeOutlet]="placeOutletComponent">
 * </aup-vertical-place-navigation>
 * <aup-place-outlet #placeOutletComponent></aup-place-outlet>
 *
 * // CSS overrides:
 * aup-side-place-navigation {
 *   --nav-width: 56px
 *   --nav-expanded-width: 235px
 *   --nav-item-height: var(--nav-width)
 *   --nav-background-color: #555;
 *   --nav-color: rgba(255, 255, 255, 0.9);
 * }
 *
 * // Content Templates:
 * #navEndTemplate
 * <ng-template #navEndTemplate>
 *    <a mat-list-item (click)="logout()" matTooltip="Logout">
 *    <mat-icon>exit_to_app</mat-icon>
 *    <span *ngIf="sideNav.expanded">Logout</span>
 *    </a>
 * </nav-template>
 *
 * // Place nav item in an i18n.yml
 * places:
 *   myPlace:
 *     nav(NavItem):
 *       title: "Activities"
 *       icon: "build"
 *       tooltip: "Alerts, confirms and dialogs"
 *
 * // In your place
 * (at)Place({
 *   path: 'myPlace',
 *   data: {
 *     nav: I18n.places.myPlace.nav
 *   }
 * })
 */
class SidePlaceNavigationComponent extends AbstractPlaceNavigationComponent {
    constructor(router) {
        super(router);
    }
    expandMenu() {
        this.expanded = true;
    }
    collapseMenu() {
        this.expanded = false;
    }
    toggleMenu() {
        this.expanded = !this.expanded;
    }
}
SidePlaceNavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SidePlaceNavigationComponent, deps: [{ token: PlaceRouter }], target: i0.ɵɵFactoryTarget.Component });
SidePlaceNavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: SidePlaceNavigationComponent, selector: "aup-side-place-navigation", inputs: { expanded$: "expanded$", expanded: "expanded" }, host: { properties: { "class.expanded": "this.expanded" } }, queries: [{ propertyName: "navEndTemplate", first: true, predicate: ["navEndTemplate"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<mat-nav-list>\n  <a mat-list-item (click)=\"toggleMenu()\" class=\"home\">\n    <aup-icon class=\"collapsed-only\" icon=\"mat:menu\"></aup-icon>\n    <aup-icon class=\"expanded-only\" icon=\"mat:arrow_back\"></aup-icon>\n    <span class=\"expanded-only\">Menu</span>\n  </a>\n  <a mat-list-item *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [class.active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-icon *ngIf=\"getNavigationFace(item.place).icon()\" [icon]=\"getNavigationFace(item.place).icon()\"></aup-icon>\n    <span class=\"expanded-only\">{{getNavigationFace(item.place).text()}}</span>\n  </a>\n  <span [style.flex]=\"1\"></span>\n  <ng-container *ngIf=\"navEndTemplate\" [ngTemplateOutlet]=\"navEndTemplate\"></ng-container>\n</mat-nav-list>\n", styles: [":host{display:flex;flex-direction:column;--resolved-nav-item-width: var(--nav-width, 56px);--resolved-nav-item-height: var(--nav-item-height, var(--resolved-nav-item-width));--resolved-expanded-width: var(--nav-expanded-width, 235px);--resolved-color: var(--nav-color, rgba(255, 255, 255, .9));--resolved-background-color: var(--nav-background-color, #555);width:var(--resolved-nav-item-width);transition:width 125ms linear;background-color:var(--resolved-background-color);color:var(--resolved-color)}:host.expanded{width:var(--resolved-expanded-width);max-width:var(--resolved-expanded-width)}:host-context(.expanded) .expanded-only{max-width:100%}:host-context(.expanded) .collapsed-only{max-width:0}:host-context(.expanded) .mat-list-item aup-icon:not(.collapsed-only){margin-right:12px}:host-context(.expanded) .mat-list-item span{text-wrap:none;white-space:nowrap}.expanded-only{max-width:0;overflow:hidden}.collapsed-only{max-width:100%;overflow:hidden}mat-nav-list{flex:1;display:flex;flex-direction:column}.mat-list-item{width:var(--resolved-nav-item-width);height:var(--resolved-nav-item-height);color:inherit}.mat-list-item.active{background-color:#444}.mat-list-item.home{text-align:left}mat-icon{color:inherit}mat-icon.flip-horizontal{transform:scaleX(-1)}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i3$2.MatNavList, selector: "mat-nav-list", inputs: ["disableRipple", "disabled"], exportAs: ["matNavList"] }, { kind: "component", type: i3$2.MatListItem, selector: "mat-list-item, a[mat-list-item], button[mat-list-item]", inputs: ["disableRipple", "disabled"], exportAs: ["matListItem"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "directive", type: GarbageCollectorDirective, selector: "[aup-gc]", exportAs: ["aup-gc"] }, { kind: "component", type: IconComponent, selector: "aup-icon", inputs: ["icon"] }] });
__decorate([
    TrackExternal(),
    __metadata("design:type", MutableValueModel)
], SidePlaceNavigationComponent.prototype, "expanded$", void 0);
__decorate([
    StoreInValueModel("expanded$"),
    __metadata("design:type", Boolean)
], SidePlaceNavigationComponent.prototype, "expanded", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: SidePlaceNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-side-place-navigation', template: "<mat-nav-list>\n  <a mat-list-item (click)=\"toggleMenu()\" class=\"home\">\n    <aup-icon class=\"collapsed-only\" icon=\"mat:menu\"></aup-icon>\n    <aup-icon class=\"expanded-only\" icon=\"mat:arrow_back\"></aup-icon>\n    <span class=\"expanded-only\">Menu</span>\n  </a>\n  <a mat-list-item *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [class.active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-icon *ngIf=\"getNavigationFace(item.place).icon()\" [icon]=\"getNavigationFace(item.place).icon()\"></aup-icon>\n    <span class=\"expanded-only\">{{getNavigationFace(item.place).text()}}</span>\n  </a>\n  <span [style.flex]=\"1\"></span>\n  <ng-container *ngIf=\"navEndTemplate\" [ngTemplateOutlet]=\"navEndTemplate\"></ng-container>\n</mat-nav-list>\n", styles: [":host{display:flex;flex-direction:column;--resolved-nav-item-width: var(--nav-width, 56px);--resolved-nav-item-height: var(--nav-item-height, var(--resolved-nav-item-width));--resolved-expanded-width: var(--nav-expanded-width, 235px);--resolved-color: var(--nav-color, rgba(255, 255, 255, .9));--resolved-background-color: var(--nav-background-color, #555);width:var(--resolved-nav-item-width);transition:width 125ms linear;background-color:var(--resolved-background-color);color:var(--resolved-color)}:host.expanded{width:var(--resolved-expanded-width);max-width:var(--resolved-expanded-width)}:host-context(.expanded) .expanded-only{max-width:100%}:host-context(.expanded) .collapsed-only{max-width:0}:host-context(.expanded) .mat-list-item aup-icon:not(.collapsed-only){margin-right:12px}:host-context(.expanded) .mat-list-item span{text-wrap:none;white-space:nowrap}.expanded-only{max-width:0;overflow:hidden}.collapsed-only{max-width:100%;overflow:hidden}mat-nav-list{flex:1;display:flex;flex-direction:column}.mat-list-item{width:var(--resolved-nav-item-width);height:var(--resolved-nav-item-height);color:inherit}.mat-list-item.active{background-color:#444}.mat-list-item.home{text-align:left}mat-icon{color:inherit}mat-icon.flip-horizontal{transform:scaleX(-1)}\n"] }]
        }], ctorParameters: function () { return [{ type: PlaceRouter }]; }, propDecorators: { expanded$: [{
                type: Input
            }], expanded: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.expanded']
            }], navEndTemplate: [{
                type: ContentChild,
                args: ['navEndTemplate']
            }] } });

class TabbedPlaceNavigationComponent extends AbstractPlaceNavigationComponent {
    constructor(router) {
        super(router);
    }
}
TabbedPlaceNavigationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TabbedPlaceNavigationComponent, deps: [{ token: PlaceRouter }], target: i0.ɵɵFactoryTarget.Component });
TabbedPlaceNavigationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.2", type: TabbedPlaceNavigationComponent, selector: "aup-tabbed-place-navigation", usesInheritance: true, ngImport: i0, template: "<nav mat-tab-nav-bar>\n  <ng-content select=\"[nav-start]\"></ng-content>\n  <a mat-tab-link *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-command-face [faces]=\"[getNavigationFace(item.place)]\"></aup-command-face>\n  </a>\n  <ng-content select=\"[nav-end]\"></ng-content>\n</nav>\n", styles: [":host{display:block}div.place-holder{border:1px solid green}\n"], dependencies: [{ kind: "directive", type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "component", type: i2$6.MatTabNav, selector: "[mat-tab-nav-bar]", inputs: ["color"], exportAs: ["matTabNavBar", "matTabNav"] }, { kind: "directive", type: i2$6.MatTabLink, selector: "[mat-tab-link], [matTabLink]", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matTabLink"] }, { kind: "directive", type: i4.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "directive", type: CommandDirective, selector: "[pectinCommand]", inputs: ["pectinCommand", "commandParameter"] }, { kind: "directive", type: GarbageCollectorDirective, selector: "[aup-gc]", exportAs: ["aup-gc"] }, { kind: "component", type: CommandFaceComponent, selector: "aup-command-face", inputs: ["faces", "face", "ignoreIcon", "ignoreText", "includeMissingIconInLayout"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: TabbedPlaceNavigationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aup-tabbed-place-navigation', template: "<nav mat-tab-nav-bar>\n  <ng-content select=\"[nav-start]\"></ng-content>\n  <a mat-tab-link *ngFor=\"let item of menuItems.value; trackBy: trackByPlaceDef\"\n     aup-gc #gc=\"aup-gc\"\n     [pectinCommand]=\"commandFactory.create(item.place, {disposedWith: gc})\"\n     [active]=\"item.active\"\n     [matTooltip]=\"getNavigationFace(item.place).tooltip()\">\n    <aup-command-face [faces]=\"[getNavigationFace(item.place)]\"></aup-command-face>\n  </a>\n  <ng-content select=\"[nav-end]\"></ng-content>\n</nav>\n", styles: [":host{display:block}div.place-holder{border:1px solid green}\n"] }]
        }], ctorParameters: function () { return [{ type: PlaceRouter }]; } });

class PlaceModule {
}
PlaceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PlaceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: PlaceModule, declarations: [PlaceOutletComponent,
        TabbedPlaceNavigationComponent,
        ListPlaceNavComponent,
        SidePlaceNavigationComponent,
        AbstractPlaceNavigationComponent,
        NotAuthorisedNoticeComponent], imports: [CommonModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        RouterModule,
        MatTabsModule,
        MatListModule,
        MatTooltipModule,
        MatIconModule,
        DirectivesModule,
        FlexModule,
        ComponentsModule,
        PortalModule], exports: [PlaceOutletComponent,
        TabbedPlaceNavigationComponent,
        ListPlaceNavComponent,
        SidePlaceNavigationComponent,
        AbstractPlaceNavigationComponent] });
PlaceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceModule, imports: [CommonModule,
        BrowserAnimationsModule,
        MatProgressSpinnerModule,
        RouterModule,
        MatTabsModule,
        MatListModule,
        MatTooltipModule,
        MatIconModule,
        DirectivesModule,
        FlexModule,
        ComponentsModule,
        PortalModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        BrowserAnimationsModule,
                        MatProgressSpinnerModule,
                        RouterModule,
                        MatTabsModule,
                        MatListModule,
                        MatTooltipModule,
                        MatIconModule,
                        DirectivesModule,
                        FlexModule,
                        ComponentsModule,
                        PortalModule
                    ],
                    declarations: [
                        PlaceOutletComponent,
                        TabbedPlaceNavigationComponent,
                        ListPlaceNavComponent,
                        SidePlaceNavigationComponent,
                        AbstractPlaceNavigationComponent,
                        NotAuthorisedNoticeComponent
                    ],
                    exports: [
                        PlaceOutletComponent,
                        TabbedPlaceNavigationComponent,
                        ListPlaceNavComponent,
                        SidePlaceNavigationComponent,
                        AbstractPlaceNavigationComponent
                    ],
                    providers: [
                    // {provide: AUP_PLACE_CONFIG, useValue: {animationDuration: "2000ms"}}
                    ]
                }]
        }] });

class AngularUiPowerupsModule {
}
AngularUiPowerupsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AngularUiPowerupsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AngularUiPowerupsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.2", ngImport: i0, type: AngularUiPowerupsModule, imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        DirectivesModule,
        ComponentsModule,
        PlaceModule,
        InteractionModule,
        ObserversModule], exports: [InteractionModule,
        PlaceModule,
        DirectivesModule,
        ComponentsModule,
        NoopComponent,
        HighlightPipe] });
AngularUiPowerupsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AngularUiPowerupsModule, imports: [CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTabsModule,
        DirectivesModule,
        ComponentsModule,
        PlaceModule,
        InteractionModule,
        ObserversModule, InteractionModule,
        PlaceModule,
        DirectivesModule,
        ComponentsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: AngularUiPowerupsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        BrowserAnimationsModule,
                        FormsModule,
                        MatInputModule,
                        MatFormFieldModule,
                        MatSelectModule,
                        MatTabsModule,
                        DirectivesModule,
                        ComponentsModule,
                        PlaceModule,
                        InteractionModule,
                        ObserversModule
                    ],
                    exports: [
                        InteractionModule,
                        PlaceModule,
                        DirectivesModule,
                        ComponentsModule,
                        NoopComponent,
                        HighlightPipe
                    ]
                }]
        }] });

const slideDownOnEnterDef = style({
    opacity: 0,
    'height': '0',
    paddingTop: '0',
    paddingBottom: '0'
});
// TODO: params aren't getting customised in the view.  Need to figure out the correct approach.
const slideDownOnEnterAnimation = trigger('slideDownOnEnter', [
    transition(':enter', [slideDownOnEnterDef, animate('{{duration}}')], { params: { duration: '100ms' } }),
    transition(':leave', [animate('{{duration}}', slideDownOnEnterDef)], { params: { duration: '100ms' } })
]);
const slideLeftOnEnterDef = style({
    opacity: 0,
    'width': '0',
    paddingLeft: '0',
    paddingRight: '0'
});
const slideRightOnEnterAnimation = trigger('slideRightOnEnter', [
    transition(':enter', [slideLeftOnEnterDef, animate('{{duration}}')], { params: { duration: '100ms' } }),
    transition(':leave', [animate('{{duration}}', slideLeftOnEnterDef)], { params: { duration: '100ms' } })
]);

/**
 * @file Automatically generated by barrelsby.
 */

/**
 * @file Automatically generated by barrelsby.
 */

class DialogInteractionContext extends AbstractInteractionContext {
    constructor(identifier, api, dialogService, config) {
        super();
        this.identifier = identifier;
        this.api = api;
        this.dialogService = dialogService;
        this.config = config;
        this.garbage = new GarbageCollector();
        assert$1.notNil(dialogService);
    }
    cancelActiveActivity() {
        return this.activityContainer.cancelActiveActivity();
    }
    dispose() {
        if (this.isActive()) {
            lang.illegalState('Dispose called while active.');
        }
        this.garbage.dispose();
    }
    registerDisposable(disposable) {
        return this.garbage.registerDisposable(disposable);
    }
    isActive() {
        return !!this.activityContainer && this.activityContainer.isActive();
    }
    createAndLaunchActivity(activityType, data, disableClose) {
        assert$1.isNil(this._currentActivityRef);
        const config = {
            ...this.config,
            ...{
                disableClose,
                panelClass: 'dialog-interaction-context'
            }
        };
        const self = this;
        const matDialogRef = this.dialogService.open(ActivityContainerComponent, config);
        const activityContainer = this.activityContainer = matDialogRef.componentInstance;
        this.activityContainer.initialise(this.identifier, this.api);
        const activityResult = this.activityContainer.startActivity(activityType, data);
        activityResult.finally(() => matDialogRef.close());
        // we need to check if our onDone/onCancel methods above we called or if we were
        // closed by the user clicking the backdrop.  If the later then we need to cancel our
        // activity.
        matDialogRef.afterClosed().subscribe(promiseAlreadyFinished => {
            if (activityContainer.isActive()) {
                activityContainer.cancelActiveActivity();
            }
            this.activityContainer = null;
        });
        matDialogRef.updateSize();
        matDialogRef.afterOpened().subscribe(promiseAlreadyFinished => {
            matDialogRef.updateSize();
        });
        return activityResult;
    }
}

const DIALOG_INTERACTION_SERVICE_DEFAULTS = new InjectionToken('DIALOG_INTERACTION_SERVICE_DEFAULTS');
class DialogInteractionContextFactory extends ModalInteractionContextFactory {
    constructor(dialogService, dialogServiceDefaults, matDialogDefaultConfig) {
        super();
        this.dialogService = dialogService;
        this.dialogServiceDefaults = dialogServiceDefaults;
        this.matDialogDefaultConfig = matDialogDefaultConfig;
        assert$1.notNil(dialogService);
    }
    createInteractionContext(identifier, api, disableClose) {
        const config = {
            autoFocus: false,
            hasBackdrop: true,
            closeOnNavigation: false,
            ...this.matDialogDefaultConfig,
            ...this.dialogServiceDefaults
        };
        return new DialogInteractionContext(identifier, api, this.dialogService, config);
    }
}
DialogInteractionContextFactory.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogInteractionContextFactory, deps: [{ token: i1$6.MatDialog }, { token: DIALOG_INTERACTION_SERVICE_DEFAULTS, optional: true }, { token: MAT_DIALOG_DEFAULT_OPTIONS, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
DialogInteractionContextFactory.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogInteractionContextFactory, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: DialogInteractionContextFactory, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$6.MatDialog }, { type: i1$6.MatDialogConfig, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DIALOG_INTERACTION_SERVICE_DEFAULTS]
                }] }, { type: i1$6.MatDialogConfig, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DIALOG_DEFAULT_OPTIONS]
                }] }]; } });

/**
 * @file Automatically generated by barrelsby.
 */

function Place(options) {
    return (target) => {
        if (PlaceComponent.isPlaceComponentConstructor(target)) {
            PlaceComponent.injectDefinition(target, new PlaceDefinition(target, options.path, isNil(options.authenticate) ? true : options.authenticate, options.role ?? options.roles, options.data, PlaceComponent.getRouteParameters(target), (options.children || []).map(c => PlaceComponent.getDefinition(c)), options.redirectToFirstChild ?? false));
            if (options.roles) {
                console.warn(`${target.name} @Place({roles: string[]}) is deprecated.  Use @Place({role:any}) instead`);
            }
        }
        else {
            lang.illegalState(`${target} must extend PlaceComponent to use the @Place decorator`);
        }
    };
}

class NoopAuthGuard {
    constructor() {
    }
    async canActivate(activatedRoute, state) {
        return true;
    }
}
NoopAuthGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NoopAuthGuard, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NoopAuthGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NoopAuthGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: NoopAuthGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class VisitSanitiser {
    constructor(navigationSession, activatedRoute, router, placeHistory, injector) {
        this.navigationSession = navigationSession;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.placeHistory = placeHistory;
        this.injector = injector;
    }
    // @Trace()
    async sanitise(visit) {
        const placeDef = visit.placeDefinition;
        if (placeDef.hasRouteId()) {
            const routeIdDef = placeDef.getRouteIdParameterDef();
            const routeId = visit.getRouteId();
            const sanitisedValue = await routeIdDef.sanitise(routeId, visit, this.placeHistory, this.injector, this.navigationSession.isPopState);
            // console.log({routeId, sanitisedValue});
            // ###------- EARLY EXIT --------###
            if (routeIdDef.hasChanged(routeId, sanitisedValue)) {
                // if the route id has changed we redirect immediately as other
                // parameter sanitisers might use it.
                return visit.replace(routeIdDef, sanitisedValue);
            }
        }
        // if we didn't replace the routeId we continue the url present parameters.
        const parameterDefs = placeDef.getVisitParameterDefs({
            includeRouteParameters: true,
            includeNonRouteParameters: true
        });
        let sanitisedVisit = visit;
        for (let i = 0; i < parameterDefs.length; i++) {
            const def = parameterDefs[i];
            const value = visit.getParameterValue(def);
            const sanitisedValue = await def.sanitise(value, sanitisedVisit, this.placeHistory, this.injector, this.navigationSession.isPopState);
            if (def.hasChanged(value, sanitisedValue)) {
                sanitisedVisit = sanitisedVisit.replace(def, sanitisedValue);
            }
        }
        return sanitisedVisit.hasChangedFrom(visit) ? sanitisedVisit : visit;
    }
}

class PlaceGuard {
    constructor(router, urlService, placeRouter, placeHistory, interactionService, injector) {
        this.router = router;
        this.urlService = urlService;
        this.placeRouter = placeRouter;
        this.placeHistory = placeHistory;
        this.interactionService = interactionService;
        this.injector = injector;
    }
    // @Trace()
    async canActivate(activatedRoute, state) {
        if (PlaceComponent.isPlaceComponentConstructor(activatedRoute.component)) {
            const placeDefinition = PlaceComponent.getDefinition(activatedRoute.component);
            const accessGuard = this.placeRouter.accessGuard.value;
            if (placeDefinition.authenticate) {
                const authenticated = await accessGuard.isAuthenticated();
                if (!authenticated || !accessGuard.isAuthorised(placeDefinition)) {
                    const redirectLocation = this.placeRouter.getAuthenticationFailureRedirect(activatedRoute, state);
                    const nextPlaceDef = this.getPlaceDefinition(redirectLocation);
                    if (nextPlaceDef.authenticate) {
                        lang.illegalState(`handleNotAuthenticated hook returned place ${nextPlaceDef.component.name} that requires authentication.`);
                    }
                    return this.createUrlTree(redirectLocation);
                }
            }
            const result = await this.cleanInteractionState(activatedRoute, state, async () => {
                const navigationSession = this.placeRouter.navigationSession;
                // Parse our route params.
                const params = new ConsolidatedParameterMap(activatedRoute.url, activatedRoute.paramMap);
                // console.log("RouteParams", params)
                const parsedParams = placeDefinition.parseRouteParams(params);
                const initialVisit = navigationSession.getVisitFor(placeDefinition) || new Visit(placeDefinition, parsedParams);
                const sanitiser = new VisitSanitiser(navigationSession, activatedRoute, this.router, this.placeHistory, this.injector);
                const sanitisedVisit = await sanitiser.sanitise(initialVisit.mergeRouteParameters(parsedParams));
                // Save the visit with any updated parameters.  We need to save it so we remember any non route parameters
                navigationSession.storeVisit(sanitisedVisit);
                const destUrlSnapshot = this.urlService.parseUrl(state.url);
                if (initialVisit.hasRoutingChangedFrom(sanitisedVisit)) {
                    // Regenerate the url
                    const urlSnapshot = destUrlSnapshot.updateVisitSegments(sanitisedVisit);
                    console.log('##### Place Guard Redirect', urlSnapshot);
                    return urlSnapshot;
                }
                else {
                    // Our visit parameters are all sorted, now check if we should redirect to our child.
                    if (destUrlSnapshot.isLastPlaceInUrl(placeDefinition) && placeDefinition.redirectToFirstChild) {
                        if (placeDefinition.children.length < 1) {
                            lang.illegalState(`redirectToFirstChild set to true, but there were no children `);
                        }
                        for (let child of placeDefinition.children) {
                            if (!child.authenticate || accessGuard.isAuthorised(child)) {
                                return destUrlSnapshot.appendVisit(new Visit(child));
                            }
                        }
                        // hmm, what should I do here, we didn't have an authorised child
                        lang.illegalState(`redirectToFirstChild set to true, but there were no authenticated children`);
                    }
                    return true;
                }
            });
            return result instanceof UrlSnapshot ? result.urlTree : result;
        }
        else {
            return lang.illegalState(`expected component to be an instance of PlaceComponent, got ${activatedRoute.component}`);
        }
    }
    // @Trace()
    async canDeactivate(component, currentRoute, currentState, nextState) {
        if (!component) {
            // this happens when the place wasn't authorised and the associated
            // router outlet was removed from the dom.
            return true;
        }
        const currentUrl = this.urlService.parseUrl(currentState.url);
        const nextUrl = this.urlService.parseUrl(nextState.url);
        const result = await this.placeRouter.navigationSession.canDeactivatePlace(component, currentUrl, nextUrl);
        return result instanceof UrlSnapshot ? result.urlTree : result;
    }
    getPlaceDefinition(result) {
        return result instanceof Visit ?
            result.placeDefinition :
            PlaceComponent.getDefinition(result);
    }
    createUrlTree(result) {
        const visit = result instanceof Visit ? result : new Visit(PlaceComponent.getDefinition(result), {});
        return this.urlService.createUrlSnapshot(visit).urlTree;
    }
    // @Trace()
    async cleanInteractionState(route, state, next) {
        const url = this.urlService.parseUrl(state.url);
        if (!this.interactionService.isActive() && url.hasInteractions()) {
            // This happens if we reload the page or the url was pasted as the route should only be activated
            // after the interaction context has become active.
            return url.removeInteractionIds();
        }
        else {
            return next();
        }
    }
}
PlaceGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceGuard, deps: [{ token: i1$4.Router }, { token: UrlService }, { token: PlaceRouter }, { token: PlaceHistory }, { token: InteractionService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable });
PlaceGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: PlaceGuard, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1$4.Router }, { type: UrlService }, { type: PlaceRouter }, { type: PlaceHistory }, { type: InteractionService }, { type: i0.Injector }]; } });

var Formatter;
(function (Formatter) {
    class StringType {
        format(value) {
            return value;
        }
        parse(value) {
            return value;
        }
    }
    class NumberType {
        format(value) {
            return isNumber(value) && !isNaN(value) ? `${value}` : null;
        }
        parse(value) {
            const parsed = Number.parseFloat(value);
            return isNaN$1(parsed) ? null : parsed;
        }
    }
    class BooleanType {
        format(value) {
            return value ? 'true' : 'false';
        }
        parse(value) {
            return value === 'true';
        }
    }
    Formatter.STRING = new StringType();
    Formatter.NUMBER = new NumberType();
    Formatter.BOOLEAN = new BooleanType();
})(Formatter || (Formatter = {}));

function installMechanics(parameterDef, prototype, propertyKey, tagPrefix) {
    Klass.get(prototype).addToOwnMetadataList(ROUTE_PARAMETER_LIST_KEY, parameterDef);
    function getMechanics(instance, propertyName) {
        const key = `__mechanics_${propertyName.toString()}`;
        if (!instance[key]) {
            const backingModel = parameterDef.createBackingModel();
            instance[key] = {
                backingModel: backingModel,
                binding: null
            };
            const tag = `${tagPrefix}(${prototype.constructor.name}.${propertyKey.toString()})`;
            DebugContext.getOrCreate(instance[key].backingModel).tag(tag);
        }
        return instance[key];
    }
    Object.defineProperty(prototype, propertyKey, {
        get: function () {
            return getMechanics(this, propertyKey).backingModel;
        },
        set: function (userModel) {
            const mechanics = getMechanics(this, propertyKey);
            // This handles the scenario where we want to push an existing value model (such as a form model)
            // to and from the route.
            if (mechanics.binding) {
                mechanics.binding.dispose();
            }
            if (userModel) {
                mechanics.binding = new Binding(mechanics.backingModel, userModel, {
                    toLeft: Functions.identity,
                    toRight: Functions.identity
                });
                if (parameterDef.isEmptyValue(userModel.value)) {
                    // console.log(`Push visit to model for ${tag}`, {value: mechanics.backingModel.value});
                    mechanics.binding.writeRight(); // push the visit into the user model;
                }
                else {
                    if (!parameterDef.isEmptyValue(mechanics.backingModel.value)) {
                        console.warn('Assigning a visit model with an existing value to a visit parameter with an existing value.  Visit parameter will be overridden');
                    }
                    mechanics.binding.writeLeft(); // push the user model into the visit
                }
            }
        }
    });
}
function RouteId(formatter, options) {
    return (prototype, propertyKey) => {
        const parameterDef = new ParameterDefinition.RouteId(propertyKey.toString(), options, formatter);
        installMechanics(parameterDef, prototype, propertyKey, '@RouteId');
    };
}
function VisitParameter(options) {
    const opts = Opts.get(options);
    return (prototype, propertyKey) => {
        const parameterDef = new ParameterDefinition.ValueParameter(propertyKey.toString(), options, opts.getOptional('storeInUrl', null));
        installMechanics(parameterDef, prototype, propertyKey, '@VisitParameter');
    };
}
function VisitParameterList(options) {
    const opts = Opts.get(options);
    return (prototype, propertyKey) => {
        const parameterDef = new ParameterDefinition.ArrayParameter(propertyKey.toString(), options, opts.getOptional('storeInUrl', null));
        installMechanics(parameterDef, prototype, propertyKey, '@VisitParameterList');
    };
}

/**
 * @file Automatically generated by barrelsby.
 */

// TODO: Merge various wake detection events into this class.  visibility, wake events, websocket connection, online detection.
// Taken from: https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
class VisibilityService extends GarbageCollector {
    // private _wakeEvents = new MutableStream<Instant>();
    // private _throttledWakeEvents: Stream<Instant>;
    constructor(document) {
        super();
        this._visible$ = new MutableValueModel();
        this.document = document; // see https://stackoverflow.com/a/53715642
        const { chain } = Dsl.disposeWith(this);
        // Set the name of the hidden property and the change event for visibility
        if (typeof this.document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
            this.attributeName = 'hidden';
            this.eventName = 'visibilitychange';
        }
        else if (typeof this.document['msHidden'] !== 'undefined') {
            this.attributeName = 'msHidden';
            this.eventName = 'msvisibilitychange';
        }
        else if (typeof this.document['webkitHidden'] !== 'undefined') {
            this.attributeName = 'webkitHidden';
            this.eventName = 'webkitvisibilitychange';
        }
        // Warn if the browser doesn't support addEventListener or the Page Visibility API
        if (typeof this.document.addEventListener === 'undefined' || typeof document[this.attributeName] === 'undefined') {
            console.log('This app requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');
        }
        else {
            // Handle page visibility change
            const handler = () => this.updateVisibilityState();
            this.document.addEventListener(this.eventName, handler, false);
            this.onDispose(() => {
                this.document.removeEventListener(this.eventName, handler);
            });
        }
        this._visible$.value = this.isVisible();
        // give the network a chance to come back or we end up with a bunch of failed requests.
        // should probably also implement a connection service so that we can go
        // connectionServer.ensureConnectedThen(fireWakeEvent);
        // this._throttledWakeEvents = chain(this._wakeEvents).throttle(300);
    }
    // get wakeEvents(): Stream<Instant> {
    //   return this._throttledWakeEvents;
    // }
    // @trace
    updateVisibilityState() {
        this._visible$.value = this.isVisible();
        // this._wakeEvents.publish(Instant.now());
    }
    /**
     * @deprecated use visible$ instead.
     */
    get visibleModel() {
        return this._visible$.readonly;
    }
    get visible$() {
        return this._visible$.readonly;
    }
    isHidden() {
        return !!this.document[this.attributeName];
    }
    isVisible() {
        return !this.isHidden();
    }
}
VisibilityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: VisibilityService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable });
VisibilityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: VisibilityService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.2", ngImport: i0, type: VisibilityService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/**
 * @file Automatically generated by barrelsby.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ACTIVITY_DATA, ALERT_CONFIG, AUP_PLACE_CONFIG, AUP_UNAUTHORISED_PLACE_NOTICE_COMPONENT, AbstractActivityTriggerComponent, AbstractCardContainerComponent, AbstractConfirmDialogComponent, AbstractDialogComponent, AbstractInputComponent, AbstractInteractionContext, AbstractListInputComponent, AbstractPlaceNavigationComponent, AbstractPopStateNavigation, AbstractPopupMenuComponent, AbstractTableComponent, AbstractTableFilterModel, AbstractTableModel, AbstractValueInputComponent, Activity, ActivityActionsComponent, ActivityBodyComponent, ActivityContainerComponent, ActivityOutletComponent, ActivityRef, ActivityTitleComponent, AddCardActivityComponent, AddItemInteractionContextComponent, Alert, AlertDialogComponent, AngularUiPowerupsModule, AutocompleteInputComponent, Bounds, BusyOverlayComponent, CELL_EDITOR_PORTAL, CELL_RENDERER_PORTAL, CardContainerComponent, CardStackComponent, CellEditorPortalRef, CellHeaderPortalRef, CellPortalRef, CellRendererPortalRef, CheckboxInputComponent, ColumnListModel, ColumnModel, ColumnTemplateDirective, ColumnTextSearchFormatter, CommandComponent, CommandContainer, CommandDirective, CommandFace, CommandFaceComponent, ComponentCellRendererPortalRef, ComponentsModule, ConfirmThenDialogComponent, ConfirmThenExecuteDialogComponent, ConfirmationDialogComponent, ConsolidatedParameterMap, CustomTemplateColumnModel, CustomValueColumnModel, DEFINITION_META_DATA_KEY, DIALOG_INTERACTION_SERVICE_DEFAULTS, DecoratedTreeNode, DefaultCellRendererComponent, DefaultHeaderCellRendererComponent, DialogInteractionContext, DialogInteractionContextFactory, Dimension, DirectivesModule, DisposableComponent, EditRowControls, EditSession, EditorControlColumnModel, EmptyStateComponent, EnableCellTextSearch, EventCleanUpSession, FlattenedTreeListModel, FlexComponent, FocusBinding, FocusBindingDirective, FocusBindingFactory, FocusContainerComponent, FocusableComponent, Formatter, GarbageCollectorDirective, HEADER_CELL_RENDERER_PORTAL, HighlightPipe, HighlightTextModelDirective, HorizontalAlignment, IconComponent, InPlaceInteractionContextComponent, InlineActivityTriggerComponent, InlineEditorModel, InlineStringEditorComponent, InputActivity, InteractionContextTriggerFor, InteractionModule, InteractionService, InteractionServiceRoutingAdapter, Keys, LEFT_RIGHT_PLACE_ANIMATION, LabelledValueComponent, ListPlaceNavComponent, ListPropertyColumnModel, LoadingContainerComponent, MarkdownComponent, MarkdownService, ModalActivityTriggerComponent, ModalInteractionContextFactory, MoreMenuComponent, MultipleSelectInputComponent, Navigating, NavigatingDuringInteraction, NavigationContext, NavigationSession, NoopAuthGuard, NoopComponent, NotAuthorisedNoticeComponent, NumberInputComponent, POPUP_CONTAINER, PORTAL_EDITOR_COMPONENT, PORTAL_RENDERER_COMPONENT, PaginatorComponent, ParameterDefinition, PasswordInputComponent, Place, PlaceAccessGuard, PlaceComponent, PlaceComponentDeactivationHandler, PlaceDefinition, PlaceGuard, PlaceHistory, PlaceModule, PlaceOutletComponent, PlaceRouter, Point, PopStateDuringInteractionNavigation, PopStateNavigation, PopupActivityTriggerComponent, PopupAwareComponent, PopupInteractionContextComponent, PopupMenuComponent, PopupMenuRendererComponent, PropertyColumnModel, ROUTE_PARAMETER_LIST_KEY, RemoveLastInteractionFromUrlNavigationSession, ResizeAwareComponent, RouteId, ScrollContainerComponent, SectionHeaderComponent, SelectInputActivity, SelectInputComponent, SelectionCellComponent, SelectionColumnModel, SelectionHeaderCellComponent, SeparatorComponent, SidePlaceNavigationComponent, StringInputActivity, StringInputComponent, SwitchCaseComponent, SwitchCaseDefaultDirective, SwitchCaseOption, SwitchCaseWhenDirective, SynchroniseInteractionContextIdsWithRoute, TabbedPlaceNavigationComponent, TableBodyComponent, TableCellComponent, TableComponent, TableFilterModel, TableHeaderCellComponent, TableModel, TableRowMenuComponent, TemplateCellRendererPortalRef, TextInputComponent, ToolBarComponent, TrackBy, TreeExpansionModel, TreeInheritanceIconComponent, TreeLabelCellRendererComponent, TreeLabelColumnModel, TreeTableComponent, TreeTableModel, UrlService, UrlSnapshot, VerticalFocusContainerComponent, VisibilityService, Visit, VisitParameter, VisitParameterList, VisitSanitiser, WaitUntilLeavingInteractionTransitionCancelled, WaitUntilLinkTriggeredNavigationInteractionCancellationTypeDetermined, WaitUntilPopStateDuringCanDeactivateInteractionFinishes, leftRightPlaceAnimation, markdownPillExtension, slideDownOnEnterAnimation, slideRightOnEnterAnimation, treeNodeDecorator };
